//
export const ON_START_CHECK_FILE = "ON_START_CHECK_FILE";
export const ON_CHECK_FILE = "ON_CHECK_FILE";
export const ON_ERROR_CHECK_FILE = "ON_ERROR_CHECK_FILE";
export const ON_CLOSE_CHECK_FILE = "ON_CLOSE_CHECK_FILE";
export const ON_START_GET_DIALER_USER_HISTORY = "ON_START_GET_DIALER_USER_HISTORY";
export const ON_GET_DIALER_USER_HISTORY = "ON_GET_DIALER_USER_HISTORY";
export const ON_ERROR_GET_DIALER_USER_HISTORY = "ON_ERROR_GET_DIALER_USER_HISTORY";
//
export const ON_START_GET_DASHBOARD_VALUEOF = "ON_START_GET_DASHBOARD_VALUEOF";
export const ON_GET_DASHBOARD_VALUEOF = "ON_GET_DASHBOARD_VALUEOF";
export const ON_ERROR_GET_DASHBOARD_VALUEOF = "ON_ERROR_GET_DASHBOARD_VALUEOF";
export const ON_START_UPDATE_DASHBOARD_VALUEOF = "ON_START_UPDATE_DASHBOARD_VALUEOF";
export const ON_UPDATE_DASHBOARD_VALUEOF = "ON_UPDATE_DASHBOARD_VALUEOF";
export const ON_ERROR_UPDATE_DASHBOARD_VALUEOF = "ON_ERROR_UPDATE_DASHBOARD_VALUEOF";
//
export const ON_START_GET_SMS_SETTINGS = "ON_START_GET_SMS_SETTINGS";
export const ON_GET_SMS_SETTINGS = "ON_GET_SMS_SETTINGS";
export const ON_ERROR_GET_SMS_SETTINGS = "ON_ERROR_GET_SMS_SETTINGS";
export const ON_START_UPDATE_SMS_SETTINGS = "ON_START_UPDATE_SMS_SETTINGS";
export const ON_UPDATE_SMS_SETTINGS = "ON_UPDATE_SMS_SETTINGS";
export const ON_ERROR_UPDATE_SMS_SETTINGS = "ON_ERROR_UPDATE_SMS_SETTINGS";
//
export const ON_START_UPDATE_PROSPEKT_DEADLINE = "ON_START_UPDATE_PROSPEKT_DEADLINE";
export const ON_UPDATE_PROSPEKT_DEADLINE = "ON_UPDATE_PROSPEKT_DEADLINE";
export const ON_ERROR_UPDATE_PROSPEKT_DEADLINE = "ON_ERROR_UPDATE_PROSPEKT_DEADLINE";
//
export const ON_START_GET_LOBBY_CUSTOM = "ON_START_GET_LOBBY_CUSTOM";
export const ON_GET_LOBBY_CUSTOM = "ON_GET_LOBBY_CUSTOM";
export const ON_ERROR_GET_LOBBY_CUSTOM = "ON_ERROR_GET_LOBBY_CUSTOM";
export const ON_START_UPDATE_LOBBY_CUSTOM = "ON_START_UPDATE_LOBBY_CUSTOM";
export const ON_UPDATE_LOBBY_CUSTOM = "ON_UPDATE_LOBBY_CUSTOM";
export const ON_ERROR_UPDATE_LOBBY_CUSTOM = "ON_ERROR_GET_LOBBY_CUSTOM";
//
export const ON_START_GET_PROSPEKT_PROSPEKT_KALKYL_SUMMARY = "ON_START_GET_PROSPEKT_PROSPEKT_KALKYL_SUMMARY";
export const ON_GET_PROSPEKT_PROSPEKT_KALKYL_SUMMARY = "ON_GET_PROSPEKT_PROSPEKT_KALKYL_SUMMARY";
export const ON_ERROR_GET_PROSPEKT_PROSPEKT_KALKYL_SUMMARY = "ON_ERROR_GET_PROSPEKT_PROSPEKT_KALKYL_SUMMARY";
export const ON_START_GET_PROSPEKTLIST_USER = "ON_START_GET_PROSPEKTLIST_USER";
export const ON_GET_PROSPEKTLIST_USER = "ON_GET_PROSPEKTLIST_USER";
export const ON_ERROR_GET_PROSPEKTLIST_USER = "ON_ERROR_GET_PROSPEKTLIST_USER";
//
export const PROJEKT_ON_START_GET_CARD_DETAILS = "PROJEKT_ON_START_GET_CARD_DETAILS";
export const PROJEKT_ON_GET_CARD_DETAILS = "PROJEKT_ON_GET_CARD_DETAILS";
export const PROJEKT_ON_ERROR_GET_GET_CARD_DETAILS = "PROJEKT_ON_ERROR_GET_GET_CARD_DETAILS";
//
export const ON_START_GET_KONTO_TAGS = "ON_START_GET_KONTO_TAGS";
export const ON_GET_KONTO_TAGS = "ON_GET_KONTO_TAGS";
export const ON_ERROR_GET_KONTO_TAGS = "ON_ERROR_GET_KONTO_TAGS";
//
export const ON_START_CHANGE_PROSPEKT_KUND = "ON_START_CHANGE_PROSPEKT_KUND";
export const ON_CHANGE_PROSPEKT_KUND = "ON_CHANGE_PROSPEKT_KUND";
export const ON_ERROR_CHANGE_PROSPEKT_KUND = "ON_ERROR_CHANGE_PROSPEKT_KUND";
//
export const ON_START_GET_AVTAL_SHARED_KUNDER = "ON_START_GET_AVTAL_SHARED_KUNDER";
export const ON_GET_AVTAL_SHARED_KUNDER = "ON_GET_AVTAL_SHARED_KUNDER";
export const ON_ERROR_GET_AVTAL_SHARED_KUNDER = "ON_ERROR_GET_AVTAL_SHARED_KUNDER";
export const ON_START_DELETE_AVTAL_SHARED_KUNDER = "ON_START_DELETE_AVTAL_SHARED_KUNDER";
export const ON_DELETE_AVTAL_SHARED_KUNDER = "ON_DELETE_AVTAL_SHARED_KUNDER";
export const ON_ERROR_DELETE_AVTAL_SHARED_KUNDER = "ON_ERROR_DELETE_AVTAL_SHARED_KUNDER";
export const ON_START_ADD_AVTAL_SHARED_KUNDER = "ON_START_ADD_AVTAL_SHARED_KUNDER";
export const ON_ADD_AVTAL_SHARED_KUNDER = "ON_ADD_AVTAL_SHARED_KUNDER";
export const ON_ERROR_ADD_AVTAL_SHARED_KUNDER = "ON_ERROR_ADD_AVTAL_SHARED_KUNDER";
//
export const ON_START_UPDATE_ORDER_KUNDDATA_KANUPDATE = "ON_START_UPDATE_ORDER_KUNDDATA_KANUPDATE";
export const ON_UPDATE_ORDER_KUNDDATA_KANUPDATE = "ON_UPDATE_ORDER_KUNDDATA_KANUPDATE";
export const ON_ERROR_UPDATE_ORDER_KUNDDATA_KANUPDATE = "ON_ERROR_UPDATE_ORDER_KUNDDATA_KANUPDATE";
//
export const ON_START_GET_KUND_KONTAKTER = "ON_START_GET_KUND_KONTAKTER";
export const ON_GET_KUND_KONTAKTER = "ON_GET_KUND_KONTAKTER";
export const ON_ERROR_GET_KUND_KONTAKTER = "ON_ERROR_GET_KUND_KONTAKTER";
//
export const ON_CHANGE_INITURL = "ON_CHANGE_INITURL";
export const FETCH_START_INTERFACE = "FETCH_START_INTERFACE";
//ON_GET_CHANGE_PROSPEKT_VY
export const ON_GET_CHANGE_PROSPEKT_VY = "ON_GET_CHANGE_PROSPEKT_VY";
export const ON_GET_CHANGE_PROSPEKT_VY_SORT = "ON_GET_CHANGE_PROSPEKT_VY_SORT";
//
export const ON_GET_CHANGE_ORDER_VY_SORT = "ON_GET_CHANGE_ORDER_VY_SORT";
//
export const ON_START_GET_ARTIKEL_TBAVDRAG = "ON_START_GET_ARTIKEL_TBAVDRAG";
export const ON_GET_ARTIKEL_TBAVDRAG = "ON_GET_ARTIKEL_TBAVDRAG";
export const ON_ERROR_GET_ARTIKEL_TBAVDRAG = "ON_ERROR_GET_ARTIKEL_TBAVDRAG";
export const ON_START_ADD_ARTIKEL_TBAVDRAG = "ON_START_ADD_ARTIKEL_TBAVDRAG";
export const ON_ADD_ARTIKEL_TBAVDRAG = "ON_ADD_ARTIKEL_TBAVDRAG";
export const ON_ERROR_ADD_ARTIKEL_TBAVDRAG = "ON_ERROR_ADD_ARTIKEL_TBAVDRAG";
//
export const ON_START_ORGNR_FAMILY_TREE = "ON_START_ORGNR_FAMILY_TREE";
export const ON_ORGNR_FAMILY_TREE = "ON_ORGNR_FAMILY_TREE";
export const ON_ERROR__ORGNR_FAMILY_TREE = "ON_ERROR__ORGNR_FAMILY_TREE";
export const ON_START_ADD_ORGNR_FAMILY_TREE = "ON_START_ADD_ORGNR_FAMILY_TREE";
export const ON_ADD_ORGNR_FAMILY_TREE = "ON_ADD_ORGNR_FAMILY_TREE";
export const ON_ERROR_ADD_ORGNR_FAMILY_TREE = "ON_ERROR_ADD_ORGNR_FAMILY_TREE";
export const ON_START_DELETE_ORGNR_FAMILY_TREE = "ON_START_DELETE_ORGNR_FAMILY_TREE";
export const ON_DELETE_ORGNR_FAMILY_TREE = "ON_DELETE_ORGNR_FAMILY_TREE";
//
export const ON_START_UPPDATE_DIALER_KOMMMENTAR = "ON_START_UPPDATE_DIALER_KOMMMENTAR";
export const ON_UPPDATE_DIALER_KOMMMENTAR = "ON_UPPDATE_DIALER_KOMMMENTAR";
export const ON_ERROR_UPPDATE_DIALER_KOMMMENTAR = "ON_ERROR_UPPDATE_DIALER_KOMMMENTAR";
//
export const ON_UPDATE_CURRENTUSER_FAVTALPAGEROW = "ON_UPDATE_CURRENTUSER_FAVTALPAGEROW";
export const ON_UPDATE_CURRENTUSER_AVTALPAGEROW = "ON_UPDATE_CURRENTUSER_AVTALPAGEROW";
export const ON_GET_SETTING_INITIAL_AVTAL = "ON_GET_SETTING_INITIAL_AVTAL";
//
export const ON_START_SEARCH_KOMMENTAR = "ON_START_SEARCH_KOMMENTAR";
export const ON_SEARCH_KOMMENTAR = "ON_SEARCH_KOMMENTAR";
export const ON_ERROR_SEARCH_KOMMENTAR = "ON_ERROR_SEARCH_KOMMENTAR";
//
export const ON_START_FLODE_LIKES = "ON_START_FLODE_LIKES";
export const ON_FLODE_LIKES = "ON_FLODE_LIKES";
export const ON_ERROR_FLODE_LIKES = "ON_ERROR_FLODE_LIKES";
//
export const ON_START_GET_VALITIVE = "ON_START_GET_VALITIVE";
export const ON_GET_VALITIVE = "ON_GET_VALITIVE";
export const ON_ERROR_GET_VALITIVE = "ON_ERROR_GET_VALITIVE";
//
export const ON_START_GET_UNDERKONTO_KUNDER = "ON_START_GET_UNDERKONTO_KUNDER";
export const ON_GET_UNDERKONTO_KUNDER = "ON_GET_UNDERKONTO_KUNDER";
export const ON_ERROR_GET_UNDERKONTO_KUNDER = "ON_ERROR_GET_UNDERKONTO_KUNDER";
//
export const ON_START_CHECH_KUNDNR = "ON_START_CHECH_KUNDNR";
export const ON_CHECH_KUNDNR = "ON_CHECH_KUNDNR";
export const ON_ERROR_CHECH_KUNDNR = "ON_ERROR_CHECH_KUNDNR";
//
export const ON_FETCH_KOPIERA_USER = "ON_FETCH_KOPIERA_USER";
export const ON_START_FETCH_KOPIERA_USER = "ON_START_FETCH_KOPIERA_USER";
//
export const KALKYL_ALLREADY_SAVED = "KALKYL_ALLREADY_SAVED";
export const ON_START_GET_ORDER_ORGNR_PROJEKT = "ON_START_GET_ORDER_ORGNR_PROJEKT";
export const ON_GET_ORDER_ORGNR_PROJEKT = "ON_GET_ORDER_ORGNR_PROJEKT";
//
export const ON_START_GET_IMPORT_SAMPLE = "ON_START_GET_IMPORT_SAMPLE";
export const ON_GET_IMPORT_SAMPLE = "ON_GET_IMPORT_SAMPLE";
export const ON_ERROR_GET_IMPORT_SAMPLE = "ON_ERROR_GET_IMPORT_SAMPLE";
export const ON_START_FETCH_RAPPORTV2 = "ON_START_FETCH_RAPPORTV2";
export const ON_FETCH_RAPPORTV2 = "ON_FETCH_RAPPORTV2";
export const ON_ERROR_FETCH_RAPPORTV2 = "ON_ERROR_FETCH_RAPPORTV2";
export const ON_SET_TO_NULL_IMPORTSAMPLE = "ON_SET_TO_NULL_IMPORTSAMPLE";
export const ON_START_GET_SPARAD_RAPPORTV2 = "ON_START_GET_SPARAD_RAPPORTV2";
export const ON_GET_SPARAD_RAPPORTV2 = "ON_GET_SPARAD_RAPPORTV2";
export const ON_ERROR_GET_SPARAD_RAPPORTV2 = "ON_ERROR_GET_SPARAD_RAPPORTV2";
export const ON_START_GET_LOGG_RAPPORTV2 = "ON_START_GET_LOGG_RAPPORTV2";
export const ON_GET_LOGG_RAPPORTV2 = "ON_GET_LOGG_RAPPORTV2";
export const ON_ERROR_GET_LOGG_RAPPORTV2 = "ON_ERROR_GET_LOGG_RAPPORTV2";
export const ON_START_DELETE_AFID_RAPPORTV2 = "ON_START_DELETE_AFID_RAPPORTV2";
export const ON_DELETE_AFID_RAPPORTV2 = "ON_DELETE_AFID_RAPPORTV2";
export const ON_ERROR_DELETE_AFID_RAPPORTV2 = "ON_ERROR_DELETE_AFID_RAPPORTV2";
export const ON_START_UPDATE_RAPPORTV2 = "ON_START_UPDATE_RAPPORTV2";
export const ON_UPDATE_RAPPORTV2 = "ON_UPDATE_RAPPORTV2";
export const ON_ERROR_UPDATE_RAPPORTV2 = "ON_ERROR_UPDATE_RAPPORTV2";

//ON_START_GET_LOGG_RAPPORTV2,ON_GET_LOGG_RAPPORTV2,ON_ERROR_GET_LOGG_RAPPORTV2,
export const ON_START_GET_KONTO_STORAGE = "ON_START_GET_KONTO_STORAGE";
export const ON_GET_KONTO_STORAGE = "ON_GET_KONTO_STORAGE";
export const ON_ERROR_GET_KONTO_STORAGE = "ON_ERROR_GET_KONTO_STORAGE";
//
export const ON_START_GET_CATE_ARENDE_AFID = "ON_START_GET_CATE_ARENDE_AFID";
export const ON_GE_CATE_ARENDE_AFID = "ON_GE_CATE_ARENDE_AFID";
export const ON_ERROR_CATE_ARENDE_AFID = "ON_ERROR_CATE_ARENDE_AFID";
export const ON_START_SAVE_NEW_CATE_ARENDE = "ON_START_SAVE_NEW_CATE_ARENDE";
export const ON_SAVE_SAVE_NEW_CATE_ARENDE = "ON_SAVE_SAVE_NEW_CATE_ARENDE";
export const ON_ERROR_SAVE_NEW_CATE_ARENDE = "ON_ERROR_SAVE_NEW_CATE_ARENDE";
export const ON_DELETE_SAVE_NEW_CATE_ARENDE = "ON_DELETE_SAVE_NEW_CATE_ARENDE";
export const ON_START_GET_FREEINPUT_ARENDE_AFID = "ON_START_GET_FREEINPUT_ARENDE_AFID";
export const ON_GET_FREEINPUT_ARENDE_AFID = "ON_GET_FREEINPUT_ARENDE_AFID";
export const ON_ERROR_FREEINPUT_ARENDE_AFID = "ON_ERROR_FREEINPUT_ARENDE_AFID";
export const ON_START_SAVE_NEW_ARENDE_CATE_FREEINPUT = "ON_START_SAVE_NEW_ARENDE_CATE_FREEINPUT";
export const ON_SAVE_NEW_NEW_ARENDE_CATE_FREEINPUT = "ON_SAVE_NEW_NEW_ARENDE_CATE_FREEINPUT";
export const ON_ERROR_SAVE_NEW_ARENDE_CATE_FREEINPUT = "ON_ERROR_SAVE_NEW_ARENDE_CATE_FREEINPUT";
export const ON_DELETE_ARENDE_CATE_FREEINPUT = "ON_DELETE_ARENDE_CATE_FREEINPUT";
export const ON_START_GET_FI_AFID_ARENDE = "ON_START_GET_FI_AFID_ARENDE";
export const ON_GET_FI_AFID_ARENDE = "ON_GET_FI_AFID_ARENDE";
export const ON_ERROR_FI_AFID_ARENDE = "ON_ERROR_FI_AFID_ARENDE";
//
export const ON_START_Delete_SHARED_OFFICE = "ON_START_Delete_SHARED_OFFICE";
export const ON_Delete_SHARED_OFFIC = "ON_Delete_SHARED_OFFIC";
export const ON_ERROR_Delete_SHARED_OFFIC = "ON_ERROR_Delete_SHARED_OFFIC";
//
export const ON_START_GET_IMPORTERAD_RINGLISTOR = "ON_START_GET_IMPORTERAD_RINGLISTOR";
export const ON_GET_IMPORTERAD_RINGLISTOR = "ON_GET_IMPORTERAD_RINGLISTOR";
export const ON_ERROR_GET_IMPORTERAD_RINGLISTOR = "ON_ERROR_GET_IMPORTERAD_RINGLISTOR";
//
export const ON_START_CREATE_RINGLIST_FROM_KUNDLIST = "ON_START_CREATE_RINGLIST_FROM_KUNDLIST";
export const ON_CREATE_RINGLIST_FROM_KUNDLIST = "ON_CREATE_RINGLIST_FROM_KUNDLIST";
export const ON_ERROR_CREATE_RINGLIST_FROM_KUNDLIST = "ON_ERROR_CREATE_RINGLIST_FROM_KUNDLIST";
//FETCH_TOKEN_EXPIR
export const FETCH_TOKEN_EXPIR = "FETCH_TOKEN_EXPIR";
export const ON_GET_UPDATE_DASHBOARD = "ON_GET_UPDATE_DASHBOARD";
export const ON_GET_UPDATE_DASHBOARD_BOKATV = "ON_GET_UPDATE_DASHBOARD_BOKATV";
export const ON_GET_UPDATE_DASHBOARD_ORDERTV = "ON_GET_UPDATE_DASHBOARD_ORDERTV";
export const ON_GET_UPDATE_DASHBOARD_DIALER = "ON_GET_UPDATE_DASHBOARD_DIALER";
export const ON_GET_UPDATE_DASHBOARD_AKTIVITET = "ON_GET_UPDATE_DASHBOARD_AKTIVITET";
export const ON_GET_UPDATE_DASHBOARD_PROSPEKT = "ON_GET_UPDATE_DASHBOARD_PROSPEKT";
export const ON_GET_UPDATE_DASHBOARD_OFFERT = "ON_GET_UPDATE_DASHBOARD_OFFERT";
export const ON_GET_UPDATE_DASHBOARD_PROJEKT = "ON_GET_UPDATE_DASHBOARD_PROJEKT";
export const ON_GET_UPDATE_DASHBOARD_TIDPROJEKT = "ON_GET_UPDATE_DASHBOARD_TIDPROJEKT";
export const ON_GET_UPDATE_DASHBOARD_ARENDE = "ON_GET_UPDATE_DASHBOARD_ARENDE";
export const ON_GET_UPDATE_DASHBOARD_AVTAL = "ON_GET_UPDATE_DASHBOARD_AVTAL";
export const ON_GET_UPDATE_DASHBOARD_LYNES = "ON_GET_UPDATE_DASHBOARD_LYNES";
export const ON_GET_UPDATE_DASHBOARD_DEVICE = "ON_GET_UPDATE_DASHBOARD_DEVICE";
export const ON_GET_UPDATE_DASHBOARD_ISMESSAGE = "ON_GET_UPDATE_DASHBOARD_ISMESSAGE";

export const ON_FETCH_TOTAL_SALES = "ON_FETCH_TOTAL_SALES";
export const ON_ERROR_FETCH_TOTAL_SALES = "ON_ERROR_FETCH_TOTAL_SALES";
export const ON_START_FETCH_TOTAL_SALES = "ON_START_FETCH_TOTAL_SALES";
export const ON_FETCH_MRR = "ON_FETCH_MRR";
export const ON_ERROR_FETCH_MRR = "ON_ERROR_FETCH_MRR";
export const ON_START_FETCH_MRR = "ON_START_FETCH_MRR";
export const ON_FETCH_ARR = "ON_FETCH_ARR";
export const ON_ERROR_FETCH_ARR = "ON_ERROR_FETCH_ARR";
export const ON_START_FETCH_ARR = "ON_START_FETCH_ARR";
export const ON_FETCH_ARPU = "ON_FETCH_ARPU";
export const ON_ERROR_FETCH_ARPU = "ON_ERROR_FETCH_ARPU";
export const ON_START_FETCH_ARPU = "ON_START_FETCH_ARPU";

export const ON_GET_START_ESIGNERING_PROCESS= "ON_GET_START_ESIGNERING_PROCESS";
export const ON_GET_UPDATE_ESIGNERING= "ON_GET_UPDATE_ESIGNERING";
export const ON_GET_UPDATE_ESIGNERING_ERROR= "ON_GET_UPDATE_ESIGNERING_ERROR";
export const ON_GET_UPDATE_ESIGNERING_KUNDNAMN= "ON_GET_UPDATE_ESIGNERING_KUNDNAMN";
//
export const ON_START_UPDATE_ARENDE_MESSAGE = "ON_START_UPDATE_ARENDE_MESSAGE";
export const ON_UPDATE_ARENDE_MESSAGE = "ON_UPDATE_ARENDE_MESSAGE";
export const ON_ERROR_UPDATE_ARENDE_MESSAGE = "ON_ERROR_UPDATE_ARENDE_MESSAGE";
//
export const ON_START_GET_UPDATED_AVTAL_KALKYL = "ON_START_GET_UPDATED_AVTAL_KALKYL";
export const ON_GET_UPDATED_AVTAL_KALKYL = "ON_GET_UPDATED_AVTAL_KALKYL";
export const ON_ERROR_GET_UPDATED_AVTAL_KALKYL = "ON_ERROR_GET_UPDATED_AVTAL_KALKYL";
//ON_START_DELETE_LOBBY_FLODE,ON_DELETE_LOBBY_FLODE,ON_ERROR_DELETE_LOBBY_FLODE,
export const ON_START_DELETE_LOBBY_FLODE = "ON_START_DELETE_LOBBY_FLODE";
export const ON_DELETE_LOBBY_FLODE = "ON_DELETE_LOBBY_FLODE";
export const ON_ERROR_DELETE_LOBBY_FLODE = "ON_ERROR_DELETE_LOBBY_FLODE";
//ON_START_LOADING,ON_END_LOADING,
export const ON_START_LOADING = "ON_START_LOADING";
export const ON_END_LOADING = "ON_END_LOADING";
export const ON_OPEN_REFRESH_TOKEN = "ON_OPEN_REFRESH_TOKEN";
//ON_START_GET_DOWN_FILE_NO_SAVE,ON_GET_DOWN_FILE_NO_SAVE,ON_ERROR_GET_DOWN_FILE_NO_SAVE,
export const ON_START_GET_DOWN_FILE_NO_SAVE = "ON_START_GET_DOWN_FILE_NO_SAVE";
export const ON_GET_DOWN_FILE_NO_SAVE = "ON_GET_DOWN_FILE_NO_SAVE";
export const ON_ERROR_GET_DOWN_FILE_NO_SAVE = "ON_ERROR_GET_DOWN_FILE_NO_SAVE";
//
export const ON_START_GET_FAKTURA_INTERVALL_AFID = "ON_START_GET_FAKTURA_INTERVALL_AFID";
export const ON_GET_FAKTURA_INTERVALL_AFID = "ON_GET_FAKTURA_INTERVALL_AFID";
export const ON_ERROR_GET_FAKTURA_INTERVALL_AFID = "ON_ERROR_GET_FAKTURA_INTERVALL_AFID";
//
export const ON_START_GET_DIALER_KOMMUN_LIST = "ON_START_GET_DIALER_KOMMUN_LIST";
export const ON_GET_DIALER_KOMMUN_LIST = "ON_GET_DIALER_KOMMUN_LIST";
export const ON_ERROR_GET_DIALER_KOMMUN_LIST = "ON_ERROR_GET_DIALER_KOMMUN_LIST";
//ON_UPDATE_ORDER_LIST_SEARCHTYPE
export const ON_UPDATE_ORDER_LIST_SEARCHTYPE = "ON_UPDATE_ORDER_LIST_SEARCHTYPE";
export const ON_UPDATE_ORDER_LIST_SEARCHWORD = "ON_UPDATE_ORDER_LIST_SEARCHWORD";
//
  export const START_FETCH_CONTACT1_BY_ID = "START_FETCH_CONTACT1_BY_ID";
  export const ON_FETCH_CONTACT1_BY_ID_REST = "ON_FETCH_CONTACT1_BY_ID_REST";
  export const START_FETCH_CONTACT2_BY_ID = "START_FETCH_CONTACT2_BY_ID";
  export const ON_FETCH_CONTACT2_BY_ID_REST = "ON_FETCH_CONTACT2_BY_ID_REST";
  export const START_FETCH_CONTACT3_BY_ID = "START_FETCH_CONTACT3_BY_ID";
  export const ON_FETCH_CONTACT3_BY_ID_REST = "ON_FETCH_CONTACT3_BY_ID_REST";
//
export const ON_START_SAVE_NEW_TYP_AV_AFFAR = "ON_START_SAVE_NEW_TYP_AV_AFFAR";
export const ON_SAVE_NEW_TYP_AV_AFFAR = "ON_SAVE_NEW_TYP_AV_AFFAR";
export const ON_ERROR_SAVE_NEW_TYP_AV_AFFAR = "ON_ERROR_SAVE_NEW_TYP_AV_AFFAR";
export const ON_START_GET_TYP_AV_AFFAR = "ON_START_GET_TYP_AV_AFFAR";
export const ON_GET_TYP_AV_AFFAR = "ON_GET_TYP_AV_AFFAR";
export const ON_ERROR_GET_TYP_AV_AFFAR = "ON_ERROR_GET_TYP_AV_AFFAR";
export const ON_START_DELETE_TYP_AV_AFFAR = "ON_START_DELETE_TYP_AV_AFFAR";
export const ON_DELETE_TYP_AV_AFFAR = "ON_DELETE_TYP_AV_AFFAR";
export const ON_ERROR_DELETE_TYP_AV_AFFAR = "ON_ERROR_DELETE_TYP_AV_AFFAR";
export const ON_START_AKTIVE_TYP_AV_AFFAR = "ON_START_AKTIVE_TYP_AV_AFFAR";
export const ON_AKTIVE_TYP_AV_AFFAR = "ON_AKTIVE_TYP_AV_AFFAR";
export const ON_ERROR_AKTIVE_TYP_AV_AFFAR = "ON_ERROR_AKTIVE_TYP_AV_AFFAR";
//
export const ON_START_GET_ADS = "ON_START_GET_ADS";
export const ON_GET_ADS = "ON_GET_ADS";
export const ON_ERROR_GET_ADS = "ON_ERROR_GET_ADS";
export const ON_START_GET_FBADS = "ON_START_GET_FBADS";
export const ON_GET_FBADS = "ON_GET_FBADS";
export const ON_ERROR_GET_FBADS = "ON_ERROR_GET_FBADS";

//
//ON_START_CHECK_FORTNOX_KUNDNAME1,ON_GET_CHECK_FORTNOX_KUNDNAME1,ON_ERROR_GET_CHECK_FORTNOX_KUNDNAME1,
//ON_SET_ARTIKLAR_TAB_INDEX
//ON_START_GET_PRISLISTA_BY_ORGNR,ON_GET_PRISLISTA_BY_ORGNR,ON_ERROR_GET_PRISLISTA_BY_ORGNR,
//
export const ON_START_OFFERT_UPDATE_STATUS = "ON_START_OFFERT_UPDATE_STATUS";
export const ON_OFFERT_UPDATE_STATUS = "ON_OFFERT_UPDATE_STATUS";
export const ON_OFFERT_UPDATE_STATUS_1 = "ON_OFFERT_UPDATE_STATUS_1";
export const ON_OFFERT_UPDATE_STATUS_2 = "ON_OFFERT_UPDATE_STATUS_2";
export const ON_OFFERT_UPDATE_STATUS_3 = "ON_OFFERT_UPDATE_STATUS_3";
export const ON_OFFERT_UPDATE_STATUS_4 = "ON_OFFERT_UPDATE_STATUS_4";
export const ON_ERROR_OFFERT_UPDATE_STATUS = "ON_ERROR_OFFERT_UPDATE_STATUS";
//
export const ON_START_GET_AVTAL_OTASKS = "ON_START_GET_AVTAL_OTASKS";
export const ON_GET_AVTAL_OTASKS = "ON_GET_AVTAL_OTASKS";
export const ON_ERROR_GET_AVTAL_OTASKS = "ON_ERROR_GET_AVTAL_OTASKS";
export const ON_START_NEW_AF_ORDER_TASK = "ON_START_NEW_AF_ORDER_TASK";
export const ON_NEW_AF_ORDER_TASK = "ON_NEW_AF_ORDER_TASK";
export const ON_ERROR_NEW_AF_ORDER_TASK = "ON_ERROR_NEW_AF_ORDER_TASK";
export const ON_START_GET_AF_ORDER_TASK = "ON_START_GET_AF_ORDER_TASK";
export const ON_GET_AF_ORDER_TASK = "ON_GET_AF_ORDER_TASK";
export const ON_ERROR_GET_AF_ORDER_TASK = "ON_ERROR_GET_AF_ORDER_TASK";
export const ON_START_UPDATE_AF_ORDER_TASK = "ON_START_UPDATE_AF_ORDER_TASK";
export const ON_UPDATE_AF_ORDER_TASK = "ON_UPDATE_AF_ORDER_TASK";
export const ON_ERROR_UPDATE_AF_ORDER_TASK = "ON_ERROR_UPDATE_AF_ORDER_TASK";
export const ON_START_DELETE_AF_ORDER_TASK = "ON_START_DELETE_AF_ORDER_TASK";
export const ON_DELETE_AF_ORDER_TASK = "ON_DELETE_AF_ORDER_TASK";
export const ON_ERROR_DELETE_AF_ORDER_TASK = "ON_ERROR_DELETE_AF_ORDER_TASK";

export const ON_START_GET_AVTAL_FREEINPUTS = "ON_START_GET_AVTAL_FREEINPUTS";
export const ON_GET_AVTAL_FREEINPUTS = "ON_GET_AVTAL_FREEINPUTS";
export const ON_ERROR_GET_AVTAL_FREEINPUTS = "ON_ERROR_GET_AVTAL_FREEINPUTS";

export const ON_START_GET_PRISLISTA_BY_ORGNR = "ON_START_GET_PRISLISTA_BY_ORGNR";
export const ON_GET_PRISLISTA_BY_ORGNR = "ON_GET_PRISLISTA_BY_ORGNR";
export const ON_ERROR_GET_PRISLISTA_BY_ORGNR = "ON_ERROR_GET_PRISLISTA_BY_ORGNR";
//
export const ON_SET_ARTIKLAR_TAB_INDEX = "ON_SET_ARTIKLAR_TAB_INDEX";
export const ON_START_CHECK_FORTNOX_KUNDNAME1 = "ON_START_CHECK_FORTNOX_KUNDNAME1";
export const ON_GET_CHECK_FORTNOX_KUNDNAME1 = "ON_GET_CHECK_FORTNOX_KUNDNAME1";
export const ON_ERROR_GET_CHECK_FORTNOX_KUNDNAME1 = "ON_ERROR_GET_CHECK_FORTNOX_KUNDNAME1";
//
export const ON_START_ESIGNERING_UPDATE_NYTT = "ON_START_ESIGNERING_UPDATE_NYTT";
export const ON_CLOSE_ARANDE_TOASTR = "ON_CLOSE_ARANDE_TOASTR";
//
export const ON_START_GET_OFFERT_HOGIA_VARDE_TOOLTIP = "ON_START_GET_OFFERT_HOGIA_VARDE_TOOLTIP";
export const ON_GET_OFFERT_HOGIA_VARDE_TOOLTIP = "ON_GET_OFFERT_HOGIA_VARDE_TOOLTIP";
export const ON_ERROR_GET_OFFERT_HOGIA_VARDE_TOOLTIP = "ON_ERROR_GET_OFFERT_HOGIA_VARDE_TOOLTIP";
//
export const ON_START_CHECK_FORTNOX_KUNDNAME = "ON_START_CHECK_FORTNOX_KUNDNAME";
export const ON_GET_CHECK_FORTNOX_KUNDNAME = "ON_GET_CHECK_FORTNOX_KUNDNAME";
export const ON_ERROR_GET_CHECK_FORTNOX_KUNDNAME = "ON_ERROR_GET_CHECK_FORTNOX_KUNDNAME";
//
export const ON_START_UPDATE_EVENT_STATUS = "ON_START_UPDATE_EVENT_STATUS";
export const ON_UPDATE_EVENT_STATUS = "ON_UPDATE_EVENT_STATUS";
export const ON_ERROR_UPDATE_EVENT_STATUS = "ON_ERROR_UPDATE_EVENT_STATUS";
export const ON_START_GET_EVENT_SETTING_AF = "ON_START_GET_EVENT_SETTING_AF";
export const ON_GET_EVENT_SETTING_AF = "ON_GET_EVENT_SETTING_AF";
export const ON_ERROR_GET_EVENT_SETTING_AF = "ON_ERROR_GET_EVENT_SETTING_AF";
export const ON_START_UPDATE_EVENT_SETTING_AF = "ON_START_UPDATE_EVENT_SETTING_AF";
export const ON_UPDATE_EVENT_SETTING_AF = "ON_UPDATE_EVENT_SETTING_AF";
export const ON_ERROR_UPDATE_EVENT_SETTING_AF = "ON_ERROR_UPDATE_EVENT_SETTING_AF";
//
export const ON_START_DELETE_EVENT_STATUS = "ON_START_DELETE_EVENT_STATUS";
export const ON_DELETE_EVENT_STATUS = "ON_DELETE_EVENT_STATUS";
export const ON_ERROR_DELETE_EVENT_STATUS = "ON_ERROR_DELETE_EVENT_STATUS";
export const ON_START_GET_EVENT_STATUS = "ON_START_GET_EVENT_STATUS";
export const ON_GET_EVENT_STATUS = "ON_GET_EVENT_STATUS";
export const ON_START_NEW_EVENT_STATUS = "ON_START_NEW_EVENT_STATUS";
export const ON_NEW_EVENT_STATUS = "ON_NEW_EVENT_STATUS";
export const ON_ERROR_EVENT_STATUS = "ON_ERROR_EVENT_STATUS";
//
export const ON_START_GET_AKTIVITETE_TYPE = "ON_START_GET_AKTIVITETE_TYPE";
export const ON_GET_AKTIVITETE_TYPE = "ON_GET_AKTIVITETE_TYPE";
export const ON_ERROR_GET_AKTIVITETE_TYPE = "ON_ERROR_GET_AKTIVITETE_TYPE";
export const ON_START_NEW_AKTIVITETE_TYPE = "ON_START_NEW_AKTIVITETE_TYPE";
export const ON_NEW_AKTIVITETE_TYPE = "ON_NEW_AKTIVITETE_TYPE";
export const ON_ERROR_AKTIVITETE_TYPE = "ON_ERROR_AKTIVITETE_TYPE";
export const ON_START_UPDATE_AKTIVITETE_TYPE = "ON_START_UPDATE_AKTIVITETE_TYPE";
export const ON_UPDATE_AKTIVITETE_TYPE = "ON_UPDATE_AKTIVITETE_TYPE";
export const ON_ERROR_UPDATE_AKTIVITETE_TYPE = "ON_ERROR_UPDATE_AKTIVITETE_TYPE";
export const ON_START_DELETE_AKTIVITETE_TYPE = "ON_START_DELETE_AKTIVITETE_TYPE";
export const ON_DELETE_AKTIVITETE_TYPE = "ON_DELETE_AKTIVITETE_TYPE";
export const ON_ERROR_DELETE_AKTIVITETE_TYPE = "ON_ERROR_DELETE_AKTIVITETE_TYPE";
//
export const ON_START_FETCH_GET_RAPPORT_DIALER = "ON_START_FETCH_GET_RAPPORT_DIALER";
export const ON_ERROR_FETCH_GET_RAPPORT_DIALER = "ON_ERROR_FETCH_GET_RAPPORT_DIALER";
//
export const ON_START_GET_DIALER_AVTALSTID_LIST = "ON_START_GET_DIALER_AVTALSTID_LIST";
export const ON_GET_DIALER_AVTALSTID_LIST = "ON_GET_DIALER_AVTALSTID_LIST";
export const ON_ERROR_GET_DIALER_AVTALSTID_LIST = "ON_ERROR_GET_DIALER_AVTALSTID_LIST";
//
export const DOCTEMPEDITOR_ON_START_GET_MSG_SEND_DOCUMENT = "DOCTEMPEDITOR_ON_START_GET_MSG_SEND_DOCUMENT";
export const DOCTEMPEDITOR_ON_GET_MSG_SEND_DOCUMENT = "DOCTEMPEDITOR_ON_GET_MSG_SEND_DOCUMENT";
export const DOCTEMPEDITOR_ON_ERROR_GET_MSG_SEND_DOCUMENT = "DOCTEMPEDITOR_ON_ERROR_GET_MSG_SEND_DOCUMENT";
//
export const ON_START_GET_AVTALS_FORTNOX_SETTINGS = "ON_START_GET_AVTALS_FORTNOX_SETTINGS";
export const ON_GET_AVTALS_FORTNOX_SETTINGSG = "ON_GET_AVTALS_FORTNOX_SETTINGSG";
export const ON_ERROR_GET_AVTALS_FORTNOX_SETTINGS = "ON_ERROR_GET_AVTALS_FORTNOX_SETTINGS";
export const ON_START_UPDATE_AVTALS_FORTNOX_SETTING = "ON_START_UPDATE_AVTALS_FORTNOX_SETTING";
export const ON_UPDATE_AVTALS_FORTNOX_SETTING = "ON_UPDATE_AVTALS_FORTNOX_SETTING";
export const ON_ERROR_UPDATE_AVTALS_FORTNOX_SETTING = "ON_ERROR_UPDATE_AVTALS_FORTNOX_SETTING";
//
export const ON_START_GET_AVTAL_FAKTUROR = "ON_START_GET_AVTAL_FAKTUROR";
export const ON_GET_AVTAL_FAKTUROR = "ON_GET_AVTAL_FAKTUROR";
export const ON_ERROR_GET_AVTAL_FAKTUROR = "ON_ERROR_GET_AVTAL_FAKTUROR";
//
export const ON_START_GET_ORDER_FREE_INPUTS = "ON_START_GET_ORDER_FREE_INPUTS";
export const ON_GET_ORDER_FREE_INPUTS = "ON_GET_ORDER_FREE_INPUTS";
export const ON_ERROR_GET_ORDER_FREE_INPUTS = "ON_ERROR_GET_ORDER_FREE_INPUTS";
//ON_SAVE_PAGE_ANV
export const ON_SAVE_PAGE_ANV = "ON_SAVE_PAGE_ANV";
//
export const ON_START_GET_ORDER_USER_NEXT_PREV = "ON_START_GET_ORDER_USER_NEXT_PREV";
export const ON_GET_ORDER_USER_NEXT_PREV = "ON_GET_ORDER_USER_NEXT_PREV";
export const ON_ERROR_GET_ORDER_USER_NEXT_PREV = "ON_ERROR_GET_ORDER_USER_NEXT_PREV";
//
export const ON_START_GET_AVTALS_AVSLUTNING = "ON_START_GET_AVTALS_AVSLUTNING";
export const ON_GET_AVTALS_AVSLUTNING = "ON_GET_AVTALS_AVSLUTNING";
export const ON_ERROR_GET_AVTALS_AVSLUTNING = "ON_ERROR_GET_AVTALS_AVSLUTNING";
export const ON_START_SAVE_NEW_AVTAL_AVSLUTNING = "ON_START_SAVE_NEW_AVTAL_AVSLUTNING";
export const ON_SAVE_NEW_AVTAL_AVSLUTNING = "ON_SAVE_NEW_AVTAL_AVSLUTNING";
export const ON_ERROR_SAVE_NEW_AVTAL_AVSLUTNING = "ON_ERROR_SAVE_NEW_AVTAL_AVSLUTNING";
export const ON_START_DELETE_AVTAL_AVSLUTNING = "ON_START_DELETE_AVTAL_AVSLUTNING";
export const ON_DELETE_DELETE_AVTAL_AVSLUTNING = "ON_DELETE_DELETE_AVTAL_AVSLUTNING";
export const ON_ERROR_DELETE_AVTAL_AVSLUTNING = "ON_ERROR_DELETE_AVTAL_AVSLUTNING";
//Toastr
export const ON_START_ORDER_CLOSE_TOASTR = "ON_START_ORDER_CLOSE_TOASTR";
export const ON_START_ARTIKEL_CLOSE_TOASTR = "ON_START_ARTIKEL_CLOSE_TOASTR";
export const ON_CLOSE_KONTO_TOASTR = "ON_CLOSE_KONTO_TOASTR";
export const ON_CLOSE_AVTAL_TOASTR = "ON_CLOSE_AVTAL_TOASTR";
export const ON_CLOSE_KUND_TOASTR = "ON_CLOSE_KUND_TOASTR";
export const ON_CLOSE_USER_TOASTR = "ON_CLOSE_USER_TOASTR";
export const ON_CLOSE_RAPPORT_TOASTR = "ON_CLOSE_RAPPORT_TOASTR";
//
export const ON_START_GET_KUND_MESSAGE = "ON_START_GET_KUND_MESSAGE";
export const ON_GET_KUND_MESSAGE = "ON_GET_KUND_MESSAGE";
export const ON_ERROR_GET_KUND_MESSAGE = "ON_ERROR_GET_KUND_MESSAGE";
//  
export const FETCH_ALL_CONTACT_FLAGS = "FETCH_ALL_CONTACT_FLAGS";
export const ON_FETCH_CONTACT_FLAGS_BY_ID = "ON_FETCH_CONTACT_FLAGS_BY_ID";
export const FETCH_ACCOUNT_FLAGS_ERROR = "FETCH_ACCOUNT_FLAGS_ERROR";
//
export const ON_START_SAVE_NEW_PRISLISTA = "ON_START_SAVE_NEW_PRISLISTA";
export const ON_SAVE_NEW_PRISLISTA = "ON_SAVE_NEW_PRISLISTA";
export const ON_ERROR_SAVE_NEW_PRISLISTA = "ON_ERROR_SAVE_NEW_PRISLISTA";
export const ON_START_GET_AFID_PRISLISTA = "ON_START_GET_AFID_PRISLISTA";
export const ON_GET_AFID_PRISLISTA = "ON_GET_AFID_PRISLISTA";
export const ON_ERROR_GET_AFID_PRISLISTA = "ON_ERROR_GET_AFID_PRISLISTA";
export const ON_DELETE_DELETE_AFID_PRISLISTA = "ON_DELETE_DELETE_AFID_PRISLISTA";
export const ON_UPDATE_AFID_PRISLISTA = "ON_UPDATE_AFID_PRISLISTA";
//
export const ON_START_MESSAGE_KUND = "ON_START_MESSAGE_KUND";
export const ON_MESSAGE_KUND = "ON_MESSAGE_KUND";
export const ON_ERROR_MESSAGE_KUND = "ON_ERROR_MESSAGE_KUND";
//GET_USER_CONNECT
export const GET_USER_CONNECT = "GET_USER_CONNECT";
//
export const ON_START_GET_ARTEKLAR_EXCEL = "ON_START_GET_ARTEKLAR_EXCEL";
export const ON_GET_ARTEKLAR_EXCEL = "ON_GET_ARTEKLAR_EXCEL";
export const ON_ERROR_GET_ARTEKLAR_EXCEL = "ON_ERROR_GET_ARTEKLAR_EXCEL";
export const ON_START_IMPORT_ARTIKLAR_FUNC = "ON_START_IMPORT_ARTIKLAR_FUNC";
export const ON_IMPORT_ARTIKLAR_FUNC = "ON_IMPORT_ARTIKLAR_FUNC";
export const ON_ERROR_IMPORT_ARTIKLAR_FUNC = "ON_ERROR_IMPORT_ARTIKLAR_FUNC";
//
export const FETCH_START_SET_AUTHE = "FETCH_START_SET_AUTHE";
export const FETCH_START_SET_UNAUTHE = "FETCH_START_SET_UNAUTHE";
//
export const ON_START_GET_SEARCHABLE_ARTKEL_FI = "ON_START_GET_SEARCHABLE_ARTKEL_FI";
export const ON_GET_SEARCHABLE_ARTKEL_FI = "ON_GET_SEARCHABLE_ARTKEL_FI";
export const ON_ERROR_GET_SEARCHABLE_ARTKEL_FI = "ON_ERROR_GET_SEARCHABLE_ARTKEL_FI";
//
export const ON_START_SYNK_ENENTS = "ON_START_SYNK_ENENTS";
export const ON_SYNK_ENENTS = "ON_SYNK_ENENTS";
export const ON_ERROR_SYNK_ENENTS = "ON_ERROR_SYNK_ENENTS";
export const ON_START_GET_EVENT_USER_DONTREFRESH = "ON_START_GET_EVENT_USER_DONTREFRESH";
//
export const ON_START_FETCH_SAVED_ANPASSAD = "ON_START_FETCH_SAVED_ANPASSAD";
export const ON_START_FETCH_UPDATE_ANPASSAD = "ON_START_FETCH_UPDATE_ANPASSAD";
export const ON_FETCH_SAVED_ANPASSAD = "ON_FETCH_SAVED_ANPASSAD";
export const ON_ERROR_FETCH_SAVED_ANPASSAD = "ON_ERROR_FETCH_SAVED_ANPASSAD";
//
export const ON_START_ADD_PROJEKT_TIME_TYPE = "ON_START_ADD_PROJEKT_TIME_TYPE";
export const ON_ADD_PROJEKT_TIME_TYPE = "ON_ADD_PROJEKT_TIME_TYPE";
export const ON_ERROR_ADD_PROJEKT_TIME_TYPE = "ON_ERROR_ADD_PROJEKT_TIME_TYPE";
export const ON_UPPDATE_PROJEKT_TIME_TYPE = "ON_UPPDATE_PROJEKT_TIME_TYPE";
export const ON_DELETE_PROJEKT_TIME_TYPE = "ON_DELETE_PROJEKT_TIME_TYPE";
export const ON_NEW_PROJEKT_TIME_TYPE_CATEGORY = "ON_NEW_PROJEKT_TIME_TYPE_CATEGORY";
export const ON_DELETE_PROJEKT_TIME_TYPE_CATEGORY = "ON_DELETE_PROJEKT_TIME_TYPE_CATEGORY";
export const ON_ADD_PROJEKT_NEW_TEMPLATE_BOARD = "ON_ADD_PROJEKT_NEW_TEMPLATE_BOARD";
export const ON_UPDATE_PROJEKT_TEMPLATE_BOARD = "ON_UPDATE_PROJEKT_TEMPLATE_BOARD";
export const ON_ERROR_UPDATE_PROJEKT_TIME_TYPE = "ON_ERROR_UPDATE_PROJEKT_TIME_TYPE";
export const ON_DELETE_PROJEKT_TEMPLATE_BOARD = "ON_DELETE_PROJEKT_TEMPLATE_BOARD";
//
export const ON_START_NEW_ARTIKEL_TAGG = "ON_START_NEW_ARTIKEL_TAGG";
export const ON_NEW_ARTIKEL_TAGG = "ON_NEW_ARTIKEL_TAGG";
export const ON_ERROR_NEW_ARTIKEL_TAGG = "ON_ERROR_NEW_ARTIKEL_TAGG";
export const ON_UPPDATE_ARTIKEL_TAGG = "ON_UPPDATE_ARTIKEL_TAGG";
export const ON_DELETE_ARTIKEL_TAGG = "ON_DELETE_ARTIKEL_TAGG";
//
export const ON_START_ADD_NEW_FREEINPUT_ARTIKEL = "ON_START_ADD_NEW_FREEINPUT_ARTIKEL";
export const ON_ADD_NEW_FREEINPUT_ARTIKEL = "ON_ADD_NEW_FREEINPUT_ARTIKEL";
export const ON_ERROR_ADD_NEW_FREEINPUT_ARTIKEL = "ON_ERROR_ADD_NEW_FREEINPUT_ARTIKEL";
export const ON_GET_FREEINPUT_ARTIKEL = "ON_GET_FREEINPUT_ARTIKEL";
export const ON_START_GET_FREEINPUT_ARTIKEL = "ON_START_GET_FREEINPUT_ARTIKEL";
export const ON_START_GET_THIS_FREEINPUT_ARTIKEL = "ON_START_GET_THIS_FREEINPUT_ARTIKEL";
export const ON_GET_THIS_FREEINPUT_ARTIKEL = "ON_GET_THIS_FREEINPUT_ARTIKEL";
export const ON_START_DETELE_THIS_ARTICLE_FREEINPUT = "ON_START_DETELE_THIS_ARTICLE_FREEINPUT";
export const ON_DETELE_THIS_ARTICLE_FREEINPUT = "ON_DETELE_THIS_ARTICLE_FREEINPUT";
export const ON_ERROR_DETELE_THIS_ARTICLE_FREEINPUT = "ON_ERROR_DETELE_THIS_ARTICLE_FREEINPUT";
export const ON_START_UPDATE_FREEINPUT_ARTIKEL = "ON_START_UPDATE_FREEINPUT_ARTIKEL";
export const ON_UPDATE_FREEINPUT_ARTIKEL = "ON_UPDATE_FREEINPUT_ARTIKEL";
export const ON_ERROR_UPDATE_FREEINPUT_ARTIKEL = "ON_ERROR_UPDATE_FREEINPUT_ARTIKEL";
export const ON_START_GET_THIS_FREEINPUTS_ARTIKEL = "ON_START_GET_THIS_FREEINPUTS_ARTIKEL";
export const ON_GET_THIS_FREEINPUTS_ARTIKEL = "ON_GET_THIS_FREEINPUTS_ARTIKEL";
//
export const ON_START_GET_ORDER_FORTNOX = "ON_START_GET_ORDER_FORTNOX";
export const ON_GET_ORDER_FORTNOX = "ON_GET_ORDER_FORTNOX";
export const ON_ERROR_GET_ORDER_FORTNOX = "ON_ERROR_GET_ORDER_FORTNOX";
//
export const ON_START_SET_KUNDLIST_TAG = "ON_START_SET_KUNDLIST_TAG";
export const ON_SET_KUNDLIST_TAG = "ON_SET_KUNDLIST_TAG";
export const ON_ERROR_SET_KUNDLIST_TAG = "ON_ERROR_SET_KUNDLIST_TAG";
//
export const ON_START_GET_EVENT_SETTING = "ON_START_GET_EVENT_SETTING";
export const ON_GET_EVENT_SETTING = "ON_GET_EVENT_SETTING";
export const ON_ERROR_GET_EVENT_SETTING = "ON_ERROR_GET_EVENT_SETTING";
//
export const ON_START_GET_ORGNR_FORDON = "ON_START_GET_ORGNR_FORDON";
export const ON_GET_ORGNR_FORDON = "ON_GET_ORGNR_FORDON";
export const ON_ERROR_GET_ORGNR_FORDON = "ON_ERROR_GET_ORGNR_FORDON";
export const ON_UPDATE_ORDER_FORNOX = "ON_UPDATE_ORDER_FORNOX";
//
export const ON_START_FETCH_ORDER_IMPORT_FILE = "ON_START_FETCH_ORDER_IMPORT_FILE";
export const ON_FETCH_ORDER_IMPORT_FILE = "ON_FETCH_ORDER_IMPORT_FILE";
//
export const ON_START_GET_AFID_USERLIST = "ON_START_GET_AFID_USERLIST";
export const ON_GET_AFID_USERLIST = "ON_GET_AFID_USERLIST";
export const ON_ERROR_GET_AFID_USERLIST = "ON_ERROR_GET_AFID_USERLIST";
//ON_START_FETCH_KUND_HANDELSER_DIALERD,   ON_FETCH_KUND_HANDELSER_DIALERD,   ON_ERROR_FETCH_KUND_HANDELSER_DIALERD,
export const ON_START_FETCH_KUND_HANDELSER_DIALERD = "ON_START_FETCH_KUND_HANDELSER_DIALERD";
export const ON_FETCH_KUND_HANDELSER_DIALERD = "ON_FETCH_KUND_HANDELSER_DIALERD";
export const ON_ERROR_FETCH_KUND_HANDELSER_DIALERD = "ON_ERROR_FETCH_KUND_HANDELSER_DIALERD";
//
export const ON_START_UPDATE_ARTIKEL_FORTNOX = "ON_START_UPDATE_ARTIKEL_FORTNOX";
export const ARTREG_ON_UPDATE_ARTIKEL_FORTNOX = "ARTREG_ON_UPDATE_ARTIKEL_FORTNOX";
export const ARTREG_ERROR_ON_UPDATE_ARTIKEL_FORTNOX = "ARTREG_ERROR_ON_UPDATE_ARTIKEL_FORTNOX";
//
export const ON_START_SAVE_NEW_TYPE_ARTIKEL = "ON_START_SAVE_NEW_TYPE_ARTIKEL";
export const ON_SAVE_SAVE_NEW_TYPE_ARTIKEL = "ON_SAVE_SAVE_NEW_TYPE_ARTIKEL";
export const ON_ERROR_SAVE_NEW_TYPE_ARTIKEL = "ON_ERROR_SAVE_NEW_TYPE_ARTIKEL";
export const ON_START_GET_TYPE_ARTIKEL_AFID = "ON_START_GET_TYPE_ARTIKEL_AFID";
export const ON_GET_TYPE_ARTIKEL_AFID = "ON_GET_TYPE_ARTIKEL_AFID";
export const ON_ERROR_TYPE_ARTIKEL_AFID = "ON_ERROR_TYPE_ARTIKEL_AFID";
export const ON_DELETE_SAVE_NEW_TYPE_ARTIKEL = "ON_DELETE_SAVE_NEW_TYPE_ARTIKEL";
export const ON_START_SAVE_NEW_TYPE_ARTIKEL_FREEINPUT = "ON_START_SAVE_NEW_TYPE_ARTIKEL_FREEINPUT";
export const ON_SAVE_NEW_TYPE_ARTIKEL_FREEINPUT = "ON_SAVE_NEW_TYPE_ARTIKEL_FREEINPUT";
export const ON_ERROR_SAVE_NEW_TYPE_ARTIKEL_FREEINPUT = "ON_ERROR_SAVE_NEW_TYPE_ARTIKEL_FREEINPUT";
export const ON_START_GET_FREEINPUT_ARTIKEL_AFID = "ON_START_GET_FREEINPUT_ARTIKEL_AFID";
export const ON_GET_FREEINPUT_ARTIKEL_AFID = "ON_GET_FREEINPUT_ARTIKEL_AFID";
export const ON_ERROR_FREEINPUT_ARTIKEL_AFID = "ON_ERROR_FREEINPUT_ARTIKEL_AFID";
export const ON_DELETE_TYPE_ARTIKEL_FREEINPUT = "ON_DELETE_TYPE_ARTIKEL_FREEINPUT";
export const ON_START_GET_FREEINPUT_ARTIKEL_ALL_AFID = "ON_START_GET_FREEINPUT_ARTIKEL_ALL_AFID";
export const ON_GET_FREEINPUT_ARTIKEL_ALL_AFID = "ON_GET_FREEINPUT_ARTIKEL_ALL_AFID";
export const ON_START_GET_FREEINPUT_ARTIKEL_AFID_LIST = "ON_START_GET_FREEINPUT_ARTIKEL_AFID_LIST";
export const ON_GET_FREEINPUT_ARTIKEL_AFID_LIST = "ON_GET_FREEINPUT_ARTIKEL_AFID_LIST";
export const ON_ERROR_FREEINPUT_ARTIKEL_AFID_LIST = "ON_ERROR_FREEINPUT_ARTIKEL_AFID_LIST";
export const ON_START_GET_FREEINPUT_ARTIKEL_AFID_LIST_FILTER_OPTIONS = "ON_START_GET_FREEINPUT_ARTIKEL_AFID_LIST_FILTER_OPTIONS";
export const ON_GET_FREEINPUT_ARTIKEL_AFID_LIST_FILTER_OPTIONS = "ON_GET_FREEINPUT_ARTIKEL_AFID_LIST_FILTER_OPTIONS";
export const ON_ERROR_FREEINPUT_ARTIKEL_AFID_LIST_FILTER_OPTIONS = "ON_ERROR_FREEINPUT_ARTIKEL_AFID_LIST_FILTER_OPTIONS";
//
export const ON_START_ADD_KD_DIALER_NEWLINE = "ON_START_ADD_KD_DIALER_NEWLINE";
export const ON_ADD_KD_DIALER_NEWLINE = "ON_ADD_KD_DIALER_NEWLINE";
export const ON_ERROR_ADD_KD_DIALER_NEWLINE = "ON_ERROR_ADD_KD_DIALER_NEWLINE";
export const ON_START_FETCH_GET_KD_DIALER = "ON_START_FETCH_GET_KD_DIALER";
export const ON_FETCH_GET_KD_DIALER = "ON_FETCH_GET_KD_DIALER";
export const ON_ERROR_FETCH_GET_KD_DIALER = "ON_ERROR_FETCH_GET_KD_DIALER";
export const ON_UPPDATE_KD_DIALER_NEWLINE = "ON_UPPDATE_KD_DIALER_NEWLINE";
export const ON_ERROR_UPPDATE_KD_DIALER_NEWLINE = "ON_ERROR_UPPDATE_KD_DIALER_NEWLINE";
export const ON_DELETE_KD_DIALER_NEWLINE = "ON_DELETE_KD_DIALER_NEWLINE";
export const ON_ERROR_DELETE_KD_DIALER_NEWLINE = "ON_ERROR_DELETE_KD_DIALER_NEWLINE";
//
export const ON_START_GET_KUNDDATA_HEADER = "ON_START_GET_KUNDDATA_HEADER";
export const ON_GET_KUNDDATA_HEADER = "ON_GET_KUNDDATA_HEADER";
export const ON_ERROR_GET_KUNDDATA_HEADER = "ON_ERROR_GET_KUNDDATA_HEADER";
export const ON_START_GET_KUNDDATA_BYTYPE = "ON_START_GET_KUNDDATA_BYTYPE";
export const ON_GET_KUNDDATA_BYTYPE = "ON_GET_KUNDDATA_BYTYPE";
export const ON_ERROR_GET_KUNDDATA_BYTYPE = "ON_ERROR_GET_KUNDDATA_BYTYPE";
export const ON_START_DELETE_ROW_KUNDDATA_BYTYPE = "ON_START_DELETE_ROW_KUNDDATA_BYTYPE";
export const ON_DELETE_ROW_KUNDDATA_BYTYPE = "ON_DELETE_ROW_KUNDDATA_BYTYPE";
export const ON_ERROR_DELETE_ROW_KUNDDATA_BYTYPE = "ON_ERROR_DELETE_ROW_KUNDDATA_BYTYPE";
export const ON_SAVE_ROW_KUNDDATA_BYTYPE = "ON_SAVE_ROW_KUNDDATA_BYTYPE";
export const ON_START_SAVE_ROW_KUNDDATA_BYTYPE = "ON_START_SAVE_ROW_KUNDDATA_BYTYPE";
export const ON_SAVE_All_ROW_KUNDDATA_BYTYPE = "ON_SAVE_All_ROW_KUNDDATA_BYTYPE";
export const ON_START_DELETE_ROW_ALL_KUNDDATA_BYTYPE = "ON_START_DELETE_ROW_ALL_KUNDDATA_BYTYPE";
export const ON_DELETE_ROW_ALL_KUNDDATA_BYTYPE = "ON_DELETE_ROW_ALL_KUNDDATA_BYTYPE";
export const ON_START_DELETE_ALL_ROW_KUNDDATA_BYTYPE = "ON_START_DELETE_ALL_ROW_KUNDDATA_BYTYPE";
export const ON_DELETE_ALL_ROW_KUNDDATA_BYTYPE = "ON_DELETE_ALL_ROW_KUNDDATA_BYTYPE";
export const ON_ERROR_DELETE_ALL_ROW_KUNDDATA_BYTYPE = "ON_ERROR_DELETE_ALL_ROW_KUNDDATA_BYTYPE";
export const ON_START_CREATE_RINGLIST_FROM_KUNDDATA = "ON_START_CREATE_RINGLIST_FROM_KUNDDATA";
export const ON_CREATE_RINGLIST_FROM_KUNDDATA = "ON_CREATE_RINGLIST_FROM_KUNDDATA";
export const ON_ERROR_CREATE_RINGLIST_FROM_KUNDDATA = "ON_ERROR_CREATE_RINGLIST_FROM_KUNDDATA";
//
export const ON_START_GET_AVTALFORMULA = "ON_START_GET_AVTALFORMULA";
export const ON_GET_AVTALFORMULA = "ON_GET_AVTALFORMULA";
export const ON_ERROR_AVTALFORMULA = "ON_ERROR_AVTALFORMULA";
export const ON_START_UPDATE_AVTALFORMULA = "ON_START_UPDATE_AVTALFORMULA";
export const ON_UPDATE_AVTALFORMULA = "ON_UPDATE_AVTALFORMULA";
export const ON_ERROR_UPDATE_AVTALFORMULA = "ON_ERROR_UPDATE_AVTALFORMULA";
//
export const ON_START_CREATE_RINGLIST_FROM_AVTALSTID = "ON_START_CREATE_RINGLIST_FROM_AVTALSTID";
export const ON_CREATE_RINGLIST_FROM_AVTALSTID = "ON_CREATE_RINGLIST_FROM_AVTALSTID";
export const ON_ERROR_CREATE_RINGLIST_FROM_AVTALSTID = "ON_ERROR_CREATE_RINGLIST_FROM_AVTALSTID";
//
export const ON_START_GET_KUNDDATA_ALL_HEADER = "ON_START_GET_KUNDDATA_ALL_HEADER";
export const ON_GET_KUNDDATA_ALL_HEADER = "ON_GET_KUNDDATA_ALL_HEADER";
export const ON_ERROR_GET_KUNDDATA_ALL_HEADER = "ON_ERROR_GET_KUNDDATA_ALL_HEADER";
export const ON_START_GET_KUNDDATA_ALL_BYTYPE = "ON_START_GET_KUNDDATA_ALL_BYTYPE";
export const ON_GET_KUNDDATA_ALL_BYTYPE = "ON_GET_KUNDDATA_ALL_BYTYPE";
export const ON_ERROR_GET_KUNDDATA_ALL_BYTYPE = "ON_ERROR_GET_KUNDDATA_ALL_BYTYPE";
export const ON_START_GET_KUNDDATA_DIALER_ALL_BYTYPE = "ON_START_GET_KUNDDATA_DIALER_ALL_BYTYPE";
export const ON_GET_KUNDDATA_DIALER_ALL_BYTYPE = "ON_GET_KUNDDATA_DIALER_ALL_BYTYPE";
export const ON_ERROR_GET_KUNDDATA_DIALER_ALL_BYTYPE = "ON_ERROR_GET_KUNDDATA_DIALER_ALL_BYTYPE";
export const ON_START_SAVE_ROW_KUNDDATA_DIALER_BYTYPE = "ON_START_SAVE_ROW_KUNDDATA_DIALER_BYTYPE";
export const ON_SAVE_All_ROW_KUNDDATA_DIALER_BYTYPE = "ON_SAVE_All_ROW_KUNDDATA_DIALER_BYTYPE";
export const ON_ERROR_GET_KUNDDATA_ALL_DIALER_BYTYPE = "ON_ERROR_GET_KUNDDATA_ALL_DIALER_BYTYPE";
//
export const ON_START_GET_NOTYFILE_USERS = "ON_START_GET_NOTYFILE_USERS";
export const ON_GET_NOTYFILE_USERS = "ON_GET_NOTYFILE_USERS";
export const ON_ERROR_GET_NOTYFILE_USERS = "ON_ERROR_GET_NOTYFILE_USERS";
//
export const ON_START_KUND_KUNDDATA_GET = "ON_START_KUND_KUNDDATA_GET";
export const ON_KUND_KUNDDATA_GET = "ON_KUND_KUNDDATA_GET";
export const ON_ERROR_KUND_KUNDDATA_GET = "ON_ERROR_KUND_KUNDDATA_GET";
//
export const ON_START_NEW_USER_VAXLE = "ON_START_NEW_USER_VAXLE";
export const ON_NEW_USER_VAXLE = "ON_NEW_USER_VAXLE";
export const ON_START_GET_USER_VAXLE = "ON_START_GET_USER_VAXLE";
export const ON_ERROR_NEW_USER_VAXLE = "ON_ERROR_NEW_USER_VAXLE";
//
export const PROJEKT_ON_START_GET_FORTNOX_INVOICES_PROJECT = "PROJEKT_ON_START_GET_FORTNOX_INVOICES_PROJECT";
export const PROJEKT_ON_GET_FORTNOX_INVOICES_PROJECT = "PROJEKT_ON_GET_FORTNOX_INVOICES_PROJECT";
export const PROJEKT_ON_ERROR_GET_FORTNOX_INVOICES_PROJECT = "PROJEKT_ON_ERROR_GET_FORTNOX_INVOICES_PROJECT";
export const PROJEKT_ON_START_GET_FORTNOX_PROJECT = "PROJEKT_ON_START_GET_FORTNOX_PROJECT";
export const PROJEKT_ON_GET_FORTNOX_PROJECT = "PROJEKT_ON_GET_FORTNOX_PROJECT";
export const PROJEKT_ON_ERROR_GET_FORTNOX_PROJECT = "PROJEKT_ON_ERROR_GET_FORTNOX_PROJECT";
//
export const ON_START_GET_HOGIA_OFFICES = "ON_START_GET_HOGIA_OFFICES";
export const ON_GET_HOGIA_OFFICES = "ON_GET_HOGIA_OFFICES";
export const ON_ERROR_GET_HOGIA_OFFICES = "ON_ERROR_GET_HOGIA_OFFICES";
//
export const ON_START_ESIGNERING_NEW_FREEIPUT = "ON_START_ESIGNERING_NEW_FREEIPUT";
export const ON_ESIGNERING_NEW_FREEIPUT = "ON_ESIGNERING_NEW_FREEIPUT";
export const ON_ERROR_ESIGNERING_NEW_FREEIPUT = "ON_ERROR_ESIGNERING_NEW_FREEIPUT";
export const ON_START_ESIGNERING_DELETE_FREEIPUT = "ON_START_ESIGNERING_DELETE_FREEIPUT";
export const ON_ESIGNERING_DELETE_FREEIPUT = "ON_ESIGNERING_DELETE_FREEIPUT";
export const ON_ERROR_ESIGNERING_DELETE_FREEIPUT = "ON_ERROR_ESIGNERING_DELETE_FREEIPUT";
export const ON_START_ESIGNERING_EDIT_FREEIPUT = "ON_START_ESIGNERING_EDIT_FREEIPUT";
export const ON_ESIGNERING_EDIT_FREEIPUT = "ON_ESIGNERING_EDIT_FREEIPUT";
export const ON_ERROR_ESIGNERING_EDIT_FREEIPUT = "ON_ERROR_ESIGNERING_EDIT_FREEIPUT";
//
export const ON_START_NEW_ESIGNERING_FREE_SETTING_AF = "ON_START_NEW_ESIGNERING_FREE_SETTING_AF";
export const ON_NEW_ESIGNERING_FREE_SETTING_AF = "ON_NEW_ESIGNERING_FREE_SETTING_AF";
export const ON_ERROR_NEW_ESIGNERING_FREE_SETTING_AF = "ON_ERROR_NEW_ESIGNERING_FREE_SETTING_AF";
export const ON_START_GET_ESIGNERING_FREE_SETTING_AF = "ON_START_GET_ESIGNERING_FREE_SETTING_AF";
export const ON_GET_ESIGNERING_FREE_SETTING_AF = "ON_GET_ESIGNERING_FREE_SETTING_AF";
export const ON_ERROR_GET_ESIGNERING_FREE_SETTING_AF = "ON_ERROR_GET_ESIGNERING_FREE_SETTING_AF";
export const ON_START_DELETE_ESIGNERING_FREE_SETTING_AF = "ON_START_DELETE_ESIGNERING_FREE_SETTING_AF";
export const ON_DELETE_ESIGNERING_FREE_SETTING_AF = "ON_DELETE_ESIGNERING_FREE_SETTING_AF";
export const ON_ERROR_DELETE_ESIGNERING_FREE_SETTING_AF = "ON_ERROR_DELETE_ESIGNERING_FREE_SETTING_AF";
export const ON_START_UPDATE_ESIGNERING_FREE_SETTING_AF = "ON_START_UPDATE_ESIGNERING_FREE_SETTING_AF";
export const ON_UPDATE_ESIGNERING_FREE_SETTING_AF = "ON_UPDATE_ESIGNERING_FREE_SETTING_AF";
export const ON_ERROR_UPDATE_ESIGNERING_FREE_SETTING_AF = "ON_ERROR_UPDATE_ESIGNERING_FREE_SETTING_AF";
//
export const ON_START_GET_DOWN_FILE = "ON_START_GET_DOWN_FILE";
export const ON_GET_DOWN_FILE = "ON_GET_DOWN_FILE";
export const ON_ERROR_GET_DOWN_FILE = "ON_ERROR_GET_DOWN_FILE";
export const ON_START_FETCH_KAMPANJ_KUND_PER = "ON_START_FETCH_KAMPANJ_KUND_PER";
//ON_GET_KUND_MOTE_ANTAL
export const ON_GET_KUND_MOTE_ANTAL = "ON_GET_KUND_MOTE_ANTAL";
//
export const ON_START_UPDATE_ORDER_AFFAR_FROM_AF = "ON_START_UPDATE_ORDER_AFFAR_FROM_AF";
export const ON_UPDATE_ORDER_AFFAR_FROM_AF = "ON_UPDATE_ORDER_AFFAR_FROM_AF";
export const ON_START_NEW_ORDER_AFFAR_FROM_AF = "ON_START_NEW_ORDER_AFFAR_FROM_AF";
export const ON_NEW_ORDER_AFFAR_FROM_AF = "ON_NEW_ORDER_AFFAR_FROM_AF";
export const ON_ERROR_ORDER_AFFAR_FROM_AF = "ON_ERROR_ORDER_AFFAR_FROM_AF";
export const ON_START_GET_ORDER_AFFAR_FROM_AF = "ON_START_GET_ORDER_AFFAR_FROM_AF";
export const ON_GET_ORDER_AFFAR_FROM_AF = "ON_GET_ORDER_AFFAR_FROM_AF";
export const ON_ERROR_GET_ORDER_AFFAR_FROM_AF = "ON_ERROR_GET_ORDER_AFFAR_FROM_AF";
//
export const ON_START_GET_ORDER_SETTING_AF = "ON_START_GET_ORDER_SETTING_AF";
export const ON_GET_ORDER_SETTING_AF = "ON_GET_ORDER_SETTING_AF";
export const ON_ERROR_GET_ORDER_SETTING_AF = "ON_ERROR_GET_ORDER_SETTING_AF";
export const ON_START_UPDATE_ORDER_SETTING_AF = "ON_START_UPDATE_ORDER_SETTING_AF";
export const ON_UPDATE_ORDER_SETTING_AF = "ON_UPDATE_ORDER_SETTING_AF";
export const ON_ERROR_UPDATE_ORDER_SETTING_AF = "ON_ERROR_UPDATE_ORDER_SETTING_AF";
//
export const ON_START_GET_LOBBY_SETTING_AF = "ON_START_GET_LOBBY_SETTING_AF";
export const ON_GET_LOBBY_SETTING_AF = "ON_GET_LOBBY_SETTING_AF";
export const ON_ERROR_GET_LOBBY_SETTING_AF = "ON_ERROR_GET_LOBBY_SETTING_AF";
export const ON_START_UPDATE_LOBBY_SETTING_AF = "ON_START_UPDATE_LOBBY_SETTING_AF";
export const ON_UPDATE_LOBBY_SETTING_AF = "ON_UPDATE_LOBBY_SETTING_AF";
export const ON_ERROR_UPDATE_LOBBY_SETTING_AF = "ON_ERROR_UPDATE_LOBBY_SETTING_AF";
//ON_START_STATISTIC_TOTALORDER,GET_STATISTIC_TOTALORDER,ERROR_STATISTIC_TOTALORDER,
export const ON_START_STATISTIC_TOTALORDER = "ON_START_STATISTIC_TOTALORDER";
export const GET_STATISTIC_TOTALORDER = "GET_STATISTIC_TOTALORDER";
export const ERROR_STATISTIC_TOTALORDER = "ERROR_STATISTIC_TOTALORDER";
//ON_START_STATISTIC_TOTALMOTEN,GET_STATISTIC_TOTALMOTE,ERROR_STATISTIC_TOTALMOTE,
export const ON_START_STATISTIC_TOTALMOTEN = "ON_START_STATISTIC_TOTALMOTEN";
export const GET_STATISTIC_TOTALMOTE = "GET_STATISTIC_TOTALMOTE";
export const ERROR_STATISTIC_TOTALMOTE = "ERROR_STATISTIC_TOTALMOTE";
//ON_START_STATISTIC_TOTALAKTIVITETER, GET_STATISTIC_TOTALAKTIVITETER, ERROR_STATISTIC_TOTALAKTIVITETER
export const ON_START_STATISTIC_TOTALAKTIVITETER = "ON_START_STATISTIC_TOTALAKTIVITETER";
export const GET_STATISTIC_TOTALAKTIVITETER = "GET_STATISTIC_TOTALAKTIVITETER";
export const ERROR_STATISTIC_TOTALAKTIVITETER = "ERROR_STATISTIC_TOTALAKTIVITETER";
//ON_START_STATISTIC_TOTALOFFERT,GET_STATISTIC_TOTALOFFERT,ERROR_STATISTIC_TOTALOFFERT
export const ON_START_STATISTIC_TOTALOFFERT = "ON_START_STATISTIC_TOTALOFFERT";
export const GET_STATISTIC_TOTALOFFERT = "GET_STATISTIC_TOTALOFFERT";
export const ERROR_STATISTIC_TOTALOFFERT = "ERROR_STATISTIC_TOTALOFFERT";
//ON_START_STATISTIC_LOPANDEINTAKT_TOTAL, GET_STATISTIC_LOPANDEINTAKT_TOTAL, ERROR_STATISTIC_LOPANDEINTAKT_TOTAL
export const ON_START_STATISTIC_LOPANDEINTAKT_TOTAL = "ON_START_STATISTIC_LOPANDEINTAKT_TOTAL";
export const GET_STATISTIC_LOPANDEINTAKT_TOTAL = "GET_STATISTIC_LOPANDEINTAKT_TOTAL";
export const ERROR_STATISTIC_LOPANDEINTAKT_TOTAL = "ERROR_STATISTIC_LOPANDEINTAKT_TOTAL";
//ON_START_STATISTIC_ORDERTYP_TOTAL, GET_STATISTIC_ORDERTYP_TOTAL, ERROR_STATISTIC_ORDERTYP_TOTAL,
export const ON_START_STATISTIC_ORDERTYP_TOTAL = "ON_START_STATISTIC_ORDERTYP_TOTAL";
export const GET_STATISTIC_ORDERTYP_TOTAL = "GET_STATISTIC_ORDERTYP_TOTAL";
export const ERROR_STATISTIC_ORDERTYP_TOTAL = "ERROR_STATISTIC_ORDERTYP_TOTAL";
//ON_START_STATISTIC_SALES_TOTAL, GET_STATISTIC_SALES_TOTAL, ERROR_STATISTIC_SALES_TOTAL
export const ON_START_STATISTIC_SALES_TOTAL = "ON_START_STATISTIC_SALES_TOTAL";
export const GET_STATISTIC_SALES_TOTAL = "GET_STATISTIC_SALES_TOTAL";
export const ERROR_STATISTIC_SALES_TOTAL = "ERROR_STATISTIC_SALES_TOTAL";
//
export const ON_SET_NULL_MESSAGE_DIALER = "ON_SET_NULL_MESSAGE_DIALER";
export const ON_SET_NULL_EVENT_DIALER = "ON_SET_NULL_EVENT_DIALER";
export const ON_SET_NULL_NOACCESS_DIALER = "ON_SET_NULL_NOACCESS_DIALER";
//
export const ON_START_GET_SVEACREDIT = "ON_START_GET_SVEACREDIT";
export const ON_GET_SVEACREDIT = "ON_GET_SVEACREDIT";
export const ON_ERROR_GET_SVEACREDIT = "ON_ERROR_GET_SVEACREDIT";
export const ON_START_BESTALLA_SVEACREDIT = "ON_START_BESTALLA_SVEACREDIT";
export const ON_BESTALLA_SVEACREDIT = "ON_BESTALLA_SVEACREDIT";
export const ON_ERROR_BESTALLA_SVEACREDIT = "ON_ERROR_BESTALLA_SVEACREDIT";
export const ON_START_GET_ALL_SVEACREDIT_ALLOW_USER = "ON_START_GET_ALL_SVEACREDIT_ALLOW_USER";
export const ON_GET_ALL_SVEACREDIT_ALLOW_USER = "ON_GET_ALL_SVEACREDIT_ALLOW_USER";
export const ON_ERROR_GET_ALL_SVEACREDIT_ALLOW_USER = "ON_ERROR_GET_ALL_SVEACREDIT_ALLOW_USER";
export const ON_START_SVEACREDIT_AKTIVE_ALLOW_USER = "ON_START_SVEACREDIT_AKTIVE_ALLOW_USER";
export const ON_SVEACREDIT_AKTIVE_ALLOW_USER = "ON_SVEACREDIT_AKTIVE_ALLOW_USER";
export const ON_ERROR_SVEACREDIT_AKTIVE_ALLOW_USER = "ON_ERROR_SVEACREDIT_AKTIVE_ALLOW_USER";
export const ON_START_SVEACREDIT_ALLOW_USER = "ON_START_SVEACREDIT_ALLOW_USER";
export const ON_SVEACREDIT_ALLOW_USER = "ON_SVEACREDIT_ALLOW_USER";
export const ON_ERROR_SVEACREDIT_ALLOW_USER = "ON_ERROR_SVEACREDIT_ALLOW_USER";
export const ON_START_GET_LAST_SVEACREDIT = "ON_START_GET_LAST_SVEACREDIT";
export const ON_GET_LAST_SVEACREDIT = "ON_GET_LAST_SVEACREDIT";
export const ON_ERROR_GET_LAST_SVEACREDIT = "ON_ERROR_GET_LAST_SVEACREDIT";
export const ON_START_SEND_SVEACREDIT = "ON_START_SEND_SVEACREDIT";
export const ON_SEND_SVEACREDIT = "ON_SEND_SVEACREDIT";
export const ON_ERROR_SEND_SVEACREDIT = "ON_ERROR_SEND_SVEACREDIT";
//
export const ON_START_GET_CREDITSAFE = "ON_START_GET_CREDITSAFE";
export const ON_GET_CREDITSAFE = "ON_GET_CREDITSAFE";
export const ON_ERROR_GET_CREDITSAFE = "ON_ERROR_GET_CREDITSAFE";
export const ON_START_BESTALLA_CREDITSAFE = "ON_START_BESTALLA_CREDITSAFE";
export const ON_BESTALLA_CREDITSAFE = "ON_BESTALLA_CREDITSAFE";
export const ON_ERROR_BESTALLA_CREDITSAFE = "ON_ERROR_BESTALLA_CREDITSAFE";
export const ON_START_SEND_CREDITSAFE = "ON_START_SEND_CREDITSAFE";
export const ON_SEND_CREDITSAFE = "ON_SEND_CREDITSAFE";
export const ON_ERROR_SEND_CREDITSAFE = "ON_ERROR_SEND_CREDITSAFE";
export const ON_START_CREDITSAFE_ALLOW_USER = "ON_START_CREDITSAFE_ALLOW_USER";
export const ON_CREDITSAFE_ALLOW_USER = "ON_CREDITSAFE_ALLOW_USER";
export const ON_ERROR_CREDITSAFE_ALLOW_USER = "ON_ERROR_CREDITSAFE_ALLOW_USER";
export const ON_START_GET_ALL_CREDITSAFE_ALLOW_USER = "ON_START_GET_ALL_CREDITSAFE_ALLOW_USER";
export const ON_GET_ALL_CREDITSAFE_ALLOW_USER = "ON_GET_ALL_CREDITSAFE_ALLOW_USER";
export const ON_ERROR_GET_ALL_CREDITSAFE_ALLOW_USER = "ON_ERROR_GET_ALL_CREDITSAFE_ALLOW_USER";
export const ON_START_CREDITSAFE_AKTIVE_ALLOW_USER = "ON_START_CREDITSAFE_AKTIVE_ALLOW_USER";
export const ON_CREDITSAFE_AKTIVE_ALLOW_USER = "ON_CREDITSAFE_AKTIVE_ALLOW_USER";
export const ON_ERROR_CREDITSAFE_AKTIVE_ALLOW_USER = "ON_ERROR_CREDITSAFE_AKTIVE_ALLOW_USER";
export const ON_START_GET_ALL_CREDITSAFE_CREDIT_RES = "ON_START_GET_ALL_CREDITSAFE_CREDIT_RES";
export const ON_GET_ALL_CREDITSAFE_CREDIT_RES = "ON_GET_ALL_CREDITSAFE_CREDIT_RES";
export const ON_ERROR_GET_ALL_CREDITSAFE_CREDIT_RES = "ON_ERROR_GET_ALL_CREDITSAFE_CREDIT_RES";
export const ON_START_SEND_CREDITSAFE_CR = "ON_START_SEND_CREDITSAFE_CR";
export const ON_ERROR_SEND_CREDITSAFE_CR = "ON_ERROR_SEND_CREDITSAFE_CR";
export const ON_RESET_CREDITSAFE = "ON_RESET_CREDITSAFE";
export const ON_START_GET_LAST_CREDIT = "ON_START_GET_LAST_CREDIT";
export const ON_GET_LAST_CREDIT = "ON_GET_LAST_CREDIT";
export const ON_ERROR_GET_LAST_CREDIT = "ON_ERROR_GET_LAST_CREDIT";
export const ON_START_GET_RPS_CREDIT = "ON_START_GET_RPS_CREDIT";
export const ON_GET_RPS_CREDIT = "ON_GET_RPS_CREDIT";
export const ON_ERROR_GET_RPS_CREDIT = "ON_ERROR_GET_RPS_CREDIT";
//
export const SET_EVENTVY_PAGE_ROWS = "SET_EVENTVY_PAGE_ROWS";
export const SET_ESIGNVY_PAGE_ROWS = "SET_ESIGNVY_PAGE_ROWS";
//SET_AVTALVY_TYPE
export const SET_AVTALVY_TYPE = "SET_AVTALVY_TYPE";
export const UNSET_AVTALVY_TYPE = "UNSET_AVTALVY_TYPE";
export const SET_ORDERVY_TYPE = "SET_ORDERVY_TYPE";
export const UNSET_ORDERVY_TYPE = "UNSET_AVTALVY_TYPE";
export const SET_EVENTVY_TYPE = "SET_EVENTVY_TYPE";
export const UNSET_EVENTVY_TYPE = "UNSET_EVENTVY_TYPE";
export const SET_ESIGNVY_TYPE = "SET_ESIGNVY_TYPE";
export const UNSET_ESIGNVY_TYPE = "UNSET_ESIGNVY_TYPE";
export const UNSET_ARTIKLARVY_TYPE = "UNSET_ARTIKLARVY_TYPE";
export const ON_START_GET_EVENT_DOKUMENT = "ON_START_GET_EVENT_DOKUMENT";
export const ON_GET_EVENT_DOKUMENT = "ON_GET_EVENT_DOKUMENT";
export const ON_ERROR_GET_EVENT_DOKUMENT = "ON_ERROR_GET_EVENT_DOKUMENT";
//ON_START_FETCH_GET_NEXT_KUND, ON_FETCH_GET_NEXT_KUND, ON_ERROR_FETCH_GET_NEXT_KUND,
export const ON_START_FETCH_GET_NEXT_KUND = "ON_START_FETCH_GET_NEXT_KUND";
export const ON_FETCH_GET_NEXT_KUND = "ON_FETCH_GET_NEXT_KUND";
export const ON_ERROR_FETCH_GET_NEXT_KUND = "ON_ERROR_FETCH_GET_NEXT_KUND";
export const ON_FETCH_GET_NEXT_KUND_1 = "ON_FETCH_GET_NEXT_KUND_1";
export const ON_FETCH_GET_NEXT_KUND_2 = "ON_FETCH_GET_NEXT_KUND_2";
export const ON_START_FETCH_GET_NEXT_KUND_2 = "ON_START_FETCH_GET_NEXT_KUND_2";
export const ON_START_FETCH_GET_NEXT_KUND_1 = "ON_START_FETCH_GET_NEXT_KUND_1";
//
export const ON_START_SEND_ESIGNERIGN_REMAINDER = "ON_START_SEND_ESIGNERIGN_REMAINDER";
export const ON_SEND_ESIGNERIGN_REMAINDER = "ON_SEND_ESIGNERIGN_REMAINDER";
export const ON_ERROR_SEND_ESIGNERIGN_REMAINDER = "ON_ERROR_SEND_ESIGNERIGN_REMAINDER";
//
export const ON_START_ADD_ESIGNERIGN_ATTAC_FILE = "ON_START_ADD_ESIGNERIGN_ATTAC_FILE";
export const ON_ADD_ESIGNERIGN_ATTAC_FILE = "ON_ADD_ESIGNERIGN_ATTAC_FILE";
export const ON_ERROR_ADD_ESIGNERIGN_ATTAC_FILE = "ON_ERROR_ADD_ESIGNERIGN_ATTAC_FILE";
//
export const ON_START_DEL_ATT_FILE = "ON_START_DEL_ATT_FILE";
export const ON_DEL_ATT_FILE = "ON_DEL_ATT_FILE";
export const ON_ERROR_DEL_ATT_FILE = "ON_ERROR_DEL_ATT_FILE";
//
export const ON_START_FORTNOX_TERMOFPAY_GET = "ON_START_FORTNOX_TERMOFPAY_GET";
export const ON_FORTNOX_TERMOFPAY_GET = "ON_FORTNOX_TERMOFPAY_GET";
export const ON_ERROR_FORTNOX_TERMOFPAY_GET = "ON_ERROR_FORTNOX_TERMOFPAY_GET";
//
export const ON_START_FORTNOX_PRISLISTOR_GET = "ON_START_FORTNOX_PRISLISTOR_GET";
export const ON_FORTNOX_PRISLISTOR_GET = "ON_FORTNOX_PRISLISTOR_GET";
export const ON_ERROR_FORTNOX_PRISLISTOR_GET = "ON_ERROR_FORTNOX_PRISLISTOR_GET";
export const ON_START_FORTNOX_WAYOFDELIVERY_GET = "ON_START_FORTNOX_WAYOFDELIVERY_GET";
export const ON_FORTNOX_WAYOFDELIVERY_GET = "ON_FORTNOX_WAYOFDELIVERY_GET";
export const ON_ERROR_FORTNOX_WAYOFDELIVERY_GET = "ON_ERROR_FORTNOX_WAYOFDELIVERY_GET";
export const ON_START_FORTNOX_TERMSOFDELIVERY_GET = "ON_START_FORTNOX_TERMSOFDELIVERY_GET";
export const ON_FORTNOX_TERMSOFDELIVERY_GET = "ON_FORTNOX_TERMSOFDELIVERY_GET";
export const ON_ERROR_FORTNOX_TERMSOFDELIVERY_GET = "ON_ERROR_FORTNOX_TERMSOFDELIVERY_GET";
//
export const ON_START_CHECK_FORTNOX = "ON_START_CHECK_FORTNOX";
export const ON_GET_CHECK_FORTNOX = "ON_GET_CHECK_FORTNOX";
export const ON_ERROR_GET_CHECK_FORTNOX = "ON_ERROR_GET_CHECK_FORTNOX";
//
export const ON_START_GET_SIG_FILE = "ON_START_GET_SIG_FILE";
export const ON_GET_SIG_FILE = "ON_GET_SIG_FILE";
export const ON_ERROR_GET_SIG_FILE = "ON_ERROR_GET_SIG_FILE";
//
export const ON_START_FORTNOX_TEMPLATE_GET = "ON_START_FORTNOX_TEMPLATE_GET";
export const ON_FORTNOX_TEMPLATE_GET = "ON_FORTNOX_TEMPLATE_GET";
export const ON_ERROR_FORTNOX_TEMPLATE_GET = "ON_ERROR_FORTNOX_TEMPLATE_GET";
export const ON_START_FORTNOX_PROJEKT_GET = "ON_START_FORTNOX_PROJEKT_GET";
export const ON_FORTNOX_PROJEKT_GET = "ON_FORTNOX_PROJEKT_GET";
export const ON_ERROR_FORTNOX_PROJEKT_GET = "ON_ERROR_FORTNOX_PROJEKT_GET";
export const ON_START_FORTNOX_TERMOFPAYMENTS_GET = "ON_START_FORTNOX_TERMOFPAYMENTS_GET";
export const ON_FORTNOX_TERMOFPAYMENTS_GET = "ON_FORTNOX_TERMOFPAYMENTS_GET";
export const ON_ERROR_FORTNOX_TERMOFPAYMENTS_GET = "ON_ERROR_FORTNOX_TERMOFPAYMENTS_GET";
export const ON_START_FORTNOX_ATTACHMENTS_GET = "ON_START_FORTNOX_ATTACHMENTS_GET";
export const ON_FORTNOX_ATTACHMENTS_GET = "ON_FORTNOX_ATTACHMENTS_GET";
export const ON_ERROR_FORTNOX_ATTACHMENTS_GET = "ON_ERROR_FORTNOX_ATTACHMENTS_GET";
//
export const ON_START_FETCH_GET_BLACKLIST_LIST = "ON_START_FETCH_GET_BLACKLIST_LIST";
export const ON_FETCH_GET_BLACKLIST_LIST = "ON_FETCH_GET_BLACKLIST_LIST";
export const ON_ERROR_FETCH_GET_BLACKLIST_LIST = "ON_ERROR_FETCH_GET_BLACKLIST_LIST";
//
export const ON_START_FORTNOX_SEND_ORDER = "ON_START_FORTNOX_SEND_ORDER";
export const ON_FORTNOX_SEND_ORDER = "ON_FORTNOX_SEND_ORDER";
export const ON_ERROR_FORTNOX_SEND_ORDER = "ON_ERROR_FORTNOX_SEND_ORDER";
export const ON_START_FORTNOX_CANCEL_ORDER = "ON_START_FORTNOX_CANCEL_ORDER";
export const ON_FORTNOX_CANCEL_ORDER = "ON_FORTNOX_CANCEL_ORDER";
export const ON_ERROR_FORTNOX_CANCEL_ORDER = "ON_ERROR_FORTNOX_CANCEL_ORDER";
//
export const ON_START_GET_DONT_HA_PL_CHILD = "ON_START_GET_DONT_HA_PL_CHILD";
export const ON_GET_DONT_HA_PL_CHILD = "ON_GET_DONT_HA_PL_CHILD";
export const ON_ERROR_GET_DONT_HA_PL_CHILD = "ON_ERROR_GET_DONT_HA_PL_CHILD";
//
export const ON_START_DELETE_HANDELSE_LOGG = "ON_START_DELETE_HANDELSE_LOGG";
export const ON_DELETE_HANDELSE_LOGG = "ON_DELETE_HANDELSE_LOGG";
export const ON_ERROR_DELETE_HANDELSE_LOGG = "ON_ERROR_DELETE_HANDELSE_LOGG";
export const ON_START_EDIT_HANDELSE_LOGG = "ON_START_EDIT_HANDELSE_LOGG";
export const ON_EDIT_HANDELSE_LOGG = "ON_EDIT_HANDELSE_LOGG";
export const ON_ERROR_START_EDIT_HANDELSE_LOGG = "ON_ERROR_START_EDIT_HANDELSE_LOGG";
//
export const ON_RESET_CURRENT_OBJEKT_FALT = "ON_RESET_CURRENT_OBJEKT_FALT";
export const ON_GET_KUNDER_PAGE_BASIC = "ON_GET_KUNDER_PAGE_BASIC";
export const ON_GET_KUNDER_PAGE_ROWS_BASIC = "ON_GET_KUNDER_PAGE_ROWS_BASIC";
export const ON_GET_KUNDER_SEARCH_BASIC = "ON_GET_KUNDER_SEARCH_BASIC";
export const ON_GET_KONTAKT_PAGE_BASIC = "ON_GET_KONTAKT_PAGE_BASIC";
export const ON_GET_KUND_TABINDEX = "ON_GET_KUND_TABINDEX";
export const ON_GET_KUND_SORTOBJ = "ON_GET_KUND_SORTOBJ";
export const ON_GET_ORDER_PAGE_BASIC = "ON_GET_ORDER_PAGE_BASIC";
export const ON_GET_ORDER_PAGEROWS_BASIC = "ON_GET_ORDER_PAGEROWS_BASIC";
export const ON_GET_AVTAL_PAGE_BASIC = "ON_GET_AVTAL_PAGE_BASIC";
export const ON_GET_ARENDE_PAGE_BASIC = "ON_GET_ARENDE_PAGE_BASIC";
export const ON_GET_ARENDE_FILTER_BASIC = "ON_GET_ARENDE_FILTER_BASIC";
export const ON_GET_ARTIKLAR_PAGE_BASIC = "ON_GET_ARTIKLAR_PAGE_BASIC";
export const ON_GET_OFFERT_PAGE_BASIC = "ON_GET_OFFERT_PAGE_BASIC";
//
export const ON_GET_OFFERT_PAGE_SIZE_BASIC = "ON_GET_OFFERT_PAGE_SIZE_BASIC";

//Child
export const FETCH_START_SAVE_NEW_CHILD = "FETCH_START_SAVE_NEW_CHILD";
export const ON_SAVE_NEW_CHILD = "ON_SAVE_NEW_CHILD";
export const ON_ERROR_SAVE_NEW_CHILD = "ON_ERROR_SAVE_NEW_CHILD";
export const ON_START_GET_CHILD = "ON_START_GET_CHILD";
export const ON_GET_CHILD = "ON_GET_CHILD";
export const ON_ERROR_GET_CHILD = "ON_ERROR_GET_CHILD";
export const ON_START_DELETE_AFID_CHILD = "ON_START_DELETE_AFID_CHILD";
export const ON_DELETE_AFID_CHILD = "ON_DELETE_AFID_CHILD";
export const ON_ERROR_DELETE_AFID_CHILD = "ON_ERROR_DELETE_AFID_CHILD";
export const FETCH_START_SAVE_BLTYPE_CHILD = "FETCH_START_SAVE_BLTYPE_CHILD";
export const ON_SAVE_BLTYPE_CHILD = "ON_SAVE_BLTYPE_CHILD";
export const ON_SAVE_CCTYPE_CHILD = "ON_SAVE_CCTYPE_CHILD";
export const ON_ERROR_SAVE_BLTYPE_CHILD = "ON_ERROR_SAVE_BLTYPE_CHILD";
export const ON_START_CHILD_KONTO_AVTALTYPER_GET = "ON_START_CHILD_KONTO_AVTALTYPER_GET";
export const ON_CHILD_KONTO_AVTALTYPER_GET = "ON_CHILD_KONTO_AVTALTYPER_GET";
export const ON_ERROR_CHILD_KONTO_AVTALTYPER_GET = "ON_ERROR_CHILD_KONTO_AVTALTYPER_GET";
export const FETCH_START_SAVE_FNTYPE_CHILD = "FETCH_START_SAVE_FNTYPE_CHILD";
export const ON_SAVE_FNTYPE_CHILD = "ON_SAVE_FNTYPE_CHILD";
export const ON_ERROR_SAVE_FNTYPE_CHILD = "ON_ERROR_SAVE_FNTYPE_CHILD";
export const FETCH_START_SAVE_CLTYPE_CHILD = "FETCH_START_SAVE_CLTYPE_CHILD";
export const ON_SAVE_CLTYPE_CHILD = "ON_SAVE_CLTYPE_CHILD";
export const ON_ERROR_SAVE_CLTYPE_CHILD = "ON_ERROR_SAVE_CLTYPE_CHILD";
export const FETCH_START_SAVE_CATYPE_CHILD = "FETCH_START_SAVE_CATYPE_CHILD";
export const ON_SAVE_CATYPE_CHILD = "ON_SAVE_CATYPE_CHILD";
export const ON_ERROR_SAVE_CATYPE_CHILD = "ON_ERROR_SAVE_CATYPE_CHILD";
//
export const ON_START_GET_ORDER_USER_HV = "ON_START_GET_ORDER_USER_HV";
export const ON_GET_ORDER_USER_HV = "ON_GET_ORDER_USER_HV";
export const ON_ERROR_ORDER_USER_HV = "ON_ERROR_ORDER_USER_HV";
//
export const ON_START_GET_USER_KUND_TABLE_COLUMN = "ON_START_GET_USER_KUND_TABLE_COLUMN"
export const ON_ERROR_GET_USER_KUND_TABLE_COLUMN = "ON_ERROR_GET_USER_KUND_TABLE_COLUMN"
export const ON_GET_USER_KUND_TABLE_COLUMN = "ON_GET_USER_KUND_TABLE_COLUMN"
export const ON_START_UPDATE_USER_KUND_TABLE_COLUMN = "ON_START_UPDATE_USER_KUND_TABLE_COLUMN"
export const ON_ERROR_UPDATE_USER_KUND_TABLE_COLUMN = "ON_ERROR_UPDATE_USER_KUND_TABLE_COLUMN"
export const ON_UPDATE_USER_KUND_TABLE_COLUMN = "ON_UPDATE_USER_KUND_TABLE_COLUMN"

export const ON_START_GET_USER_OFFERT_ART_TABLE_COLUMN = "ON_START_GET_USER_OFFERT_ART_TABLE_COLUMN"
export const ON_ERROR_GET_USER_OFFERT_ART_TABLE_COLUMN = "ON_ERROR_GET_USER_OFFERT_ART_TABLE_COLUMN"
export const ON_GET_USER_OFFERT_ART_TABLE_COLUMN = "ON_GET_USER_OFFERT_ART_TABLE_COLUMN"
export const ON_START_UPDATE_USER_OFFERT_ART_TABLE_COLUMN = "ON_START_UPDATE_USER_OFFERT_ART_TABLE_COLUMN"
export const ON_ERROR_UPDATE_USER_OFFERT_ART_TABLE_COLUMN = "ON_ERROR_UPDATE_USER_OFFERT_ART_TABLE_COLUMN"
export const ON_UPDATE_USER_OFFERT_ART_TABLE_COLUMN = "ON_UPDATE_USER_OFFERT_ART_TABLE_COLUMN"

//Child Konto
export const ON_START_CHILD_KONTO_GET = "ON_START_CHILD_KONTO_GET";
export const ON_CHILD_KONTO_GET = "ON_CHILD_KONTO_GET";
export const ON_ERROR_CHILD_KONTO_GET = "ON_ERROR_CHILD_KONTO_GET";
export const ON_START_CHILD_KONTO_USERS_GET = "ON_START_CHILD_KONTO_USERS_GET";
export const ON_START_CHILD_KONTO_OFFICES_GET = "ON_START_CHILD_KONTO_OFFICES_GET";
export const ON_CHILD_KONTO_OFFICES_GET = "ON_CHILD_KONTO_OFFICES_GET";
export const ON_ERROR_CHILD_KONTO_OFFICES_GET = "ON_ERROR_CHILD_KONTO_OFFICES_GET";
export const ON_START_CHILD_KONTO_TEAMS_GET = "ON_START_CHILD_KONTO_TEAMS_GET";
export const ON_CHILD_KONTO_TEAMS_GET = "ON_CHILD_KONTO_TEAMS_GET";
export const ON_ERROR_CHILD_KONTO_TEAMS_GET = "ON_ERROR_CHILD_KONTO_TEAMS_GET";
export const ON_START_CHILD_KONTO_TEAM_SGET_ALL = "ON_START_CHILD_KONTO_TEAM_SGET_ALL";
export const ON_CHILD_KONTO_TEAMS_GET_ALL = "ON_CHILD_KONTO_TEAMS_GET_ALL";
export const ON_ERROR_CHILD_KONTO_TEAMS_GET_ALL = "ON_ERROR_CHILD_KONTO_TEAMS_GET_ALL";
export const ON_START_CHILD_KONTO_KONTOR_GET = "ON_START_CHILD_KONTO_KONTOR_GET";
export const ON_CHILD_KONTO_KONTOR_GET = "ON_CHILD_KONTO_KONTOR_GET";
export const ON_ERROR_CHILD_KONTO_KONTOR_GET = "ON_ERROR_CHILD_KONTO_KONTOR_GET";
//
export const ON_CHILD_KONTO_USERS_GET = "ON_CHILD_KONTO_USERS_GET";
export const ON_ERROR_CHILD_KONTO_USERS_GET = "ON_ERROR_CHILD_KONTO_USERS_GET";
export const ON_START_CHILD_KONTO_USERS_ALL_GET = "ON_START_CHILD_KONTO_USERS_ALL_GET";
export const ON_CHILD_KONTO_USERS_ALL_GET = "ON_CHILD_KONTO_USERS_ALL_GET";
export const ON_ERROR_CHILD_KONTO_ALL_USERS_GET = "ON_ERROR_CHILD_KONTO_ALL_USERS_GET";
//
export const ON_START_GET_MINA_DOCUMENT_LIST = "ON_START_GET_MINA_DOCUMENT_LIST";
export const ON_GET_MINA_DOCUMENT_LIST = "ON_GET_MINA_DOCUMENT_LIST";
export const ON_ERROR_GET_MINA_DOCUMENT_LIST = "ON_ERROR_GET_MINA_DOCUMENT_LIST";
export const ON_START_GET_MINA_DOCUMENT_KUND_LIST = "ON_START_GET_MINA_DOCUMENT_KUND_LIST";
export const ON_GET_MINA_DOCUMENT_KUND_LIST = "ON_GET_MINA_DOCUMENT_KUND_LIST";
export const ON_ERROR_GET_MINA_DOCUMENT_KUND_LIST = "ON_ERROR_GET_MINA_DOCUMENT_KUND_LIST";
//
export const ON_START_GET_AF_LHOGIA = "ON_START_GET_AF_LHOGIA";
export const ON_GET_AF_LHOGIA = "ON_GET_AF_LHOGIA";
export const ON_GET_AF_LHOGIA_STORE = "ON_GET_AF_LHOGIA_STORE";
export const ON_GET_AF_LHOGIA_DELETE_STORE = "ON_GET_AF_LHOGIA_DELETE_STORE";
export const ON_ERROR_GET_AF_LHOGIA = "ON_ERROR_GET_AF_LHOGIA";
export const ON_START_BESTALLA_HOGIA = "ON_START_BESTALLA_HOGIA";
export const ON_BESTALLA_HOGIA = "ON_BESTALLA_HOGIA";
export const ON_ERROR_BESTALLA_HOGIA = "ON_ERROR_BESTALLA_HOGIA";
//
export const ON_START_CONNECT_WOOCOMMERCE_WP_REST = "ON_START_CONNECT_WOOCOMMERCE_WP_REST";
export const ON_CONNECT_WOOCOMMERCE_WP_REST = "ON_CONNECT_WOOCOMMERCE_WP_REST";
export const ON_ERROR_CONNECT_WOOCOMMERCE_WP_REST = "ON_ERROR_CONNECT_WOOCOMMERCE_WP_REST";
export const ON_ERROR_DISCONNECT_WOOCOMMERCE_WP_REST = "ON_ERROR_DISCONNECT_WOOCOMMERCE_WP_REST";
export const ON_START_DISCONNECT_WOOCOMMERCE_WP_REST = "ON_START_DISCONNECT_WOOCOMMERCE_WP_REST";
export const ON_DISCONNECT_WOOCOMMERCE_WP_REST = "ON_DISCONNECT_WOOCOMMERCE_WP_REST";

export const ON_START_CONNECT_BITLOG_REST = "ON_START_CONNECT_BITLOG_REST";
export const ON_CONNECT_BITLOG_REST = "ON_CONNECT_BITLOG_REST";
export const ON_ERROR_CONNECT_BITLOG_REST = "ON_ERROR_CONNECT_BITLOG_REST";
export const ON_ERROR_DISCONNECT_BITLOG_REST = "ON_ERROR_DISCONNECT_BITLOG_REST";
export const ON_START_DISCONNECT_BITLOG_REST = "ON_START_DISCONNECT_BITLOG_REST";
export const ON_DISCONNECT_BITLOG_REST = "ON_DISCONNECT_BITLOG_REST";

export const ON_START_CONNECT_WOOCOMMERCE = "ON_START_CONNECT_WOOCOMMERCE";
export const ON_CONNECT_WOOCOMMERCE = "ON_CONNECT_WOOCOMMERCE";
export const ON_ERROR_CONNECT_WOOCOMMERCE = "ON_ERROR_CONNECT_WOOCOMMERCE";
export const ON_START_GET_WOOCOMMERCE = "ON_START_GET_WOOCOMMERCE";
export const ON_GET_WOOCOMMERCE = "ON_GET_WOOCOMMERCE";
export const ON_ERROR_GET_WOOCOMMERCE = "ON_ERROR_GET_WOOCOMMERCE";
export const ON_START_DISCONNECT_WOOCOMMERCE = "ON_START_DISCONNECT_WOOCOMMERCE";
export const ON_DISCONNECT_WOOCOMMERCE = "ON_DISCONNECT_WOOCOMMERCE";
export const ON_ERROR_DISCONNECT_WOOCOMMERCE = "ON_ERROR_DISCONNECT_WOOCOMMERCE";
export const ON_START_SYNC_WOOCOMMERCE_CUSTOMERS = "ON_START_SYNC_WOOCOMMERCE_CUSTOMERS";
export const ON_SYNC_WOOCOMMERCE_CUSTOMERS = "ON_SYNC_WOOCOMMERCE_CUSTOMERS";
export const ON_ERROR_SYNC_WOOCOMMERCE_CUSTOMERS = "ON_ERROR_SYNC_WOOCOMMERCE_CUSTOMERS";
export const ON_START_CREATE_WOOCOMMERCE_CUSTOMER = "ON_START_CREATE_WOOCOMMERCE_CUSTOMER";
export const ON_CREATE_WOOCOMMERCE_CUSTOMER = "ON_CREATE_WOOCOMMERCE_CUSTOMER";
export const ON_ERROR_CREATE_WOOCOMMERCE_CUSTOMER = "ON_ERROR_CREATE_WOOCOMMERCE_CUSTOMER";
export const ON_START_CONNECT_WOOCOMMERCE_CUSTOMER = "ON_START_CONNECT_WOOCOMMERCE_CUSTOMER";
export const ON_CONNECT_WOOCOMMERCE_CUSTOMER = "ON_CONNECT_WOOCOMMERCE_CUSTOMER";
export const ON_ERROR_CONNECT_WOOCOMMERCE_CUSTOMER = "ON_ERROR_CONNECT_WOOCOMMERCE_CUSTOMER";
export const ON_START_DISCONNECT_WOOCOMMERCE_CUSTOMER = "ON_START_DISCONNECT_WOOCOMMERCE_CUSTOMER";
export const ON_DISCONNECT_WOOCOMMERCE_CUSTOMER = "ON_DISCONNECT_WOOCOMMERCE_CUSTOMER";
export const ON_ERROR_DISCONNECT_WOOCOMMERCE_CUSTOMER = "ON_ERROR_DISCONNECT_WOOCOMMERCE_CUSTOMER";
export const ON_START_GET_WOOCOMMERCE_CUSTOMER = "ON_START_GET_WOOCOMMERCE_CUSTOMER";
export const ON_GET_WOOCOMMERCE_CUSTOMER = "ON_GET_WOOCOMMERCE_CUSTOMER";
export const ON_ERROR_GET_WOOCOMMERCE_CUSTOMER = "ON_ERROR_GET_WOOCOMMERCE_CUSTOMER";
export const ON_START_UPDATE_WOOCOMMERCE = "ON_START_UPDATE_WOOCOMMERCE";
export const ON_UPDATE_WOOCOMMERCE = "ON_UPDATE_WOOCOMMERCE";
export const ON_ERROR_UPDATE_WOOCOMMERCE = "ON_ERROR_UPDATE_WOOCOMMERCE";

//Wholesale
export const ON_GET_WHOLESALESUTIE_ROLES = "ON_GET_WHOLESALESUTIE_ROLES"
export const ON_START_GET_WHOLESALESUTIE_ROLES = "ON_START_GET_WHOLESALESUTIE_ROLES"
export const ON_ERROR_GET_WHOLESALESUTIE_ROLES = "ON_ERROR_GET_WHOLESALESUTIE_ROLES"
export const ON_CONNECT_WHOLESALESUTIE_ROLES_AFID_LIST = "ON_CONNECT_WHOLESALESUTIE_ROLES_AFID_LIST"
export const ON_START_CONNECT_WHOLESALESUTIE_ROLES_AFID_LIST  = "ON_START_CONNECT_WHOLESALESUTIE_ROLES_AFID_LIST"
export const ON_ERROR_CONNECT_WHOLESALESUTIE_ROLES_AFID_LIST  = "ON_ERROR_CONNECT_WHOLESALESUTIE_ROLES_AFID_LIST"
export const ON_CREATE_WHOLESALESUTIE_ROLES_AFID_LIST  = "ON_CREATE_WHOLESALESUTIE_ROLES_AFID_LIST"
export const ON_START_CREATE_WHOLESALESUTIE_ROLES_AFID_LIST  = "ON_START_CREATE_WHOLESALESUTIE_ROLES_AFID_LIST"
export const ON_ERROR_CREATE_WHOLESALESUTIE_ROLES_AFID_LIST  = "ON_ERROR_CREATE_WHOLESALESUTIE_ROLES_AFID_LIST"
export const ON_UPDATE_WHOLESALESUTIE_PRODUCT_DATA  = "ON_UPDATE_WHOLESALESUTIE_PRODUCT_DATA"
export const ON_START_UPDATE_WHOLESALESUTIE_PRODUCT_DATA = "ON_START_UPDATE_WHOLESALESUTIE_PRODUCT_DATA"
export const ON_ERROR_UPDATE_WHOLESALESUTIE_PRODUCT_DATA = "ON_ERROR_UPDATE_WHOLESALESUTIE_PRODUCT_DATA"

//Zendesk
export const ON_START_CONNECT_ZENDESK = "ON_START_CONNECT_ZENDESK";
export const ON_CONNECT_ZENDESK = "ON_CONNECT_ZENDESK";
export const ON_ERROR_CONNECT_ZENDESK = "ON_ERROR_CONNECT_ZENDESK";
export const ON_START_DISCONNECT_ZENDESK = "ON_START_DISCONNECT_ZENDESK";
export const ON_DISCONNECT_ZENDESK = "ON_DISCONNECT_ZENDESK";
export const ON_ERROR_DISCONNECT_ZENDESK = "ON_ERROR_DISCONNECT_ZENDESK";
export const ON_GET_ZENDESK = "ON_GET_ZENDESK";
export const ON_ERROR_GET_ZENDESK = "ON_ERROR_GET_ZENDESK";
export const ON_START_GET_ZENDESK = "ON_START_GET_ZENDESK";

export const ON_START_CREATE_WOOCOMMERCE_PRODUCT = "ON_START_CREATE_WOOCOMMERCE_PRODUCT";
export const ON_CREATE_WOOCOMMERCE_PRODUCT = "ON_CREATE_WOOCOMMERCE_PRODUCT";
export const ON_ERROR_CREATE_WOOCOMMERCE_PRODUCT = "ON_ERROR_CREATE_WOOCOMMERCE_PRODUCT";
export const ON_START_CONNECT_WOOCOMMERCE_PRODUCT = "ON_START_CONNECT_WOOCOMMERCE_PRODUCT";
export const ON_CONNECT_WOOCOMMERCE_PRODUCT = "ON_CONNECT_WOOCOMMERCE_PRODUCT";
export const ON_ERROR_CONNECT_WOOCOMMERCE_PRODUCT = "ON_ERROR_CONNECT_WOOCOMMERCE_PRODUCT";
export const ON_START_DISCONNECT_WOOCOMMERCE_PRODUCT = "ON_START_DISCONNECT_WOOCOMMERCE_PRODUCT";
export const ON_DISCONNECT_WOOCOMMERCE_PRODUCT = "ON_DISCONNECT_WOOCOMMERCE_PRODUCT";
export const ON_ERROR_DISCONNECT_WOOCOMMERCE_PRODUCT = "ON_ERROR_DISCONNECT_WOOCOMMERCE_PRODUCT";
//
// Pyramid
export const ON_START_GET_PYRAMID = "ON_START_GET_PYRAMID";
export const ON_GET_PYRAMID = "ON_GET_PYRAMID";
export const ON_ERROR_GET_PYRAMID = "ON_ERROR_GET_PYRAMID";
export const ON_START_CONNECT_PYRAMID = "ON_START_CONNECT_PYRAMID";
export const ON_CONNECT_PYRAMID = "ON_CONNECT_PYRAMID";
export const ON_ERROR_CONNECT_PYRAMID = "ON_ERROR_CONNECT_PYRAMID";
export const ON_START_DISCONNECT_PYRAMID = "ON_START_DISCONNECT_PYRAMID";
export const ON_DISCONNECT_PYRAMID = "ON_DISCONNECT_PYRAMID";
export const ON_ERROR_DISCONNECT_PYRAMID = "ON_ERROR_DISCONNECT_PYRAMID";
export const ON_START_UPDATE_PYRAMID = "ON_START_UPDATE_PYRAMID";
export const ON_UPDATE_PYRAMID = "ON_UPDATE_PYRAMID";
export const ON_ERROR_UPDATE_PYRAMID = "ON_ERROR_UPDATE_PYRAMID";

export const ON_START_CREATE_PYRAMID_CUSTOMER = "ON_START_CREATE_PYRAMID_CUSTOMER";
export const ON_CREATE_PYRAMID_CUSTOMER = "ON_CREATE_PYRAMID_CUSTOMER";
export const ON_ERROR_CREATE_PYRAMID_CUSTOMER = "ON_ERROR_CREATE_PYRAMID_CUSTOMER";
export const ON_START_CONNECT_PYRAMID_CUSTOMER = "ON_START_CONNECT_PYRAMID_CUSTOMER";
export const ON_CONNECT_PYRAMID_CUSTOMER = "ON_CONNECT_PYRAMID_CUSTOMER";
export const ON_ERROR_CONNECT_PYRAMID_CUSTOMER = "ON_ERROR_CONNECT_PYRAMID_CUSTOMER";
export const ON_START_DISCONNECT_PYRAMID_CUSTOMER = "ON_START_DISCONNECT_PYRAMID_CUSTOMER";
export const ON_DISCONNECT_PYRAMID_CUSTOMER = "ON_DISCONNECT_PYRAMID_CUSTOMER";
export const ON_ERROR_DISCONNECT_PYRAMID_CUSTOMER = "ON_ERROR_DISCONNECT_PYRAMID_CUSTOMER";
export const ON_START_GET_PYRAMID_CUSTOMER = "ON_START_GET_PYRAMID_CUSTOMER";
export const ON_GET_PYRAMID_CUSTOMER = "ON_GET_PYRAMID_CUSTOMER";
export const ON_ERROR_GET_PYRAMID_CUSTOMER = "ON_ERROR_GET_PYRAMID_CUSTOMER";

export const ON_START_CREATE_PYRAMID_CONTACT = "ON_START_CREATE_PYRAMID_CONTACT";
export const ON_CREATE_PYRAMID_CONTACT = "ON_CREATE_PYRAMID_CONTACT";
export const ON_ERROR_CREATE_PYRAMID_CONTACT = "ON_ERROR_CREATE_PYRAMID_CONTACT";
export const ON_START_CONNECT_PYRAMID_CONTACT = "ON_START_CONNECT_PYRAMID_CONTACT";
export const ON_CONNECT_PYRAMID_CONTACT = "ON_CONNECT_PYRAMID_CONTACT";
export const ON_ERROR_CONNECT_PYRAMID_CONTACT = "ON_ERROR_CONNECT_PYRAMID_CONTACT";
export const ON_START_DISCONNECT_PYRAMID_CONTACT = "ON_START_DISCONNECT_PYRAMID_CONTACT";
export const ON_DISCONNECT_PYRAMID_CONTACT = "ON_DISCONNECT_PYRAMID_CONTACT";
export const ON_ERROR_DISCONNECT_PYRAMID_CONTACT = "ON_ERROR_DISCONNECT_PYRAMID_CONTACT";
export const ON_START_GET_PYRAMID_CONTACT = "ON_START_GET_PYRAMID_CONTACT";
export const ON_GET_PYRAMID_CONTACT = "ON_GET_PYRAMID_CONTACT";
export const ON_ERROR_GET_PYRAMID_CONTACT = "ON_ERROR_GET_PYRAMID_CONTACT";


export const ON_START_FORTNOX_AVTAL_FAKTUROR = "ON_START_FORTNOX_AVTAL_FAKTUROR";
export const ON_FORTNOX_AVTAL_FAKTUROR = "ON_FORTNOX_AVTAL_FAKTUROR";
export const ON_ERROR_FORTNOX_AVTAL_FAKTUROR = "ON_ERROR_FORTNOX_AVTAL_FAKTUROR";
//
export const ON_MOTE_LIST_DIALER = "ON_MOTE_LIST_DIALER";
export const ON_START_MOTE_LIST_DIALER = "ON_START_MOTE_LIST_DIALER";
//
export const ON_START_FLYTTA_INAKTIV_USER = "ON_START_FLYTTA_INAKTIV_USER";
export const ON_FETCH_FLYTTA_INAKTIV_USER = "ON_FETCH_FLYTTA_INAKTIV_USER";
export const ON_ERROR_FLYTTA_INAKTIV_USER = "ON_ERROR_FLYTTA_INAKTIV_USER";
//
export const ON_START_FETCH_GET_PERSONAL_LIST = "ON_START_FETCH_GET_PERSONAL_LIST";
export const ON_FETCH_GET_PERSONAL_LIST = "ON_FETCH_GET_PERSONAL_LIST";
export const ON_ERROR_FETCH_GET_PERSONAL_LIST = "ON_ERROR_FETCH_GET_PERSONAL_LIST";
export const ON_START_DELETE_FROM_PERSONAL_LIST = "ON_START_DELETE_FROM_PERSONAL_LIST";
export const ON_DELETE_FROM_PERSONAL_LIST = "ON_DELETE_FROM_PERSONAL_LIST";
export const ON_ERROR_DELETE_FROM_PERSONAL_LIST = "ON_ERROR_DELETE_FROM_PERSONAL_LIST";
//
export const ON_START_FETCH_DASHBOARD_SALJ_FILTER = "ON_START_FETCH_DASHBOARD_SALJ_FILTER";
export const ON_START_FETCH_DASHBOARD_ORDER_FILTER = "ON_START_FETCH_DASHBOARD_ORDER_FILTER";
export const ON_FETCH_DASHBOARD_SALJ_FILTER = "ON_FETCH_DASHBOARD_SALJ_FILTER";
export const ON_ERROR_FETCH_DASHBOARD_SALJ_FILTER = "ON_ERROR_FETCH_DASHBOARD_SALJ_FILTER";
export const ON_START_FETCH_DASHBOARD_BOKA_FILTER = "ON_START_FETCH_DASHBOARD_BOKA_FILTER";
export const ON_FETCH_DASHBOARD_BARN_FILTER = "ON_FETCH_DASHBOARD_BARN_FILTER";
export const ON_FETCH_DASHBOARD_BOKA_FILTER = "ON_FETCH_DASHBOARD_BOKA_FILTER";
export const ON_FETCH_DASHBOARD_ORDER_FILTER = "ON_FETCH_DASHBOARD_ORDER_FILTER";
export const ON_ERROR_FETCH_DASHBOARD_BOKA_FILTER = "ON_ERROR_FETCH_DASHBOARD_BOKA_FILTER";
export const ON_START_FETCH_DASHBOARD_DIALER_FILTER = "ON_START_FETCH_DASHBOARD_DIALER_FILTER";
export const ON_FETCH_DASHBOARD_DIALER_FILTER = "ON_FETCH_DASHBOARD_DIALER_FILTER";
export const ON_ERROR_FETCH_DASHBOARD_DIALER_FILTER = "ON_ERROR_FETCH_DASHBOARD_DIALER_FILTER";
export const ON_START_FETCH_DASHBOARD_PROSPEKT_FILTER = "ON_START_FETCH_DASHBOARD_PROSPEKT_FILTER";
export const ON_FETCH_DASHBOARD_PROSPEKT_FILTER = "ON_FETCH_DASHBOARD_PROSPEKT_FILTER";
export const ON_ERROR_FETCH_DASHBOARD_PROSPEKT_FILTER = "ON_ERROR_FETCH_DASHBOARD_PROSPEKT_FILTER";
export const ON_START_FETCH_DASHBOARD_KONTOR_FILTER = "ON_START_FETCH_DASHBOARD_KONTOR_FILTER";
export const ON_FETCH_DASHBOARD_KONTOR_FILTER = "ON_FETCH_DASHBOARD_KONTOR_FILTER";
export const ON_ERROR_FETCH_DASHBOARD_KONTOR_FILTER = "ON_ERROR_FETCH_DASHBOARD_KONTOR_FILTER";
//ON_START_FETCH_DASHBOARD_KONTOR_FILTER,ON_FETCH_DASHBOARD_KONTOR_FILTER,ON_ERROR_FETCH_DASHBOARD_KONTOR_FILTER,
export const ON_START_GET_DASHBOARD_CUSTOM_LIST = "ON_START_GET_DASHBOARD_CUSTOM_LIST"
export const ON_GET_DASHBOARD_CUSTOM_LIST = "ON_GET_DASHBOARD_CUSTOM_LIST"
export const ON_ERROR_GET_DASHBOARD_CUSTOM_LIST = "ON_ERROR_GET_DASHBOARD_CUSTOM_LIST"
export const ON_START_ADD_DASHBOARD_CUSTOM = "ON_START_ADD_DASHBOARD_CUSTOM"
export const ON_ADD_DASHBOARD_CUSTOM = "ON_ADD_DASHBOARD_CUSTOM"
export const ON_ERROR_ADD_DASHBOARD_CUSTOM = "ON_ERROR_ADD_DASHBOARD_CUSTOM"
export const ON_START_REMOVE_DASHBOARD_CUSTOM = "ON_START_REMOVE_DASHBOARD_CUSTOM"
export const ON_REMOVE_DASHBOARD_CUSTOM = "ON_REMOVE_DASHBOARD_CUSTOM"
export const ON_ERROR_REMOVE_DASHBOARD_CUSTOM = "ON_ERROR_REMOVE_DASHBOARD_CUSTOM"
export const ON_START_GET_DASHBOARD_CUSTOM = "ON_START_GET_DASHBOARD_CUSTOM"
export const ON_GET_DASHBOARD_CUSTOM = "ON_GET_DASHBOARD_CUSTOM"
export const ON_ERROR_GET_DASHBOARD_CUSTOM = "ON_ERROR_GET_DASHBOARD_CUSTOM"
export const ON_START_UPDATE_DASHBOARD_CUSTOM = "ON_START_UPDATE_DASHBOARD_CUSTOM"
export const ON_UPDATE_DASHBOARD_CUSTOM = "ON_UPDATE_DASHBOARD_CUSTOM"
export const ON_ERROR_UPDATE_DASHBOARD_CUSTOM = "ON_ERROR_UPDATE_DASHBOARD_CUSTOM"
export const ON_START_DELETE_DASHBOARD_CUSTOM = "ON_START_DELETE_DASHBOARD_CUSTOM"
export const ON_DELETE_DASHBOARD_CUSTOM = "ON_DELETE_DASHBOARD_CUSTOM"
export const ON_ERROR_DELETE_DASHBOARD_CUSTOM = "ON_ERROR_DELETE_DASHBOARD_CUSTOM"

export const ON_START_GET_DASHBOARD_COMPETITION_LIST = "ON_START_GET_DASHBOARD_COMPETITION_LIST"
export const ON_GET_DASHBOARD_COMPETITION_LIST = "ON_GET_DASHBOARD_COMPETITION_LIST"
export const ON_ERROR_GET_DASHBOARD_COMPETITION_LIST = "ON_ERROR_GET_DASHBOARD_COMPETITION_LIST"
export const ON_START_ADD_DASHBOARD_COMPETITION = "ON_START_ADD_DASHBOARD_COMPETITION"
export const ON_ADD_DASHBOARD_COMPETITION = "ON_ADD_DASHBOARD_COMPETITION"
export const ON_ERROR_ADD_DASHBOARD_COMPETITION = "ON_ERROR_ADD_DASHBOARD_COMPETITION"
export const ON_START_REMOVE_DASHBOARD_COMPETITION = "ON_START_REMOVE_DASHBOARD_COMPETITION"
export const ON_REMOVE_DASHBOARD_COMPETITION = "ON_REMOVE_DASHBOARD_COMPETITION"
export const ON_ERROR_REMOVE_DASHBOARD_COMPETITION = "ON_ERROR_REMOVE_DASHBOARD_COMPETITION"
export const ON_START_GET_DASHBOARD_COMPETITION = "ON_START_GET_DASHBOARD_COMPETITION"
export const ON_GET_DASHBOARD_COMPETITION = "ON_GET_DASHBOARD_COMPETITION"
export const ON_ERROR_GET_DASHBOARD_COMPETITION = "ON_ERROR_GET_DASHBOARD_COMPETITION"
export const ON_START_UPDATE_DASHBOARD_COMPETITION = "ON_START_UPDATE_DASHBOARD_COMPETITION"
export const ON_UPDATE_DASHBOARD_COMPETITION = "ON_UPDATE_DASHBOARD_COMPETITION"
export const ON_ERROR_UPDATE_DASHBOARD_COMPETITION = "ON_ERROR_UPDATE_DASHBOARD_COMPETITION"
export const ON_START_DELETE_DASHBOARD_COMPETITION = "ON_START_DELETE_DASHBOARD_COMPETITION"
export const ON_DELETE_DASHBOARD_COMPETITION = "ON_DELETE_DASHBOARD_COMPETITION"
export const ON_ERROR_DELETE_DASHBOARD_COMPETITION = "ON_ERROR_DELETE_DASHBOARD_COMPETITION"
export const ON_POST_CHAT_DASHBOARD_COMPETITION = "ON_POST_CHAT_DASHBOARD_COMPETITION"
export const ON_START_POST_CHAT_DASHBOARD_COMPETITION = "ON_START_POST_CHAT_DASHBOARD_COMPETITION"
export const ON_ERROR_POST_CHAT_DASHBOARD_COMPETITION = "ON_ERROR_POST_CHAT_DASHBOARD_COMPETITION"

export const ON_START_GET_AF_NOTIS = "ON_START_GET_AF_NOTIS"
export const ON_GET_AF_NOTIS = "ON_GET_AF_NOTIS"
export const ON_ERROR_GET_AF_NOTIS = "ON_ERROR_GET_AF_NOTIS"
export const ON_START_ADD_AF_NOTIS = "ON_START_ADD_AF_NOTIS"
export const ON_ADD_AF_NOTIS = "ON_ADD_AF_NOTIS"
export const ON_ERROR_ADD_AF_NOTIS = "ON_ERROR_ADD_AF_NOTIS"
export const ON_START_SET_AF_NOTIS_SEEN = "ON_START_SET_AF_NOTIS_SEEN"
export const ON_SET_AF_NOTIS_SEEN = "ON_SET_AF_NOTIS_SEEN"
export const ON_ERROR_SET_AF_NOTIS_SEEN = "ON_ERROR_SET_AF_NOTIS_SEEN"

//Dashboard TV - Enheter
export const ON_START_GET_DASHBOARD_TV_DEVICE_LIST = "ON_START_GET_DASHBOARD_TV_DEVICE_LIST"
export const ON_GET_DASHBOARD_TV_DEVICE_LIST = "ON_GET_DASHBOARD_TV_DEVICE_LIST"
export const ON_ERROR_GET_DASHBOARD_TV_DEVICE_LIST = "ON_ERROR_GET_DASHBOARD_TV_DEVICE_LIST"
export const ON_START_ADD_DASHBOARD_TV_DEVICE = "ON_START_ADD_DASHBOARD_TV_DEVICE"
export const ON_ADD_DASHBOARD_TV_DEVICE = "ON_ADD_DASHBOARD_TV_DEVICE"
export const ON_ERROR_ADD_DASHBOARD_TV_DEVICE = "ON_ERROR_ADD_DASHBOARD_TV_DEVICE"
export const ON_START_REMOVE_DASHBOARD_TV_DEVICE = "ON_START_REMOVE_DASHBOARD_TV_DEVICE"
export const ON_REMOVE_DASHBOARD_TV_DEVICE = "ON_REMOVE_DASHBOARD_TV_DEVICE"
export const ON_ERROR_REMOVE_DASHBOARD_TV_DEVICE = "ON_ERROR_REMOVE_DASHBOARD_TV_DEVICE"
export const ON_START_CONNECT_DASHBOARD_TV_DEVICE = "ON_START_CONNECT_DASHBOARD_TV_DEVICE"
export const ON_CONNECT_DASHBOARD_TV_DEVICE = "ON_CONNECT_DASHBOARD_TV_DEVICE"
export const ON_ERROR_CONNECT_DASHBOARD_TV_DEVICE = "ON_ERROR_CONNECT_DASHBOARD_TV_DEVICE"

export const ON_START_INIT_DASHBOARD_TV_DEVICE = "ON_START_INIT_DASHBOARD_TV_DEVICE"
export const ON_INIT_DASHBOARD_TV_DEVICE = "ON_INIT_DASHBOARD_TV_DEVICE"
export const ON_ERROR_INIT_DASHBOARD_TV_DEVICE = "ON_ERROR_INIT_DASHBOARD_TV_DEVICE"

export const ON_START_ADD_DASHBOARD_TV_DEVICE_VY = "ON_START_ADD_DASHBOARD_TV_DEVICE_VY"
export const ON_ADD_DASHBOARD_TV_DEVICE_VY = "ON_ADD_DASHBOARD_TV_DEVICE_VY"
export const ON_ERROR_ADD_DASHBOARD_TV_DEVICE_VY = "ON_ERROR_ADD_DASHBOARD_TV_DEVICE_VY"
export const ON_START_REMOVE_DASHBOARD_TV_DEVICE_VY = "ON_START_REMOVE_DASHBOARD_TV_DEVICE_VY"
export const ON_REMOVE_DASHBOARD_TV_DEVICE_VY = "ON_REMOVE_DASHBOARD_TV_DEVICE_VY"
export const ON_ERROR_REMOVE_DASHBOARD_TV_DEVICE_VY = "ON_ERROR_REMOVE_DASHBOARD_TV_DEVICE_VY"
export const ON_START_UPDATE_DASHBOARD_TV_DEVICE_VY = "ON_START_UPDATE_DASHBOARD_TV_DEVICE_VY"
export const ON_UPDATE_DASHBOARD_TV_DEVICE_VY = "ON_UPDATE_DASHBOARD_TV_DEVICE_VY"
export const ON_ERROR_UPDATE_DASHBOARD_TV_DEVICE_VY = "ON_ERROR_UPDATE_DASHBOARD_TV_DEVICE_VY"


//
export const ON_START_FETCH_GET_NEXT_ORGNR = "ON_START_FETCH_GET_NEXT_ORGNR";
export const ON_START_FETCH_GET_NEXT_ORGNR_1 = "ON_START_FETCH_GET_NEXT_ORGNR_1";
export const ON_FETCH_GET_NEXT_ORGNR = "ON_FETCH_GET_NEXT_ORGNR";
export const ON_ERROR_FETCH_GET_NEXT_ORGNR = "ON_ERROR_FETCH_GET_NEXT_ORGNR";
//
export const ON_START_DASHBORD_USERLIST = "ON_START_DASHBORD_USERLIST";
export const ON_DASHBORD_USERLIST = "ON_DASHBORD_USERLIST";
export const ON_ERROR_DASHBORD_USERLIST = "ON_ERROR_DASHBORD_USERLIST";
//, , ,
export const ON_START_AVTAL_BILLING_START = "ON_START_AVTAL_BILLING_START";
export const ON_AVTAL_BILLING_START = "ON_AVTAL_BILLING_START";
export const ON_ERROR_AVTAL_BILLING_START = "ON_ERROR_AVTAL_BILLING_START";
export const ON_START_AVTAL_BILLING_CLOSE = "ON_START_AVTAL_BILLING_CLOSE";
export const ON_AVTAL_BILLING_CLOSE = "ON_AVTAL_BILLING_CLOSE";
export const ON_ERROR_AVTAL_BILLING_CLOSE = "ON_ERROR_AVTAL_BILLING_CLOSE";
export const ON_START_AVTAL_BILLING_UPDATE = "ON_START_AVTAL_BILLING_UPDATE";
export const ON_AVTAL_BILLING_UPDATE = "ON_AVTAL_BILLING_UPDATE";
export const ON_ERROR_AVTAL_BILLING_UPDATE = "ON_ERROR_AVTAL_BILLING_UPDATE";
//
export const ON_START_FETCH_GET_BLACKLIST = "ON_START_FETCH_GET_BLACKLIST";
export const ON_FETCH_GET_BLACKLIST = "ON_FETCH_GET_BLACKLIST";
export const ON_ERROR_FETCH_GET_BLACKLIST = "ON_ERROR_FETCH_GET_BLACKLIST";
//OFFERTPREV_ON_GET_ALL_OFFERTS
export const OFFERTPREV_ON_GET_ALL_OFFERTS = "OFFERTPREV_ON_GET_ALL_OFFERTS";
export const OFFERTPREV_ON_START_GET_ALL_OFFERTS = "OFFERTPREV_ON_START_GET_ALL_OFFERTS";
export const OFFERTPREV_ON_GET_AVTAL_OFFERTS = "OFFERTPREV_ON_GET_AVTAL_OFFERTS";
//DElete Handelse Order 
export const ON_START_DELETE_ORDER_HANDELSE = "ON_START_DELETE_ORDER_HANDELSE";
export const ON_DELETE_ORDER_HANDELSE = "ON_DELETE_ORDER_HANDELSE";
export const ON_ERROR_DELETE_ORDER_HANDELSE = "ON_ERROR_DELETE_ORDER_HANDELSE";
//
export const ON_START_FETCH_EXCELMALL = "ON_START_FETCH_EXCELMALL";
export const ON_FETCH_EXCELMALL = "ON_FETCH_EXCELMALL";
export const ON_ERROR_EXCELMAL = "ON_ERROR_EXCELMAL";
//
export const ON_START_FETCH_EXCEL_KUNDDATA_AVTAL = "ON_START_FETCH_EXCEL_KUNDDATA_AVTAL";
export const ON_FETCH_EXCEL_KUNDDATA_AVTAL = "ON_FETCH_EXCEL_KUNDDATA_AVTAL";
export const ON_ERROR_EXCEL_KUNDDATA_AVTAL = "ON_ERROR_EXCEL_KUNDDATA_AVTAL";
export const ON_START_FETCH_EXCEL_KUNDDATA_ORDER = "ON_START_FETCH_EXCEL_KUNDDATA_ORDER";
export const ON_FETCH_EXCEL_KUNDDATA_ORDER = "ON_FETCH_EXCEL_KUNDDATA_ORDER";
export const ON_ERROR_EXCEL_KUNDDATA_ORDER = "ON_ERROR_EXCEL_KUNDDATA_ORDER";
//
export const ON_START_KUND_KALKYL_OPTIONS = "ON_START_KUND_KALKYL_OPTIONS";
export const ON_KUND_KALKYL_OPTIONS = "ON_KUND_KALKYL_OPTIONS";
export const ON_ERROR_KUND_KALKYL_OPTIONS = "ON_ERROR_KUND_KALKYL_OPTIONS";
//
export const ON_START_BLACK_LIST = "ON_START_BLACK_LIST";
export const ON_BLACK_LIST = "ON_BLACK_LIST";
export const ON_ERROR_BLACK_LIST = "ON_ERROR_BLACK_LIST";
export const ON_START_DELETE_FROM_BL = "ON_START_DELETE_FROM_BL";
export const ON_DELETE_FROM_BL = "ON_DELETE_FROM_BL";
export const ON_ERROR_DELETE_FROM_BL = "ON_ERROR_DELETE_FROM_BL";
//
export const ON_START_DELETE_AVTAL_HANDELSE = "ON_START_DELETE_AVTAL_HANDELSE";
export const ON_DELETE_AVTAL_HANDELSE = "ON_DELETE_AVTAL_HANDELSE";
export const ON_ERROR_DELETE_AVTAL_HANDELSE = "ON_ERROR_DELETE_AVTAL_HANDELSE";
export const ON_START_UPDATER_AVTAL_HANDELSE = "ON_START_UPDATER_AVTAL_HANDELSE";
export const ON_UPDATER_AVTAL_HANDELSE = "ON_UPDATER_AVTAL_HANDELSE";
export const ON_ERROR_UPDATER_AVTAL_HANDELSE = "ON_ERROR_UPDATER_AVTAL_HANDELSE";
//
export const ON_START_GET_AVTAL_OFFERTL_ID = "ON_START_GET_AVTAL_OFFERTL_ID";
export const ON_GET_AVTAL_OFFERTL_ID = "ON_GET_AVTAL_OFFERTL_ID";
export const ON_ERROR_GET_AVTAL_OFFERTL_ID = "ON_ERROR_GET_AVTAL_OFFERTL_ID";
//Office
export const ON_START_OFFICE_ALL_USERS = "ON_START_OFFICE_ALL_USERS";
export const ON_OFFICE_ALL_USERS = "ON_OFFICE_ALL_USERS";
export const ON_ERROR_OFFICE_ALL_USERS = "ON_ERROR_OFFICE_ALL_USERS";
export const ON_START_OFFICE_UPDATE_USER = "ON_START_OFFICE_UPDATE_USER";
export const ON_OFFICE_UPDATE_USER = "ON_OFFICE_UPDATE_USER";
export const ON_ERROR_OFFICE_UPDATE_USER = "ON_ERROR_OFFICE_UPDATE_USER";
export const ON_START_OFFICE_GET = "ON_START_OFFICE_GET";
export const ON_OFFICE_GET = "ON_OFFICE_GET";
export const ON_ERROR_OFFICE_GET = "ON_ERROR_OFFICE_GET";
//
export const ON_START_PERATER_USER = "ON_START_PERATER_USER";
export const ON_PERATER_USER = "ON_PERATER_USER";
export const ON_ERROR_PERATER_USER = "ON_ERROR_PERATER_USER";
//Utokning
export const ON_START_FETCH_UTOKNING_DYNAMIC_FIELDS = "ON_START_FETCH_UTOKNING_DYNAMIC_FIELDS";
export const ON_FETCH_UTOKNING_DYNAMIC_FIELDS = "ON_FETCH_UTOKNING_DYNAMIC_FIELDS";
export const ON_ERROR_FETCH_UTOKNING_DYNAMIC_FIELDS = "ON_ERROR_FETCH_UTOKNING_DYNAMIC_FIELDS";
export const ON_START_FETCH_UTOKNING = "ON_START_FETCH_UTOKNING";
export const ON_FETCH_UTOKNING = "ON_FETCH_UTOKNING";
export const ON_ERROR_FETCH_UTOKNING = "ON_ERROR_FETCH_UTOKNING";
export const ON_START_FETCH_UTOKNING_RAPPORT = "ON_START_FETCH_UTOKNING_RAPPORT";
export const ON_FETCH_UTOKNING_RAPPORT = "ON_FETCH_UTOKNING_RAPPORT";
export const ON_ERROR_FETCH_UTOKNING_RAPPORT = "ON_ERROR_FETCH_UTOKNING_RAPPORT";
//Fortnox
export const ON_START_BESTALLA_FORTNOX = "ON_START_BESTALLA_FORTNOX";
export const ON_BESTALLA_FORTNOX = "ON_BESTALLA_FORTNOX";
export const ON_ERROR_BESTALLA_FORTNOX = "ON_ERROR_BESTALLA_FORTNOX";
export const ON_START_GET_AF_FORTNOX = "ON_START_GET_AF_FORTNOX";
export const ON_GET_AF_FORTNOX = "ON_GET_AF_FORTNOX";
export const ON_ERROR_GET_AF_FORTNOX = "ON_ERROR_GET_AF_FORTNOX";
export const ON_START_GET_AF_LFORTNOX = "ON_START_GET_AF_LFORTNOX";
export const ON_GET_AF_LFORTNOX = "ON_GET_AF_LFORTNOX";
export const ON_ERROR_GET_AF_LFORTNOX = "ON_ERROR_GET_AF_LFORTNOX";
export const ON_START_GET_AF_FORTNOX_KUNDER = "ON_START_GET_AF_FORTNOX_KUNDER";
export const ON_GET_AF_FORTNOX_KUNDER = "ON_GET_AF_FORTNOX_KUNDER";
export const ON_ERROR_GET_AF_FORTNOX_KUNDER = "ON_ERROR_GET_AF_FORTNOX_KUNDER";
export const ON_START_FORTNOX_NEWKUND = "ON_START_FORTNOX_NEWKUND";
export const ON_FORTNOX_NEWKUND = "ON_FORTNOX_NEWKUND";
export const ON_ERROR_FORTNOX_NEWKUND = "ON_ERROR_FORTNOX_NEWKUND";
export const ON_START_FORTNOX_DELKUND = "ON_START_FORTNOX_DELKUND";
export const ON_FORTNOX_DELKUND = "ON_FORTNOX_DELKUND";
export const ON_ERROR_FORTNOX_DELKUND = "ON_ERROR_FORTNOX_DELKUND";
export const ON_SET_ZERO_FORTNOX_UPPGIFTER = "ON_SET_ZERO_FORTNOX_UPPGIFTER";
export const ON_START_GET_AF_DFORTNOX = "ON_START_GET_AF_DFORTNOX";
export const ON_GET_AF_DFORTNOX = "ON_GET_AF_DFORTNOX";
export const ON_ERROR_GET_AF_DFORTNOX = "ON_ERROR_GET_AF_DFORTNOX";
export const ON_START_FORTNOX_CONNECT_KUND = "ON_START_FORTNOX_CONNECT_KUND";
export const ON_FORTNOX_CONNECT_KUND = "ON_FORTNOX_CONNECT_KUND";
export const ON_ERROR_FORTNOX_CONNECT_KUND = "ON_ERROR_FORTNOX_CONNECT_KUND";
export const ON_START_FORTNOX_EDITKUND = "ON_START_FORTNOX_EDITKUND";
export const ON_FORTNOX_EDITKUND = "ON_FORTNOX_EDITKUND";
export const ON_ERROR_FORTNOX_EDITKUND = "ON_ERROR_FORTNOX_EDITKUND";
//

export const ON_START_GET_AF_FORTNOX_KUND = "ON_START_GET_AF_FORTNOX_KUND";
export const ON_GET_AF_FORTNOX_KUND = "ON_GET_AF_FORTNOX_KUND";
export const ON_ERROR_GET_AF_FORTNOX_KUND = "ON_ERROR_GET_AF_FORTNOX_KUND";
export const ON_START_GET_AF_FORTNOX_ARTIKLAR = "ON_START_GET_AF_FORTNOX_ARTIKLAR";
export const ON_GET_AF_FORTNOX_ARTIKLAR = "ON_GET_AF_FORTNOX_ARTIKLAR";
export const ON_ERROR_GET_AF_FORTNOX_ARTIKLAR = "ON_ERROR_GET_AF_FORTNOX_ARTIKLAR";

export const ON_START_GET_AF_FORTNOX_ORDER = "ON_START_GET_AF_FORTNOX_ORDER";
export const ON_GET_AF_FORTNOX_ORDER = "ON_GET_AF_FORTNOX_ORDER";
export const ON_ERROR_GET_AF_FORTNOX_ORDER = "ON_ERROR_GET_AF_FORTNOX_ORDER";
export const ON_START_GET_AF_FORTNOX_OFFERT = "ON_START_GET_AF_FORTNOX_OFFERT";
export const ON_GET_AF_FORTNOX_OFFERT = "ON_GET_AF_FORTNOX_OFFERT";
export const ON_ERROR_GET_AF_FORTNOX_OFFERT = "ON_ERROR_GET_AF_FORTNOX_OFFERT";


export const ON_RESET_FORTNOX_KUND_FAKTUROR = "ON_RESET_FORTNOX_KUND_FAKTUROR";
export const ON_START_FORTNOX_KUND_FAKTUROR = "ON_START_FORTNOX_KUND_FAKTUROR";
export const ON_FORTNOX_KUND_FAKTUROR = "ON_FORTNOX_KUND_FAKTUROR";
export const ON_ERROR_FORTNOX_KUND_FAKTUROR = "ON_ERROR_FORTNOX_KUND_FAKTUROR";
export const ON_START_FORTNOX_FAKTUROR_CONNECT = "ON_START_FORTNOX_FAKTUROR_CONNECT";
export const ON_FORTNOX_FAKTUROR_CONNECT = "ON_FORTNOX_FAKTUROR_CONNECT";
export const ON_ERROR_FORTNOX_FAKTUROR_CONNECT = "ON_ERROR_FORTNOX_FAKTUROR_CONNECT";
export const ON_START_FORTNOX_FAKTUROR_DOWNLOAD = "ON_START_FORTNOX_FAKTUROR_DOWNLOAD";
export const ON_FORTNOX_FAKTURO_DOWNLOAD = "ON_FORTNOX_FAKTURO_DOWNLOAD";
export const ON_ERROR_FORTNOX_FAKTUROR_DOWNLOAD = "ON_ERROR_FORTNOX_FAKTUROR_DOWNLOAD";
export const ON_START_FORTNOX_FAKTUROR_CANCEL = "ON_START_FORTNOX_FAKTUROR_CANCEL";
export const ON_FORTNOX_FAKTUROR_CANCEL = "ON_FORTNOX_FAKTUROR_CANCEL";
export const ON_ERROR_FORTNOX_FAKTUROR_CANCEL = "ON_ERROR_FORTNOX_FAKTUROR_CANCEL";
export const ON_START_FORTNOX_FAKTURA_GET = "ON_START_FORTNOX_FAKTURA_GET";
export const ON_FORTNOX_FAKTURA_GET = "ON_FORTNOX_FAKTURA_GET";
export const ON_ERROR_FORTNOX_FAKTURA_GET = "ON_ERROR_FORTNOX_FAKTURA_GET";
export const ON_START_FORTNOX_FAKTUROR_SEND = "ON_START_FORTNOX_FAKTUROR_SEND";
export const ON_FORTNOX_FAKTUROR_SEND = "ON_FORTNOX_FAKTUROR_SEND";
export const ON_ERROR_FORTNOX_FAKTUROR_SEND = "ON_ERROR_FORTNOX_FAKTUROR_SEND";
export const ON_START_FORTNOX_FAKTUROR_EDIT = "ON_START_FORTNOX_FAKTUROR_EDIT";
export const ON_FORTNOX_FAKTUROR_EDIT = "ON_FORTNOX_FAKTUROR_EDIT";
export const ON_ERROR_FORTNOX_FAKTUROR_EDIT = "ON_ERROR_FORTNOX_FAKTUROR_EDIT";
export const ON_START_FORTNOX_FAKTUROR_NEW = "ON_START_FORTNOX_FAKTUROR_NEW";
export const ON_FORTNOX_FAKTUROR_NEW = "ON_FORTNOX_FAKTUROR_NEW";
export const ON_ERROR_FORTNOX_FAKTUROR_NEW = "ON_ERROR_FORTNOX_FAKTUROR_NEW";
export const ON_START_FORTNOX_NEWKUND_AVTAL = "ON_START_FORTNOX_NEWKUND_AVTAL";
export const ON_FORTNOX_NEWKUND_AVTAL = "ON_FORTNOX_NEWKUND_AVTAL";
export const ON_ERROR_FORTNOX_NEWKUND_AVTAL = "ON_ERROR_FORTNOX_NEWKUND_AVTAL";
export const ON_START_FORTNOX_NEWKUND_ORDER = "ON_START_FORTNOX_NEWKUND_ORDER";
export const ON_FORTNOX_NEWKUND_ORDER = "ON_FORTNOX_NEWKUND_ORDER";
export const ON_ERROR_FORTNOX_NEWKUND_ORDER = "ON_ERROR_FORTNOX_NEWKUND_ORDER";
//

export const ON_START_GET_NOTIST = "ON_START_GET_NOTIST";
export const ON_GET_NOTIST = "ON_GET_NOTIST";
export const ON_ERROR_GET_NOTIST = "ON_ERROR_GET_NOTIST";
export const ON_FETCH_KAMPANJ_KUND_KOMPANJ = "ON_FETCH_KAMPANJ_KUND_KOMPANJ";
export const ON_FETCH_KAMPANJ_KUND_KOMPANJ_P = "ON_FETCH_KAMPANJ_KUND_KOMPANJ_P";
export const ON_FETCH_KAMPANJ_KUND_KOMPANJ_INNE = "ON_FETCH_KAMPANJ_KUND_KOMPANJ_INNE";

//set to Zero
export const SET_ZERO_KUND = "SET_ZERO_KUND";
export const SET_ZERO_AVTAL = "SET_ZERO_AVTAL";
export const SET_ZERO_PROSPEKT = "SET_ZERO_PROSPEKT";
export const SET_ZERO_ORDER = "SET_ZERO_ORDER";
export const SET_ZERO_EVENT = "SET_ZERO_EVENT";
export const SET_ZERO_INTRANET = "SET_ZERO_INTRANET";
export const SET_ZERO_OFFER = "SET_ZERO_OFFER";
export const SET_ZERO_AKTIVITET = "SET_ZERO_AKTIVITET";
export const SET_ZERO_USER = "SET_ZERO_USER";
export const SET_ZERO_DASHBOARD = "SET_ZERO_DASHBOARD";
export const SET_ZERO_AUTHENTICATION = "SET_ZERO_AUTHENTICATION";
export const SET_ZERO_ESIGNERING = "SET_ZERO_ESIGNERING";
export const SET_ZERO_ARENDE = "SET_ZERO_ARENDE";
export const SET_ZERO_DIALER = "SET_ZERO_DIALER";
export const SET_ZERO_OFFERT = "SET_ZERO_OFFERT";
export const SET_ZERO_PROJECT = "SET_ZERO_PROJECT";
export const ON_SET_KUND_SEARCH = "ON_SET_KUND_SEARCH";
export const ON_RESET_AKTIVITET_MESSAGE = "ON_RESET_AKTIVITET_MESSAGE";
//,  ,  ,
export const ON_START_GET_FORSALJING_ORGNR = "ON_START_GET_FORSALJING_ORGNR";
export const ON_GET_FORSALJING_ORGNR = "ON_GET_FORSALJING_ORGNR";
export const ON_ERROR_GET_FORSALJING_ORGNR = "ON_ERROR_GET_FORSALJING_ORGNR";
//CASE 
export const ON_START_NEW_CASE_TYPE = "ON_START_NEW_CASE_TYPE";
export const ON_NEW_CASE_TYPE = "ON_NEW_CASE_TYPE";
export const ON_ERROR_NEW_CASE_TYPE = "ON_ERROR_NEW_CASE_TYPE";
export const ON_START_GET_ARANDETYP_KUND = "ON_START_GET_ARANDETYP_KUND";
export const ON_FETCH_ARANDETYP_KUND = "ON_FETCH_ARANDETYP_KUND";
export const ON_ERROR_ARANDETYP_KUND = "ON_ERROR_ARANDETYP_KUND";
export const ON_START_NEW_CASE_CATE_TYPE = "ON_START_NEW_CASE_CATE_TYPE";
export const ON_NEW_CASE_CATE_TYPE = "ON_NEW_CASE_CATE_TYPE";
export const ON_ERROR_NEW_CASE_CATE_TYPE = "ON_ERROR_NEW_CASE_CATE_TYPE";
export const ON_START_DELETE_CASE_CATE_TYPE = "ON_START_DELETE_CASE_CATE_TYPE";
export const ON_DELETE_CASE_CATE_TYPE = "ON_DELETE_CASE_CATE_TYPE";
export const ON_ERROR_DELETE_CASE_CATE_TYPE = "ON_ERROR_DELETE_CASE_CATE_TYPE";
export const ON_START_DELETE_CASE_TYPE = "ON_START_DELETE_CASE_TYPE";
export const ON_DELETE_CASE_TYPE = "ON_DELETE_CASE_TYPE";
export const ON_ERROR_DELETE_CASE_TYPE = "ON_ERROR_DELETE_CASE_TYPE";
export const ON_START_NEW_ARANDE_EMAIL = "ON_START_NEW_ARANDE_EMAIL";
export const ON_NEW_ARANDE_EMAIL = "ON_NEW_ARANDE_EMAIL";
export const ON_ERROR_NEW_ARANDE_EMAIL = "ON_ERROR_NEW_ARANDE_EMAIL";
export const ON_START_DELETE_ARANDE_EMAIL = "ON_START_DELETE_ARANDE_EMAIL";
export const ON_DELETE_ARANDE_EMAIL = "ON_DELETE_ARANDE_EMAIL";
export const ON_ERROR_DELETE_ARANDE_EMAIL = "ON_ERROR_DELETE_ARANDE_EMAIL";
export const ON_START_UPDATEN_ARANDE_EMAIL = "ON_START_UPDATEN_ARANDE_EMAIL";
export const ON_UPDATEN_ARANDE_EMAIL = "ON_UPDATEN_ARANDE_EMAIL";
export const ON_ERROR_UPDATEN_ARANDE_EMAIL = "ON_ERROR_UPDATEN_ARANDE_EMAIL";

export const ON_GET_ONEDRIVE_ROOT = "ON_GET_ONEDRIVE_ROOT"
export const ON_ERROR_GET_ONEDRIVE_ROOT = "ON_ERROR_GET_ONEDRIVE_ROOT"
export const ON_START_GET_ONEDRIVE_ROOT = "ON_START_GET_ONEDRIVE_ROOT"
export const ON_GET_MY_DRIVES = "ON_GET_MY_DRIVES"
export const ON_ERROR_GET_MY_DRIVES = "ON_ERROR_GET_MY_DRIVES"
export const ON_START_GET_MY_DRIVES = "ON_START_GET_MY_DRIVES"
export const ON_ADD_ONEDRIVE_ROOT = "ON_ADD_ONEDRIVE_ROOT"
export const ON_ERROR_ADD_ONEDRIVE_ROOT = "ON_ERROR_ADD_ONEDRIVE_ROOT"
export const ON_START_ADD_ONEDRIVE_ROOT = "ON_START_ADD_ONEDRIVE_ROOT"

//, , ,
export const ON_START_GET_DASHBORAD_LINK = "ON_START_GET_DASHBORAD_LINK";
export const ON_FETCH_DASHBORAD_LINK = "ON_FETCH_DASHBORAD_LINK";
export const ON_ERROR_DASHBORAD_LINK = "ON_ERROR_DASHBORAD_LINK";
export const ON_START_GENERATE_DASHBORAD_LINK = "ON_START_GENERATE_DASHBORAD_LINK";
export const ON_GENERATE_DASHBORAD_LINK = "ON_GENERATE_DASHBORAD_LINK";
export const ON_ERROR_GENERATE_DASHBORAD_LINK = "ON_ERROR_GENERATE_DASHBORAD_LINK";
export const ON_START_GET_DASHBORAD_OBJEKT = "ON_START_GET_DASHBORAD_OBJEKT";
export const ON_FETCH_DASHBORAD_OBJEKT = "ON_FETCH_DASHBORAD_OBJEKT";
export const ON_ERROR_DASHBORAD_OBJEKT = "ON_ERROR_DASHBORAD_OBJEKT";
export const ON_START_GET_DASHBORAD_LOOP_OBJEKT = "ON_START_GET_DASHBORAD_LOOP_OBJEKT";
export const ON_FETCH_DASHBORAD_LOOP_OBJEKT = "ON_FETCH_DASHBORAD_LOOP_OBJEKT";
export const ON_ERROR_DASHBORAD_LOOP_OBJEKT = "ON_ERROR_DASHBORAD_LOOP_OBJEKT";
//
export const ON_START_GET_TILLGODO_KUND = "ON_START_GET_TILLGODO_KUND";
export const ON_FETCH_TILLGODO_KUND = "ON_FETCH_TILLGODO_KUND";
export const ON_ERROR_TILLGODO_KUND = "ON_ERROR_TILLGODO_KUND";
export const ON_START_INSERT_TILLGODO_KUND = "ON_START_INSERT_TILLGODO_KUND";
export const ON_INSERT_TILLGODO_KUND = "ON_INSERT_TILLGODO_KUND";
export const ON_ERROR_INSERT_TILLGODO_KUND = "ON_ERROR_INSERT_TILLGODO_KUND";
//, , ,
//
export const ON_START_CONNENCT_OUTLOOK = "ON_START_CONNENCT_OUTLOOK";
export const ON_CONNENCT_OUTLOOK = "ON_CONNENCT_OUTLOOK";
export const ON_ERROR_CONNENCT_OUTLOOK = "ON_ERROR_CONNENCT_OUTLOOK";
//Notis
export const ON_START_GET_NOTIS = "ON_START_GET_NOTIS";
export const ON_GET_NOTIS = "ON_GET_NOTIS";
export const ON_ERROR_GET_NOTIS = "ON_ERROR_GET_NOTIS";
//Itesco 
export const ON_START_IMPORT_ITESCO = "ON_START_IMPORT_ITESCO";
export const ON_IMPORT_ITESCO = "ON_IMPORT_ITESCO";
export const ON_ERROR_IMPORT_ITESCO = "ON_ERROR_IMPORT_ITESCO";
//SNABBORDER
export const ON_START_SNABB_ORDER = "ON_START_SNABB_ORDER";
export const ON_SNABB_ORDER = "ON_SNABB_ORDER";
export const ON_ERROR_SNABB_ORDER = "ON_ERROR_SNABB_ORDER";
//
export const ON_START_SNABB_VUNNEN = "ON_START_SNABB_VUNNEN";
export const ON_SNABB_VUNNEN = "ON_SNABB_VUNNEN";
export const ON_ERROR_SNABB_VUNNEN = "ON_ERROR_SNABB_VUNNEN";
//
export const ON_START_ORDER_DASHBOARD_UPDATE = "ON_START_ORDER_DASHBOARD_UPDATE";
export const ON_NEW_ORDER_DASHBOARD_UPDATE = "ON_NEW_ORDER_DASHBOARD_UPDATE";
export const ON_ERROR_ORDER_DASHBOARD_UPDATE = "ON_ERROR_ORDER_DASHBOARD_UPDATE";
//
export const ON_START_FETCH_ORDER_RAPPORT = "ON_START_FETCH_ORDER_RAPPORT";
export const ON_FETCH_ORDER_RAPPORT = "ON_FETCH_ORDER_RAPPORT";
export const ON_ERROR_FETCH_ORDER_RAPPORT = "ON_ERROR_FETCH_ORDER_RAPPORT";
//
export const ON_START_DELETE_KUND_DOCUMENT = "ON_START_DELETE_KUND_DOCUMENT";
export const ON_DELETE_KUND_DOCUMENT = "ON_DELETE_KUND_DOCUMENT";
export const ON_ERROR_DELETE_KUND_DOCUMENT = "ON_ERROR_DELETE_KUND_DOCUMENT";
//ON_AKTIVITET_ANTAL
export const ON_GET_ANTAL_AKTIVITETER_AVTAL = "ON_GET_ANTAL_AKTIVITETER_AVTAL";
export const ON_GET_ANTAL_AKTIVITETER_ARENDE = "ON_GET_ANTAL_AKTIVITETER_ARENDE";
//
export const ON_START_FETCH_ADMIN_STATISTIK = "ON_START_FETCH_ADMIN_STATISTIK";
export const ON_FETCH_ADMIN_STATISTIK = "ON_FETCH_ADMIN_STATISTIK";
export const ON_ERROR_ADMIN_STATISTIK = "ON_ERROR_ADMIN_STATISTIK";
//RAPPORT
export const ON_START_FETCH_RAPPORT = "ON_START_FETCH_RAPPORT";
export const ON_FETCH_RAPPORT = "ON_FETCH_RAPPORT";
export const ON_ERROR_FETCH_RAPPORT = "ON_ERROR_FETCH_RAPPORT";
export const ON_FETCH_RAPPORT_MESSAGE = "ON_FETCH_RAPPORT_MESSAGE";
export const ON_ERROR_FETCH_RAPPORT_MESSAGE = "ON_ERROR_FETCH_RAPPORT_MESSAGE";
//
export const ON_START_FETCH_MINAORT = "ON_START_FETCH_MINAORT";
export const ON_FETCH_MINAORT = "ON_FETCH_MINAORT";
export const ON_ERROR_MINAORT = "ON_ERROR_MINAORT";
//MinaTag
export const ON_START_FETCH_MINATAG = "ON_START_FETCH_MINATAG";
export const ON_FETCH_MINATAG = "ON_FETCH_MINATAG";
export const ON_ERROR_MINATAG = "ON_ERROR_MINATAG";

//RingList
export const ON_START_FETCH_HIT_COUNT = "ON_START_FETCH_HIT_COUNT";
export const ON_FETCH_HIT_COUNT = "ON_FETCH_HIT_COUNT";
export const ON_ERROR_FETCH_HIT_COUNT = "ON_ERROR_FETCH_HIT_COUNT";
export const ON_START_FETCH_RL_PREPARE = "ON_START_FETCH_RL_PREPARE";
export const ON_FETCH_RL_PREPARE = "ON_FETCH_RL_PREPARE";
export const ON_ERROR_FETCH_RL_PREPARE = "ON_ERROR_FETCH_RL_PREPARE";
export const ON_START_FETCH_KUND_LIST = "ON_START_FETCH_KUND_LIST";
export const ON_FETCH_KUND_LIST = "ON_FETCH_KUND_LIST";
export const ON_ERROR_FETCH_KUND_LIST = "ON_ERROR_FETCH_KUND_LIST";
export const ON_START_NEW_RINGLIST = "ON_START_NEW_RINGLIST";
export const ON_NEW_RINGLIST = "ON_NEW_RINGLIST";
export const ON_ERROR_NEW_RINGLIST = "ON_ERROR_NEW_RINGLIST";
//

export const ON_START_FETCH_KAMPANJER_ALL = "ON_START_FETCH_KAMPANJER_ALL";
export const ON_FETCH_KAMPANJER_ALL = "ON_FETCH_KAMPANJER_ALL";
export const ON_ERROR_FETCH_KAMPANJER_ALL = "ON_ERROR_FETCH_KAMPANJER_ALL";

export const ON_START_FETCH_KAMPANJER = "ON_START_FETCH_KAMPANJER";
export const ON_FETCH_KAMPANJER = "ON_FETCH_KAMPANJER";
export const ON_ERROR_FETCH_KAMPANJER = "ON_ERROR_FETCH_KAMPANJER";
export const ON_START_DELETE_KAMPANJER = "ON_START_DELETE_KAMPANJER";
export const ON_DELETE_KAMPANJER = "ON_DELETE_KAMPANJER";
export const ON_ERROR_DELETE_KAMPANJER = "ON_ERROR_DELETE_KAMPANJER";
export const ON_START_FETCH_KUND_LIST_BYID = "ON_START_FETCH_KUND_LIST_BYID";
export const ON_FETCH_KUND_LIST_BYID = "ON_FETCH_KUND_LIST_BYID";
export const ON_ERROR_FETCH_KUND_LIST_BYID = "ON_ERROR_FETCH_KUND_LIST_BYID";
export const ON_START_FETCH_KAMPANJ_BYID = "ON_START_FETCH_KAMPANJ_BYID";
export const ON_FETCH_KAMPANJ_BYID = "ON_FETCH_KAMPANJ_BYID";
export const ON_ERROR_FETCH_KAMPANJ_BYID = "ON_ERROR_FETCH_KAMPANJ_BYID";
export const ON_START_UPDATE_RINGLIST = "ON_START_UPDATE_RINGLIST";
export const ON_UPDATE_RINGLIST = "ON_UPDATE_RINGLIST";
export const ON_ERROR_UPDATE_RINGLIST = "ON_ERROR_UPDATE_RINGLIST";
export const ON_START_FETCH_KUND_LISTVY_BYID = "ON_START_FETCH_KUND_LISTVY_BYID";
export const ON_START_FETCH_KUND_LISTVY_BYID1 = "ON_START_FETCH_KUND_LISTVY_BYID1";
export const ON_FETCH_KUND_LISTVY_BYID = "ON_FETCH_KUND_LISTVY_BYID";
export const ON_ERROR_FETCH_KUND_LISTVY_BYID = "ON_ERROR_FETCH_KUND_LISTVY_BYID";
export const ON_START_FETCH_KUND_LISTVY_HR_BYID = "ON_START_FETCH_KUND_LISTVY_HR_BYID";
export const ON_FETCH_KUND_LISTVY_HR_BYID = "ON_FETCH_KUND_LISTVY_HR_BYID";
export const ON_ERROR_FETCH_KUND_LISTVY_HR_BYID = "ON_ERROR_FETCH_KUND_LISTVY_HR_BYID";
//,,
export const ON_START_FLAG_RINGLIST = "ON_START_FLAG_RINGLIST";
export const ON_FLAG_RINGLIST = "ON_FLAG_RINGLIST";
export const ON_ERROR_FLAG_RINGLIST = "ON_ERROR_FLAG_RINGLIST";
export const ON_START_FETCH_KAMPANJ_KUND = "ON_START_FETCH_KAMPANJ_KUND";
export const ON_FETCH_KAMPANJ_KUND = "ON_FETCH_KAMPANJ_KUND";
export const ON_ERROR_FETCH_KAMPANJ_KUND = "ON_ERROR_FETCH_KAMPANJ_KUND";
export const ON_SET_ZERO_KAMPANJ_KUND = "ON_SET_ZERO_KAMPANJ_KUND";
export const ON_START_KOMMENTAR_RINGLIST = "ON_START_KOMMENTAR_RINGLIST";
export const ON_KOMMENTAR_RINGLIST = "ON_KOMMENTAR_RINGLIST";
export const ON_KOMMENTAR_RINGLIST1 = "ON_KOMMENTAR_RINGLIST1";
export const ON_ERROR_KOMMENTAR_RINGLIST = "ON_ERROR_KOMMENTAR_RINGLIST";
export const ON_START_GET_AF_DIALER = "ON_START_GET_AF_DIALER";
export const ON_GET_AF_DIALER = "ON_GET_AF_DIALER";
export const ON_ERROR_GET_AF_DIALER = "ON_ERROR_GET_AF_DIALER";
export const ON_START_GET_USER_DIALER = "ON_START_GET_USER_DIALER";
export const ON_GET_USER_DIALER = "ON_GET_USER_DIALER";
export const ON_ERROR_GET_USER_DIALER = "ON_ERROR_GET_USER_DIALER";
export const ON_START_SAVE_USER_DIALER = "ON_START_SAVE_USER_DIALER";
export const ON_SAVE_USER_DIALER = "ON_SAVE_USER_DIALER";
export const ON_ERROR_SAVE_USER_DIALER = "ON_ERROR_SAVE_USER_DIALER";
//
export const ON_START_SAVE_DIALER = "ON_START_SAVE_DIALER";
export const ON_SAVE_DIALER = "ON_SAVE_DIALER";
export const ON_ERROR_SAVE_DIALER = "ON_ERROR_SAVE_DIALER";
export const ON_START_DIALER_ADD_EJSVAR = "ON_START_DIALER_ADD_EJSVAR";
export const ON_DIALER_ADD_EJSVAR = "ON_DIALER_ADD_EJSVAR";
export const ON_ERROR_DIALER_ADD_EJSVAR = "ON_ERROR_DIALER_ADD_EJSVAR";
export const ON_START_DIALER_ADD_NEJTACK = "ON_START_DIALER_ADD_NEJTACK";
export const ON_DIALER_ADD_NEJTACK = "ON_DIALER_ADD_NEJTACK";
export const ON_ERROR_DIALER_ADD_NEJTACK = "ON_ERROR_DIALER_ADD_NEJTACK";
export const ON_DIALER_DELETE_NEJTACK = "ON_DIALER_DELETE_NEJTACK";
export const ON_DIALER_DELETE_EJSVAR = "ON_DIALER_DELETE_EJSVAR";
export const ON_START_KAMPANJ_KUND_AKTIV = "ON_START_KAMPANJ_KUND_AKTIV";
export const ON_KAMPANJ_KUND_AKTIV = "ON_KAMPANJ_KUND_AKTIV";
export const ON_ERROR_KAMPANJ_KUND_AKTIV = "ON_ERROR_KAMPANJ_KUND_AKTIV";
export const ON_START_KAMPANJ_KUND_BOKAMOTE = "ON_START_KAMPANJ_KUND_BOKAMOTE";
export const ON_KAMPANJ_KUND_BOKAMOTE = "ON_KAMPANJ_KUND_BOKAMOTE";
export const ON_KAMPANJ_KUND_BOKAMOTE_D = "ON_KAMPANJ_KUND_BOKAMOTE_D";
export const ON_ERROR_KAMPANJ_KUND_BOKAMOTE = "ON_ERROR_KAMPANJ_KUND_BOKAMOTE";
export const ON_START_KAMPANJ_KUND_PROSPEKT = "ON_START_KAMPANJ_KUND_PROSPEKT";
export const ON_KAMPANJ_KUND_PROSPEKT = "ON_KAMPANJ_KUND_PROSPEKT";
export const ON_ERROR_KAMPANJ_KUND_PROSPEKT = "ON_ERROR_KAMPANJ_KUND_PROSPEKT";
export const ON_START_KAMPANJ_KUND_AVTAL = "ON_START_KAMPANJ_KUND_AVTAL";
export const ON_KAMPANJ_KUND_AVTAL = "ON_KAMPANJ_KUND_AVTAL";
export const ON_START_KAMPANJ_KUND_ESIGNERING = "ON_START_KAMPANJ_KUND_ESIGNERING";
export const ON_ERROR_KAMPANJ_KUND_ESIGNERING = "ON_ERROR_KAMPANJ_KUND_ESIGNERING";
export const ON_ERROR_KAMPANJ_KUND_AVTAL = "ON_ERROR_KAMPANJ_KUND_AVTAL";
export const ON_START_KAMPANJ_KUND_ORDER = "ON_START_KAMPANJ_KUND_ORDER";
export const ON_KAMPANJ_KUND_ORDER = "ON_KAMPANJ_KUND_ORDER";
export const ON_ERROR_KAMPANJ_KUND_ORDER = "ON_ERROR_KAMPANJ_KUND_ORDER";
export const ON_START_KAMPANJ_KUND_AKTIVITET = "ON_START_KAMPANJ_KUND_AKTIVITET";
export const ON_KAMPANJ_KUND_AKTIVITET = "ON_KAMPANJ_KUND_AKTIVITET";
export const ON_ERROR_KAMPANJ_KUND_AKTIVITET = "ON_ERROR_KAMPANJ_KUND_AKTIVITET";
export const ON_START_FETCH_RANDOM_KUND_LIST_BYID = "ON_START_FETCH_RANDOM_KUND_LIST_BYID";
export const ON_FETCH_RANDOM_KUND_LIST_BYID = "ON_FETCH_RANDOM_KUND_LIST_BYID";
export const ON_ERROR_FETCH_RANDOM_KUND_LIST_BYID = "ON_ERROR_FETCH_RANDOM_KUND_LIST_BYID";
export const ON_ERROR_FETCH_RANDOM_KUND_LIST_BYID_M = "ON_ERROR_FETCH_RANDOM_KUND_LIST_BYID_M";
export const ON_START_FETCH_KAMPANJ_MOTE = "ON_START_FETCH_KAMPANJ_MOTE";
export const ON_FETCH_KAMPANJ_MOTE = "ON_FETCH_KAMPANJ_MOTE";
export const ON_ERROR_FETCH_KAMPANJ_MOTE = "ON_ERROR_FETCH_KAMPANJ_MOTE";
export const ON_START_FETCH_KAMPANJ_PERATERKOMT = "ON_START_FETCH_KAMPANJ_PERATERKOMT";
export const ON_FETCH_KAMPANJ_PERATERKOMT = "ON_FETCH_KAMPANJ_PERATERKOMT";
export const ON_ERROR_FETCH_KAMPANJ_PERATERKOMT = "ON_ERROR_FETCH_KAMPANJ_PERATERKOMT";
export const ON_START_FETCH_SEARCH_DIALERVYN_1 = "ON_START_FETCH_SEARCH_DIALERVYN_1";
export const ON_START_FETCH_SEARCH_DIALERVYN = "ON_START_FETCH_SEARCH_DIALERVYN";
export const ON_FETCH_SEARCH_DIALERVYN = "ON_FETCH_SEARCH_DIALERVYN";
export const ON_FETCH_SEARCH_DIALERVYN_NOACCESS = "ON_FETCH_SEARCH_DIALERVYN_NOACCESS";
export const ON_ERROR_FETCH_SEARCH_DIALERVYN = "ON_ERROR_FETCH_SEARCH_DIALERVYN";
export const ON_START_IMPORT_RINGLIST = "ON_START_IMPORT_RINGLIST";
export const ON_IMPORT_RINGLIST = "ON_IMPORT_RINGLIST";
export const ON_ERROR_IMPORT_RINGLIST = "ON_ERROR_IMPORT_RINGLIST";
export const ON_START_FETCH_STATISTIC = "ON_START_FETCH_STATISTIC";
export const ON_FETCH_STATISTIC = "ON_FETCH_STATISTIC";
export const ON_ERROR_FETCH_STATISTIC = "ON_ERROR_FETCH_STATISTIC";
export const ON_START_FETCH_STATISTIC_KAMPANJER = "ON_START_FETCH_STATISTIC_KAMPANJER";
export const ON_FETCH_STATISTIC_KAMPANJER = "ON_FETCH_STATISTIC_KAMPANJER";
export const ON_ERROR_FETCH_STATISTIC_KAMPANJER = "ON_ERROR_FETCH_STATISTIC_KAMPANJER";
export const ON_START_KAMPANJ_ROMVE_BLIST = "ON_START_KAMPANJ_ROMVE_BLIST";
export const ON_KAMPANJ_KUND_ROMVE_BLIST = "ON_KAMPANJ_KUND_ROMVE_BLIST";
export const ON_ERROR_KAMPANJ_KUND_ROMVE_BLIST = "ON_ERROR_KAMPANJ_KUND_ROMVE_BLIST";
export const ON_START_FETCH_GET_KAMPANJER = "ON_START_FETCH_GET_KAMPANJER";
export const ON_FETCH_GET_KAMPANJER = "ON_FETCH_GET_KAMPANJER";
export const ON_ERROR_FETCH_GET_KAMPANJER = "ON_ERROR_FETCH_GET_KAMPANJER";
export const ON_START_DIALER_ADD_BORTFALL = "ON_START_DIALER_ADD_BORTFALL";
export const ON_DIALER_ADD_BORTFALL = "ON_DIALER_ADD_BORTFALL";
export const ON_ERROR_DIALER_ADD_BORTFALL = "ON_ERROR_DIALER_ADD_BORTFALL";
export const ON_DIALER_DELETE_BORTFALL = "ON_DIALER_DELETE_BORTFALL";
export const ON_DIALER_DELETE_BLACKLIST_TAGG = "ON_DIALER_DELETE_BLACKLIST_TAGG";
export const ON_START_DIALER_ADD_BLACKLIST_TAGG = "ON_START_DIALER_ADD_BLACKLIST_TAGG";
export const ON_DIALER_ADD_BLACKLIST_TAGG = "ON_DIALER_ADD_BLACKLIST_TAGG";
export const ON_ERROR_DIALER_ADD_BLACKLIST_TAGG = "ON_ERROR_DIALER_ADD_BLACKLIST_TAGG";
export const ON_START_FETCH_CHECK_ORGNR_LIST_BYID = "ON_START_FETCH_CHECK_ORGNR_LIST_BYID";
export const ON_FETCH_CHECK_ORGNR_BYID = "ON_FETCH_CHECK_ORGNR_BYID";
export const ON_ERROR_FETCH_CHECK_ORGNR_BYID = "ON_ERROR_FETCH_CHECK_ORGNR_BYID";


//
export const ON_START_ADD_DOCUMENT = "ON_START_ADD_DOCUMENT";
export const ON_ADD_DOCUMENT = "ON_ADD_DOCUMENT";
export const ON_ERROR_ADD_DOCUMENT = "ON_ERROR_ADD_DOCUMENT";
export const ON_START_UPDATE_KUND_DOCUMENT = "ON_START_UPDATE_KUND_DOCUMENT";
export const ON_UPDATE_KUND_DOCUMENT = "ON_UPDATE_KUND_DOCUMENT";
export const ON_ERROR_UPDATE_KUND_DOCUMENT = "ON_ERROR_UPDATE_KUND_DOCUMENT";
export const ON_START_SYNC_DOCUMENT_ONEDRIVE = "ON_START_SYNC_DOCUMENT_ONEDRIVE";
export const ON_SYNC_DOCUMENT_ONEDRIVE = "ON_SYNC_DOCUMENT_ONEDRIVE";
export const ON_ERROR_SYNC_DOCUMENT_ONEDRIVE = "ON_ERROR_SYNC_DOCUMENT_ONEDRIVE";
//
//dashbord
export const ON_START_FETCH_VUNNEN_MONTH = "ON_START_FETCH_VUNNEN_MONTH";
export const ON_FETCH_VUNNEN_MONTH = "ON_FETCH_VUNNEN_MONTH";
export const ON_ERROR_FETCH_VUNNEN_MONTH = "ON_ERROR_FETCH_VUNNEN_MONTH";
export const ON_START_FETCH_AVSLUTA_AFFAR = "ON_START_FETCH_AVSLUTA_AFFAR";
export const ON_FETCH_AVSLUTA_AFFAR = "ON_FETCH_AVSLUTA_AFFAR";
export const ON_ERROR_FETCH_AVSLUTA_AFFAR = "ON_ERROR_FETCH_AVSLUTA_AFFAR";
export const ON_START_FETCH_DASHORDER_LIST = "ON_START_FETCH_DASHORDER_LIST";
export const ON_FETCH_DASHORDER_LIST = "ON_FETCH_DASHORDER_LIST";
export const ON_ERROR_FETCH_DASHORDER_LIST = "ON_ERROR_FETCH_DASHORDER_LIST";
export const ON_START_FETCH_MOTE_MONTH = "ON_START_FETCH_MOTE_MONTH";
export const ON_FETCH_MOTE_MONTH = "ON_FETCH_MOTE_MONTH";
export const ON_ERROR_FETCH_MOTE_MONTH = "ON_ERROR_FETCH_MOTE_MONTH";
export const ON_START_FETCH_ABO_VUNNEN_MONTH = "ON_START_FETCH_ABO_VUNNEN_MONTH";
export const ON_FETCH_ABO_VUNNEN_MONTH = "ON_FETCH_ABO_VUNNEN_MONTH";
export const ON_ERROR_FETCH_ABO_VUNNEN_MONTH = "ON_ERROR_FETCH_ABO_VUNNEN_MONTH";
export const ON_START_FETCH_ABON_VUNNEN_MONTH = "ON_START_FETCH_ABON_VUNNEN_MONTH";
export const ON_FETCH_ABON_VUNNEN_MONTH = "ON_FETCH_ABON_VUNNEN_MONTH";
export const ON_ERROR_FETCH_ABON_VUNNEN_MONTH = "ON_ERROR_FETCH_ABON_VUNNEN_MONTH";
export const ON_START_FETCH_ORDER_VUNNEN_MONTH = "ON_START_FETCH_ORDER_VUNNEN_MONTH";
export const ON_FETCH_ORDER_VUNNEN_MONTH = "ON_FETCH_ORDER_VUNNEN_MONTH";
export const ON_ERROR_FETCH_ORDER_VUNNEN_MONTH = "ON_ERROR_FETCH_ORDER_VUNNEN_MONTH";
export const ON_START_FETCH_VUNNEN_CHART = "ON_START_FETCH_VUNNEN_CHART";
export const ON_FETCH_VUNNEN_CHART = "ON_FETCH_VUNNEN_CHART";
export const ON_ERROR_FETCH_VUNNEN_CHART = "ON_ERROR_FETCH_VUNNEN_CHART";
export const ON_FETCH_SUMMA_BILLING_AVTAL = "ON_FETCH_SUMMA_BILLING_AVTAL";
export const ON_ERROR_FETCH_SUMMA_BILLING_AVTAL = "ON_ERROR_FETCH_SUMMA_BILLING_AVTAL";
export const ON_START_FETCH_SUMMA_BILLING_AVTAL = "ON_START_FETCH_SUMMA_BILLING_AVTAL";
export const ON_FETCH_SUMMA_ABONNEMANG_AVTAL = "ON_FETCH_SUMMA_ABONNEMANG_AVTAL";
export const ON_ERROR_FETCH_SUMMA_ABONNEMANG_AVTAL = "ON_ERROR_FETCH_SUMMA_ABONNEMANG_AVTAL";
export const ON_START_FETCH_SUMMA_ABONNEMANG_AVTAL = "ON_START_FETCH_SUMMA_ABONNEMANG_AVTAL";
export const ON_START_FETCH_VUNNEN_MONTH_CHART = "ON_START_FETCH_VUNNEN_MONTH_CHART";
export const ON_FETCH_VUNNEN_MONTH_CHART = "ON_FETCH_VUNNEN_MONTH_CHART";
export const ON_ERROR_FETCH_VUNNEN_MONTH_CHART = "ON_ERROR_FETCH_VUNNEN_MONTH_CHART";
export const ON_START_FETCH_AKTIVITITER_CHART = "ON_START_FETCH_AKTIVITITER_CHART";
export const ON_FETCH_AKTIVITITER_CHART = "ON_FETCH_AKTIVITITER_CHART";
export const ON_ERROR_FETCH_AKTIVITITER_CHART = "ON_ERROR_FETCH_AKTIVITITER_CHART";
export const ON_START_FETCH_DASHBOARD_FILTER = "ON_START_FETCH_DASHBOARD_FILTER";
export const ON_FETCH_DASHBOARD_FILTER = "ON_FETCH_DASHBOARD_FILTER";
export const ON_ERROR_FETCH_DASHBOARD_FILTER = "ON_ERROR_FETCH_DASHBOARD_FILTER";
export const ON_START_FETCH_BESTLIST_DIALER_BYAFID = "ON_START_FETCH_BESTLIST_DIALER_BYAFID";
export const ON_FETCH_BESTLIST_DIALER_BYAFID = "ON_FETCH_BESTLIST_DIALER_BYAFID";
export const ON_ERROR_BESTLIST_DIALER_BYAFID = "ON_ERROR_BESTLIST_DIALER_BYAFID";
export const ON_START_FETCH_AKTIVAKUNDER_DIALER_BYAFID = "ON_START_FETCH_AKTIVAKUNDER_DIALER_BYAFID";
export const ON_FETCH_AKTIVAKUNDER_DIALER_BYAFID = "ON_FETCH_AKTIVAKUNDER_DIALER_BYAFID";
export const ON_ERROR_AKTIVAKUNDER_DIALER_BYAFID = "ON_ERROR_AKTIVAKUNDER_DIALER_BYAFID";
export const ON_GET_AKTIVAKUND_KONTAKTER = "ON_GET_AKTIVAKUND_KONTAKTER"
export const ON_START_GET_AKTIVAKUND_KONTAKTER = "ON_START_GET_AKTIVAKUND_KONTAKTER"
export const ON_ERROR_GET_AKTIVAKUND_KONTAKTER = "ON_ERROR_GET_AKTIVAKUND_KONTAKTER"
export const ON_START_FETCH_BOKAMOTE_DIALER_BYAFID = "ON_START_FETCH_BOKAMOTE_DIALER_BYAFID";
export const ON_FETCH_BOKAMOTE_DIALER_BYAFID = "ON_FETCH_BOKAMOTE_DIALER_BYAFID";
export const ON_ERROR_BOKAMOTE_DIALER_BYAFID = "ON_ERROR_BOKAMOTE_DIALER_BYAFID";
export const ON_START_FETCH_SALTABLE_DIALER_BYAFID = "ON_START_FETCH_SALTABLE_DIALER_BYAFID";
export const ON_FETCH_SALTABLE_DIALER_BYAFID = "ON_FETCH_SALTABLE_DIALER_BYAFID";
export const ON_ERROR_SALTABLE_DIALER_BYAFID = "ON_ERROR_SALTABLE_DIALER_BYAFID";
export const ON_START_FETCH_LYNES_SAMTAL_BYAFID = "ON_START_FETCH_LYNES_SAMTAL_BYAFID";
export const ON_FETCH_LYNES_SAMTAL_BYAFID = "ON_FETCH_LYNES_SAMTAL_BYAFID";
export const ON_ERROR_LYNES_SAMTAL_BYAFID = "ON_ERROR_LYNES_SAMTAL_BYAFID";
export const ON_START_FETCH_LYNES_SAMTAL_ANTAL_BYAFID = "ON_START_FETCH_LYNES_SAMTAL_ANTAL_BYAFID";
export const ON_FETCH_LYNES_SAMTAL_ANTAL_BYAFID = "ON_FETCH_LYNES_SAMTAL_ANTAL_BYAFID";
export const ON_ERROR_LYNES_SAMTAL_ANTAL_BYAFID = "ON_ERROR_LYNES_SAMTAL_ANTAL_BYAFID";
export const ON_START_FETCH_LYNES_SAMTAL_AVG_DUR_BYAFID = "ON_START_FETCH_LYNES_SAMTAL_AVG_DUR_BYAFID";
export const ON_FETCH_LYNES_SAMTAL_AVG_DUR_BYAFID = "ON_FETCH_LYNES_SAMTAL_AVG_DUR_BYAFID";
export const ON_ERROR_LYNES_SAMTAL_AVG_DUR_BYAFID = "ON_ERROR_LYNES_SAMTAL_AVG_DUR_BYAFID";

export const ON_START_FETCH_LYNES_SAMTAL_TABLE_BYAFID = "ON_START_FETCH_LYNES_SAMTAL_TABLE_BYAFID";
export const ON_FETCH_LYNES_SAMTAL_TABLE_BYAFID = "ON_FETCH_LYNES_SAMTAL_TABLE_BYAFID";
export const ON_ERROR_LYNES_SAMTAL_TABLE_BYAFID = "ON_ERROR_LYNES_SAMTAL_TABLE_BYAFID";
export const ON_START_FETCH_LYNES_SAMTAL_GRAPH_BYAFID = "ON_START_FETCH_LYNES_SGRAPH_TABLE_BYAFID";
export const ON_FETCH_LYNES_SAMTAL_GRAPH_BYAFID = "ON_FETCH_LYNES_SGRAPH_TABLE_BYAFID";
export const ON_ERROR_LYNES_SAMTAL_GRAPH_BYAFID = "ON_ERROR_LYNES_SGRAPH_TABLE_BYAFID";

export const ON_START_FETCH_LYNES_SAMTAL_HISTORY = "ON_START_FETCH_LYNES_SAMTAL_HISTORY";
export const ON_FETCH_LYNES_SAMTAL_HISTORY = "ON_FETCH_LYNES_SAMTAL_HISTORY";
export const ON_ERROR_LYNES_SAMTAL_HISTORY = "ON_ERROR_LYNES_SAMTAL_HISTORY";
export const ON_START_FETCH_AVSLUT_DIALER_BYAFID = "ON_START_FETCH_AVSLUT_DIALER_BYAFID";
export const ON_FETCH_AVSLUT_DIALER_BYAFID = "ON_FETCH_AVSLUT_DIALER_BYAFID";
export const ON_ERROR_AVSLUT_DIALER_BYAFID = "ON_ERROR_AVSLUT_DIALER_BYAFID";
export const ON_START_FETCH_STATUS_DIALER_BYAFID = "ON_START_FETCH_STATUS_DIALER_BYAFID";
export const ON_FETCH_STATUS_DIALER_BYAFID = "ON_FETCH_STATUS_DIALER_BYAFID";
export const ON_ERROR_STATUS_DIALER_BYAFID = "ON_ERROR_STATUS_DIALER_BYAFID";
export const ON_START_FETCH_AKTIVITED_DIALER_BYAFID = "ON_START_FETCH_AKTIVITED_DIALER_BYAFID";
export const ON_FETCH_AKTIVITED_DIALER_BYAFID = "ON_FETCH_AKTIVITED_DIALER_BYAFID";
export const ON_ERROR_AKTIVITED_DIALER_BYAFID = "ON_ERROR_AKTIVITED_DIALER_BYAFID";
export const ON_START_FETCH_TOPLIST_SAL_BYAFID = "ON_START_FETCH_TOPLIST_SAL_BYAFID";
export const ON_FETCH_TOPLIST_SAL_BYAFID = "ON_FETCH_TOPLIST_SAL_BYAFID";
export const ON_ERROR_TOPLIST_SAL_BYAFID = "ON_ERROR_TOPLIST_SAL_BYAFID";
export const ON_START_FETCH_TOPLIST_SALANTAL_BYAFID = "ON_START_FETCH_TOPLIST_SALANTAL_BYAFID";
export const ON_FETCH_TOPLIST_SALANTAL_BYAFID = "ON_FETCH_TOPLIST_SALANTAL_BYAFID";
export const ON_ERROR_TOPLIST_SALANTAL_BYAFID = "ON_ERROR_TOPLIST_SALANTAL_BYAFID";
export const ON_START_FETCH_AFFAR_SALANTAL_BYAFID = "ON_START_FETCH_AFFAR_SALANTAL_BYAFID";
export const ON_FETCH_AFFAR_SALANTAL_BYAFID = "ON_FETCH_AFFAR_SALANTAL_BYAFID";
export const ON_ERROR_AFFAR_SALANTAL_BYAFID = "ON_ERROR_AFFAR_SALANTAL_BYAFID";
export const ON_START_FETCH_AFFAR_SAL_BYAFID = "ON_START_FETCH_AFFAR_SAL_BYAFID";
export const ON_FETCH_AFFAR_SAL_BYAFID = "ON_FETCH_AFFAR_SAL_BYAFID";
export const ON_ERROR_AFFAR_SAL_BYAFID = "ON_ERROR_AFFAR_SAL_BYAFID";
export const ON_START_FETCH_TOPLIST_BOK_BYAFID = "ON_START_FETCH_TOPLIST_BOK_BYAFID";
export const ON_FETCH_TOPLIST_BOK_BYAFID = "ON_FETCH_TOPLIST_BOK_BYAFID";
export const ON_ERROR_TOPLIST_BOK_BYAFID = "ON_ERROR_TOPLIST_BOK_BYAFID";
export const ON_START_FETCH_TOPLIST_ANTAL_BOK_BYAFID = "ON_START_FETCH_TOPLIST_ANTAL_BOK_BYAFID";
export const ON_FETCH_TOPLIST_ANTAL_BOK_BYAFID = "ON_FETCH_TOPLIST_ANTAL_BOK_BYAFID";
export const ON_ERROR_TOPLIST_ANTAL_BOK_BYAFID = "ON_ERROR_TOPLIST_ANTAL_BOK_BYAFID";
export const ON_START_FETCH_TOPLIST_ANTAL_TAGGAR_BYAFID = "ON_START_FETCH_TOPLIST_ANTAL_TAGGAR_BYAFID";
export const ON_FETCH_TOPLIST_ANTAL_TAGGAR_BYAFID = "ON_FETCH_TOPLIST_ANTAL_TAGGAR_BYAFID";
export const ON_ERROR_TOPLIST_ANTAL_TAGGAR_BYAFID = "ON_ERROR_TOPLIST_ANTAL_TAGGAR_BYAFID";
export const ON_START_FETCH_TOPLIST_ANTAL_BOK_BYAFID_B = "ON_START_FETCH_TOPLIST_ANTAL_BOK_BYAFID_B";
export const ON_FETCH_TOPLIST_ANTAL_BOK_BYAFID_B = "ON_FETCH_TOPLIST_ANTAL_BOK_BYAFID_B";
export const ON_ERROR_TOPLIST_ANTAL_BOK_BYAFID_B = "ON_ERROR_TOPLIST_ANTAL_BOK_BYAFID_B";
export const ON_START_FETCH_TOPLIST_ANTAL_BOK_BYAFID_G = "ON_START_FETCH_TOPLIST_ANTAL_BOK_BYAFID_G";
export const ON_FETCH_TOPLIST_ANTAL_BOK_BYAFID_G = "ON_FETCH_TOPLIST_ANTAL_BOK_BYAFID_G";
export const ON_ERROR_TOPLIST_ANTAL_BOK_BYAFID_G = "ON_ERROR_TOPLIST_ANTAL_BOK_BYAFID_G";
export const ON_START_FETCH_BOKAMOTE_ANTAL_BOKAV_BYAFID = "ON_START_FETCH_BOKAMOTE_ANTAL_BOKAV_BYAFID";
export const ON_FETCH_BOKAMOTE_ANTAL_BOKAV_BYAFID = "ON_FETCH_BOKAMOTE_ANTAL_BOKAV_BYAFID";
export const ON_ERROR_BOKAMOTE_ANTAL_BOKAV_BYAFID = "ON_ERROR_BOKAMOTE_ANTAL_BOKAV_BYAFID";
export const ON_START_FETCH_BOKAMOTE_ANTAL_BOKTILL_BYAFID = "ON_START_FETCH_BOKAMOTE_ANTAL_BOKTILL_BYAFID";
export const ON_FETCH_BOKAMOTE_ANTAL_BOKTILL_BYAFID = "ON_FETCH_BOKAMOTE_ANTAL_BOKTILL_BYAFID";
export const ON_ERROR_BOKAMOTE_ANTAL_BOKTILL_BYAFID = "ON_ERROR_BOKAMOTE_ANTAL_BOKTILL_BYAFID";
export const ON_START_FETCH_AVBOKAMOTE_ANTAL_BOKAV_BYAFID = "ON_START_FETCH_AVBOKAMOTE_ANTAL_BOKAV_BYAFID";
export const ON_FETCH_AVBOKAMOTE_ANTAL_BOKAV_BYAFID = "ON_FETCH_AVBOKAMOTE_ANTAL_BOKAV_BYAFID";
export const ON_ERROR_AVBOKAMOTE_ANTAL_BOKAV_BYAFID = "ON_ERROR_AVBOKAMOTE_ANTAL_BOKAV_BYAFID";
export const ON_START_FETCH_AVBOKAMOTE_ANTAL_BOKTILL_BYAFID = "ON_START_FETCH_AVBOKAMOTE_ANTAL_BOKTILL_BYAFID";
export const ON_FETCH_AVBOKAMOTE_ANTAL_BOKTILL_BYAFID = "ON_FETCH_AVBOKAMOTE_ANTAL_BOKTILL_BYAFID";
export const ON_ERROR_AVBOKAMOTE_ANTAL_BOKTILL_BYAFID = "ON_ERROR_AVBOKAMOTE_ANTAL_BOKTILL_BYAFID";
//
export const ON_START_FETCH_ANTAL_BOK_BYAFID = "ON_START_FETCH_ANTAL_BOK_BYAFID";
export const ON_FETCH_ANTAL_BOK_BYAFID = "ON_FETCH_ANTAL_BOK_BYAFID";
export const ON_ERROR_ANTAL_BOK_BYAFID = "ON_ERROR_ANTAL_BOK_BYAFID";
export const ON_START_FETCH_TABEL_BOK_BYAFID = "ON_START_FETCH_TABEL_BOK_BYAFID";
export const ON_FETCH_TABEL_BOK_BYAFID = "ON_FETCH_TABEL_BOK_BYAFID";
export const ON_ERROR_TABEL_BOK_BYAFID = "ON_ERROR_TABEL_BOK_BYAFID";
export const ON_START_FETCH_UTFALL_BOK_BYAFID = "ON_START_FETCH_UTFALL_BOK_BYAFID";
export const ON_FETCH_UTFALL_BOK_BYAFID = "ON_FETCH_UTFALL_BOK_BYAFID";
export const ON_ERROR_UTFALL_BOK_BYAFID = "ON_ERROR_UTFALL_BOK_BYAFID";
export const ON_START_FETCH_MONTH_PROSPEKTD_BYAFID = "ON_START_FETCH_MONTH_PROSPEKTD_BYAFID";
export const ON_FETCH_MONTH_PROSPEKTD_BYAFID = "ON_FETCH_MONTH_PROSPEKTD_BYAFID";
export const ON_ERROR_MONTH_PROSPEKTD_BYAFID = "ON_ERROR_MONTH_PROSPEKTD_BYAFID";
export const ON_START_FETCH_KVARTAL_PROSPEKTD_BYAFID = "ON_START_FETCH_KVARTAL_PROSPEKTD_BYAFID";
export const ON_FETCH_KVARTAL_PROSPEKTD_BYAFID = "ON_FETCH_KVARTAL_PROSPEKTD_BYAFID";
export const ON_ERROR_KVARTAL_PROSPEKTD_BYAFID = "ON_ERROR_KVARTAL_PROSPEKTD_BYAFID";
export const ON_START_FETCH_VUNNENLIST_PROSPEKTD_BYAFID = "ON_START_FETCH_VUNNENLIST_PROSPEKTD_BYAFID";
export const ON_FETCH_VUNNENLIST_PROSPEKTD_BYAFID = "ON_FETCH_VUNNENLIST_PROSPEKTD_BYAFID";
export const ON_ERROR_VUNNENLIST_PROSPEKTD_BYAFID = "ON_ERROR_VUNNENLIST_PROSPEKTD_BYAFID";
export const ON_START_FETCH_VUNNENLISTK_PROSPEKTD_BYAFID = "ON_START_FETCH_VUNNENLISTK_PROSPEKTD_BYAFID";
export const ON_FETCH_VUNNENLISTK_PROSPEKTD_BYAFID = "ON_FETCH_VUNNENLISTK_PROSPEKTD_BYAFID";
export const ON_ERROR_VUNNENLISTK_PROSPEKTD_BYAFID = "ON_ERROR_VUNNENLISTK_PROSPEKTD_BYAFID";
export const ON_START_FETCH_PIPELINE_PROSPEKTD_BYAFID = "ON_START_FETCH_PIPELINE_PROSPEKTD_BYAFID";
export const ON_FETCH_PIPELINE_PROSPEKTD_BYAFID = "ON_FETCH_PIPELINE_PROSPEKTD_BYAFID";
export const ON_ERROR_PIPELINE_PROSPEKTD_BYAFID = "ON_ERROR_PIPELINE_PROSPEKTD_BYAFID";
export const ON_START_FETCH_UTFALL_PROSPEKTD_BYAFID = "ON_START_FETCH_UTFALL_PROSPEKTD_BYAFID";
export const ON_FETCH_UTFALL_PROSPEKTD_BYAFID = "ON_FETCH_UTFALL_PROSPEKTD_BYAFID";
export const ON_ERROR_UTFALL_PROSPEKTD_BYAFID = "ON_ERROR_UTFALL_PROSPEKTD_BYAFID";

//Puls
export const ON_START_FETCH_UTFALL_PROBABILITY_PROSPEKT_BYAFID = "ON_START_FETCH_UTFALL_PROBABILITY_PROSPEKT_BYAFID";
export const ON_FETCH_UTFALL_PROBABILITY_PROSPEKT_BYAFID = "ON_FETCH_UTFALL_PROBABILITY_PROSPEKT_BYAFID";
export const ON_ERROR_UTFALL_PROBABILITY_PROSPEKT_BYAFID = "ON_ERROR_UTFALL_PROBABILITY_PROSPEKT_BYAFID";
export const ON_START_FETCH_UTFALL_ANTAL_PROSPEKT_BYAFID = "ON_START_FETCH_ANTAL_PROBABILITY_PROSPEKT_BYAFID";
export const ON_FETCH_UTFALL_ANTAL_PROSPEKT_BYAFID = "ON_FETCH_ANTAL_PROBABILITY_PROSPEKT_BYAFID";
export const ON_ERROR_UTFALL_ANTAL_PROSPEKT_BYAFID = "ON_ERROR_ANTAL_PROBABILITY_PROSPEKT_BYAFID";
export const ON_START_FETCH_AFFAR_PROBABILITY_SAL_BYAFID = "ON_START_FETCH_AFFAR_PROBABILITY_SAL_BYAFID";
export const ON_FETCH_AFFAR_PROBABILITY_SAL_BYAFID = "ON_FETCH_AFFAR_PROBABILITY_SAL_BYAFID";
export const ON_ERROR_AFFAR_PROBABILITY_SAL_BYAFID = "ON_ERROR_AFFAR_PROBABILITY_SAL_BYAFID";
export const ON_START_FETCH_PROSPEKTTYPE_ANTAL_BYAFID = "ON_START_FETCH_PROSPEKTTYPE_ANTAL_BYAFID";
export const ON_FETCH_PROSPEKTTYPE_ANTAL_BYAFID = "ON_FETCH_PROSPEKTTYPE_ANTAL_BYAFID";
export const ON_ERROR_PROSPEKTTYPE_ANTAL_BYAFID = "ON_ERROR_PROSPEKTTYPE_ANTAL_BYAFID";
export const ON_START_FETCH_TOPLIST_PROBABILITY_VALUE_BYAFID = "ON_START_FETCH_TOPLIST_PROBABILITY_VALUE_BYAFID";
export const ON_FETCH_TOPLIST_PROBABILITY_VALUE_BYAFID = "ON_FETCH_TOPLIST_PROBABILITY_VALUE_BYAFID";
export const ON_ERROR_TOPLIST_PROBABILITY_VALUE_BYAFID = "ON_ERROR_TOPLIST_PROBABILITY_VALUE_BYAFID";

export const ON_START_FETCH_UTFALLS_PROSPEKTD_BYAFID = "ON_START_FETCH_UTFALLS_PROSPEKTD_BYAFID";
export const ON_FETCH_UTFALLS_PROSPEKTD_BYAFID = "ON_FETCH_UTFALLS_PROSPEKTD_BYAFID";
export const ON_ERROR_UTFALLS_PROSPEKTD_BYAFID = "ON_ERROR_UTFALLS_PROSPEKTD_BYAFID";
export const ON_START_FETCH_KLARA_AKTIVITET_MONTH = "ON_START_FETCH_KLARA_AKTIVITET_MONTH";
export const ON_FETCH_KLARA_AKTIVITET_MONTH = "ON_FETCH_KLARA_AKTIVITET_MONTH";
export const ON_ERROR_FETCH_KLARA_AKTIVITET_MONTH = "ON_ERROR_FETCH_KLARA_AKTIVITET_MONTH";
export const ON_START_FETCH_SKAPAD_PROSPEKT_MONTH = "ON_START_FETCH_SKAPAD_PROSPEKT_MONTH";
export const ON_FETCH_SKAPAD_PROSPEKT_MONTH = "ON_FETCH_SKAPAD_PROSPEKT_MONTH";
export const ON_ERROR_FETCH_SKAPAD_PROSPEKT_MONTH = "ON_ERROR_FETCH_SKAPAD_PROSPEKT_MONTH";
//
export const ON_START_FETCH_AVTALINVOICING_TABLE_ABONN = "ON_START_FETCH_AVTALINVOICING_TABLE_ABONN";
export const ON_FETCH_AVTALINVOICING_TABLE_ABONN = "ON_FETCH_AVTALINVOICING_TABLE_ABONN";
export const ON_ERROR_FETCH_AVTALINVOICING_TABLE_ABONN = "ON_ERROR_FETCH_AVTALINVOICING_TABLE_ABONN";
export const ON_START_FETCH_AKTIVA_AVTAL = "ON_START_FETCH_AKTIVA_AVTAL";
export const ON_FETCH_AKTIVA_AVTAL = "ON_FETCH_AKTIVA_AVTAL";
export const ON_ERROR_FETCH_AKTIVA_AVTAL = "ON_ERROR_FETCH_AKTIVA_AVTAL";
export const ON_START_FETCH_AVTAL_TABLE_ABONN = "ON_START_FETCH_AVTAL_TABLE_ABONN";
export const ON_FETCH_AVTAL_TABLE_ABONN = "ON_FETCH_AVTAL_TABLE_ABONN";
export const ON_ERROR_FETCH_AVTAL_TABLE_ABONN = "ON_ERROR_FETCH_AVTAL_TABLE_ABONN";
export const ON_START_FETCH_AVTAL_TABLE_ENGÅNG = "ON_START_FETCH_AVTAL_TABLE_ENGÅNG";
export const ON_FETCH_AVTAL_TABLE_ENGÅNG = "ON_FETCH_AVTAL_TABLE_ENGÅNG";
export const ON_ERROR_FETCH_AVTAL_TABLE_ENGÅNG = "ON_ERROR_FETCH_AVTAL_TABLE_ENGÅNG";
export const ON_START_FETCH_AVTAL_TABLE_ALL = "ON_START_FETCH_AVTAL_TABLE_ALL";
export const ON_FETCH_AVTAL_TABLE_ALL = "ON_FETCH_AVTAL_TABLE_ALL";
export const ON_ERROR_FETCH_AVTAL_TABLE_ALL = "ON_ERROR_FETCH_AVTAL_TABLE_ALL";
export const ON_START_FETCH_AVTAL_GRAPH_VALUE_REMAINING = "ON_START_FETCH_AVTAL_GRAPH_VALUE_REMAINING";
export const ON_FETCH_AVTAL_GRAPH_VALUE_REMAINING = "ON_FETCH_AVTAL_GRAPH_VALUE_REMAINING";
export const ON_ERROR_FETCH_AVTAL_GRAPH_VALUE_REMAINING = "ON_ERROR_FETCH_AVTAL_GRAPH_VALUE_REMAINING";
export const ON_START_FETCH_AVTAL_SUM_VALUE_REMAINING = "ON_START_FETCH_AVTAL_SUM_VALUE_REMAINING";
export const ON_FETCH_AVTAL_SUM_VALUE_REMAINING = "ON_FETCH_AVTAL_SUM_VALUE_REMAINING";
export const ON_ERROR_FETCH_AVTAL_SUM_VALUE_REMAINING = "ON_ERROR_FETCH_AVTAL_SUM_VALUE_REMAINING";

export const ON_START_FETCH_SUMMA_OFFERT_MONTH = "ON_START_FETCH_SUMMA_OFFERT_MONTH";
export const ON_FETCH_SUMMA_OFFERT_MONTH = "ON_FETCH_SUMMA_OFFERT_MONTH";
export const ON_ERROR_FETCH_SUMMA_OFFERT_MONTH = "ON_ERROR_FETCH_SUMMA_OFFERT_MONTH";
export const ON_START_FETCH_GENOM_MOTE = "ON_START_FETCH_GENOM_MOTE";
export const ON_FETCH_GENOM_MOTE = "ON_FETCH_GENOM_MOTE";
export const ON_ERROR_FETCH_GENOM_MOTE = "ON_ERROR_FETCH_GENOM_MOTE";
export const ON_START_FETCH_AVBOKA_MOTE = "ON_START_FETCH_AVBOKA_MOTE";
export const ON_FETCH_AVBOKA_MOTE = "ON_FETCH_AVBOKA_MOTE";
export const ON_ERROR_FETCH_AVBOKA_MOTE = "ON_ERROR_FETCH_AVBOKA_MOTE";
export const ON_START_FETCH_BEFKUND_MOTE = "ON_START_FETCH_BEFKUND_MOTE";
export const ON_FETCH_BEFKUND_MOTE = "ON_FETCH_BEFKUND_MOTE";
export const ON_ERROR_FETCH_BEFKUND_MOTE = "ON_ERROR_FETCH_BEFKUND_MOTE";
export const ON_START_FETCH_NYKUND_MOTE = "ON_START_FETCH_NYKUND_MOTE";
export const ON_FETCH_NYKUND_MOTE = "ON_FETCH_NYKUND_MOTE";
export const ON_ERROR_FETCH_NYKUND_MOTE = "ON_ERROR_FETCH_NYKUND_MOTE";
export const ON_START_FETCH_NYUPPKUND_MOTE = "ON_START_FETCH_NYUPPKUND_MOTE";
export const ON_FETCH_NYUPPKUND_MOTE = "ON_FETCH_NYUPPKUND_MOTE";
export const ON_ERROR_FETCH_NYUPPKUND_MOTE = "ON_ERROR_FETCH_NYUPPKUND_MOTE";
export const ON_START_FETCH_TOPLIST_KONTOR_BYAFID = "ON_START_FETCH_TOPLIST_KONTOR_BYAFID";
export const ON_FETCH_TOPLIST_KONTOR_BYAFID = "ON_FETCH_TOPLIST_KONTOR_BYAFID";
export const ON_ERROR_TOPLIST_KONTOR_BYAFID = "ON_ERROR_TOPLIST_KONTOR_BYAFID";
export const ON_START_FETCH_LIST_KONTOR_BYAFID = "ON_START_FETCH_LIST_KONTOR_BYAFID";
export const ON_FETCH_LIST_KONTOR_BYAFID = "ON_FETCH_LIST_KONTOR_BYAFID";
export const ON_ERROR_LIST_KONTOR_BYAFID = "ON_ERROR_LIST_KONTOR_BYAFID";
export const ON_START_FETCH_UTFALLS_KONTOR_BYAFID = "ON_START_FETCH_UTFALLS_KONTOR_BYAFID";
export const ON_FETCH_UTFALLS_KONTOR_BYAFID = "ON_FETCH_UTFALLS_KONTOR_BYAFID";
export const ON_ERROR_UTFALLS_KONTOR_BYAFID = "ON_ERROR_UTFALLS_KONTOR_BYAFID";
export const ON_START_FETCH_UTFALLSPRO_KONTOR_BYAFID = "ON_START_FETCH_UTFALLSPRO_KONTOR_BYAFID";
export const ON_FETCH_UTFALLSPRO_KONTOR_BYAFID = "ON_FETCH_UTFALLSPRO_KONTOR_BYAFID";
export const ON_ERROR_UTFALLSPRO_KONTOR_BYAFID = "ON_ERROR_UTFALLSPRO_KONTOR_BYAFID";
export const ON_START_FETCH_UTFALLSORD_KONTOR_BYAFID = "ON_START_FETCH_UTFALLSORD_KONTOR_BYAFID";
export const ON_FETCH_UTFALLSORD_KONTOR_BYAFID = "ON_FETCH_UTFALLSORD_KONTOR_BYAFID";
export const ON_ERROR_UTFALLSORD_KONTOR_BYAFID = "ON_ERROR_UTFALLSORD_KONTOR_BYAFID";
export const ON_START_FETCH_UTFALLSKAKT_KONTOR_BYAFID = "ON_START_FETCH_UTFALLSKAKT_KONTOR_BYAFID";
export const ON_FETCH_UTFALLSKAKT_KONTOR_BYAFID = "ON_FETCH_UTFALLSKAKT_KONTOR_BYAFID";
export const ON_ERROR_UTFALLSKAKT_KONTOR_BYAFID = "ON_ERROR_UTFALLSKAKT_KONTOR_BYAFID";
export const ON_START_FETCH_UTFALLSNOFF_KONTOR_BYAFID = "ON_START_FETCH_UTFALLSNOFF_KONTOR_BYAFID";
export const ON_FETCH_UTFALLSNOFF_KONTOR_BYAFID = "ON_FETCH_UTFALLSNOFF_KONTOR_BYAFID";
export const ON_ERROR_UTFALLSNOFF_KONTOR_BYAFID = "ON_ERROR_UTFALLSNOFF_KONTOR_BYAFID";
export const ON_START_FETCH_UTFALLSBMOTE_KONTOR_BYAFID = "ON_START_FETCH_UTFALLSBMOTE_KONTOR_BYAFID";
export const ON_FETCH_UTFALLSBMOTE_KONTOR_BYAFID = "ON_FETCH_UTFALLSBMOTE_KONTOR_BYAFID";
export const ON_ERROR_UTFALLSBMOTE_KONTOR_BYAFID = "ON_ERROR_UTFALLSBMOTE_KONTOR_BYAFID";
export const ON_START_FETCH_LASTVUNNEN_KONTOR_BYAFID = "ON_START_FETCH_LASTVUNNEN_KONTOR_BYAFID";
export const ON_FETCH_LASTVUNNEN_KONTOR_BYAFID = "ON_FETCH_LASTVUNNEN_KONTOR_BYAFID";
export const ON_ERROR_LASTVUNNEN_KONTOR_BYAFID = "ON_ERROR_LASTVUNNEN_KONTOR_BYAFID";
export const ON_START_FETCH_BOKADE_KONTOR_BYAFID = "ON_START_FETCH_BOKADE_KONTOR_BYAFID";
export const ON_FETCH_BOKADE_KONTOR_BYAFID = "ON_FETCH_BOKADE_KONTOR_BYAFID";
export const ON_ERROR_BOKADE_KONTOR_BYAFID = "ON_ERROR_BOKADE_KONTOR_BYAFID";
export const ON_START_FETCH_COUNT_OFFERT_MONTH = "ON_START_FETCH_COUNT_OFFERT_MONTH";
export const ON_FETCH_COUNT_OFFERT_MONTH = "ON_FETCH_COUNT_OFFERT_MONTH";
export const ON_ERROR_FETCH_COUNT_OFFERT_MONTH = "ON_ERROR_FETCH_COUNT_OFFERT_MONTH";

export const ON_START_FETCH_COUNT_ARENDE_NY_MONTH = "ON_START_FETCH_COUNT_ARENDE_NY_MONTH";
export const ON_FETCH_COUNT_ARENDE_NY_MONTH = "ON_FETCH_COUNT_ARENDE_NY_MONTH";
export const ON_ERROR_FETCH_COUNT_ARENDE_NY_MONTH = "ON_ERROR_FETCH_COUNT_ARENDE_NY_MONTH";
export const ON_START_FETCH_COUNT_ARENDE_KLARA_MONTH = "ON_START_FETCH_COUNT_ARENDE_KLARA_MONTH";
export const ON_FETCH_COUNT_ARENDE_KLARA_MONTH = "ON_FETCH_COUNT_ARENDE_KLARA_MONTH";
export const ON_ERROR_FETCH_COUNT_ARENDE_KLARA_MONTH = "ON_ERROR_FETCH_COUNT_ARENDE_KLARA_MONTH";
export const ON_START_FETCH_COUNT_ARENDE_OPPNA_MONTH = "ON_START_FETCH_COUNT_ARENDE_OPPNA_MONTH";
export const ON_FETCH_COUNT_ARENDE_OPPNA_MONTH = "ON_FETCH_COUNT_ARENDE_OPPNA_MONTH";
export const ON_ERROR_FETCH_COUNT_ARENDE_OPPNA_MONTH = "ON_ERROR_FETCH_COUNT_ARENDE_OPPNA_MONTH";
export const ON_START_FETCH_COUNT_ARENDE_NYA_TOP_LIST = "ON_START_FETCH_COUNT_ARENDE_NYA_TOP_LIST";
export const ON_FETCH_COUNT_ARENDE_NYA_TOP_LIST  = "ON_FETCH_COUNT_ARENDE_NYA_TOP_LIST";
export const ON_ERROR_FETCH_COUNT_ARENDE_NYA_TOP_LIST  = "ON_ERROR_FETCH_COUNT_ARENDE_NYA_TOP_LIST";
export const ON_START_FETCH_COUNT_ARENDE_NYA_PAGAENDE_ALDER = "ON_START_FETCH_COUNT_ARENDE_NYA_PAGAENDE_ALDER";
export const ON_FETCH_COUNT_ARENDE_NYA_PAGAENDE_ALDER  = "ON_FETCH_COUNT_ARENDE_NYA_PAGAENDE_ALDER";
export const ON_ERROR_FETCH_COUNT_ARENDE_NYA_PAGAENDE_ALDER  = "ON_ERROR_FETCH_COUNT_ARENDE_NYA_PAGAENDE_ALDER";
export const ON_START_FETCH_COUNT_ARENDE_NYA_STANGDA_YEAR = "ON_START_FETCH_COUNT_ARENDE_NYA_STANGDA_YEAR";
export const ON_FETCH_COUNT_ARENDE_NYA_STANGDA_YEAR  = "ON_FETCH_COUNT_ARENDE_NYA_STANGDA_YEAR";
export const ON_ERROR_FETCH_COUNT_ARENDE_NYA_STANGDA_YEAR  = "ON_ERROR_FETCH_COUNT_ARENDE_NYA_STANGDA_YEAR";
export const ON_START_FETCH_COUNT_LAST_ARENDE = "ON_START_FETCH_COUNT_LAST_ARENDE";
export const ON_FETCH_COUNT_LAST_ARENDE  = "ON_FETCH_COUNT_LAST_ARENDE";
export const ON_ERROR_FETCH_COUNT_LAST_ARENDE  = "ON_ERROR_FETCH_COUNT_LAST_ARENDE";

export const ON_START_FETCH_COUNT_AVTAL_LOPERUT_OMFOR_YEAR = "ON_START_FETCH_COUNT_AVTAL_LOPERUT_OMFOR_YEAR";
export const ON_FETCH_COUNT_AVTAL_LOPERUT_OMFOR_YEAR  = "ON_FETCH_COUNT_AVTAL_LOPERUT_OMFOR_YEAR";
export const ON_ERROR_FETCH_COUNT_AVTAL_LOPERUT_OMFOR_YEAR  = "ON_ERROR_FETCH_COUNT_AVTAL_LOPERUT_OMFOR_YEAR";
export const ON_START_FETCH_AVTAL_TYPE_ANTAL_BYAFID = "ON_START_FETCH_AVTAL_TYPE_ANTAL_BYAFID";
export const ON_FETCH_AVTAL_TYPE_ANTAL_BYAFID = "ON_FETCH_AVTAL_TYPE_ANTAL_BYAFID";
export const ON_ERROR_AVTAL_TYPE_ANTAL_BYAFID = "ON_ERROR_AVTAL_TYPE_ANTAL_BYAFID";
export const ON_START_FETCH_AVTAL_GROWTH_BYAFID = "ON_START_FETCH_AVTAL_GROWTH_BYAFID";
export const ON_FETCH_AVTAL_GROWTH_BYAFID = "ON_FETCH_AVTAL_GROWTH_BYAFID";
export const ON_ERROR_AVTAL_GROWTH_BYAFID = "ON_ERROR_AVTAL_GROWTH_BYAFID";
export const ON_START_FETCH_AVTAL_VALUE_SAL_BYAFID = "ON_START_FETCH_AVTAL_VALUE_SAL_BYAFID";
export const ON_FETCH_AVTAL_VALUE_SAL_BYAFID = "ON_FETCH_AVTAL_VALUE_SAL_BYAFID";
export const ON_ERROR_AVTAL_VALUE_SAL_BYAFID = "ON_ERROR_AVTAL_VALUE_SAL_BYAFID";
export const ON_START_FETCH_AVTAL_VALUE_YEAR_BYAFID = "ON_START_FETCH_AVTAL_VALUE_YEAR_BYAFID";
export const ON_FETCH_AVTAL_VALUE_YEAR_BYAFID = "ON_FETCH_AVTAL_VALUE_YEAR_BYAFID";
export const ON_ERROR_AVTAL_VALUE_YEAR_BYAFID = "ON_ERROR_AVTAL_VALUE_YEAR_BYAFID";
export const ON_START_FETCH_AVTAL_VALUE_BILLING_SAL_BYAFID = "ON_START_FETCH_AVTAL_VALUE_BILLING_SAL_BYAFID";
export const ON_FETCH_AVTAL_VALUE_BILLING_SAL_BYAFID = "ON_FETCH_AVTAL_VALUE_BILLING_SAL_BYAFID";
export const ON_ERROR_AVTAL_VALUE_BILLING_SAL_BYAFID = "ON_ERROR_AVTAL_VALUE_BILLING_SAL_BYAFID";
export const ON_START_FETCH_AVTAL_VALUE_BILLING_YEAR_SAL_BYAFID = "ON_START_FETCH_AVTAL_VALUE_BILLING_YEAR_SAL_BYAFID";
export const ON_FETCH_AVTAL_VALUE_BILLING_YEAR_SAL_BYAFID = "ON_FETCH_AVTAL_VALUE_BILLING_YEAR_SAL_BYAFID";
export const ON_ERROR_AVTAL_VALUE_BILLING_YEAR_SAL_BYAFID = "ON_ERROR_AVTAL_VALUE_BILLING_YEAR_SAL_BYAFID";

export const ON_START_FETCH_PROJECT_WORKLOAD = "ON_START_FETCH_PROJECT_WORKLOAD";
export const ON_FETCH_PROJECT_WORKLOAD = "ON_FETCH_PROJECT_WORKLOAD";
export const ON_ERROR_FETCH_PROJECT_WORKLOAD = "ON_ERROR_FETCH_PROJECT_WORKLOAD";
export const ON_START_FETCH_PROJECT_CREATEDVSCOMPLETED = "ON_START_FETCH_PROJECT_CREATEDVSCOMPLETED";
export const ON_FETCH_PROJECT_CREATEDVSCOMPLETED = "ON_FETCH_PROJECT_CREATEDVSCOMPLETED";
export const ON_ERROR_FETCH_PROJECT_CREATEDVSCOMPLETED = "ON_ERROR_FETCH_PROJECT_CREATEDVSCOMPLETED";
export const ON_START_FETCH_PROJECT_TASKS = "ON_START_FETCH_PROJECT_TASKS";
export const ON_FETCH_PROJECT_TASKS = "ON_FETCH_PROJECT_TASKS";
export const ON_ERROR_FETCH_PROJECT_TASKS = "ON_ERROR_FETCH_PROJECT_TASKS";
export const ON_START_FETCH_PROJECT_TIMESPENT = "ON_START_FETCH_PROJECT_TIMESPENT";
export const ON_FETCH_PROJECT_TIMESPENT = "ON_FETCH_PROJECT_TIMESPENT";
export const ON_ERROR_FETCH_PROJECT_TIMESPENT = "ON_ERROR_FETCH_PROJECT_TIMESPENT";
export const ON_START_FETCH_PROJECT_AHEAD_BEHIND = "ON_START_FETCH_PROJECT_AHEAD_BEHIND";
export const ON_FETCH_PROJECT_AHEAD_BEHIND = "ON_FETCH_PROJECT_AHEAD_BEHIND";
export const ON_ERROR_FETCH_PROJECT_AHEAD_BEHIND = "ON_ERROR_FETCH_PROJECT_AHEAD_BEHIND";
export const ON_START_FETCH_PROJECT_STATUS_LIST_ANTAL = "ON_START_FETCH_PROJECT_STATUS_LIST_ANTAL";
export const ON_FETCH_PROJECT_STATUS_LIST_ANTAL = "ON_FETCH_PROJECT_STATUS_LIST_ANTAL";
export const ON_ERROR_FETCH_PROJECT_STATUS_LIST_ANTAL = "ON_ERROR_FETCH_PROJECT_STATUS_LIST_ANTAL";
export const ON_START_FETCH_PROJECT_DEADLINE_LIST_ANTAL = "ON_START_FETCH_PROJECT_DEADLINE_LIST_ANTAL";
export const ON_FETCH_PROJECT_DEADLINE_LIST_ANTAL = "ON_FETCH_PROJECT_DEADLINE_LIST_ANTAL";
export const ON_ERROR_FETCH_PROJECT_DEADLINE_LIST_ANTAL = "ON_ERROR_FETCH_PROJECT_DEADLINE_LIST_ANTAL";

export const ON_START_FETCH_PROJECT_KLARA_KORT_TM = "ON_START_FETCH_PROJECT_KLARA_KORT_TM";
export const ON_FETCH_PROJECT_KLARA_KORT_TM = "ON_FETCH_PROJECT_KLARA_KORT_TM";
export const ON_ERROR_FETCH_PROJECT_KLARA_KORT_TM = "ON_ERROR_FETCH_PROJECT_KLARA_KORT_TM";
export const ON_START_FETCH_PROJECT_KORT_KVAR_TM = "ON_START_FETCH_PROJECT_KORT_KVAR_TM";
export const ON_FETCH_PROJECT_KORT_KVAR_TM = "ON_FETCH_PROJECT_KORT_KVAR_TM";
export const ON_ERROR_FETCH_PROJECT_KORT_KVAR_TM = "ON_ERROR_FETCH_PROJECT_KORT_KVAR_TM";

export const ON_START_FETCH_UTFALL_BOK_BUDGET_BYAFID = "ON_START_FETCH_UTFALL_BOK_BUDGET_BYAFID";
export const ON_FETCH_UTFALL_BOK_BUDGET_BYAFID = "ON_FETCH_UTFALL_BOK_BUDGET_BYAFID";
export const ON_ERROR_UTFALL_BOK_BUDGET_BYAFID = "ON_ERROR_UTFALL_BOK_BUDGET_BYAFID";
export const ON_START_FETCH_ORDERTYPE_ANTAL_BYAFID = "ON_START_FETCH_ORDERTYPE_ANTAL_BYAFID";
export const ON_FETCH_ORDERTYPE_ANTAL_BYAFID = "ON_FETCH_ORDERTYPE_ANTAL_BYAFID";
export const ON_ERROR_ORDERTYPE_ANTAL_BYAFID = "ON_ERROR_ORDERTYPE_ANTAL_BYAFID";
export const ON_START_FETCH_ARTIKLAR_ANTAL_BYAFID = "ON_START_FETCH_ARTIKLAR_ANTAL_BYAFID";
export const ON_FETCH_ARTIKLAR_ANTAL_BYAFID = "ON_FETCH_ARTIKLAR_ANTAL_BYAFID";
export const ON_ERROR_ARTIKLAR_ANTAL_BYAFID = "ON_ERROR_ARTIKLAR_ANTAL_BYAFID";
export const ON_START_FETCH_NY_ORDER_ANTAL_BYAFID = "ON_START_FETCH_NY_ORDER_ANTAL_BYAFID";
export const ON_FETCH_NY_ORDER_ANTAL_BYAFID = "ON_FETCH_NY_ORDER_ANTAL_BYAFID";
export const ON_ERROR_NY_ORDER_ANTAL_BYAFID = "ON_ERROR_NY_ORDER_ANTAL_BYAFID";
export const ON_START_FETCH_NY_ORDER_ARTIKLAR_ANTAL_BYAFID = "ON_START_FETCH_NY_ORDER_ARTIKLAR_ANTAL_BYAFID";
export const ON_FETCH_NY_ORDER_ARTIKLAR_ANTAL_BYAFID = "ON_FETCH_NY_ORDER_ARTIKLAR_ANTAL_BYAFID";
export const ON_ERROR_NY_ORDER_ARTIKLAR_ANTAL_BYAFID = "ON_ERROR_NY_ORDER_ARTIKLAR_ANTAL_BYAFID";
export const ON_START_FETCH_STATUS_ORDER_ANTAL_BYAFID = "ON_START_FETCH_STATUS_ORDER_ANTAL_BYAFID";
export const ON_FETCH_STATUS_ORDER_ANTAL_BYAFID = "ON_FETCH_STATUS_ORDER_ANTAL_BYAFID";
export const ON_ERROR_STATUS_ORDER_ANTAL_BYAFID = "ON_ERROR_STATUS_ORDER_ANTAL_BYAFID";
export const ON_START_FETCH_STATUS_HAS_ABONN = "ON_START_FETCH_STATUS_HAS_ABONN";
export const ON_FETCH_STATUS_HAS_ABONN = "ON_FETCH_STATUS_HAS_ABONN";
export const ON_ERROR_STATUS_HAS_ABONN = "ON_ERROR_STATUS_HAS_ABONN";
export const ON_START_FETCH_STATUS_HAS_ORERV = "ON_START_FETCH_STATUS_HAS_ORERV";
export const ON_FETCH_STATUS_HAS_ORERV = "ON_FETCH_STATUS_HAS_ORERV";
export const ON_ERROR_STATUS_HAS_ORERV = "ON_ERROR_STATUS_HAS_ORERV";
export const ON_START_FETCH_ORDER_VARDE_YEAR = "ON_START_FETCH_ORDER_VARDE_YEAR";
export const ON_FETCH_ORDER_VARDE_YEAR = "ON_FETCH_ORDER_VARDE_YEAR";
export const ON_ERROR_ORDER_VARDE_YEAR = "ON_ERROR_ORDER_VARDE_YEAR";
export const ON_START_FETCH_TOPLIST_CHILD_KONTO_BYAFID = "ON_START_FETCH_TOPLIST_CHILD_KONTO_BYAFID";
export const ON_FETCH_TOPLIST_CHILD_KONTO_BYAFID = "ON_FETCH_TOPLIST_CHILD_KONTO_BYAFID";
export const ON_ERROR_TOPLIST_CHILD_KONTO_BYAFID = "ON_ERROR_TOPLIST_CHILD_KONTO_BYAFID";
export const ON_START_FETCH_LIST_CHILD_KONTO_BYAFID = "ON_START_FETCH_LIST_CHILD_KONTO_BYAFID";
export const ON_FETCH_LIST_CHILD_KONTO_BYAFID = "ON_FETCH_LIST_CHILD_KONTO_BYAFID";
export const ON_ERROR_LIST_CHILD_KONTO_BYAFID = "ON_ERROR_LIST_CHILD_KONTO_BYAFID";
export const ON_START_FETCH_UTFALLS_CHILD_KONTO_BYAFID = "ON_START_FETCH_UTFALLS_CHILD_KONTO_BYAFID";
export const ON_FETCH_UTFALLS_CHILD_KONTO_BYAFID = "ON_FETCH_UTFALLS_CHILD_KONTO_BYAFID";
export const ON_ERROR_UTFALLS_CHILD_KONTO_BYAFID = "ON_ERROR_UTFALLS_CHILD_KONTO_BYAFID";
export const ON_START_FETCH_UTFALLSORD_CHILD_KONTO_BYAFID = "ON_START_FETCH_UTFALLSORD_CHILD_KONTO_BYAFID";
export const ON_FETCH_UTFALLSORD_CHILD_KONTO_BYAFID = "ON_FETCH_UTFALLSORD_CHILD_KONTO_BYAFID";
export const ON_ERROR_UTFALLSORD_CHILD_KONTO_BYAFID = "ON_ERROR_UTFALLSORD_CHILD_KONTO_BYAFID";
export const ON_START_FETCH_ORDRAR_CHILD_KONTO_BYAFID = "ON_START_FETCH_ORDRAR_CHILD_KONTO_BYAFID";
export const ON_FETCH_ORDRAR_CHILD_KONTO_BYAFID = "ON_FETCH_ORDRAR_CHILD_KONTO_BYAFID";
export const ON_ERROR_ORDRAR_CHILD_KONTO_BYAFID = "ON_ERROR_ORDRAR_CHILD_KONTO_BYAFID";
export const ON_START_FETCH_UTFALLSBMOTE_CHILD_KONTO_BYAFID = "ON_START_FETCH_UTFALLSBMOTE_CHILD_KONTO_BYAFID";
export const ON_FETCH_UTFALLSBMOTE_CHILD_KONTO_BYAFID = "ON_FETCH_UTFALLSBMOTE_CHILD_KONTO_BYAFID";
export const ON_ERROR_UTFALLSBMOTE_CHILD_KONTO_BYAFID = "ON_ERROR_UTFALLSBMOTE_CHILD_KONTO_BYAFID";
export const ON_START_FETCH_LASTVUNNEN_CHILD_KONTO_BYAFID = "ON_START_FETCH_LASTVUNNEN_CHILD_KONTO_BYAFID";
export const ON_FETCH_LASTVUNNEN_CHILD_KONTO_BYAFID = "ON_FETCH_LASTVUNNEN_CHILD_KONTO_BYAFID";
export const ON_ERROR_LASTVUNNEN_CHILD_KONTO_BYAFID = "ON_ERROR_LASTVUNNEN_CHILD_KONTO_BYAFID";
export const ON_START_FETCH_BOKADE_CHILD_KONTO_BYAFID = "ON_START_FETCH_BOKADE_CHILD_KONTO_BYAFID";
export const ON_FETCH_BOKADE_CHILD_KONTO_BYAFID = "ON_FETCH_BOKADE_CHILD_KONTO_BYAFID";
export const ON_ERROR_BOKADE_CHILD_KONTO_BYAFID = "ON_ERROR_BOKADE_CHILD_KONTO_BYAFID";


//
//Filter
export const ON_OPEN_FILTER_AVTAL = "ON_OPEN_FILTER_AVTAL";
export const ON_OPEN_FILTER_PROSPEKT = "ON_OPEN_FILTER_PROSPEKT";
export const ON_OPEN_FILTER_AKTIVITETER = "ON_OPEN_FILTER_AKTIVITETER";
export const ON_OPEN_FILTER_KUNDER = "ON_OPEN_FILTER_KUNDER";

export const ON_OPEN_FILTER_ESIGNERING = "ON_OPEN_FILTER_ESIGNERING";
export const ON_OPEN_FILTER_ORDER = "ON_OPEN_FILTER_ORDER";
export const ON_OPEN_FILTER_MOTE = "ON_OPEN_FILTER_MOTE";
export const ON_OPEN_FILTER_DASHBOARD = "ON_OPEN_FILTER_DASHBOARD";
export const ON_OPEN_FILTER_DASHBOARD_SALJ = "ON_OPEN_FILTER_DASHBOARD_SALJ";
export const ON_OPEN_FILTER_ARENDE = "ON_OPEN_FILTER_ARENDE";
export const ON_OPEN_FILTER_PROJEKT = "ON_OPEN_FILTER_PROJEKT";
export const ON_OPEN_FILTER_ARTIKLAR = "ON_OPEN_FILTER_ARTIKLAR";
export const ON_OPEN_FILTER_USERS = "ON_OPEN_FILTER_USERS";
export const ON_OPEN_FILTER_SMSS = "ON_OPEN_FILTER_SMSS";
export const ON_OPEN_FILTER_CAMPAIGN = "ON_OPEN_FILTER_CAMPAIGN";
export const ON_OPEN_FILTER_PROJEKTKORT = "ON_OPEN_FILTER_PROJEKTKORT";
export const ON_OPEN_FILTER_DASHBOARD_BOKA = "ON_OPEN_FILTER_DASHBOARD_BOKA";
export const ON_OPEN_FILTER_DASHBOARD_DIALER = "ON_OPEN_FILTER_DASHBOARD_DIALER";
export const ON_OPEN_FILTER_DASHBOARD_ORDER = "ON_OPEN_FILTER_DASHBOARD_ORDER";
export const ON_OPEN_FILTER_DASHBOARD_BARN = "ON_OPEN_FILTER_DASHBOARD_BARN";
export const ON_ClOSE_FILTER_DASHBOARD_BARN = "ON_ClOSE_FILTER_DASHBOARD_BARN";
export const SET_DASHBORD_BARN_FILTER = "SET_DASHBORD_BARN_FILTER";
export const SET_DASHBORD_PROSPEKT_FILTER = "SET_DASHBORD_PROSPEKT_FILTER";
export const SET_DASHBORD_PULS_FILTER = "SET_DASHBORD_PULS_FILTER";
export const SET_DASHBORD_KONTOR_FILTER = "SET_DASHBORD_KONTOR_FILTER";
export const ON_ClOSE_FILTER_DASHBOARD_PROSPEKT = "ON_ClOSE_FILTER_DASHBOARD_PROSPEKT";
export const ON_OPEN_FILTER_DASHBOARD_PROSPEKT = "ON_OPEN_FILTER_DASHBOARD_PROSPEKT";
export const ON_ClOSE_FILTER_DASHBOARD_PULS = "ON_ClOSE_FILTER_DASHBOARD_PULS";
export const ON_OPEN_FILTER_DASHBOARD_PULS = "ON_OPEN_FILTER_DASHBOARD_PULS";
export const ON_OPEN_FILTER_DASHBOARD_KONTOR = "ON_OPEN_FILTER_DASHBOARD_KONTOR";
export const ON_ClOSE_FILTER_DASHBOARD_KONTOR = "ON_ClOSE_FILTER_DASHBOARD_KONTOR";
export const ON_ClOSE_FILTER_USERS = "ON_ClOSE_FILTER_USERS";
export const ON_ClOSE_FILTER_SMSS = "ON_ClOSE_FILTER_SMSS";
export const ON_ClOSE_FILTER_CAMPAIGN = "ON_ClOSE_FILTER_CAMPAIGN";
//
//ON_OPEN_FILTER_SMSS,ON_ClOSE_FILTER_SMSS
export const SET_KUNDER_FILTER = "SET_KUNDER_FILTER";
export const SET_PROSPEKT_FILTER = "SET_PROSPEKT_FILTER";
export const SET_AVTAL_FILTER = "SET_AVTAL_FILTER";
export const SET_EVENT_FILTER = "SET_EVENT_FILTER";
export const SET_ESIGNERING_FILTER = "SET_ESIGNERING_FILTER";
export const SET_DASHBORD_FILTER = "SET_DASHBORD_FILTER";
export const SET_DASHBORD_ANPASSAD_FILTER = "SET_DASHBORD_ANPASSAD_FILTER";
export const SET_DASHBORD_SALJ_FILTER = "SET_DASHBORD_SALJ_FILTER";
export const SET_ORDER_FILTER = "SET_ORDER_FILTER";
export const SET_AKTIVITETER_FILTER = "SET_AKTIVITETER_FILTER";
export const SET_ARENDE_FILTER = "SET_ARENDE_FILTER";
export const SET_PROJEKT_FILTER = "SET_PROJEKT_FILTER";
export const SET_ARTIKLAR_FILTER = "SET_ARTIKLAR_FILTER";
export const SET_USERS_FILTER = "SET_USERS_FILTER";
export const SET_SMSS_FILTER = "SET_SMSS_FILTER";
export const SET_PROJEKTKORT_FILTER = "SET_PROJEKTKORT_FILTER";
export const SET_DASHBORD_BOKA_FILTER = "SET_DASHBORD_BOKA_FILTER";
export const SET_DASHBORD_DIALER_FILTER = "SET_DASHBORD_DIALER_FILTER";
export const SET_DASHBORD_ORDER_FILTER = "SET_DASHBORD_ORDER_FILTER";
export const SET_CAMPAIGN_FILTER = "SET_CAMPAIGN_FILTER";

//Account tags
export const ON_START_ADD_NEW_TAG = "ON_START_ADD_NEW_TAG"
export const ON_ADD_NEW_TAG = "ON_ADD_NEW_TAG"
export const ON_ERROR_ADD_NEW_TAG = "ON_ERROR_ADD_NEW_TAG"
export const ON_START_REMOVE_TAG_FROM_SOURCE = "ON_START_REMOVE_TAG_FROM_SOURCE"
export const ON_REMOVE_TAG_FROM_SOURCE  = "ON_REMOVE_TAG_FROM_SOURCE"
export const ON_ERROR_REMOVE_TAG_FROM_SOURCE  = "ON_ERROR_REMOVE_TAG_FROM_SOURCE"
export const ON_START_REMOVE_TAG_FROM_ACCOUNT = "ON_START_REMOVE_TAG_FROM_ACCOUNT"
export const ON_REMOVE_TAG_FROM_ACCOUNT  = "ON_REMOVE_TAG_FROM_ACCOUNT"
export const ON_ERROR_REMOVE_TAG_FROM_ACCOUNT  = "ON_ERROR_REMOVE_TAG_FROM_ACCOUNT"
export const ON_START_ADD_TAG_FROM_ACCOUNT = "ON_START_ADD_TAG_FROM_ACCOUNT"
export const ON_ADD_TAG_FROM_ACCOUNT  = "ON_ADD_TAG_FROM_ACCOUNT"
export const ON_ERROR_ADD_TAG_FROM_ACCOUNT  = "ON_ERROR_ADD_TAG_FROM_ACCOUNT"
export const ON_START_UPDATE_TAG_FROM_ACCOUNT = "ON_START_UPDATE_TAG_FROM_ACCOUNT"
export const ON_UPDATE_TAG_FROM_ACCOUNT  = "ON_UPDATE_TAG_FROM_ACCOUNT"
export const ON_ERROR_UPDATE_TAG_FROM_ACCOUNT  = "ON_ERROR_UPDATE_TAG_FROM_ACCOUNT"

export const ON_START_ADD_NEW_TAG_EVENT = "ON_START_ADD_NEW_TAG_EVENT"
export const ON_ADD_NEW_TAG_EVENT = "ON_ADD_NEW_TAG_EVENT"
export const ON_ERROR_ADD_NEW_TAG_EVENT = "ON_ERROR_ADD_NEW_TAG_EVENT"


export const ON_ClOSE_FILTER_AVTAL = "ON_ClOSE_FILTER_AVTAL";
export const ON_ClOSE_FILTER_PROSPEKT = "ON_ClOSE_FILTER_PROSPEKT";
export const ON_ClOSE_FILTER_AKTIVITETER = "ON_ClOSE_FILTER_AKTIVITETER";
export const ON_ClOSE_FILTER_KUNDER = "ON_ClOSE_FILTER_KUNDER";
export const ON_ClOSE_FILTER_DASHBOARD = "ON_ClOSE_FILTER_DASHBOARD";
export const ON_ClOSE_FILTER_ARENDE = "ON_ClOSE_FILTER_ARENDE";
export const ON_ClOSE_FILTER_PROJEKT = "ON_ClOSE_FILTER_PROJEKT";
export const ON_ClOSE_FILTER_ARTIKLAR = "ON_ClOSE_FILTER_ARTIKLAR";
export const ON_ClOSE_FILTER_PROJEKTKORT = "ON_ClOSE_FILTER_PROJEKTKORT";
export const ON_ClOSE_FILTER_DASHBOARD_SALJ = "ON_ClOSE_FILTER_DASHBOARD_SALJ";
export const ON_ClOSE_FILTER_DASHBOARD_DIALER = "ON_ClOSE_FILTER_DASHBOARD_DIALER";
export const ON_ClOSE_FILTER_DASHBOARD_ORDER = "ON_ClOSE_FILTER_DASHBOARD_ORDER";

export const ON_ClOSE_FILTER_ESIGNERING = "ON_ClOSE_FILTER_ESIGNERING";
export const ON_ClOSE_FILTER_ORDER = "ON_ClOSE_FILTER_ORDER";
export const ON_ClOSE_FILTER_DASHBOARD_BOKA = "ON_ClOSE_FILTER_DASHBOARD_BOKA";
export const ON_ClOSE_FILTER_MOTE = "ON_ClOSE_FILTER_MOTE";
//Kedja
export const ON_START_NEW_AFID_KEDJA = "ON_START_NEW_AFID_KEDJA";
export const ON_NEW_AFID_KEDJA = "ON_NEW_AFID_KEDJA";
export const ON_ERROR_NEW_AFID_KEDJA = "ON_ERROR_NEW_AFID_KEDJA";
export const ON_START_DELETE_AFID_KEDJA = "ON_START_DELETE_AFID_KEDJA";
export const ON_DELETE_AFID_KEDJA = "ON_DELETE_AFID_KEDJA";
export const ON_ERROR_DELETE_AFID_KEDJA = "ON_ERROR_DELETE_AFID_KEDJA";
export const ON_START_UPDATE_AFID_KEDJA = "ON_START_UPDATE_AFID_KEDJA";
export const ON_UPDATE_AFID_KEDJA = "ON_UPDATE_AFID_KEDJA";
export const ON_ERROR_UPDATE_AFID_KEDJA = "ON_ERROR_UPDATE_AFID_KEDJA";

//

//E-signering
export const ON_START_NEW_ESIGNERING = "ON_START_NEW_ESIGNERING";
export const ON_NEW_ESIGNERING = "ON_NEW_ESIGNERING";
export const ON_ERROR_NEW_ESIGNERING = "ON_ERROR_NEW_ESIGNERING";
export const ON_START_GET_ESIGNERIGN_USER = "ON_START_GET_ESIGNERIGN_USER";
export const ON_GET_ESIGNERIGN_USER = "ON_GET_ESIGNERIGN_USER";
export const ON_ERROR_GET_ESIGNERIGN_USER = "ON_ERROR_GET_ESIGNERIGN_USER";
export const ON_START_GET_ESIGNERIGN_ID = "ON_START_GET_ESIGNERIGN_ID";
export const ON_GET_ESIGNERIGN_ID = "ON_GET_ESIGNERIGN_ID";
export const ON_GET_ESIGNERIGN_ID_FROM_OFFERT_PROCESS = "ON_GET_ESIGNERIGN_ID_FROM_OFFERT_PROCESS";
export const ON_ERROR_GET_ESIGNERIGN_ID = "ON_ERROR_GET_ESIGNERIGN_ID";
export const ON_START_GET_TIMELINE = "ON_START_GET_TIMELINE";
export const ON_GET_ESIGNERIGN_TIMELINE = "ON_GET_ESIGNERIGN_TIMELINE";
export const ON_ERROR_GET_ESIGNERIGN_TIMELINE = "ON_ERROR_GET_ESIGNERIGN_TIMELINE";
export const ON_START_ESIGNERING_SKICKA = "ON_START_ESIGNERING_SKICKA";
export const ON_ESIGNERING_SKICKA = "ON_ESIGNERING_SKICKA";
export const ON_ERROR_ESIGNERING_SKICKA = "ON_ERROR_ESIGNERING_SKICKA";
export const ON_START_ESIGNERING_RECALL = "ON_START_ESIGNERING_RECALL";
export const ON_ESIGNERING_RECALL = "ON_ESIGNERING_RECALL";
export const ON_ERROR_ESIGNERING_RECALL = "ON_ERROR_ESIGNERING_RECALL";
export const ON_START_ESIGNERING_RESTART = "ON_START_ESIGNERING_RESTART";
export const ON_ESIGNERING_RESTART = "ON_ESIGNERING_RESTART";
export const ON_ERROR_ESIGNERING_RESTART = "ON_ERROR_ESIGNERING_RESTART";
export const ON_START_ESIGNERING_DELETE = "ON_START_ESIGNERING_DELETE";
export const ON_ESIGNERING_DELETE = "ON_ESIGNERING_DELETE";
export const ON_ERROR_ESIGNERING_DELETE = "ON_ERROR_ESIGNERING_DELETE";
export const ON_START_GET_ESIGNERIGN_HISTORY = "ON_START_GET_ESIGNERIGN_HISTORY";
export const ON_GET_ESIGNERIGN_HISTORY = "ON_GET_ESIGNERIGN_HISTORY";
export const ON_ERROR_GET_ESIGNERIGN_HISTORY = "ON_ERROR_GET_ESIGNERIGN_HISTORY";
export const ON_START_UPDATE_ESIGNERIGN_MESSAGE = "ON_START_UPDATE_ESIGNERIGN_MESSAGE";
export const ON_UPDATE_ESIGNERIGN_MESSAGE = "ON_UPDATE_ESIGNERIGN_MESSAGE";
export const ON_ERROR_UPDATE_ESIGNERIGN_MESSAGE = "ON_ERROR_UPDATE_ESIGNERIGN_MESSAGE";
export const ON_START_UPDATE_ESIGNERIGN_MOTAGARE = "ON_START_UPDATE_ESIGNERIGN_MOTAGARE";
export const ON_UPDATE_ESIGNERIGN_MOTAGARE = "ON_UPDATE_ESIGNERIGN_MOTAGARE";
export const ON_ERROR_UPDATE_ESIGNERIGN_MOTAGARE = "ON_ERROR_UPDATE_ESIGNERIGN_MOTAGARE";
export const ON_START_NEW_ESIGNERIGN_MOTAGARE = "ON_START_NEW_ESIGNERIGN_MOTAGARE";
export const ON_NEW_ESIGNERIGN_MOTAGARE = "ON_NEW_ESIGNERIGN_MOTAGARE";
export const ON_ERROR_NEW_ESIGNERIGN_MOTAGARE = "ON_ERROR_NEW_ESIGNERIGN_MOTAGARE";
export const ON_START_DELETE_ESIGNERIGN_MOTAGARE = "ON_START_DELETE_ESIGNERIGN_MOTAGARE";
export const ON_DELETE_ESIGNERIGN_MOTAGARE = "ON_DELETE_ESIGNERIGN_MOTAGARE";
export const ON_ERROR_DELETE_ESIGNERIGN_MOTAGARE = "ON_ERROR_DELETE_ESIGNERIGN_MOTAGARE";
export const ON_START_UPDATE_ESIGNERIGN_FILE = "ON_START_UPDATE_ESIGNERIGN_FILE";
export const ON_UPDATE_ESIGNERIGN_FILE = "ON_UPDATE_ESIGNERIGN_FILE";
export const ON_ERROR_UPDATE_ESIGNERIGN_FILE = "ON_ERROR_UPDATE_ESIGNERIGN_FILE";
export const ON_START_GET_ESIGNERIGN_AVTAL = "ON_START_GET_ESIGNERIGN_AVTAL";
export const ON_GET_ESIGNERIGN_AVTAL = "ON_GET_ESIGNERIGN_AVTAL";
export const ON_ERROR_GET_ESIGNERIGN_AVTAL = "ON_ERROR_GET_ESIGNERIGN_AVTAL";
export const ON_START_GET_ESIGNERIGN_ORGNR = "ON_START_GET_ESIGNERIGN_ORGNR";
export const ON_GET_ESIGNERIGN_ORGNR = "ON_GET_ESIGNERIGN_ORGNR";
export const ON_ERROR_GET_ESIGNERIGN_ORGNR = "ON_ERROR_GET_ESIGNERIGN_ORGNR";
export const ON_START_GET_SIGNERAD_FILE = "ON_START_GET_SIGNERAD_FILE";
export const ON_GET_SIGNERAD_FILE = "ON_GET_SIGNERAD_FILE";
export const ON_ERROR_GET_SIGNERAD_FILE = "ON_ERROR_GET_SIGNERAD_FILE";
export const ON_START_ESIGNERING_ORGNR_DELETE = "ON_START_ESIGNERING_ORGNR_DELETE";
export const ON_ESIGNERING_ORGNR_DELETE = "ON_ESIGNERING_ORGNR_DELETE";
export const ON_ERROR_ESIGNERING_ORGNR_DELETE = "ON_ERROR_ESIGNERING_ORGNR_DELETE";


//
//Intranet
export const ON_START_FETCH_FOLDE = "ON_START_FETCH_FOLDE";
export const ON_FETCH_FOLDE = "ON_FETCH_FOLDE";
export const ON_ERROR_FETCH_FOLDE = "ON_ERROR_FETCH_FOLDE";
export const ON_START_NEW_FLODE = "ON_START_NEW_FLODE";
export const ON_NEW_FLODE = "ON_NEW_FLODE";
export const ON_ERROR_NEW_FLODE = "ON_ERROR_NEW_FLODE";
export const ON_START_FETCH_TODOLIST = "ON_START_FETCH_TODOLIST";
export const ON_FETCH_TODOLIST = "ON_FETCH_TODOLIST";
export const ON_ERROR_FETCH_TODOLIST = "ON_ERROR_FETCH_TODOLIST";
//
export const ON_START_SEARCH_KUND_BASIC = "ON_START_SEARCH_KUND_BASIC";
export const ON_SEARCH_KUND_BASIC = "ON_SEARCH_KUND_BASIC";
export const ON_ERROR_SEARCH_KUND_BASIC = "ON_ERROR_SEARCH_KUND_BASIC";


//Konto distrikt

export const ON_START_ADD_NEW_DISTRIKT = "ON_START_ADD_NEW_DISTRIKT";
export const ON_ERROR_ADD_NEW_DISTRIKT = "ON_ERROR_ADD_NEW_DISTRIKT";
export const ON_ADD_NEW_DISTRIKT = "ON_ADD_NEW_DISTRIKT";

export const ON_START_UPDATE_DISTRIKT = "ON_START_UPDATE_DISTRIKT";
export const ON_ERROR_UPDATE_DISTRIKT = "ON_ERROR_UPDATE_DISTRIKT";
export const ON_UPDATE_DISTRIKT = "ON_UPDATE_DISTRIKT";

export const ON_START_DELETE_DISTRIKT = "ON_START_DELETE_DISTRIKT";
export const ON_ERROR_DELETE_DISTRIKT = "ON_ERROR_DELETE_DISTRIKT";
export const ON_DELETE_DISTRIKT = "ON_DELETE_DISTRIKT";

export const ON_START_GET_DISTRIKT = "ON_START_GET_DISTRIKT";
export const ON_ERROR_GET_DISTRIKT = "ON_ERROR_GET_DISTRIKT";
export const ON_GET_DISTRIKT = "ON_GET_DISTRIKT";
//
export const ON_START_GET_MINA_DISTRIKT_POSTNR = "ON_START_GET_MINA_DISTRIKT_POSTNR";
export const ON_ERROR_GET_MINA_DISTRIKT_POSTNR  = "ON_ERROR_GET_MINA_DISTRIKT_POSTNR";
export const ON_GET_MINA_DISTRIKT_POSTNR  = "ON_GET_MINA_DISTRIKT_POSTNR";

export const ON_START_GET_THIS_DISTRIKT = "ON_START_GET_THIS_DISTRIKT";
export const ON_ERROR_GET_THIS_DISTRIKT = "ON_ERROR_GET_THIS_DISTRIKT";
export const ON_GET_THIS_DISTRIKT = "ON_GET_THIS_DISTRIKT";

export const ON_START_UPDATE_THIS_DISTRIKT_RANGE = "ON_START_UPDATE_THIS_DISTRIKT_RANGE";
export const ON_ERROR_UPDATE_THIS_DISTRIKT_RANGE= "ON_ERROR_UPDATE_THIS_DISTRIKT_RANGE";
export const ON_UPDATE_THIS_DISTRIKT_RANGE = "ON_UPDATE_THIS_DISTRIKT_RANGE";

export const ON_START_DELETE_THIS_DISTRIKT_RANGE = "ON_START_UPDATE_THIS_DISTRIKT_RANGE";
export const ON_ERROR_DELETE_THIS_DISTRIKT_RANGE= "ON_ERROR_UPDATE_THIS_DISTRIKT_RANGE";
export const ON_DELETE_THIS_DISTRIKT_RANGE = "ON_UPDATE_THIS_DISTRIKT_RANGE";



//Konto info 
export const ON_START_KONTO_INFO_UPDATE = "ON_START_KONTO_INFO_UPDATE";
export const ON_KONTO_INFO_UPDATE = "ON_KONTO_INFO_UPDATE";
export const ON_ERROR_KONTO_INFO_UPDATE = "ON_ERROR_KONTO_INFO_UPDATE";
export const ON_START_UPDATE_MODULE = "ON_START_UPDATE_MODULE";
export const ON_UPDATE_MODULE = "ON_UPDATE_MODULE";
export const ON_UPDATE_MODULE_DONT_UPDATE = "ON_UPDATE_MODULE_DONT_UPDATE";
export const ON_ERROR_UPDATE_MODULE = "ON_ERROR_UPDATE_MODULE";
export const ON_START_NEW_ORDER_EMAIL = "ON_START_NEW_ORDER_EMAIL";
export const ON_NEW_ORDER_EMAIL = "ON_NEW_ORDER_EMAIL";
export const ON_ERROR_NEW_ORDER_EMAIL = "ON_ERROR_NEW_ORDER_EMAIL";
export const ON_START_DELETE_ORDER_EMAIL = "ON_START_DELETE_ORDER_EMAIL";
export const ON_DELETE_ORDER_EMAIL = "ON_DELETE_ORDER_EMAIL";
export const ON_ERROR_DELETE_ORDER_EMAIL = "ON_ERROR_DELETE_ORDER_EMAIL";
export const ON_START_MINA_KUNDER = "ON_START_MINA_KUNDER";
export const ON_MINA_KUNDER = "ON_MINA_KUNDER";
export const ON_START_MINA_KUNDER_NOMESSAGE = "ON_START_MINA_KUNDER_NOMESSAGE";
export const ON_MINA_KUNDER_NOMESSAGE = "ON_MINA_KUNDER_NOMESSAGE";
export const ON_SET_CURRENT_KONTO_TAB_INDEX = "ON_SET_CURRENT_KONTO_TAB_INDEX"

export const ON_ERROR_MINA_KUNDER = "ON_ERROR_MINA_KUNDER";
export const ON_START_MINA_KUNDER_CLOSE_TO = "ON_START_MINA_KUNDER_CLOSE_TO";
export const ON_MINA_KUNDER_CLOSE_TO = "ON_MINA_KUNDER_CLOSE_TO";
export const ON_ERROR_MINA_KUNDER_CLOSE_TO = "ON_ERROR_MINA_KUNDER_CLOSE_TO";
export const ON_START_MINA_KONTAKTPERSONER = "ON_START_MINA_KONTAKTPERSONER";
export const ON_MINA_KONTAKTPERSONER = "ON_MINA_KONTAKTPERSONER";
export const ON_START_MINA_KONTAKTPERSONER_NOMESSAGE = "ON_START_MINA_KONTAKTPERSONER_NOMESSAGE";
export const ON_MINA_KONTAKTPERSONER_NOMESSAGE = "ON_MINA_KONTAKTPERSONER_NOMESSAGE";
export const ON_ERROR_MINA_KONTAKTPERSONER = "ON_ERROR_MINA_KONTAKTPERSONER";
export const ON_START_IMPORT_FUNC = "ON_START_IMPORT_FUNC";
export const ON_IMPORT_FUNC = "ON_IMPORT_FUNC";
export const ON_ERROR_IMPORT_FUNC = "ON_ERROR_IMPORT_FUNC";
export const ON_START_BESTALLA_ESIGN = "ON_START_BESTALLA_ESIGN";
export const ON_BESTALLA_ESIGN = "ON_BESTALLA_ESIGN";
export const ON_ERROR_BESTALLA_ESIGN = "ON_ERROR_BESTALLA_ESIGN";
export const ON_START_GET_AF_ESIGNERING = "ON_START_GET_AF_ESIGNERING";
export const ON_GET_AF_ESIGNERING = "ON_GET_AF_ESIGNERING";
export const ON_ERROR_GET_AF_ESIGNERING = "ON_ERROR_GET_AF_ESIGNERING";
export const ON_START_SAVE_ESIGN = "ON_START_SAVE_ESIGN";
export const ON_SAVE_ESIGN = "ON_SAVE_ESIGN";
export const ON_ERROR_SAVE_ESIGN = "ON_ERROR_SAVE_ESIGN";
export const ON_START_GET_OLD_AF = "ON_START_GET_OLD_AF";
export const ON_GET_OLD_AF = "ON_GET_OLD_AF";
export const ON_ERROR_GET_OLD_AF = "ON_ERROR_GET_OLD_AF";
export const ON_START_GET_OLD_AF_USER = "ON_START_GET_OLD_AF_USER";
export const ON_GET_OLD_AF_USER = "ON_GET_OLD_AF_USER";
export const ON_ERROR_GET_OLD_AF_USER = "ON_ERROR_GET_OLD_AF_USER";
export const ON_START_SYNC_USER = "ON_START_SYNC_USER";
export const ON_SYNC_USER = "ON_SYNC_USER";
export const ON_ERROR_SYNC_USER = "ON_ERROR_SYNC_USER";
export const ON_KUND_ANTAL_ORDER = "ON_KUND_ANTAL_ORDER";
export const ON_START_GET_NEW_KUND_BASIC = "ON_START_GET_NEW_KUND_BASIC";
export const ON_GET_NEW_KUND_BASIC = "ON_GET_NEW_KUND_BASIC";
export const ON_ERROR_GET_NEW_KUND_BASIC = "ON_ERROR_GET_NEW_KUND_BASIC";
//export const ON_START_GET_NEW_KUND_TOOLTIP_DETAILS = "ON_START_GET_NEW_KUND_TOOLTIP_DETAILS";
//export const ON_GET_NEW_KUND_TOOLTIP_DETAILS = "ON_GET_NEW_KUND_TOOLTIP_DETAILS";
//export const ON_ERROR_GET_NEW_KUND_TOOLTIP_DETAILS = "ON_ERROR_GET_NEW_KUND_TOOLTIP_DETAILS";
export const ON_START_NEW_KUND = "ON_START_NEW_KUND";
export const ON_NEW_KUND = "ON_NEW_KUND";
export const ON_ERROR_NEW_KUND = "ON_ERROR_NEW_KUND";
export const ON_START_EJAKTIV_USER = "ON_START_EJAKTIV_USER";
export const ON_EJAKTIV_USER = "ON_EJAKTIV_USER";
export const ON_TAEJAKTIV_USER = "ON_TAEJAKTIV_USER";
export const ON_ERROR_EJAKTIV_USER = "ON_ERROR_EJAKTIV_USER";

//,  ,  ,

//user Const
export const GET_USER = "get_user";
export const GET_USER_PROFILE_PIC = "get_user_profile_pic";
export const UPDATE_USER = "update_user";
export const UPDATE_USER_SETTING = "get_user_setting";
export const GET_USER_BUDGET = "get_user_budget";
export const GET_USER_BUDGET_WORK_DAYS = "GET_USER_BUDGET_WORK_DAYS";
export const GET_AF_BUDGET_WORK_DAYS = "GET_AF_BUDGET_WORK_DAYS";
export const GET_USER_BUDGET_UTPRIS = "GET_USER_BUDGET_UTPRIS";
export const GET_USER_BUDGET_ANTAL = "GET_USER_BUDGET_ANTAL";
export const UPDATE_USER_BUDGET = "update_user_budget";
export const GET_USER_BUDGET_ACTIVITIES = "get_user_budget_activities";
export const GET_USER_BUDGET_MOTE = "GET_USER_BUDGET_MOTE";
export const GET_USER_UPDATE_BUDGET_MOTE = "GET_USER_UPDATE_BUDGET_MOTE";
export const GET_USER_BUDGET_ORDERVARDE = "GET_USER_BUDGET_ORDERVARDE";
export const GET_USER_UPDATE_BUDGET_ORDERVARDER = "GET_USER_UPDATE_BUDGET_ORDERVARDER";
export const UPDATE_USER_ACTIVITIES = "update_user_budget_activities";
export const GET_USER_INTEGRATION = "get_user_integration";
export const UPDATE_USER_INTEGRATION = "update_user_integration";
export const UPDATE_MY_USER = "UPDATE_MY_USER";
export const UPDATE_THIS_USER = "UPDATE_THIS_USER";
export const FETCH_START_GET_USER = "FETCH_START_GET_USER";
export const FETCH_ERROR_GET_USER = "FETCH_ERROR_GET_USER";
export const ON_START_GET_USER_LOGIN_HISTORY = "FETCH_START_GET_USER_LOGIN_HISTORY";
export const ON_ERROR_GET_USER_LOGIN_HISTORY = "ON_ERROR_GET_USER_LOGIN_HISTORY";
export const ON_GET_USER_LOGIN_HISTORY = "ON_GET_USER_LOGIN_HISTORY";
export const MY_IPADDRESS = "MY_IPADDRESS";


export const FETCH_START_CHECK_USER_PASS = "FETCH_START_CHECK_USER_PASS";
export const CHECK_USER_PASS = "CHECK_USER_PASS";
export const FETCH_ERROR_CHECK_USER_PASS = "FETCH_ERROR_CHECK_USER_PASS";
//
export const ON_START_UPDATE_USER_FLAGS = "ON_START_UPDATE_USER_FLAGS";
export const ON_UPDATE_USER_FLAGS = "ON_UPDATE_USER_FLAGS";
export const ON_ERROR_UPDATE_USER_FLAGS = "ON_ERROR_UPDATE_USER_FLAGS";
//SERACH KUND
export const ON_SEARCH_KUND = "ON_SEARCH_KUND";
export const ON_START_SEARCH_KUND = "ON_START_SEARCH_KUND";
export const ON_ERROR_SEARCH_KUND = "ON_ERROR_SEARCH_KUND";
export const ON_FETCH_KUND_BASIC = "ON_FETCH_KUND_BASIC";
export const ON_START_FETCH_KUND_BASIC = "ON_START_FETCH_KUND_BASIC";
export const ON_ERROR_FETCH_KUND_BASIC = "ON_ERROR_FETCH_KUND_BASIC";
export const ON_START_FETCH_KUND_BASIC_NOMESSAGE = "ON_START_FETCH_KUND_BASIC_NOMESSAGE";
export const ON_FETCH_KUND_BASIC_NOMESSAGE = "ON_FETCH_KUND_BASIC_NOMESSAGE";
export const ON_START_FETCH_KUND_BASIC_REST = "ON_START_FETCH_KUND_BASIC_REST";

export const ON_AKTIVE_KUND = "ON_AKTIVE_KUND";
export const ON_ERROR_AKTIVE_KUND = "ON_ERROR_AKTIVE_KUND";
export const ON_START_AKTIVE_KUND = "ON_START_AKTIVE_KUND";
export const ON_START_INAKTIVE_KUND = "ON_START_INAKTIVE_KUND";
export const ON_INAKTIVE_KUND = "ON_INAKTIVE_KUND";
//
export const ON_START_DELETE_KUND_ANSVARIG = "ON_START_DELETE_KUND_ANSVARIG";
export const ON_DELETE_KUND_ANSVARIG = "ON_DELETE_KUND_ANSVARIG";
export const ON_ERROR_DELETE_KUND_ANSVARIG = "ON_ERROR_DELETE_KUND_ANSVARIG";
export const ON_NEW_KUND_ANSVARIG = "ON_NEW_KUND_ANSVARIG";
export const ON_START_NEW_KUND_ANSVARIG = "ON_START_NEW_KUND_ANSVARIG";
export const ON_ERROR_NEW_KUND_ANSVARIG = "ON_ERROR_NEW_KUND_ANSVARIG";
export const ON_START_DELETE_KUND_TAG = "ON_START_DELETE_KUND_TAG";
export const ON_DELETE_KUND_TAG = "ON_DELETE_KUND_TAG";
export const ON_ERROR_DELETE_KUND_TAG = "ON_ERROR_DELETE_KUND_TAG";
export const ON_NEW_KUND_TAG = "ON_NEW_KUND_TAG";
export const ON_START_NEW_KUND_TAG = "ON_START_NEW_KUND_TAG";
export const ON_ERROR_NEW_KUND_TAG = "ON_ERROR_NEW_KUND_TAG";
//handelse
export const ON_START_CREATE_HANDELSE = "ON_START_CREATE_HANDELSE";
export const ON_ERROR_CREATE_HANDELSE = "ON_ERROR_CREATE_HANDELSE";
export const ON_CREATE_HANDELSE = "ON_CREATE_HANDELSE";
export const ON_FETCH_KUND_HANDELSER = "ON_FETCH_KUND_HANDELSER";
export const ON_ERROR_FETCH_KUND_HANDELSER = "ON_ERROR_FETCH_KUND_HANDELSER";
export const ON_START_FETCH_KUND_HANDELSER = "ON_START_FETCH_KUND_HANDELSER";
export const ON_START_FETCH_CURRENT_HANDELSE = "ON_START_FETCH_CURRENT_HANDELSE";
export const ON_FETCH_CURRENT_HANDELSE = "ON_FETCH_CURRENT_HANDELSE";
export const ON_ERROR_FETCH_CURRENT_HANDELSE = "ON_ERROR_FETCH_CURRENT_HANDELSE";
export const ON_FETCH_CURRENT_HANDELSE_NEW_TEXT = "ON_FETCH_CURRENT_HANDELSE_NEW_TEXT";
export const ON_ERROR_FETCH_CURRENT_HANDELSE_NEW_TEXT = "ON_ERROR_FETCH_CURRENT_HANDELSE_NEW_TEXT";
export const ON_START_FETCH_CURRENT_HANDELSE_NEW_TEXT = "ON_START_FETCH_CURRENT_HANDELSE_NEW_TEXT";
export const ON_DELETE_CURRENT_HANDELSE = "ON_DELETE_CURRENT_HANDELSE";
export const ON_ERROR_DELETE_CURRENT_HANDELSE = "ON_ERROR_DELETE_CURRENT_HANDELSE";
export const ON_START_DELETE_CURRENT_HANDELSE = "ON_START_DELETE_CURRENT_HANDELSE";
export const ON_START_FLAGA_HANDELSE = "ON_START_FLAGA_HANDELSE";
export const ON_FLAGA_HANDELSE = "ON_FLAGA_HANDELSE";
export const ON_ERROR_FLAGA_HANDELSE = "ON_ERROR_FLAGA_HANDELSE";
//Kund Utokning
export const ON_START_KUND_NEW_UTOKNING = "ON_START_KUND_NEW_UTOKNING";
export const ON_KUND_NEW_UTOKNING = "ON_KUND_NEW_UTOKNING";
export const ON_ERROR_KUND_NEW_UTOKNING = "ON_ERROR_KUND_NEW_UTOKNING";
//
export const ON_START_GET_UTOKNING_DESC_BY_ORGNR = "ON_START_GET_UTOKNING_DESC_BY_ORGNR";
export const ON_GET_UTOKNING_DESC_BY_ORGNR = "ON_GET_UTOKNING_DESC_BY_ORGNR";
export const ON_ERROR_GET_UTOKNING_DESC_BY_ORGNR = "ON_ERROR_GET_UTOKNING_DESC_BY_ORGNR";
export const ON_START_SAVE_UTOKNING_DESC_BY_ORGNR = "ON_START_SAVE_UTOKNING_DESC_BY_ORGNR";
export const ON_SAVE_UTOKNING_DESC_BY_ORGNR = "ON_SAVE_UTOKNING_DESC_BY_ORGNR";
export const ON_ERROR_SAVE_UTOKNING_DESC_BY_ORGNR = "ON_ERROR_SAVE_UTOKNING_DESC_BY_ORGNR";
export const ON_START_GET_UTOKNING_BY_ORGNR = "ON_START_GET_UTOKNING_BY_ORGNR";
export const ON_GET_UTOKNING_BY_ORGNR = "ON_GET_UTOKNING_BY_ORGNR";
export const ON_ERROR_UTOKNING_BY_ORGNR = "ON_ERROR_UTOKNING_BY_ORGNR";
export const ON_START_GET_UTOKNING_LIST_BY_ORGNR = "ON_START_GET_UTOKNING_LIST_BY_ORGNR";
export const ON_GET_UTOKNING_LIST_BY_ORGNR = "ON_GET_UTOKNING_LIST_BY_ORGNR";
export const ON_ERROR_UTOKNING_LIST_BY_ORGNR = "ON_ERROR_UTOKNING_LIST_BY_ORGNR";
export const ON_START_DELETE_UTOKNING_BY_ORGNR = "ON_START_DELETE_UTOKNING_BY_ORGNR";
export const ON_DELETE_UTOKNING_BY_ORGNR = "ON_DELETE_UTOKNING_BY_ORGNR";
export const ON_ERROR_DELETE_UTOKNING_BY_ORGNR = "ON_ERROR_DELETE_UTOKNING_BY_ORGNR";
export const ON_START_KUND_UPDATE_UTOKNING = "ON_START_KUND_UPDATE_UTOKNING";
export const ON_KUND_UPDATE_UTOKNING = "ON_KUND_UPDATE_UTOKNING";
export const ON_ERROR_KUND_UPDATE_UTOKNING = "ON_ERROR_KUND_UPDATE_UTOKNING";
export const ON_START_GET_UTOKNING_KUND_LIST_BY_TYPE = "ON_START_GET_UTOKNING_KUND_LIST_BY_TYPE"
export const ON_GET_UTOKNING_KUND_LIST_BY_TYPE = "ON_GET_UTOKNING_KUND_LIST_BY_TYPE"
export const ON_ERROR_GET_UTOKNING_KUND_LIST_BY_TYPE = "ON_ERROR_GET_UTOKNING_KUND_LIST_BY_TYPE"

export const ON_START_UPDATE_KUND_UTOKNING_BY_AFID = "ON_START_UPDATE_KUND_UTOKNING_BY_AFID";
export const ON_ERROR_UPDATE_KUND_UTOKNING_BY_AFID = "ON_ERROR_UPDATE_KUND_UTOKNING_BY_AFID";
export const ON_UPDATE_KUND_UTOKNING_BY_AFID = "ON_UPDATE_KUND_UTOKNING_BY_AFID";

export const ON_START_GET_UTOKNING_BY_AFID = "ON_START_GET_UTOKNING_BY_AFID";
export const ON_ERROR_UTOKNING_BY_AFID = "ON_ERROR_UTOKNING_BY_AFID";
export const ON_GET_UTOKNING_BY_AFID = "ON_GET_UTOKNING_BY_AFID";
export const ON_CACHE_UTOKNING_BY_AFID = "ON_CACHE_UTOKNING_BY_AFID";
export const ON_LOAD_CACHE_UTOKNING_BY_AFID = "ON_LOAD_CACHE_UTOKNING_BY_AFID";

export const ON_START_BUFFER_UTOKNING_BY_AFID = "ON_START_BUFFER_UTOKNING_BY_AFID";
export const ON_BUFFER_UTOKNING_BY_AFID = "ON_BUFFER_UTOKNING_BY_AFID";

export const ON_START_SEARCH_UTOKNING_BY_AFID = "ON_START_SEARCH_UTOKNING_BY_AFID";
export const ON_ERROR_SEARCH_UTOKNING_BY_AFID = "ON_ERROR_SEARCH_UTOKNING_BY_AFID";
export const ON_SEARCH_UTOKNING_BY_AFID = "ON_SEARCH_UTOKNING_BY_AFID";

export const ON_START_GET_UTOKNING_LOGG = "ON_START_GET_UTOKNING_LOGG";
export const ON_ERROR_GET_UTOKNING_LOGG = "ON_ERROR_GET_UTOKNING_LOGG";
export const ON_GET_UTOKNING_LOGG = "ON_GET_UTOKNING_LOGG";



//Kontakt
export const ON_START_NEW_KUND_KONTAKT = "ON_START_NEW_KUND_KONTAKT";
export const ON_NEW_KUND_KONTAKT = "ON_NEW_KUND_KONTAKT";
export const ON_ERROR_NEW_KUND_KONTAKT = "ON_ERROR_NEW_KUND_KONTAKT";
export const ON_ERROR_EDIT_KUND_KONTAKT = "ON_ERROR_EDIT_KUND_KONTAKT";
export const ON_START_EDIT_KUND_KONTAKT = "ON_START_EDIT_KUND_KONTAKT";
export const ON_EDIT_KUND_KONTAKT = "ON_EDIT_KUND_KONTAKT";
export const ON_DELETE_KUND_KONTAKT = "ON_DELETE_KUND_KONTAKT";
export const ON_START_DELETE_KUND_KONTAKT = "ON_START_DELETE_KUND_KONTAKT";
export const ON_ERROR_DELETE_KUND_KONTAKT = "ON_ERROR_DELETE_KUND_KONTAKT";
export const ON_START_FETCH_KUND_KONTAKT = "ON_START_FETCH_KUND_KONTAKT";
export const ON_FETCH_KUND_KONTAKT = "ON_FETCH_KUND_KONTAKT";
export const ON_ERROR_FETCH_KUND_KONTAKT = "ON_ERROR_FETCH_KUND_KONTAKT";
//update info Kund 
export const ON_START_EDIT_KUND_INFO = "ON_START_EDIT_KUND_INFO";
export const ON_EDIT_KUND_INFO = "ON_EDIT_KUND_INFO";
export const ON_ERROR_EDIT_KUND_INFO = "ON_ERROR_EDIT_KUND_INFO";
export const ON_START_GET_DOC_ORGNR = "ON_START_GET_DOC_ORGNR";
export const ON_GET_DOC_ORGNR = "ON_GET_DOC_ORGNR";
export const ON_GET_DOC_ORGNR_0 = "ON_GET_DOC_ORGNR_0";
export const ON_ERROR_GET_DOC_ORGNR = "ON_ERROR_GET_DOC_ORGNR";
export const ON_START_GET_DOC_ORGNR_PDF = "ON_START_GET_DOC_ORGNR_PDF";
export const ON_GET_DOC_ORGNR_PDF = "ON_GET_DOC_ORGNR_PDF";
export const ON_ERROR_GET_DOC_ORGNR_PDF = "ON_ERROR_GET_DOC_ORGNR_PDF";
export const ON_START_EDIT_KUND_ITESCO_INFO = "ON_START_EDIT_KUND_ITESCO_INFO";
export const ON_EDIT_KUND_ITESCO_INFO = "ON_EDIT_KUND_ITESCO_INFO";
export const ON_ERROR_EDIT_KUND_ITESCO_INFO = "ON_ERROR_EDIT_KUND_ITESCO_INFO";
//
//Avtal Order prospekt type
export const ON_START_NEW_LEVERANTOR = "ON_START_NEW_LEVERANTOR";
export const ON_NEW_LEVERANTOR = "ON_NEW_LEVERANTOR";
export const ON_ERROR_NEW_LEVERANTOR = "ON_ERROR_NEW_LEVERANTOR";
export const ON_START_DELETE_LEVERANTOR = "ON_START_DELETE_LEVERANTOR";
export const ON_DELETE_LEVERANTOR = "ON_DELETE_LEVERANTOR";
export const ON_ERROR_DELETE_LEVERANTOR = "ON_ERROR_DELETE_LEVERANTOR";
export const ON_NEW_TYPE = "ON_NEW_TYPE";
export const ON_START_NEW_TYPE = "ON_START_NEW_TYPE";
export const ON_ERROR_NEW_TYPE = "ON_ERROR_NEW_TYPE";
export const ON_START_DELETE_TYPE = "ON_START_DELETE_TYPE";
export const ON_DELETE_TYPE = "ON_DELETE_TYPE";
export const ON_ERROR_DELETE_TYPE = "ON_ERROR_DELETE_TYPE";
export const ON_START_UPDATE_TYPE = "ON_START_UPDATE_TYPE";
export const ON_UPDATE_TYPE = "ON_UPDATE_TYPE";
export const ON_ERROR_UPDATE_TYPE = "ON_ERROR_UPDATE_TYPE";
//get Avtal Prospekt 
export const ON_GET_AVTPRO_BY_ORGNR = "ON_GET_AVTPRO_BY_ORGNR";
export const ON_START_GET_AVTPRO_BY_ORGNR = "ON_START_GET_AVTPRO_BY_ORGNR";
export const ON_ERROR_GET_AVTPRO_BY_ORGNR = "ON_ERROR_GET_AVTPRO_BY_ORGNR";
//propsekt
export const ON_START_GET_PROSPEKT_ORGNR = "ON_START_GET_PROSPEKT_ORGNR";
export const ON_GET_PROSPEKT_ORGNR = "ON_GET_PROSPEKT_ORGNR";
export const ON_ERROR_GET_PROSPEKT_ORGNR = "ON_ERROR_GET_PROSPEKT_ORGNR";
export const ON_START_GET_PROSPEKT_USER = "ON_START_GET_PROSPEKT_USER";
export const ON_START_GET_PROSPEKT_USER_START = "ON_START_GET_PROSPEKT_USER_START";
export const ON_GET_PROSPEKT_USER = "ON_GET_PROSPEKT_USER";
export const ON_ERROR_GET_PROSPEKT_USER = "ON_ERROR_GET_PROSPEKT_USER";
export const ON_START_PROSPEKT_FORLORAD = "ON_START_PROSPEKT_FORLORAD";
export const ON_PROSPEKT_FORLORAD = "ON_PROSPEKT_FORLORAD";
export const ON_ERROR_PROSPEKT_FORLORAD = "ON_ERROR_PROSPEKT_FORLORAD";
export const ON_START_PROSPEKT_TILLBAKA = "ON_START_PROSPEKT_TILLBAKA";
export const ON_PROSPEKT_TILLBAKA = "ON_PROSPEKT_TILLBAKA";
export const ON_START_AVTAL_TILLBAKA = "ON_START_AVTAL_TILLBAKA";
export const ON_AVTAL_TILLBAKA = "ON_AVTAL_TILLBAKA";
export const ON_ERROR_AVTAL_TILLBAKA = "ON_ERROR_AVTAL_TILLBAKA";
export const ON_ERROR_PROSPEKT_TILLBAKA = "ON_ERROR_PROSPEKT_TILLBAKA";
export const ON_START_GET_PROSPEKT_USER_NEW = "ON_START_GET_PROSPEKT_USER_NEW";
export const ON_GET_PROSPEKT_USER_NEW = "ON_GET_PROSPEKT_USER_NEW";

export const ON_SET_NUMAKTIVITETER_KUND = "ON_SET_NUMAKTIVITETER_KUND"

//
export const ON_START_OMFORHANDLA_AVTAL = "ON_START_OMFORHANDLA_AVTAL";
export const ON_OMFORHANDLA_AVTAL = "ON_OMFORHANDLA_AVTAL";
export const ON_ERROR_OMFORHANDLA_AVTAL = "ON_ERROR_OMFORHANDLA_AVTAL";
//
export const ON_UPDATE_PROSPEKT_KUND_PARAMETERS = "ON_UPDATE_PROSPEKT_KUND_PARAMETERS";
//delete avtal/prospekt
export const ON_START_DELETE_PROSPEKT = "ON_START_DELETE_PROSPEKT";
export const ON_DELETE_PROSPEKT = "ON_DELETE_PROSPEKT";
export const ON_ERROR_DELETE_PROSPEKT = "ON_ERROR_DELETE_PROSPEKT";
export const ON_START_DELETE_AVTAL = "ON_START_DELETE_AVTAL";
export const ON_DELETE_AVTAL = "ON_DELETE_AVTAL";
export const ON_ERROR_DELETE_AVTAL = "ON_ERROR_DELETE_AVTAL";
//
export const ON_START_DELETE_AVTALLIST = "ON_START_DELETE_AVTALLIST";
export const ON_DELETE_AVTALLIST = "ON_DELETE_AVTALLIST";
export const ON_ERROR_DELETE_AVTALLIST = "ON_ERROR_DELETE_AVTALLIST";
export const ON_START_CHANGE_ANSVARIG_AVTALLIST = "ON_START_CHANGE_ANSVARIG_AVTALLIST";
export const ON_CHANGE_ANSVARIG_AVTALLIST = "ON_CHANGE_ANSVARIG_AVTALLIST";
export const ON_ERROR_CHANGE_ANSVARIG_AVTALLIST = "ON_ERROR_CHANGE_ANSVARIG_AVTALLIST";
export const ON_START_CHANGE_DATE_AVTALLIST = "ON_START_CHANGE_DATE_AVTALLIST";
export const ON_CHANGE_DATE_AVTALLIST = "ON_CHANGE_DATE_AVTALLIST";
export const ON_ERROR_CHANGE_DATE_AVTALLIST = "ON_ERROR_CHANGE_DATE_AVTALLIST";
export const ON_START_CHANGE_START_BILLING_AVTALLIST = "ON_START_CHANGE_START_BILLING_AVTALLIST";
export const ON_CHANGE_START_BILLING_AVTALLIST = "ON_CHANGE_START_BILLING_AVTALLIST";
export const ON_ERROR_CHANGE_START_BILLING_AVTALLIST = "ON_ERROR_CHANGE_START_BILLING_AVTALLIST";
export const ON_START_CHANGE_CLOSE_BILLING_AVTALLIST = "ON_START_CHANGE_CLOSE_BILLING_AVTALLIST";
export const ON_CHANGE_CLOSE_BILLING_AVTALLIST = "ON_CHANGE_CLOSE_BILLING_AVTALLIST";
export const ON_ERROR_CHANGE_CLOSE_BILLING_AVTALLIST = "ON_ERROR_CHANGE_CLOSE_BILLING_AVTALLIST";
export const ON_START_CHANGE_SKAPA_BILLING_AVTALLIST = "ON_START_CHANGE_SKAPA_BILLING_AVTALLIST";
export const ON_CHANGE_SKAPA_BILLING_AVTALLIST = "ON_CHANGE_SKAPA_BILLING_AVTALLIST";
export const ON_ERROR_CHANGE_SKAPA_BILLING_AVTALLIST = "ON_ERROR_CHANGE_SKAPA_BILLING_AVTALLIST";
//
//KundData
export const ON_START_NEW_KUNDDATA = "ON_START_NEW_KUNDDATA";
export const ON_NEW_KUNDDATA = "ON_NEW_KUNDDATA";
export const ON_ERROR_NEW_KUNDDATA = "ON_ERROR_NEW_KUNDDATA";
export const ON_START_GET_KUNDDATA_BY_AVTAL = "ON_START_GET_KUNDDATA_BY_AVTAL";
export const ON_GET_KUNDDATA_BY_AVTAL = "ON_GET_KUNDDATA_BY_AVTAL";
export const ON_ERROR_GET_KUNDDATA_BY_AVTAL = "ON_ERROR_GET_KUNDDATA_BY_AVTAL";
export const ON_START_DELETE_KUNDDATA = "ON_START_DELETE_KUNDDATA";
export const ON_DELETE_KUNDDATA = "ON_DELETE_KUNDDATA";
export const ON_ERROR_DELETE_KUNDDATA = "ON_ERROR_DELETE_KUNDDATA";
export const ON_START_UPDATE_KUNDDATA = "ON_START_UPDATE_KUNDDATA";
export const ON_UPDATE_KUNDDATA = "ON_UPDATE_KUNDDATA";
export const ON_ERROR_UPDATE_KUNDDATA = "ON_ERROR_UPDATE_KUNDDATA";
//Utokning
export const ON_START_NEW_UTOKNING = "ON_START_NEW_UTOKNING";
export const ON_NEW_UTOKNING = "ON_NEW_UTOKNING";
export const ON_ERROR_NEW_UTOKNING = "ON_ERROR_NEW_UTOKNING";
export const ON_START_NEW_FALT = "ON_START_NEW_FALT";
export const ON_NEW_FALT = "ON_NEW_FALT";
export const ON_ERROR_NEW_FALT = "ON_ERROR_NEW_FALT";
export const ON_START_GET_UTOKNING = "ON_START_GET_UTOKNING";
export const ON_GET_UTOKNING = "ON_GET_UTOKNING";
export const ON_ERROR_GET_UTOKNING = "ON_ERROR_GET_UTOKNING";
export const ON_START_DELETE_FALT = "ON_START_DELETE_FALT";
export const ON_DELETE_FALT = "ON_DELETE_FALT";
export const ON_ERROR_DELETE_FALT = "ON_ERROR_DELETE_FALT";
export const ON_START_SAVE_FALT = "ON_START_SAVE_FALT";
export const ON_SAVE_FALT = "ON_SAVE_FALT";
export const ON_ERROR_SAVE_FALT = "ON_ERROR_SAVE_FALT";
export const ON_SAVE_KONTO_OBJECT = "ON_SAVE_KONTO_OBJECT";
export const ON_ARCHIVE_KONTO_OBJECT = "ON_ARCHIVE_KONTO_OBJECT";

//Utokning kalkyl mall rad
export const ON_START_DELETE_KALK_TEMP_ROW = "ON_START_DELETE_KALK_TEMP_ROW";
export const ON_DELETE_KALK_TEMP_ROW = "ON_DELETE_KALK_TEMP_ROW";
export const ON_ERROR_DELETE_KALK_TEMP_ROW = "ON_ERROR_DELETE_KALK_TEMP_ROW";
export const ON_START_ADD_KALK_TEMP_ROW = "ON_START_ADD_KALK_TEMP_ROW";
export const ON_ADD_KALK_TEMP_ROW = "ON_ADD_KALK_TEMP_ROW";
export const ON_ERROR_ADD_KALK_TEMP_ROW = "ON_ERROR_ADD_KALK_TEMP_ROW";
export const ON_START_UPDATE_KALK_TEMP_ROW = "ON_START_UPDATE_KALK_TEMP_ROW";
export const ON_UPDATE_KALK_TEMP_ROW = "ON_UPDATE_KALK_TEMP_ROW";
export const ON_ERROR_UPDATE_KALK_TEMP_ROW = "ON_ERROR_UPDATE_KALK_TEMP_ROW";
//Prospekt falt
//
export const ON_START_NEW_PROSPEKT_FALT = "ON_START_NEW_PROSPEKT_FALT";
export const ON_NEW_PROSPEKT_FALT = "ON_NEW_PROSPEKT_FALT";
export const ON_ERROR_PROSPEKT_FALT = "ON_ERROR_PROSPEKT_FALT";
export const ON_START_UPDATE_PROSPEKT_FALT = "ON_START_UPDATE_PROSPEKT_FALT";
export const ON_UPDATE_PROSPEKT_FALT = "ON_UPDATE_PROSPEKT_FALT";
export const ON_ERROR_UPDATE_PROSPEKT_FALT = "ON_ERROR_UPDATE_PROSPEKT_FALT";
export const ON_START_DELETE_PROSPEKT_FALT = "ON_START_DELETE_PROSPEKT_FALT";
export const ON_DELETE_PROSPEKT_FALT = "ON_DELETE_PROSPEKT_FALT";
export const ON_ERROR_DELETE_PROSPEKT_FALT = "ON_ERROR_DELETE_PROSPEKT_FALT";
//ORder falt
export const ON_START_NEW_ORDER_FALT = "ON_START_NEW_ORDER_FALT";
export const ON_NEW_ORDER_FALT = "ON_NEW_ORDER_FALT";
export const ON_ERROR_ORDER_FALT = "ON_ERROR_ORDER_FALT";
export const ON_START_DELETE_ORDER_FALT = "ON_START_DELETE_ORDER_FALT";
export const ON_DELETE_ORDER_FALT = "ON_DELETE_ORDER_FALT";
export const ON_ERROR_DELETE_ORDER_FALT = "ON_ERROR_DELETE_ORDER_FALT";
export const ON_START_UPDATE_ORDER_FALT = "ON_START_UPDATE_ORDER_FALT";
export const ON_UPDATE_ORDER_FALT = "ON_UPDATE_ORDER_FALT";
export const ON_ERROR_UPDATE_ORDER_FALT = "ON_ERROR_UPDATE_ORDER_FALT";
// OrderStatus
export const ON_START_NEW_ORDER_STATUS = "ON_START_NEW_ORDER_STATUS";
export const ON_NEW_ORDER_STATUS = "ON_NEW_ORDER_STATUS";
export const ON_ERROR_ORDER_STATUS = "ON_ERROR_ORDER_STATUS";
export const ON_START_DELETE_ORDER_STATUS = "ON_START_DELETE_ORDER_STATUS";
export const ON_DELETE_ORDER_STATUS = "ON_DELETE_ORDER_STATUS";
export const ON_ERROR_DELETE_ORDER_STATUS = "ON_ERROR_DELETE_ORDER_STATUS";
export const ON_START_UPDATE_ORDER_STATUS = "ON_START_UPDATE_ORDER_STATUS";
export const ON_UPDATE_ORDER_STATUS = "ON_UPDATE_ORDER_STATUS";
export const ON_ERROR_UPDATE_ORDER_STATUS = "ON_ERROR_UPDATE_ORDER_STATUS";
export const ON_START_GET_ORDER_STATUS = "ON_START_GET_ORDER_STATUS";
export const ON_GET_ORDER_STATUS = "ON_GET_ORDER_STATUS";
//Projekt status
export const ON_START_NEW_PROJEKT_STATUS = "ON_START_NEW_PROJEKT_STATUS";
export const ON_NEW_PROJEKT_STATUS = "ON_NEW_PROJEKT_STATUS";
export const ON_ERROR_PROJEKT_STATUS = "ON_ERROR_PROJEKT_STATUS";
export const ON_START_DELETE_PROJEKT_STATUS = "ON_START_DELETE_PROJEKT_STATUS";
export const ON_DELETE_PROJEKT_STATUS = "ON_DELETE_PROJEKT_STATUS";
export const ON_ERROR_DELETE_PROJEKT_STATUS = "ON_ERROR_DELETE_PROJEKT_STATUS";
export const ON_START_UPDATE_PROJEKT_STATUS = "ON_START_UPDATE_PROJEKT_STATUS";
export const ON_UPDATE_PROJEKT_STATUS = "ON_UPDATE_PROJEKT_STATUS";
export const ON_ERROR_UPDATE_PROJEKT_STATUS = "ON_ERROR_UPDATE_PROJEKT_STATUS";
export const ON_START_GET_PROJEKT_STATUS = "ON_START_GET_PROJEKT_STATUS";
export const ON_GET_PROJEKT_STATUS = "ON_GET_PROJEKT_STATUS";
//Projekt fas
export const ON_START_GET_PROJEKT_FAS_LIST = "ON_START_GET_PROJEKT_FAS_LIST";
export const ON_GET_PROJEKT_FAS_LIST = "ON_GET_PROJEKT_FAS_LIST";
export const ON_ERROR_GET_PROJEKT_FAS_LIST = "ON_ERROR_GET_PROJEKT_FAS_LIST";
export const ON_START_NEW_PROJEKT_FAS = "ON_START_NEW_PROJEKT_FAS";
export const ON_NEW_PROJEKT_FAS = "ON_NEW_PROJEKT_FAS";
export const ON_ERROR_PROJEKT_FAS = "ON_ERROR_PROJEKT_FAS";
export const ON_START_DELETE_PROJEKT_FAS = "ON_START_DELETE_PROJEKT_FAS";
export const ON_DELETE_PROJEKT_FAS = "ON_DELETE_PROJEKT_FAS";
export const ON_ERROR_DELETE_PROJEKT_FAS = "ON_ERROR_DELETE_PROJEKT_FAS";
export const ON_START_UPDATE_PROJEKT_FAS = "ON_START_UPDATE_PROJEKT_FAS";
export const ON_UPDATE_PROJEKT_FAS = "ON_UPDATE_PROJEKT_FAS";
export const ON_ERROR_UPDATE_PROJEKT_FAS = "ON_ERROR_UPDATE_PROJEKT_FAS";

//Projekt fas views
export const ON_START_NEW_PROJEKT_FAS_VIEW = "ON_START_NEW_PROJEKT_FAS_VIEW";
export const ON_NEW_PROJEKT_FAS_VIEW = "ON_NEW_PROJEKT_FAS_VIEW";
export const ON_ERROR_NEW_PROJEKT_FAS_VIEW = "ON_ERROR_NEW_PROJEKT_FAS_VIEW";
export const ON_START_DELETE_PROJEKT_FAS_VIEW = "ON_START_DELETE_PROJEKT_FAS_VIEW";
export const ON_DELETE_PROJEKT_FAS_VIEW = "ON_DELETE_PROJEKT_FAS_VIEW";
export const ON_ERROR_DELETE_PROJEKT_FAS_VIEW = "ON_ERROR_DELETE_PROJEKT_FAS_VIEW";
export const ON_START_UPDATE_PROJEKT_FAS_VIEW = "ON_START_UPDATE_PROJEKT_FAS_VIEW";
export const ON_UPDATE_PROJEKT_FAS_VIEW = "ON_UPDATE_PROJEKT_FAS_VIEW";
export const ON_ERROR_UPDATE_PROJEKT_FAS_VIEW = "ON_ERROR_UPDATE_PROJEKT_FAS_VIEW";
//Arende status
export const ON_START_NEW_ARENDE_STATUS = "ON_START_NEW_ARENDE_STATUS";
export const ON_NEW_ARENDE_STATUS = "ON_NEW_ARENDE_STATUS";
export const ON_ERROR_ARENDE_STATUS = "ON_ERROR_ARENDE_STATUS";
export const ON_START_DELETE_ARENDE_STATUS = "ON_START_DELETE_ARENDE_STATUS";
export const ON_DELETE_ARENDE_STATUS = "ON_DELETE_ARENDE_STATUS";
export const ON_ERROR_DELETE_ARENDE_STATUS = "ON_ERROR_DELETE_ARENDE_STATUS";
export const ON_START_UPDATE_ARENDE_STATUS = "ON_START_UPDATE_ARENDE_STATUS";
export const ON_UPDATE_ARENDE_STATUS = "ON_UPDATE_ARENDE_STATUS";
export const ON_ERROR_UPDATE_ARENDE_STATUS = "ON_ERROR_UPDATE_ARENDE_STATUS";
export const ON_START_GET_ARENDE_STATUS = "ON_START_GET_ARENDE_STATUS";
export const ON_GET_ARENDE_STATUS = "ON_GET_ARENDE_STATUS";

//
//FAS
export const ON_START_NEW_FAS = "ON_START_NEW_FAS";
export const ON_NEW_FAS = "ON_NEW_FAS";
export const ON_ERROR_NEW_FAS = "ON_ERROR_NEW_FAS";
export const ON_START_DELETE_FAS = "ON_START_DELETE_FAS";
export const ON_DELETE_FAS = "ON_DELETE_FAS";
export const ON_ERROR_DELETE_FAS = "ON_ERROR_DELETE_FAS";
export const ON_UPDATE_FAS = "ON_UPDATE_FAS";
export const ON_START_UPDATE_FAS = "ON_START_UPDATE_FAS";
export const ON_ERROR_UPDATE_FAS = "ON_ERROR_UPDATE_FAS";
//kalkyl

export const ON_START_NEW_KALKYL = "ON_START_NEW_KALKYL";
export const ON_NEW_KALKYL = "ON_NEW_KALKYL";
export const ON_ERROR_NEW_KALKYL = "ON_ERROR_NEW_KALKYL";
export const ON_START_DELETE_KALKYL = "ON_START_DELETE_KALKYL";
export const ON_DELETE_KALKYL = "ON_DELETE_KALKYL";
export const ON_ERROR_DELETE_KALKYL = "ON_ERROR_DELETE_KALKYL";
export const ON_START_UPDATE_KALKYL = "ON_START_UPDATE_KALKYL";
export const ON_UPDATE_KALKYL = "ON_UPDATE_KALKYL";
export const ON_ERROR_UPDATE_KALKYL = "ON_ERROR_UPDATE_KALKYL";
//Schablon
export const ON_START_NEW_SCHABLON_PRESET = "ON_START_NEW_SCHABLON_PRESET";
export const ON_NEW_SCHABLON_PRESET = "ON_NEW_SCHABLON_PRESET";
export const ON_ERROR_NEW_SCHABLON_PRESET = "ON_ERROR_NEW_SCHABLON_PRESET";
export const ON_START_DELETE_SCHABLON_PRESET = "ON_START_DELETE_SCHABLON_PRESET";
export const ON_DELETE_SCHABLON_PRESET = "ON_DELETE_SCHABLON_PRESET";
export const ON_ERROR_DELETE_SCHABLON_PRESET = "ON_ERROR_DELETE_SCHABLON_PRESET";
export const ON_START_UPDATE_SCHABLON_PRESET = "ON_START_UPDATE_SCHABLON_PRESET";
export const ON_UPDATE_SCHABLON_PRESET = "ON_UPDATE_SCHABLON_PRESET";
export const ON_ERROR_UPDATE_SCHABLON_PRESET = "ON_ERROR_UPDATE_SCHABLON_PRESET";

export const ON_START_GET_SCHABLON = "ON_START_GET_SCHABLON";
export const ON_GET_SCHABLON = "ON_GET_SCHABLON";
export const ON_ERROR_GET_SCHABLON = "ON_ERROR_GET_SCHABLON";
export const ON_START_NEW_SCHABLON = "ON_START_NEW_SCHABLON";
export const ON_NEW_SCHABLON = "ON_NEW_SCHABLON";
export const ON_ERROR_NEW_SCHABLON = "ON_ERROR_NEW_SCHABLON";
export const ON_START_DELETE_SCHABLON = "ON_START_DELETE_SCHABLON";
export const ON_DELETE_SCHABLON = "ON_DELETE_SCHABLON";
export const ON_ERROR_DELETE_SCHABLON = "ON_ERROR_DELETE_SCHABLON";
export const ON_START_UPDATE_SCHABLON = "ON_START_UPDATE_SCHABLON";
export const ON_UPDATE_SCHABLON = "ON_UPDATE_SCHABLON";
export const ON_ERROR_UPDATE_SCHABLON = "ON_ERROR_UPDATE_SCHABLON";
export const ON_START_RESET_SCHABLON = "ON_START_RESET_SCHABLON";
export const ON_RESET_SCHABLON = "ON_RESET_SCHABLON";
export const ON_ERROR_RESET_SCHABLON = "ON_ERROR_RESET_SCHABLON";
//AVTAL
export const ON_START_NEW_AVTAL = "ON_START_NEW_AVTAL";
export const ON_NEW_AVTAL = "ON_NEW_AVTAL";
export const ON_ERROR_NEW_AVTAL = "ON_ERROR_NEW_AVTAL";
export const ON_START_GET_AVTAL_ORGNR = "ON_START_GET_AVTAL_ORGNR";
export const ON_GET_AVTAL_ORGNR = "ON_GET_AVTAL_ORGNR";
export const ON_ERROR_GET_AVTAL_ORGNR = "ON_ERROR_GET_AVTAL_ORGNR";
export const ON_START_GET_AVTAL_ID = "ON_START_GET_AVTAL_ID";
export const ON_GET_AVTAL_ID = "ON_GET_AVTAL_ID";
export const ON_ERROR_GET_AVTAL_ID = "ON_ERROR_GET_AVTAL_ID";
export const ON_START_GET_AVTAL_REST_ID = "ON_START_GET_AVTAL_REST_ID";
export const ON_ERROR_GET_AVTAL_REST_ID = "ON_ERROR_GET_AVTAL_REST_ID";
export const ON_GET_AVTAL_REST_ID = "ON_GET_AVTAL_REST_ID";
//

export const ON_SAVE_AVTAL_CALC_ITEMS = "ON_SAVE_AVTAL_CALC_ITEMS";
export const ON_START_SAVE_AVTAL_CALC_ITEMS = "ON_START_SAVE_AVTAL_CALC_ITEMS";
export const ON_ERROR_SAVE_AVTAL_CALC_ITEMS = "ON_ERROR_SAVE_AVTAL_CALC_ITEMS";
export const ON_START_EDIT_AVTAL = "ON_START_EDIT_AVTAL";
export const ON_EDIT_AVTAL = "ON_EDIT_AVTAL";
export const ON_ERROR_EDIT_AVTAL = "ON_ERROR_EDIT_AVTAL";
export const ON_START_NEW_AVTAL_HANDELSE = "ON_START_NEW_AVTAL_HANDELSE";
export const ON_ERROR_NEW_AVTAL_HANDELSE = "ON_ERROR_NEW_AVTAL_HANDELSE";
export const ON_NEW_AVTAL_HANDELSE = "ON_NEW_AVTAL_HANDELSE";
export const ON_START_GET_AVTAL_HISTORY_ID = "ON_START_GET_AVTAL_HISTORY_ID";
export const ON_GET_AVTAL_HISTORY_ID = "ON_GET_AVTAL_HISTORY_ID";
export const ON_ERROR_GET_AVTAL_HISTORY_ID = "ON_ERROR_GET_AVTAL_HISTORY_ID";
export const ON_START_NEW_AVTAL_KALKYL_ID = "ON_START_NEW_AVTAL_KALKYL_ID";
export const ON_NEW_AVTAL_KALKYL_ID = "ON_NEW_AVTAL_KALKYL_ID";
export const ON_ERROR_NEW_AVTAL_KALKYL_ID = "ON_ERROR_NEW_AVTAL_KALKYL_ID";
export const ON_START_NEW_AVTAL_ABOKALKYL_ID = "ON_START_NEW_AVTAL_ABOKALKYL_ID";
export const ON_NEW_AVTAL_ABOKALKYL_ID = "ON_NEW_AVTAL_ABOKALKYL_ID";
export const ON_ERROR_NEW_AVTAL_ABOKALKYL_ID = "ON_ERROR_NEW_AVTAL_ABOKALKYL_ID";
export const ON_START_GET_AVTAL_KALKYL_ID = "ON_START_GET_AVTAL_KALKYL_ID";
export const ON_GET_AVTAL_KALKYL_ID = "ON_GET_AVTAL_KALKYL_ID";
export const ON_ERROR_GET_AVTAL_KALKYL_ID = "ON_ERROR_GET_AVTAL_KALKYL_ID";
export const ON_START_UPDATE_AVTAL_KALKYL_RAD = "ON_START_UPDATE_AVTAL_KALKYL_RAD";
export const ON_UPDATE_AVTAL_KALKYL_RAD = "ON_UPDATE_AVTAL_KALKYL_RAD";
export const ON_ERROR_UPDATE_AVTAL_KALKYL_RAD = "ON_ERROR_UPDATE_AVTAL_KALKYL_RAD";
export const ON_START_DELETE_AVTAL_KALKYL_RAD = "ON_START_DELETE_AVTAL_KALKYL_RAD";
export const ON_DELETE_AVTAL_KALKYL_RAD = "ON_DELETE_AVTAL_KALKYL_RAD";
export const ON_ERROR_DELETE_AVTAL_KALKYL_RAD = "ON_ERROR_DELETE_AVTAL_KALKYL_RAD";
export const ON_GET_AVTAL_USER = "ON_GET_AVTAL_USER";
export const ON_GET_AVTALF_USER = "ON_GET_AVTALF_USER";
export const ON_START_GET_AVTAL_USER = "ON_START_GET_AVTAL_USER";
export const ON_ERROR_GET_AVTAL_USER = "ON_ERROR_GET_AVTAL_USER";
export const ON_GET_AVTAL_USER_HEADER = "ON_GET_AVTAL_USER_HEADER";
export const ON_START_GET_AVTAL_USER_HEADER = "ON_START_GET_AVTAL_USER_HEADER";
export const ON_ERROR_GET_AVTAL_USER_HEADER = "ON_ERROR_GET_AVTAL_USER_HEADER";
export const ON_START_GET_BILLING_AVTAL_USER_HEADER = "ON_START_GET_BILLING_AVTAL_USER_HEADER";
export const ON_GET_BILLING_AVTAL_USER_HEADER = "ON_GET_BILLING_AVTAL_USER_HEADER";
export const ON_ERROR_GET_BILLING_AVTAL_USER_HEADER = "ON_ERROR_GET_BILLING_AVTAL_USER_HEADER";
export const ON_AVTAL_NEW_DOC = "ON_AVTAL_NEW_DOC";
export const ON_START_AVTAL_NEW_DOC = "ON_START_AVTAL_NEW_DOC";
export const ON_ERROR_AVTAL_NEW_DOC = "ON_ERROR_AVTAL_NEW_DOC";
export const ON_START_GET_AVTAL_DOC_ID = "ON_START_GET_AVTAL_DOC_ID";
export const ON_GET_AVTAL_DOC_ID = "ON_GET_AVTAL_DOC_ID";
export const ON_ERROR_GET_AVTAL_DOC_ID = "ON_ERROR_GET_AVTAL_DOC_ID";
export const ON_DELETE_AVTAL_DOC_RAD = "ON_DELETE_AVTAL_DOC_RAD";
export const ON_ERROR_DELETE_AVTAL_DOC_RAD = "ON_ERROR_DELETE_AVTAL_DOC_RAD";
export const ON_START_DELETE_AVTAL_DOC_RAD = "ON_START_DELETE_AVTAL_DOC_RAD";
export const ON_START_UPDATE_AVTAL_DOC_RAD = "ON_START_UPDATE_AVTAL_DOC_RAD";
export const ON_UPDATE_AVTAL_DOC_RAD = "ON_UPDATE_AVTAL_DOC_RAD";
export const ON_ERROR_UPDATE_AVTAL_DOC_RAD = "ON_ERROR_UPDATE_AVTAL_DOC_RAD";
//
export const ON_GET_AVTAL_ORDER_ID = "ON_GET_AVTAL_ORDER_ID";
export const ON_ERROR_GET_AVTAL_ORDER_ID = "ON_ERROR_GET_AVTAL_ORDER_ID";
export const ON_START_GET_AVTAL_ORDER_ID = "ON_START_GET_AVTAL_ORDER_ID";
export const ON_START_DELETE_AVTAL_ORDER_RAD = "ON_START_DELETE_AVTAL_ORDER_RAD";
export const ON_DELETE_AVTAL_ORDER_RAD = "ON_DELETE_AVTAL_ORDER_RAD";
export const ON_ERROR_DELETE_AVTAL_ORDER_RAD = "ON_ERROR_DELETE_AVTAL_ORDER_RAD";
export const ON_START_GET_AVTAL_KUNDDATA_ID = "ON_START_GET_AVTAL_KUNDDATA_ID";
export const ON_GET_AVTAL_KUNDDATA_ID = "ON_GET_AVTAL_KUNDDATA_ID";
export const ON_ERROR_GET_AVTAL_KUNDDATA_ID = "ON_ERROR_GET_AVTAL_KUNDDATA_ID";
export const ON_START_AVTAL_ANTAL_UPDATE = "ON_START_AVTAL_ANTAL_UPDATE";
export const ON_NEW_AVTAL_ANTAL_UPDATE = "ON_NEW_AVTAL_ANTAL_UPDATE";
export const ON_ERROR_AVTAL_ANTAL_UPDATE = "ON_ERROR_AVTAL_ANTAL_UPDATE";
export const ON_START_AVTAL_KUNDDATA_INSERT = "ON_START_AVTAL_KUNDDATA_INSERT";
export const ON_NEW_AVTAL_KUNDDATA_INSERT = "ON_NEW_AVTAL_KUNDDATA_INSERT";
export const ON_ERROR_AVTAL_KUNDDATA_INSERT = "ON_ERROR_AVTAL_KUNDDATA_INSERT";
export const ON_START_AVTAL_KUNDDATA_COPYTA = "ON_START_AVTAL_KUNDDATA_COPYTA";
export const ON_AVTAL_KUNDDATA_COPYTA = "ON_AVTAL_KUNDDATA_COPYTA";
export const ON_ERROR_AVTAL_KUNDDATA_COPYTA = "ON_ERROR_AVTAL_KUNDDATA_COPYTA";
export const ON_START_DELETE_AVTAL_KUNDDATA_RAD = "ON_START_DELETE_AVTAL_KUNDDATA_RAD";
export const ON_DELETE_AVTAL_KUNDDATA_RAD = "ON_DELETE_AVTAL_KUNDDATA_RAD";
export const ON_ERROR_DELETE_AVTAL_KUNDDATA_RAD = "ON_ERROR_DELETE_AVTAL_KUNDDATA_RAD";
export const ON_START_GET_AVTAL_Event_ID = "ON_START_GET_AVTAL_Event_ID";
export const ON_GET_AVTAL_Event_ID = "ON_GET_AVTAL_Event_ID";
export const ON_ERROR_GET_AVTAL_Event_ID = "ON_ERROR_GET_AVTAL_Event_ID";
export const ON_START_GET_EVENT_HISTORY_ID = "ON_START_GET_EVENT_HISTORY_ID";
export const ON_GET_EVENT_HISTORY_ID = "ON_GET_EVENT_HISTORY_ID";
export const ON_ERROR_GET_EVENT_HISTORY_ID = "ON_ERROR_GET_EVENT_HISTORY_ID";
export const ON_START_EVENT_COMMENT = "ON_START_EVENT_COMMENT";
export const ON_EVENT_COMMENT = "ON_EVENT_COMMENT";
export const ON_ERROR_EVENT_COMMENT = "ON_ERROR_EVENT_COMMENT";
export const ON_START_EVENT_AVBOKA = "ON_START_EVENT_AVBOKA";
export const ON_EVENT_AVBOKA = "ON_EVENT_AVBOKA";
export const ON_ERROR_EVENT_AVBOKA = "ON_ERROR_EVENT_AVBOKA";
export const ON_START_EVENT_UPDATE_KOM = "ON_START_EVENT_UPDATE_KOM";
export const ON_EVENT_UPDATE_KOM = "ON_EVENT_UPDATE_KOM";
export const ON_ERROR_EVENT_UPDATE_KOM = "ON_ERROR_EVENT_UPDATE_KOM";
export const ON_START_EVENT_UPDATE_NYTT = "ON_START_EVENT_UPDATE_NYTT";
export const ON_EVENT_UPDATE_NYTT = "ON_EVENT_UPDATE_NYTT";
export const ON_ERROR_EVENT_UPDATE_NYTT = "ON_ERROR_EVENT_UPDATE_NYTT";
export const ON_START_EVENT_UPDATE_AvtalId = "ON_START_EVENT_UPDATE_AvtalId";
export const ON_EVENT_UPDATE_AvtalId = "ON_EVENT_UPDATE_AvtalId";
export const ON_ERROR_EVENT_UPDATE_AvtalId = "ON_ERROR_EVENT_UPDATE_AvtalId";
export const ON_START_AVTAL_IMPORT_KD_EXCEL = "ON_START_AVTAL_IMPORT_KD_EXCEL";
export const ON_AVTAL_IMPORT_KD_EXCEL = "ON_AVTAL_IMPORT_KD_EXCEL";
export const ON_ERROR_AVTAL_IMPORT_KD_EXCEL = "ON_ERROR_AVTAL_IMPORT_KD_EXCEL";
export const ON_START_AVTAL_KUNDDATA_TEMPORARY = "ON_START_AVTAL_KUNDDATA_TEMPORARY";
export const ON_AVTAL_KUNDDATA_TEMPORARY = "ON_AVTAL_KUNDDATA_TEMPORARY";
export const ON_ERROR_AVTAL_KUNDDATA_TEMPORARY = "ON_ERROR_AVTAL_KUNDDATA_TEMPORARY";
export const ON_START_EVENT_OMBOKA = "ON_START_EVENT_OMBOKA";
export const ON_GET_ALL_HANDELSE_AVTAL="ON_GET_ALL_HANDELSE_AVTAL"
export const ON_START_GET_ALL_HANDELSE_AVTAL="ON_START_GET_ALL_HANDELSE_AVTAL"
export const ON_ERROR_GET_ALL_HANDELSE_AVTAL="ON_ERROR_GET_ALL_HANDELSE_AVTAL"
export const ON_SET_CURRENT_AVTAL_ANTAL_FRIA = "ON_SET_CURRENT_AVTAL_ANTAL_FRIA"
export const ON_SET_CURRENT_AVTAL_TAGGAR = "ON_SET_CURRENT_AVTAL_TAGGAR"
//
//prospekt
export const ON_ERROR_NEW_PROSPEKT = "ON_ERROR_NEW_PROSPEKT";
export const ON_NEW_PROSPEKT = "ON_NEW_PROSPEKT";
export const ON_START_NEW_PROSPEKT = "ON_START_NEW_PROSPEKT";
export const ON_START_GET_PROSPEKT_USER_HEADER = "ON_START_GET_PROSPEKT_USER_HEADER";
export const ON_GET_PROSPEKT_USER_HEADER = "ON_GET_PROSPEKT_USER_HEADER";
export const ON_ERROR_GET_PROSPEKT_USER_HEADER = "ON_ERROR_GET_PROSPEKT_USER_HEADER";
export const ON_UPDATE_PROSPEKT_FAS = "ON_UPDATE_PROSPEKT_FAS";
export const ON_ERROR_UPDATE_PROSPEKT_FAS = "ON_ERROR_UPDATE_PROSPEKT_FAS";
export const ON_START_UPDATE_PROSPEKT_FAS = "ON_START_UPDATE_PROSPEKT_FAS";
export const ON_START_GET_PROSPEKT_FASPAGE_USER = "ON_START_GET_PROSPEKT_FASPAGE_USER";
export const ON_GET_PROSPEKT_FASPAGE_USER = "ON_GET_PROSPEKT_FASPAGE_USER";
export const ON_ERROR_GET_PROSPEKT_FASPAGE_USER = "ON_ERROR_GET_PROSPEKT_FASPAGE_USER";
export const ON_START_GET_OFFERT_KALKYL_ID = "ON_START_GET_OFFERT_KALKYL_ID";
export const ON_GET_OFFERT_KALKYL_ID = "ON_GET_OFFERT_KALKYL_ID";
export const ON_ERROR_GET_OFFERT_KALKYL_ID = "ON_ERROR_GET_OFFERT_KALKYL_ID";

export const ON_NEW_AF_PROSPEKT_TASK = "ON_NEW_AF_PROSPEKT_TASK"
export const ON_START_NEW_AF_PROSPEKT_TASK = "ON_START_NEW_AF_PROSPEKT_TASK"
export const ON_ERROR_NEW_AF_PROSPEKT_TASK = "ON_ERROR_NEW_AF_PROSPEKT_TASK"
export const ON_UPDATE_AF_PROSPEKT_TASK = "ON_UPDATE_AF_PROSPEKT_TASK"
export const ON_START_UPDATE_AF_PROSPEKT_TASK = "ON_START_UPDATE_AF_PROSPEKT_TASK"
export const ON_ERROR_UPDATE_AF_PROSPEKT_TASK = "ON_ERROR_UPDATE_AF_PROSPEKT_TASK"
export const ON_DELETE_AF_PROSPEKT_TASK = "ON_DELETE_AF_PROSPEKT_TASK"
export const ON_START_DELETE_AF_PROSPEKT_TASK = "ON_START_DELETE_AF_PROSPEKT_TASK"
export const ON_ERROR_DELETE_AF_PROSPEKT_TASK = "ON_ERROR_DELETE_AF_PROSPEKT_TASK"
export const ON_GET_AF_PROSPEKT_TASK = "ON_GET_AF_PROSPEKT_TASK"
export const ON_START_GET_AF_PROSPEKT_TASK = "ON_START_GET_AF_PROSPEKT_TASK"
export const ON_ERROR_GET_AF_PROSPEKT_TASK = "ON_ERROR_GET_AF_PROSPEKT_TASK"
//
//ORDER 
export const ON_START_NEW_ORDER = "ON_START_NEW_ORDER";
export const ON_NEW_ORDER = "ON_NEW_ORDER";
export const ON_ERROR_NEW_ORDER = "ON_ERROR_NEW_ORDER";
export const ON_ERROR_GET_ORDER_ORGNR = "ON_ERROR_GET_ORDER_ORGNR";
export const ON_START_GET_ORDER_ORGNR = "ON_START_GET_ORDER_ORGNR";
export const ON_GET_ORDER_ORGNR = "ON_GET_ORDER_ORGNR";
export const ON_START_GET_ORDER_ID = "ON_START_GET_ORDER_ID";
export const ON_START_GET_ORDER_REST_ID = "ON_START_GET_ORDER_REST_ID";
export const ON_GET_ORDER_REST_ID = "ON_GET_ORDER_REST_ID";
export const ON_ERROR_GET_ORDER_REST_ID = "ON_ERROR_GET_ORDER_REST_ID";
export const ON_GET_ORDER_ID = "ON_GET_ORDER_ID";
export const ON_ERROR_GET_ORDER_ID = "ON_ERROR_GET_ORDER_ID";
export const ON_START_DELETE_ORDER = "ON_START_DELETE_ORDER";
export const ON_DELETE_ORDER = "ON_DELETE_ORDER";
export const ON_ERROR_DELETE_ORDER = "ON_ERROR_DELETE_ORDER";
export const ON_START_GET_ORDER_USER = "ON_START_GET_ORDER_USER";
export const ON_GET_ORDER_USER = "ON_GET_ORDER_USER";
export const ON_ERROR_GET_ORDER_USER = "ON_ERROR_GET_ORDER_USER";
export const ON_START_ORDER_NEW_DOC = "ON_START_ORDER_NEW_DOC";
export const ON_ORDER_NEW_DOC = "ON_ORDER_NEW_DOC";
export const ON_ERROR_ORDER_NEW_DOC = "ON_ERROR_ORDER_NEW_DOC";
export const ON_START_GET_ORDER_DOC_ID = "ON_START_GET_ORDER_DOC_ID";
export const ON_GET_ORDER_DOC_ID = "ON_GET_ORDER_DOC_ID";
export const ON_ERROR_GET_ORDER_DOC_ID = "ON_ERROR_GET_ORDER_DOC_ID";
export const ON_START_DELETE_ORDER_DOC_RAD = "ON_START_DELETE_ORDER_DOC_RAD";
export const ON_DELETE_ORDER_DOC_RAD = "ON_DELETE_ORDER_DOC_RAD";
export const ON_ERROR_DELETE_ORDER_DOC_RAD = "ON_ERROR_DELETE_ORDER_DOC_RAD";
export const ON_START_UPDATE_ORDER_DOC_RAD = "ON_START_UPDATE_ORDER_DOC_RAD";
export const ON_UPDATE_ORDER_DOC_RAD = "ON_UPDATE_ORDER_DOC_RAD";
export const ON_ERROR_UPDATE_ORDER_DOC_RAD = "ON_ERROR_UPDATE_ORDER_DOC_RAD";
//

export const ON_SAVE_ORDER_CALC_ITEMS = "ON_SAVE_ORDER_CALC_ITEMS";
export const ON_START_SAVE_ORDER_CALC_ITEMS = "ON_START_SAVE_ORDER_CALC_ITEMS";
export const ON_ERROR_SAVE_ORDER_CALC_ITEMS = "ON_ERROR_SAVE_ORDER_CALC_ITEMS";
export const ON_START_GET_ORDER_HISTORY_ID = "ON_START_GET_ORDER_HISTORY_ID";
export const ON_GET_ORDER_HISTORY_ID = "ON_GET_ORDER_HISTORY_ID";
export const ON_ERROR_GET_ORDER_HISTORY_ID = "ON_ERROR_GET_ORDER_HISTORY_ID";
export const ON_START_NEW_ORDER_HANDELSE = "ON_START_NEW_ORDER_HANDELSE";
export const ON_NEW_ORDER_HANDELSE = "ON_NEW_ORDER_HANDELSE";
export const ON_ERROR_NEW_ORDER_HANDELSE = "ON_ERROR_NEW_ORDER_HANDELSE";
export const ON_START_NEW_ORDER_KALKYL_ID = "ON_START_NEW_ORDER_KALKYL_ID";
export const ON_NEW_ORDER_KALKYL_ID = "ON_NEW_ORDER_KALKYL_ID";
export const ON_ERROR_NEW_ORDER_KALKYL_ID = "ON_ERROR_NEW_ORDER_KALKYL_ID";
export const ON_START_NEW_ORDER_ABOKALKYL_ID = "ON_START_NEW_ORDER_ABOKALKYL_ID";
export const ON_NEW_ORDER_ABOKALKYL_ID = "ON_NEW_ORDER_ABOKALKYL_ID";
export const ON_ERROR_NEW_ORDER_ABOKALKYL_ID = "ON_ERROR_NEW_ORDER_ABOKALKYL_ID";
export const ON_START_GET_ORDER_KALKYL_ID = "ON_START_GET_ORDER_KALKYL_ID";
export const ON_GET_ORDER_KALKYL_ID = "ON_GET_ORDER_KALKYL_ID";
export const ON_ERROR_GET_ORDER_KALKYL_ID = "ON_ERROR_GET_ORDER_KALKYL_ID";
export const ON_START_DELETE_ORDER_KALKYL_RAD = "ON_START_DELETE_ORDER_KALKYL_RAD";
export const ON_DELETE_ORDER_KALKYL_RAD = "ON_DELETE_ORDER_KALKYL_RAD";
export const ON_ERROR_DELETE_ORDER_KALKYL_RAD = "ON_ERROR_DELETE_ORDER_KALKYL_RAD";
export const ON_START_UPDATE_ORDER_KALKYL_RAD = "ON_START_UPDATE_ORDER_KALKYL_RAD";
export const ON_UPDATE_ORDER_KALKYL_RAD = "ON_UPDATE_ORDER_KALKYL_RAD";
export const ON_ERROR_UPDATE_ORDER_KALKYL_RAD = "ON_ERROR_UPDATE_ORDER_KALKYL_RAD";
export const ON_START_NEW_ORDER_KONTAKT_ID = "ON_START_NEW_ORDER_KONTAKT_ID";
export const ON_NEW_ORDER_KONTAKT_ID = "ON_NEW_ORDER_KONTAKT_ID";
export const ON_ERROR_NEW_ORDER_KONTAKT_ID = "ON_ERROR_NEW_ORDER_KONTAKT_ID";
export const ON_START_ORDER_INFO_UPDATE = "ON_START_ORDER_INFO_UPDATE";
export const ON_NEW_ORDER_INFO_UPDATE = "ON_NEW_ORDER_INFO_UPDATE";
export const ON_ERROR_ORDER_INFO_UPDATE = "ON_ERROR_ORDER_INFO_UPDATE";
export const ON_START_ORDER_UPDATE = "ON_START_ORDER_UPDATE";
export const ON_ORDER_UPDATE = "ON_ORDER_UPDATE";
export const ON_ERROR_ORDER_UPDATE = "ON_ERROR_ORDER_UPDATE";
export const ON_START_ORDER_KUNDDATA_INSERT = "ON_START_ORDER_KUNDDATA_INSERT";
export const ON_NEW_ORDER_KUNDDATA_INSERT = "ON_NEW_ORDER_KUNDDATA_INSERT";
export const ON_ERROR_ORDER_KUNDDATA_INSERT = "ON_ERROR_ORDER_KUNDDATA_INSERT";
export const ON_START_GET_ORDER_KUNDDATA_ID = "ON_START_GET_ORDER_KUNDDATA_ID";
export const ON_GET_ORDER_KUNDDATA_ID = "ON_GET_ORDER_KUNDDATA_ID";
export const ON_GET_ORDER_KUNDDATA2_ID = "ON_GET_ORDER_KUNDDATA2_ID";
export const ON_ERROR_GET_ORDER_KUNDDATA_ID = "ON_ERROR_GET_ORDER_KUNDDATA_ID";
export const ON_START_ORDER_ANTAL_UPDATE = "ON_START_ORDER_ANTAL_UPDATE";
export const ON_NEW_ORDER_ANTAL_UPDATE = "ON_NEW_ORDER_ANTAL_UPDATE";
export const ON_ERROR_ORDER_ANTAL_UPDATE = "ON_ERROR_ORDER_ANTAL_UPDATE";
export const ON_START_DELETE_ORDER_KUNDDATA_RAD = "ON_START_DELETE_ORDER_KUNDDATA_RAD";
export const ON_DELETE_ORDER_KUNDDATA_RAD = "ON_DELETE_ORDER_KUNDDATA_RAD";
export const ON_ERROR_DELETE_ORDER_KUNDDATA_RAD = "ON_ERROR_DELETE_ORDER_KUNDDATA_RAD";
export const ON_START_ORDER_KUNDDATA_COPYTA = "ON_START_ORDER_KUNDDATA_COPYTA";
export const ON_ORDER_KUNDDATA_COPYTA = "ON_ORDER_KUNDDATA_COPYTA";
export const ON_ERROR_ORDER_KUNDDATA_COPYTA = "ON_ERROR_ORDER_KUNDDATA_COPYTA";
export const ON_START_ORDER_REGISTER = "ON_START_ORDER_REGISTER";
export const ON_NEW_ORDER_REGISTER = "ON_NEW_ORDER_REGISTER";
export const ON_ERROR_ORDER_REGISTER = "ON_ERROR_ORDER_REGISTER";
export const ON_START_ORDER_REGISTER_KLAR = "ON_START_ORDER_REGISTER_KLAR";
export const ON_NEW_ORDER_REGISTER_KLAR = "ON_NEW_ORDER_REGISTER_KLAR";
export const ON_ERROR_ORDER_REGISTER_KLAR = "ON_ERROR_ORDER_REGISTER_KLAR";
export const ON_START_ORDER_REGISTER_SALES_MULTI = "ON_START_ORDER_REGISTER_SALES_MULTI";
export const ON_ORDER_REGISTER_SALES_MULTI = "ON_ORDER_REGISTER_SALES_MULTI";
export const ON_ERROR_ORDER_REGISTER_SALES_MULTI = "ON_ERROR_ORDER_REGISTER_SALES_MULTI";
export const ON_START_ORDER_REGISTER_BEHANDLA = "ON_START_ORDER_REGISTER_BEHANDLA";
export const ON_NEW_ORDER_REGISTER_BEHANDLA = "ON_NEW_ORDER_REGISTER_BEHANDLA";
export const ON_ERROR_ORDER_REGISTER_BEHANDLA = "ON_ERROR_ORDER_REGISTER_BEHANDLA";
export const ON_START_GET_ORDER_KEDJA = "ON_START_GET_ORDER_KEDJA";
export const ON_GET_ORDER_KEDJA = "ON_GET_ORDER_KEDJA";
export const ON_ERROR_GET_ORDER_KEDJA = "ON_ERROR_GET_ORDER_KEDJA";
export const ON_START_ORDER_KUNDDATA_TEMPORARY = "ON_START_ORDER_KUNDDATA_TEMPORARY";
export const ON_ORDER_KUNDDATA_TEMPORARY = "ON_ORDER_KUNDDATA_TEMPORARY";
export const ON_ERROR_ORDER_KUNDDATA_TEMPORARY = "ON_ERROR_ORDER_KUNDDATA_TEMPORARY";
export const ON_START_ORDER_IMPORT_KD_EXCEL = "ON_START_ORDER_IMPORT_KD_EXCEL";
export const ON_ORDER_IMPORT_KD_EXCEL = "ON_ORDER_IMPORT_KD_EXCEL";
export const ON_ERROR_ORDER_IMPORT_KD_EXCEL = "ON_ERROR_ORDER_IMPORT_KD_EXCEL";
export const ON_GET_ORDER_STATUS_ANTAL = "ON_GET_ORDER_STATUS_ANTAL"
export const ON_ERROR_GET_ORDER_STATUS_ANTAL = "ON_ERROR_GET_ORDER_STATUS_ANTAL"
export const ON_START_GET_ORDER_STATUS_ANTAL = "ON_START_GET_ORDER_STATUS_ANTAL"
export const ON_UPDATE_THIS_ORDER_STATUS = "ON_UPDATE_THIS_ORDER_STATUS"
export const ON_ERROR_UPDATE_THIS_ORDER_STATUS = "ON_ERROR_UPDATE_THIS_ORDER_STATUS"
export const ON_START_UPDATE_THIS_ORDER_STATUS = "ON_START_UPDATE_THIS_ORDER_STATUS"

export const ON_START_GET_ORDER_VARDE_TOOLTIP = "ON_START_GET_ORDER_VARDE_TOOLTIP"
export const ON_ERROR_GET_ORDER_VARDE_TOOLTIP = "ON_ERROR_GET_ORDER_VARDE_TOOLTIP"
export const ON_GET_ORDER_VARDE_TOOLTIP = "ON_GET_ORDER_VARDE_TOOLTIP"

export const ON_START_CREATE_WOOCOMMERCE_ORDER = "ON_START_CREATE_WOOCOMMERCE_ORDER";
export const ON_CREATE_WOOCOMMERCE_ORDER = "ON_CREATE_WOOCOMMERCE_ORDER";
export const ON_ERROR_CREATE_WOOCOMMERCE_ORDER = "ON_ERROR_CREATE_WOOCOMMERCE_ORDER";
export const ON_START_UPDATE_WOOCOMMERCE_ORDER = "ON_START_UPDATE_WOOCOMMERCE_ORDER";
export const ON_UPDATE_WOOCOMMERCE_ORDER = "ON_UPDATE_WOOCOMMERCE_ORDER";
export const ON_ERROR_UPDATE_WOOCOMMERCE_ORDER = "ON_ERROR_UPDATE_WOOCOMMERCE_ORDER";

export const ON_START_ADD_WOOCOMMERCE_WEBHOOK = "ON_START_ADD_WOOCOMMERCE_WEBHOOK";
export const ON_ADD_WOOCOMMERCE_WEBHOOK = "ON_ADD_WOOCOMMERCE_WEBHOOK";
export const ON_ERROR_ADD_WOOCOMMERCE_WEBHOOK = "ON_ERROR_ADD_WOOCOMMERCE_WEBHOOK";
export const ON_START_GET_WOOCOMMERCE_WEBHOOK = "ON_START_GET_WOOCOMMERCE_WEBHOOK";
export const ON_GET_WOOCOMMERCE_WEBHOOK = "ON_GET_WOOCOMMERCE_WEBHOOK";
export const ON_ERROR_GET_WOOCOMMERCE_WEBHOOK = "ON_ERROR_GET_WOOCOMMERCE_WEBHOOK";
export const ON_START_DELETE_WOOCOMMERCE_WEBHOOK = "ON_START_DELETE_WOOCOMMERCE_WEBHOOK";
export const ON_DELETE_WOOCOMMERCE_WEBHOOK = "ON_DELETE_WOOCOMMERCE_WEBHOOK";
export const ON_ERROR_DELETE_WOOCOMMERCE_WEBHOOK = "ON_ERROR_DELETE_WOOCOMMERCE_WEBHOOK";

export const ON_START_FETCH_WP_WOOCOMMERCE_WEBHOOK = "ON_START_FETCH_WP_WOOCOMMERCE_WEBHOOK";
export const ON_FETCH_WP_WOOCOMMERCE_WEBHOOK = "ON_FETCH_WP_WOOCOMMERCE_WEBHOOK";
export const ON_ERROR_FETCH_WP_WOOCOMMERCE_WEBHOOK = "ON_ERROR_FETCH_WP_WOOCOMMERCE_WEBHOOK";
//
export const ON_START_GET_ARANDE_KEDJA = "ON_START_GET_ARANDE_KEDJA";
export const ON_GET_ARANDE_KEDJA = "ON_GET_ARANDE_KEDJA";
export const ON_ERROR_GET_ARANDE_KEDJA = "ON_ERROR_GET_ARANDE_KEDJA";
//EVENT
export const ON_START_NEW_EVENT = "ON_START_NEW_EVENT";
export const ON_NEW_EVENT = "ON_NEW_EVENT";
export const ON_NEW_EVENT_AVTAL = "ON_NEW_EVENT_AVTAL";
export const ON_START_NEW_EVENT_AVTAL = "ON_START_NEW_EVENT_AVTAL";
export const ON_ERROR_NEW_EVENT = "ON_ERROR_NEW_EVENT";
export const ON_ERROR_NEW_EVENT_AVTAL = "ON_ERROR_NEW_EVENT_AVTAL";
export const ON_START_GET_EVENT_ORGNR = "ON_START_GET_EVENT_ORGNR";
export const ON_GET_EVENT_ORGNR = "ON_GET_EVENT_ORGNR";
export const ON_ERROR_GET_EVENT_ORGNR = "ON_ERROR_GET_EVENT_ORGNR";
export const ON_START_GET_EVENT_ID = "ON_START_GET_EVENT_ID";
export const ON_GET_EVENT_ID = "ON_GET_EVENT_ID";
export const ON_ERROR_GET_EVENT_ID = "ON_ERROR_GET_EVENT_ID";
export const ON_START_GET_EVENT_ID_REFRESH = "ON_START_GET_EVENT_ID_REFRESH";
export const ON_GET_EVENT_ID_REFRESH = "ON_GET_EVENT_ID_REFRESH";
export const ON_ERROR_GET_EVENT_ID_REFRESH = "ON_ERROR_GET_EVENT_ID_REFRESH";
export const ON_START_GET_EVENT_USER = "ON_START_GET_EVENT_USER";
export const ON_GET_EVENT_USER = "ON_GET_EVENT_USER";
export const ON_ERROR_GET_EVENT_USER = "ON_ERROR_GET_EVENT_USER";
export const ON_START_GET_EVENT_USER_DATE = "ON_START_GET_EVENT_USER_DATE";
export const ON_START_GET_EVENT_USER_DATE1 = "ON_START_GET_EVENT_USER_DATE1";
export const ON_GET_EVENT_USER_DATE = "ON_GET_EVENT_USER_DATE";
export const ON_ERROR_GET_EVENT_USER_DATE = "ON_ERROR_GET_EVENT_USER_DATE";
export const ON_START_EVENT_UPDATE = "ON_START_EVENT_UPDATE";
export const ON_EVENT_UPDATE = "ON_EVENT_UPDATE";
export const ON_ERROR_EVENT_UPDATE = "ON_ERROR_EVENT_UPDATE";
//AKTIVITET
export const ON_START_NEW_AKTIVITET = "ON_START_NEW_AKTIVITET";
export const ON_NEW_AKTIVITET = "ON_NEW_AKTIVITET";
export const ON_ERROR_NEW_AKTIVITET = "ON_ERROR_NEW_AKTIVITET";
export const ON_START_GET_AKTIVITETER_ORGNR = "ON_START_GET_AKTIVITETER_ORGNR";
export const ON_GET_AKTIVITETER_ORGNR = "ON_GET_AKTIVITETER_ORGNR";
export const ON_ERROR_GET_AKTIVITETER_ORGNR = "ON_ERROR_GET_AKTIVITETER_ORGNR";
export const ON_START_GET_AKTIVITETER_AVTAL = "ON_START_GET_AKTIVITETER_AVTAL";
export const ON_GET_AKTIVITETER_AVTAL = "ON_GET_AKTIVITETER_AVTAL";
export const ON_ERROR_GET_AKTIVITETER_AVTAL = "ON_ERROR_GET_AKTIVITETER_AVTAL";
export const ON_START_GET_AKTIVITETER_ARENDE = "ON_START_GET_AKTIVITETER_ARENDE";
export const ON_GET_AKTIVITETER_ARENDE = "ON_GET_AKTIVITETER_ARENDE";
export const ON_ERROR_GET_AKTIVITETER_ARENDE = "ON_ERROR_GET_AKTIVITETER_ARENDE";
export const ON_START_GET_AKTIVITETER_USER = "ON_START_GET_AKTIVITETER_USER";
export const ON_START_GET_AKTIVITETER_USER_TAGS = "ON_START_GET_AKTIVITETER_USER_TAGS";
export const ON_START_GET_AKTIVITETER_USER_NEW = "ON_START_GET_AKTIVITETER_USER_NEW";
export const ON_GET_AKTIVITETER_USER_NEW = "ON_GET_AKTIVITETER_USER_NEW";
export const ON_GET_AKTIVITETER_USER_BUFFER = "ON_GET_AKTIVITETER_USER_BUFFER";

export const ON_GET_AKTIVETETER_STATS = "ON_GET_AKTIVETETER_STATS"
export const ON_ERROR_GET_AKTIVETETER_STATS = "ON_ERROR_GET_AKTIVETETER_STATS"
export const ON_START_GET_AKTIVETETER_STATS = "ON_START_GET_AKTIVETETER_STATS"
//
export const ON_GET_AKTIVITETER_USER = "ON_GET_AKTIVITETER_USER";
export const ON_ERROR_GET_AKTIVITETER_USER = "ON_ERROR_GET_AKTIVITETER_USER";
export const ON_START_UPDATE_AKTIVITET = "ON_START_UPDATE_AKTIVITET";
export const ON_UPDATE_AKTIVITET = "ON_UPDATE_AKTIVITET";
export const ON_ERROR_UPDATE_AKTIVITET = "ON_ERROR_UPDATE_AKTIVITET";
export const ON_UPDATE_AKTIVITETS = "ON_UPDATE_AKTIVITETS";
export const ON_START_GET_AKTIVITETET = "ON_START_GET_AKTIVITETET";
export const ON_GET_AKTIVITETET = "ON_GET_AKTIVITETET";
export const ON_ERROR_GET_AKTIVITETET = "ON_ERROR_GET_AKTIVITETET";
export const ON_UPDATE_T_AKTIVITET = "ON_UPDATE_T_AKTIVITET";
export const ON_ERROR_UPDATE_T_AKTIVITET = "ON_ERROR_UPDATE_T_AKTIVITET";
export const ON_START_AKTIVITET_NEWK = "ON_START_AKTIVITET_NEWK";
export const ON_AKTIVITET_NEWK = "ON_AKTIVITET_NEWK";
export const ON_ERROR_AKTIVITET_NEWK = "ON_ERROR_AKTIVITET_NEWK";
export const ON_START_UPDATE_DATE_AKTIVITET = "ON_START_UPDATE_DATE_AKTIVITET";
export const ON_UPDATE_DATE_AKTIVITETS = "ON_UPDATE_DATE_AKTIVITETS";
export const ON_ERROR_UPDATE_DATE_AKTIVITET = "ON_ERROR_UPDATE_DATE_AKTIVITET";
export const ON_START_AKTIVITET_DELK = "ON_START_AKTIVITET_DELK";
export const ON_AKTIVITET_DELK = "ON_AKTIVITET_DELK";
export const ON_ERROR_AKTIVITET_DELK = "ON_ERROR_AKTIVITET_DELK";
export const ON_DELETE_AKTIVITET = "ON_DELETE_AKTIVITET";



//
// Customizer const
export const TOGGLE_COLLAPSED_NAV = "toggle_collapse_menu";
export const DRAWER_TYPE = "drawer_type";
export const FIXED_DRAWER = "fixed_drawer";
export const COLLAPSED_DRAWER = "collapsible";
export const MINI_DRAWER = "mini_drawer";
export const THEME_COLOR = "theme_color";
export const DARK_THEME = "dark_theme";
export const WINDOW_WIDTH = "window-width";
export const SWITCH_LANGUAGE = "switch-language";
export const CHANGE_DIRECTION = "change-direction";

export const CHANGE_NAVIGATION_STYLE = "change-navigation-style";
export const HORIZONTAL_NAVIGATION = "horizontal_navigation";
export const VERTICAL_NAVIGATION = "vertical_navigation";

export const HORIZONTAL_MENU_POSITION = "horizontal_menu_position";
export const ABOVE_THE_HEADER = "above_the_header";
export const INSIDE_THE_HEADER = "inside_the_header";
export const BELOW_THE_HEADER = "below_the_header";

//Contact Module const
//Jack ON_DELETE_CONTACT

export const ON_Update_STATUS_CONTACT='on_update_status_contact';
export const ON_Update_ANSVARIG_CONTACT='ON_Update_ANSVARIG_CONTACT';
export const ON_DELETE_CONTACT='on_delete_contact';
export const ON_SAVE_NEW_OFFICE='on_save_new_office';
export const ON_SAVE_NEW_TEAM='ON_SAVE_NEW_TEAM';
export const ON_DELETE_OFFICE='on_delete_office';
export const ON_DELETE_TEAM='ON_DELETE_TEAM';
export const ON_EDIT_OFFICE='on_edit_office';
export const ON_EDIT_TEAM='ON_EDIT_TEAM';
export const ON_SAVE_NEW_USER='on_save_new_user';
export const FETCH_ACCOUNT_ERROR='FETCH_Account_ERROR';
export const ON_EDIT_USER_BASIC='ON_EDIT_USER_BASIC';
export const ON_START_EDIT_USER_BASIC='ON_START_EDIT_USER_BASIC';
export const FETCH_START_UPDATE_PASS='FETCH_START_UPDATE_PASS';
export const FETCH_UPDATE_PASS='FETCH_UPDATE_PASS';
export const FETCH_UPDATE_PASS_ERROR='FETCH_UPDATE_PASS_ERROR';


export const FETCH_START = "fetch_start";

export const FETCH_START_FORGET_PASS = "FETCH_START_FORGET_PASS";
export const FETCH_FORGET_PASS = "FETCH_FORGET_PASS";
export const FETCH_FORGET_PASS_ERROR = "FETCH_FORGET_PASS_ERROR";

export const FETCH_SUCCESS = "fetch_success";
export const FETCH_VALIDATION_SUCCESS = "FETCH_VALIDATION_SUCCESS";
export const FETCH_ERROR = "fetch_error";
export const SHOW_MESSAGE = "show_message";
export const HIDE_MESSAGE = "hide_message";
//
export const START_FETCH_CONTACT_BY_ID = "START_FETCH_CONTACT_BY_ID";
export const ON_FETCH_CONTACT_BY_ID_REST = "ON_FETCH_CONTACT_BY_ID_REST";
export const FETCH_ACCOUNT_REST_ERROR = "FETCH_ACCOUNT_REST_ERROR";
//
export const FETCH_ALL_CONTACT = "fetch_all_contact";
export const FETCH_ALL_CONTACT_SUCCESS = "fetch_all_contact_success";
export const ON_FETCH_CONTACT_BY_ID = "on_fetch_contact_by_id";
export const ADD_FAVOURITE = "add_favourite";
export const ON_CONTACT_SELECT = "on_contact_select";
export const ON_ADD_CONTACT = "on_add_contact";
export const ON_CONTACT_CLOSE = "on_contact_close";
export const ON_FILTER_OPTION_SELECT = "on_filter_option_select";
export const ON_SAVE_CONTACT = "on_save_contact";

export const ON_DELETE_SELECTED_CONTACT = "on_delete_selected_contact";
export const FILTER_CONTACT = "filter_contact";
export const GET_ALL_CONTACT = "get_all_contact";
export const GET_UNSELECTED_ALL_CONTACT = "get_unselected_all_contact";
export const ON_ALL_CONTACT_SELECT = "on_all_contact_select";
export const UPDATE_SEARCH_USER = "update_search_user";
export const ON_TOGGLE_DRAWER = "on_toggle_drawer";
export const HANDLE_REQUEST_CLOSE = "handle_request_close";
export const HIDE_CONTACT_LOADER = "hide_contact_loader";

//Auth const
export const SIGNUP_USER = "signup_user";
export const SIGNUP_USER_SUCCESS = "signup_user_success";
export const SIGNIN_GOOGLE_USER = "signin_google_user";
export const SIGNIN_GOOGLE_USER_SUCCESS = "signin_google_user_success";
export const SIGNIN_FACEBOOK_USER = "signin_facebook_user";
export const SIGNIN_FACEBOOK_USER_SUCCESS = "signin_facebook_user_success";
export const SIGNIN_TWITTER_USER = "signin_twitter_user";
export const SIGNIN_TWITTER_USER_SUCCESS = "signin_twitter_user_success";
export const SIGNIN_GITHUB_USER = "signin_github_user";
export const SIGNIN_GITHUB_USER_SUCCESS = "signin_github_user_SUCCESS";
export const SIGNIN_USER = "signin_user";
export const SIGNIN_USER_SUCCESS = "signin_user_success";
export const SIGNOUT_USER = "signout_user";
export const SIGNOUT_USER_SUCCESS = "signout_user_success";
export const INIT_URL = "init_url";
export const USER_DATA = "user_data";
export const USER_TOKEN_SET = "user_token_set";

// Chat Module const

export const FETCH_ALL_CHAT_USER = "fetch_all_chat_user";
export const FETCH_ALL_CHAT_USER_CONVERSATION =
  "fetch_all_chat_user_conversation";
export const FETCH_ALL_CHAT_USER_SUCCESS = "fetch_all_chat_user_success";
export const FETCH_ALL_CHAT_USER_CONVERSATION_SUCCESS =
  "fetch_all_chat_user_conversation_success";
export const FILTER_USERS = "filter_users";
export const ON_SELECT_USER = "on_select_user";
export const ON_SHOW_LOADER = "on_show_loader";
export const ON_HIDE_LOADER = "on_hide_loader";
export const USER_INFO_STATE = "user_info_state";
export const SUBMIT_COMMENT = "submit_comment";
export const UPDATE_MESSAGE_VALUE = "update_message_value";
export const UPDATE_SEARCH_CHAT_USER = "update_search_chat_user";

//// Mail Module const

export const ADD_LABEL = "ADD_LABEL";
export const GET_ALL_MAIL = "get_all_mail";
export const FETCH_ALL_MAIL = "fetch_all_mail";
export const FETCH_ALL_MAIL_SUCCESS = "fetch_all_mail_success";
export const GET_IMPORTANT_MAIL = "get_important_mail";
export const GET_NAV_FILTERS = "get_nav_filters";
export const GET_NAV_LABELS = "get_nav_labels";
export const GET_NAV_FOLDER = "get_nav_folder";
export const GET_READ_MAIL = "get_read_mail";
export const GET_STARRED_MAIL = "get_starred_mail";
export const GET_UNIMPORTANT_MAIL = "get_unimportant_mail";
export const GET_UNREAD_MAIL = "get_unread_mail";
export const GET_UNSELECTED_ALL_MAIL = "get_unselected_all_mail";
export const GET_UNSTARRED_MAIL = "get_unstarred_mail";
export const ON_ALL_MAIL_SELECT = "on_all_mail_select";
export const ON_FOLDER_MENU_ITEM_SELECT = "on_folder_menu_item_select";
export const ON_FOLDER_SELECT = "on_folder_select";
export const ON_IMPORTANT_SELECT = "on_important_select";
export const ON_LABEL_MENU_ITEM_SELECT = "on_label_menu_item_select";
export const GET_MARK_AS_START = "get_mark_as_start";
export const ON_LABEL_SELECT = "on_label_select";
export const ON_MAIL_CHECKED = "on_mail_checked";
export const ON_MAIL_SELECT = "on_mail_select";
export const ON_MAIL_SEND = "on_mail_send";
export const ON_OPTION_MENU_ITEM_SELECT = "on_option_menu_item_select";
export const ON_OPTION_MENU_SELECT = "on_option_menu_select";
export const ON_START_SELECT = "on_start_select";
export const SEARCH_MAIL = "search_mail";
export const ON_DELETE_MAIL = "on_delete_mail";
export const SET_CURRENT_MAIL_NULL = "set_current_mail_null";
export const ON_COMPOSE_MAIL = "on_compose_mail";

//// TO-DO Module const

export const ON_SORTEND = "on_sortend";
export const FETCH_ALL_TODO = "fetch_all_todo";
export const FETCH_ALL_TODO_SUCCESS = "fetch_all_todo-success";
export const FETCH_ALL_TODO_CONVERSATION = "fetch_all_todo_conversation";
export const FETCH_ALL_TODO_CONVERSATION_SUCCESS =
  "fetch_all_todo_conversation_success";
export const SELECT_ALL_TODO = "select_all_todo";
export const GET_ALL_TODO = "get_all_todo";
export const GET_UNSELECTED_ALL_TODO = "get_unselected_all_todo";
export const GET_STARRED_TODO = "get_starred_todo";
export const GET_UNSTARRED_TODO = "get_unstarred_todo";
export const GET_IMPORTANT_TODO = "get_important_todo";
export const GET_UNIMPORTANT_TODO = "get_unimportant_todo";
export const ON_LABEL_UPDATE = "on_label_update";
export const ON_TODO_UPDATE = "on_todo_update";
export const ON_DELETE_TODO = "on_delete_todo";
export const SEARCH_TODO = "search_todo";
export const SHOW_TODOS = "show_todos";
export const GET_TODO_CONVERSATION = "get_todo_conversation";
export const ON_TODO_CHECKED = "on_todo_checked";
export const ON_TODO_ADD = "on_todo_add";
export const ON_TODO_SELECT = "on_todo_select";
export const SET_CURRENT_TODO_NULL = "set_current_todo_null";
export const REMOVE_LABEL = "remove_label";
export const UPDATE_SEARCH = "update_search";

//Offert const
export const START = "start";
export const ADD_OFFER = "add_offer";
export const UPDATE_OFFER = "update_offer";
export const FETCH_ALL_OFFERS = "fetch_all_offers";
export const FETCH_ALL_OFFERS_SUCCESS = "fetch_all_offers_success";
export const CREATE_OFFER = "create_offer";
export const GET_OFFERID = "get_offerid";
export const ADD_PAGE = "add_Page";
export const GET_PAGEID = "get_pageid";
export const UPDATE_PAGECOLOR = "update_pagecolor";
export const DELETE_PAGE = "delete_page";
export const GET_OFFER = "get_offer";
export const DELETE_OFFER = "delete_offer";
export const UPDATE_PAGEIMAGE = "update_pageimage";

//Prislista
export const ON_SAVE_PRICELIST = "save_pricelist";
export const GET_PRICELIST_BY_ID = "get_pricelist_by_id";
export const GET_ALL_PRICELISTS = "get_all_pricelists";

//PdfEditor
export const PDFEDITOR_ON_CHECK_TOTAL_SECTIONS_HEIGHT = "pdfeditor_on_check_total_sections_height";
export const PDFEDITOR_ON_MOVE_SECTION = "pdfeditor_on_move_section";
export const PDFEDITOR_ON_MOVE_SECTION_FROM_PAGE = "pdfeditor_on_move_section_from_page";
export const PDFEDITOR_ON_MOVE_PAGE = "pdfeditor_on_move_page";
export const PDFEDITOR_ON_NAME_CHANGE = "pdfeditor_on_name_change";
export const PDFEDITOR_ON_TYPE_CHANGE = "pdfeditor_on_type_change";
export const PDFEDITOR_ON_CATEGORY_CHANGE = "pdfeditor_on_category_change";

export const PDFEDITOR_ON_ADD_PAGE = "pdfeditor_on_add_page";
export const PDFEDITOR_ON_ADD_SECTION = "pdfeditor_on_add_section";
export const PDFEDITOR_ON_ADD_COLUMN = "pdfeditor_on_add_column";

export const PDFEDITOR_ON_DELETE_PAGE = "pdfeditor_on_delete_page";
export const PDFEDITOR_ON_DELETE_SECTION = "pdfeditor_on_delete_section";
export const PDFEDITOR_ON_DELETE_COLUMN = "pdfeditor_on_delete_column";

export const PDFEDITOR_ON_SELECT_PAGE = "pdfeditor_on_select_page";
export const PDFEDITOR_ON_SELECT_SECTION = "pdfeditor_on_select_section";
export const PDFEDITOR_ON_SELECT_COLUMN = "pdfeditor_on_select_column";
export const PDFEDITOR_ON_SELECT_TABLE_CELL = "pdfeditor_on_select_table_cell"
export const PDFEDITOR_ON_SELECT_PRODUCT_HEADER = "pdfeditor_on_select_product_header"

export const PDFEDITOR_ON_UPDATE_PAGE = "pdfeditor_on_update_page";
export const PDFEDITOR_ON_UPDATE_SECTION = "pdfeditor_on_update_section";
export const PDFEDITOR_ON_UPDATE_COLUMN = "pdfeditor_on_update_column";
export const PDFEDITOR_ON_UPDATE_TABLE_CELL = "pdfeditor_on_update_table_cell";
export const PDFEDITOR_ON_UPDATE_TABLE_CELL_WIDTH = "pdfeditor_on_update_table_cell_width";
export const PDFEDITOR_ON_UPDATE_TABLE_ROW_PADDING = "pdfeditor_on_update_table_row_padding";
export const PDFEDITOR_ON_UPDATE_PRODUCT_HEADER = "pdfeditor_on_update_product_header"

export const PDFEDITOR_ON_ADD_TEMPLATE = "pdfeditor_on_add_template";
export const PDFEDITOR_ON_DELETE_TEMPLATE = "pdfeditor_on_delete_template";
export const PDFEDITOR_ON_UPDATE_TEMPLATE = "pdfeditor_on_update_template";
export const PDFEDITOR_ON_GET_TEMPLATES = "pdfeditor_on_get_templates";
export const PDFEDITOR_ON_LOAD_TEMPLATE = "pdfeditor_on_load_template";

export const PDFEDITOR_ON_GEN_TEMPID = "pdfeditor_on_gen_tempid";
export const PDFEDITOR_ON_SET_NEW_TEMP = "pdfeditor_on_set_new_temp";
export const PDFEDITOR_ON_LOAD_IMAGE_GALLERY = "pdfeditor_on_load_image_gallery";
export const PDFEDITOR_ON_MENU_TAB_CHANGE = "pdfeditor_on_menu_tab_change";
export const PDFEDITOR_ON_RESPOSE = "pdfeditor_on_response";
export const PDFEDITOR_ON_RESPOSE_RESET = "pdfeditor_on_response_reset";
export const PDFEDITOR_ON_RESPOSE_RESET_EMPTY = "pdfeditor_on_response_reset_empty";
export const DOCUMENT_EDITOR_ON_RESPOSE_RESET_EMPTY = "DOCUMENT_EDITOR_ON_RESPOSE_RESET_EMPTY";

//OffertPrev
export const OFFERTPREV_ON_LOAD_AUTO_FILL_INPUT_TYPES = "offertprev_on_load_auto_fill_input_types";
export const OFFERTPREV_ON_LOAD_AUTO_FILL_INPUT_TYPES_FROM_LS = "offertprev_on_load_auto_fill_input_types_from_ls";
export const OFFERTPREV_ON_LOAD_CURRENT_OFFERT = "offertprev_on_load_current_offert";

export const OFFERTPREV_ON_UPDATE_INPUT_FIELD = "offertprev_on_update_input_field";
export const OFFERTPREV_ON_UPDATE_CHECKBOX = "offertprev_on_update_checkbox";
export const OFFERTPREV_ON_ADD_OFFERT = "offertprev_on_add_offert";
export const OFFERTPREV_ON_START_LOAD_OFFERT = "offertprev_on_start_load_offert";
export const OFFERTPREV_ON_LOAD_OFFERT = "offertprev_on_load_offert";
export const OFFERTPREV_ON_GET_OFFERTS = "offertprev_on_get_offerts";
export const OFFERTPREV_ON_SEARCH_OFFERTS = "offertprev_on_search_offerts";
export const OFFERTPREV_ON_GET_STATS = "offertprev_on_get_stats";
export const OFFERTPREV_ON_DELETE_OFFERT = "offertprev_on_delete_offert";
export const OFFERTPREV_ON_UPDATE_OFFERT = "offertprev_on_update_offert";
export const OFFERTPREV_ON_MAP_INPUTS = "offertprev_on_map_inputs";
export const OFFERTPREV_ON_UPDATE_MAP_INPUTS = "offertprev_on_update_map_inputs";
export const OFFERTPREV_ON_SET_CUSTOMER = "offertprev_on_set_customer";
export const OFFERTPREV_LOAD_SELECTED_CUSTOMER = "offertprev_load_selected_customer";

export const OFFERTPREV_ON_ADD_BILAGA = "offertprev_on_add_bilaga";
export const OFFERTPREV_ON_GET_BILAGOR = "offertprev_on_get_bilagor";
export const OFFERTPREV_ON_DELETE_PAGE = "offertprev_on_delete_page";
export const OFFERTPREV_ON_HIDE_PAGE = "offertprev_on_hide_page";


export const OFFERTPREV_ON_CHANGE_EDIT_TEXT = "offertprev_on_change_edit_text";
export const OFFERTPREV_ON_ADD_PRODUCT = "offertprev_on_add_product";
export const OFFERTPREV_ON_CHANGE_AVTALSTID = "offertprev_on_change_avtalstid";
export const OFFERTPREV_ON_DELETE_PRODUCT = "offertprev_on_delete_product";
export const OFFERTPREV_ON_CHANGE_PRODUCT_QNT = "offertprev_on_change_product_qnt";
export const OFFERTPREV_ON_CHANGE_PRODUCT = "offertprev_on_change_product";
export const OFFERTPREV_ON_LOAD_ARTIKLAR = "OFFERTPREV_ON_LOAD_ARTIKLAR";
export const OFFERTPREV_ON_START_LOAD_ARTIKLAR = "OFFERTPREV_ON_START_LOAD_ARTIKLAR";
export const OFFERTPREV_ON_ERROR_LOAD_ARTIKLAR = "OFFERTPREV_ON_ERROR_LOAD_ARTIKLAR";
export const OFFERTPREV_ON_SUM_TOTAL = "offertprev_on_sum_total";
export const OFFERTPREV_ON_GET_OFFERT_COUNT = "offertprev_on_get_offert_count";

export const OFFERTPREV_ON_GET_DOCUMENTS = "offertprev_on_get_documents";

export const OFFERTPREV_ON_RESPOSE = "offertprev_on_response";
export const OFFERTPREV_ON_RESPOSE_RESET = "offertprev_on_response_reset";

export const OFFERTPREV_ON_SET_LOADING = "offertprev_on_set_loading";
export const OFFERTPREV_ON_SET_LOADING_DONE = "offertprev_on_set_loading_done";

export const OFFERTPREV_ON_FETCH_ART = "offertprev_on_fetch_art"
export const OFFERTPREV_ON_START_SEARCH_ART = "offertprev_on_start_search_art"
export const OFFERTPREV_ON_SEARCH_ART = "offertprev_on_search_art"
export const OFFERTPREV_ON_CHECK_TOTAL_SECTIONS_HEIGHT = "OFFERTPREV_ON_CHECK_TOTAL_SECTIONS_HEIGHT"
export const OFFERTPREV_ON_ADD_PAGE = "OFFERTPREV_ON_ADD_PAGE"
export const OFFERTPREV_ON_SET_PRODUCT_QNT = "OFFERTPREV_ON_SET_PRODUCT_QNT"

export const ON_OPEN_FILTER_OFFERT = "ON_OPEN_FILTER_OFFERT"
export const ON_ClOSE_FILTER_OFFERT = "ON_ClOSE_FILTER_OFFERT"
export const SET_OFFERT_FILTER = "SET_OFFERT_FILTER"


//Artikel register
export const ARTREG_ON_START_ADD_ARTIKEL = "artreg_on_start_add_artikel";
export const ARTREG_ON_ERROR_ADD_ARTIKEL = "artreg_on_error_add_artikel";
export const ARTREG_ON_ADD_ARTIKEL = "artreg_on_add_artikel";

export const ARTREG_ON_START_GET_ARTIKEL_NR = "artreg_on_start_get_artikel_nr";
export const ARTREG_ON_ERROR_GET_ARTIKEL_NR = "artreg_on_error_get_artikel_nr";
export const ARTREG_ON_GET_ARTIKEL_NR = "artreg_on_get_artikel_nr";

export const ARTREG_ON_DELETE_ARTIKEL = "artreg_on_delete_artikel";
export const ARTREG_ON_GET_ARTIKLAR = "artreg_on_get_artiklar";
export const ARTREG_ON_START_GET_ARTIKLAR = "ARTREG_ON_START_GET_ARTIKLAR";
export const ARTREG_ON_ERROR_GET_ARTIKLAR = "ARTREG_ON_ERROR_GET_ARTIKLAR";
export const ARTREG_ON_EMPTY_ARTIKLAR = "ARTREG_ON_EMPTY_ARTIKLAR"
export const ARTREG_ON_GET_ARTIKEL = "artreg_on_get_artikel";
export const ARTREG_ON_CHANGE_ACTIVE_STATUS = "artreg_on_change_active_status";

export const ARTREG_ON_START_UPDATE_ARTIKEL = "artreg_on_start_update_artikel";
export const ARTREG_ON_ERROR_UPDATE_ARTIKEL = "artreg_on_error_update_artikel";
export const ARTREG_ON_UPDATE_ARTIKEL = "artreg_on_update_artikel";

export const ARTREG_ON_START_UPDATE_ARTIKEL_MULTI = "ARTREG_ON_START_UPDATE_ARTIKEL_MULTI";
export const ARTREG_ON_ERROR_UPDATE_ARTIKEL_MULTI = "ARTREG_ON_ERROR_UPDATE_ARTIKEL_MULTI";
export const ARTREG_ON_UPDATE_ARTIKEL_MULTI = "ARTREG_ON_UPDATE_ARTIKEL_MULTI";

export const ARTREG_ON_GET_ARTIKEL_COUNT = "artreg_on_get_artikel_count";

export const ARTREG_ON_SEARCH_ARTIKLAR = "artreg_on_search_artiklar";
export const ARTREG_ON_START_SEARCH_ARTIKLAR = "artreg_on_start_search_artiklar";
export const ARTREG_ON_ERROR_SEARCH_ARTIKLAR = "artreg_on_error_search_artiklar";

export const ARTREG_START_GET_PRICELISTS = "ARTREG_START_GET_PRICELISTS";
export const ARTREG_ERROR_GET_PRICELISTS = "ARTREG_ERROR_GET_PRICELISTS";
export const ARTREG_ON_GET_PRICELISTS = "ARTREG_ON_GET_PRICELISTS";
export const ARTREG_ON_ADD_PRICELIST = "artreg_on_add_pricelist";
export const ARTREG_ON_DELETE_PRICELIST = "artreg_on_delete_pricelist";
export const ARTREG_ON_SET_PRIMARY_PRICELIST = "artreg_on_set_primary_pricelist";

export const ARTREG_ON_RESPOSE = "artreg_on_response";
export const ARTREG_ON_RESPOSE_RESET = "artreg_on_response_reset";

export const ARTREG_ON_GET_ARTIKEL_TAGS = "ARTREG_ON_GET_ARTIKEL_TAGS";
export const ARTREG_ON_GET_ARTIKEL_SUB= "ARTREG_ON_GET_ARTIKEL_SUB";

export const ARENDE_ON_ADD_ARENDE = "arende_on_add_arende"
export const ARENDE_ON_DELETE_ARENDE = "arende_on_delete_arende"
export const ARENDE_ON_GET_ARENDEN = "arende_on_get_arenden"
export const ARENDE_ON_GET_ARENDE = "arende_on_get_arende"
export const ARENDE_ON_START_GET_THIS_ARENDE = "ARENDE_ON_START_GET_THIS_ARENDE"
export const ARENDE_ON_START_GET_ARENDE = "arende_on_start_get_arende"

export const ARENDE_ON_START_UPDATE_ARENDE = "ARENDE_ON_START_UPDATE_ARENDE";
export const ARENDE_ON_UPDATE_ARENDE = "arende_on_update_arende"
export const ARENDE_ON_ERROR_UPDATE_ARENDE = "ARENDE_ON_ERROR_UPDATE_ARENDE";

export const ARENDE_ON_START_SEARCH_ARENDEN = "arende_on_start_search_arenden";
export const ARENDE_ON_ERROR_SEARCH_ARENDEN = "arende_on_error_search_arenden";
export const ARENDE_ON_SEARCH_ARENDEN = "arende_on_search_arenden";

export const ARENDE_ON_GET_FLODE = "arende_on_get_flode"
export const ARENDE_ON_START_GET_FLODE = "ARENDE_ON_START_GET_FLODE"
export const ARENDE_ON_ERROR_GET_FLODE = "ARENDE_ON_ERROR_GET_FLODE"
export const ARENDE_ON_START_POST_FLODE = "ARENDE_ON_START_POST_FLODE"
export const ARENDE_ON_ERROR_POST_FLODE = "ARENDE_ON_ERROR_POST_FLODE"
export const ARENDE_ON_POST_FLODE = "ARENDE_ON_POST_FLODE"
export const ARENDE_ON_GET_ARTIKLAR= "arende_on_get_artiklar"

export const ARENDE_ON_GET_ARENDEN_COUNT = "arende_on_get_arenden_count";
export const ARENDE_ON_GET_ARENDEN_COUNT_ALL = "ARENDE_ON_GET_ARENDEN_COUNT_ALL";
export const ARENDE_ON_GET_ARTIKLAR_COUNT = "arende_on_get_artiklar_count";

export const ARENDE_ON_GET_MEDARBETARE = "arende_on_get_medarbetare";
export const ARENDE_ON_REMOVE_MEDARBETARE = "arende_on_remove_medarbetare";
export const ARENDE_ON_ADD_MEDARBETARE = "arende_on_add_medarbetare";

export const ARENDE_ON_GET_ASSISTANSBÅTAR = "arende_on_get_assistansbåt";
export const ARENDE_ON_REMOVE_ASSISTANSBÅT = "arende_on_remove_assistansbåt";
export const ARENDE_ON_ADD_ASSISTANSBÅT = "arende_on_add_assistansbåt";
export const ARENDE_ON_FETCH_ASSISTANSBÅT = "arende_on_fetch_assistansbåt";

export const ARENDE_ON_GET_OLYCKSPLATS = "arende_on_get_olycksplats";

export const ARENDE_ON_GET_INFO = "arende_on_get_info";
export const ARENDE_ON_REMOVE_INFO = "arende_on_remove_info";
export const ARENDE_ON_ADD_INFO = "arende_on_add_info";
export const ARENDE_ON_UPDATE_INFO = "arende_on_update_info";

export const ARENDE_ON_GET_EKONOMI = "arende_on_get_ekonomi";
export const ARENDE_ON_REMOVE_EKONOMI = "arende_on_remove_ekonomi";
export const ARENDE_ON_ADD_EKONOMI = "arende_on_add_ekonomi";
export const ARENDE_ON_UPDATE_EKONOMI = "arende_on_update_ekonomi";
export const ARENDE_ON_START_GET_HISTORIK = "ARENDE_ON_START_GET_HISTORIK";
export const ARENDE_ON_GET_HISTORIK = "ARENDE_ON_GET_HISTORIK";

export const ARENDE_ON_START_GET_DOKUMENT = "ARENDE_ON_START_GET_DOKUMENT";
export const ARENDE_ON_GET_DOKUMENT = "ARENDE_ON_GET_DOKUMENT";
export const SET_ARENDE_NUM_DOC = "SET_ARENDE_NUM_DOC";

export const ARENDE_ON_START_GET_CASE_PDF_REPORT = "ARENDE_ON_START_GET_CASE_PDF_REPORT";
export const ARENDE_ON_ERROR_GET_CASE_PDF_REPORT = "ARENDE_ON_ERROR_GET_CASE_PDF_REPORT";
export const ARENDE_ON_GET_CASE_PDF_REPORT = "ARENDE_ON_GET_CASE_PDF_REPORT";


export const ON_SAVE_ARENDE_CALC_ITEMS = "ON_SAVE_ARENDE_CALC_ITEMS";
export const ON_START_SAVE_ARENDE_CALC_ITEMS = "ON_START_SAVE_ARENDE_CALC_ITEMS";
export const ON_ERROR_SAVE_ARENDE_CALC_ITEMS = "ON_ERROR_SAVE_ARENDE_CALC_ITEMS";
export const ON_START_NEW_ARENDE_KALKYL_ID = "ON_START_NEW_ARENDE_KALKYL_ID";
export const ON_NEW_ARENDE_KALKYL_ID = "ON_NEW_ARENDE_KALKYL_ID";
export const ON_ERROR_NEW_ARENDE_KALKYL_ID = "ON_ERROR_NEW_ARENDE_KALKYL_ID";
export const ON_START_NEW_ARENDE_ABOKALKYL_ID = "ON_START_NEW_ARENDE_ABOKALKYL_ID";
export const ON_NEW_ARENDE_ABOKALKYL_ID = "ON_NEW_ARENDE_ABOKALKYL_ID";
export const ON_ERROR_NEW_ARENDE_ABOKALKYL_ID = "ON_ERROR_NEW_ARENDE_ABOKALKYL_ID";
export const ON_START_GET_ARENDE_KALKYL_ID = "ON_START_GET_ARENDE_KALKYL_ID";
export const ON_GET_ARENDE_KALKYL_ID = "ON_GET_ARENDE_KALKYL_ID";
export const ON_ERROR_GET_ARENDE_KALKYL_ID = "ON_ERROR_GET_ARENDE_KALKYL_ID";
export const ON_START_DELETE_ARENDE_KALKYL_RAD = "ON_START_DELETE_ARENDE_KALKYL_RAD";
export const ON_DELETE_ARENDE_KALKYL_RAD = "ON_DELETE_ARENDE_KALKYL_RAD";
export const ON_ERROR_DELETE_ARENDE_KALKYL_RAD = "ON_ERROR_DELETE_ARENDE_KALKYL_RAD";
export const ON_START_UPDATE_ARENDE_KALKYL_RAD = "ON_START_UPDATE_ARENDE_KALKYL_RAD";
export const ON_UPDATE_ARENDE_KALKYL_RAD = "ON_UPDATE_ARENDE_KALKYL_RAD";
export const ON_ERROR_UPDATE_ARENDE_KALKYL_RAD = "ON_ERROR_UPDATE_ARENDE_KALKYL_RAD";


export const PROJEKT_SET_CURRENT_TAB_INDEX = "PROJEKT_SET_CURRENT_TAB_INDEX";
export const PROJEKT_SET_SEARCH_TEXT = "PROJEKT_SET_SEARCH_TEXT";
export const PROJEKT_ON_START_GET_PROJEKT = "PROJEKT_ON_START_GET_PROJEKT";
export const PROJEKT_ON_GET_ORGNR_COUNT_ALL = "PROJEKT_ON_GET_ORGNR_COUNT_ALL";
export const PROJEKT_ON_GET_PROJEKT = "PROJEKT_ON_GET_PROJEKT";
export const PROJEKT_ON_GET_PROJEKT_AUTOCOMPLETE = "PROJEKT_ON_GET_PROJEKT_AUTOCOMPLETE";
export const PROJEKT_ON_GET_BOARD_AUTOCOMPLETE = "PROJEKT_ON_GET_BOARD_AUTOCOMPLETE";
export const PROJEKT_ON_START_GET_PROJEKT_TIMELINE = "PROJEKT_ON_START_GET_PROJEKT_TIMELINE";
export const PROJEKT_ON_GET_PROJEKT_TIMELINE = "PROJEKT_ON_GET_PROJEKT_TIMELINE";
export const PROJEKT_ON_START_GET_PROJEKT_BY_FASER = "PROJEKT_ON_START_GET_PROJEKT_BY_FASER";
export const PROJEKT_ON_GET_PROJEKT_BY_FASER = "PROJEKT_ON_GET_PROJEKT_BY_FASER";
export const PROJEKT_ON_START_GET_PROJEKT_TIME_REPORT = "PROJEKT_ON_START_GET_PROJEKT_TIME_REPORT";
export const PROJEKT_ON_GET_PROJEKT_TIME_REPORT = "PROJEKT_ON_GET_PROJEKT_TIME_REPORT";
export const PROJEKT_ON_GET_HISTORIK = "PROJEKT_ON_GET_HISTORIK";

export const PROJEKT_ON_START_LOAD_PROJEKT = "PROJEKT_ON_START_LOAD_PROJEKT";
export const PROJEKT_ON_LOAD_PROJEKT = "PROJEKT_ON_LOAD_PROJEKT";
export const PROJEKT_ON_RESET_PROJEKT_RESPONSE = "PROJEKT_ON_RESET_PROJEKT_RESPONSE";

export const PROJEKT_ON_START_UPDATE_PROJEKT = "PROJEKT_ON_START_UPDATE_PROJEKT";
export const PROJEKT_ON_UPDATE_PROJEKT = "PROJEKT_ON_UPDATE_PROJEKT";
export const PROJEKT_ON_ERROR_UPDATE_PROJEKT = "PROJEKT_ON_ERROR_UPDATE_PROJEKT";

//Projektkort actions
export const PROJEKT_KORT_ON_ADD_KOMMENTAR = "PROJEKT_KORT_ON_ADD_KOMMENTAR"
export const PROJEKT_KORT_ON_START_ADD_KOMMENTAR = "PROJEKT_KORT_ON_START_ADD_KOMMENTAR"
export const PROJEKT_KORT_ON_ERROR_ADD_KOMMENTAR = "PROJEKT_KORT_ON_ERROR_ADD_KOMMENTAR"
export const PROJEKT_KORT_ON_UPDATE_KOMMENTAR = "PROJEKT_KORT_ON_UPDATE_KOMMENTAR"
export const PROJEKT_KORT_ON_START_UPDATE_KOMMENTAR = "PROJEKT_KORT_ON_START_UPDATE_KOMMENTAR"
export const PROJEKT_KORT_ON_ERROR_UPDATE_KOMMENTAR = "PROJEKT_KORT_ON_ERROR_UPDATE_KOMMENTAR"
export const PROJEKT_KORT_ON_DELETE_KOMMENTAR = "PROJEKT_KORT_ON_DELETE_KOMMENTAR"
export const PROJEKT_KORT_ON_START_DELETE_KOMMENTAR = "PROJEKT_KORT_ON_START_DELETE_KOMMENTAR"
export const PROJEKT_KORT_ON_ERROR_DELETE_KOMMENTAR = "PROJEKT_KORT_ON_ERROR_DELETE_KOMMENTAR"
export const PROJEKT_KORT_ON_ADD_MEDARBETARE = "PROJEKT_KORT_ON_ADD_MEDARBETARE"
export const PROJEKT_KORT_ON_START_ADD_MEDARBETARE = "PROJEKT_KORT_ON_START_ADD_MEDARBETARE"
export const PROJEKT_KORT_ON_ERROR_ADD_MEDARBETARE = "PROJEKT_KORT_ON_ERROR_ADD_MEDARBETARE"
export const PROJEKT_KORT_ON_DELETE_MEDARBETARE = "PROJEKT_KORT_ON_DELETE_MEDARBETARE"
export const PROJEKT_KORT_ON_START_DELETE_MEDARBETARE = "PROJEKT_KORT_ON_START_DELETE_MEDARBETARE"
export const PROJEKT_KORT_ON_ERROR_DELETE_MEDARBETARE = "PROJEKT_KORT_ON_ERROR_DELETE_MEDARBETARE"
export const PROJEKT_KORT_ON_UPDATE_BESKRIVNING = "PROJEKT_KORT_ON_UPDATE_BESKRIVNING"
export const PROJEKT_KORT_ON_START_UPDATE_BESKRIVNING = "PROJEKT_KORT_ON_START_UPDATE_BESKRIVNING"
export const PROJEKT_KORT_ON_ERROR_UPDATE_BESKRIVNING = "PROJEKT_KORT_ON_ERROR_UPDATE_BESKRIVNING"
export const PROJEKT_KORT_ON_UPDATE_TITEL = "PROJEKT_KORT_ON_UPDATE_TITEL"
export const PROJEKT_KORT_ON_START_UPDATE_TITEL = "PROJEKT_KORT_ON_START_UPDATE_TITEL"
export const PROJEKT_KORT_ON_ERROR_UPDATE_TITEL = "PROJEKT_KORT_ON_ERROR_UPDATE_TITEL"
export const PROJEKT_KORT_ON_ADD_LABEL = "PROJEKT_KORT_ON_ADD_LABEL"
export const PROJEKT_KORT_ON_START_ADD_LABEL = "PROJEKT_KORT_ON_START_ADD_LABEL"
export const PROJEKT_KORT_ON_ERROR_ADD_LABEL = "PROJEKT_KORT_ON_ERROR_ADD_LABEL"
export const PROJEKT_KORT_ON_REMOVE_LABEL = "PROJEKT_KORT_ON_REMOVE_LABEL"
export const PROJEKT_KORT_ON_START_REMOVE_LABEL = "PROJEKT_KORT_ON_START_REMOVE_LABEL"
export const PROJEKT_KORT_ON_ERROR_REMOVE_LABEL = "PROJEKT_KORT_ON_ERROR_REMOVE_LABEL"
export const PROJEKT_KORT_ON_UPDATE_DEADLINE = "PROJEKT_KORT_ON_UPDATE_DEADLINE"
export const PROJEKT_KORT_ON_START_UPDATE_DEADLINE = "PROJEKT_KORT_ON_START_UPDATE_DEADLINE"
export const PROJEKT_KORT_ON_ERROR_UPDATE_DEADLINE = "PROJEKT_KORT_ON_ERROR_UPDATE_DEADLINE"
export const PROJEKT_KORT_ON_ADD_ATTATCHMENT = "PROJEKT_KORT_ON_ADD_ATTATCHMENT"
export const PROJEKT_KORT_ON_START_ADD_ATTATCHMENT = "PROJEKT_KORT_ON_START_ADD_ATTATCHMENT"
export const PROJEKT_KORT_ON_ERROR_ADD_ATTATCHMENT = "PROJEKT_KORT_ON_ERROR_ADD_ATTATCHMENT"
export const PROJEKT_KORT_ON_DELETE_ATTATCHMENT = "PROJEKT_KORT_ON_DELETE_ATTATCHMENT"
export const PROJEKT_KORT_ON_START_DELETE_ATTATCHMENT = "PROJEKT_KORT_ON_START_DELETE_ATTATCHMENT"
export const PROJEKT_KORT_ON_ERROR_DELETE_ATTATCHMENT = "PROJEKT_KORT_ON_ERROR_DELETE_ATTATCHMENT"
export const PROJEKT_KORT_ON_UPDATE_STATUS = "PROJEKT_KORT_ON_UPDATE_STATUS"
export const PROJEKT_KORT_ON_START_UPDATE_STATUS = "PROJEKT_KORT_ON_START_UPDATE_STATUS"
export const PROJEKT_KORT_ON_ERROR_UPDATE_STATUS = "PROJEKT_KORT_ON_ERROR_UPDATE_STATUS"
export const PROJEKT_KORT_ON_MOVE_CARD = "PROJEKT_KORT_ON_MOVE_CARD"
export const PROJEKT_KORT_ON_START_MOVE_CARD = "PROJEKT_KORT_ON_START_MOVE_CARD"
export const PROJEKT_KORT_ON_ERROR_MOVE_CARD = "PROJEKT_KORT_ON_ERROR_MOVE_CARD"
export const PROJEKT_KORT_ON_MAKE_COVER = "PROJEKT_KORT_ON_MAKE_COVER"
export const PROJEKT_KORT_ON_START_MAKE_COVER = "PROJEKT_KORT_ON_START_MAKE_COVER"
export const PROJEKT_KORT_ON_ERROR_MAKE_COVER = "PROJEKT_KORT_ON_ERROR_MAKE_COVER"
export const PROJEKT_KORT_ON_ADD_CHECKLIST = "PROJEKT_KORT_ON_ADD_CHECKLIST"
export const PROJEKT_KORT_ON_START_ADD_CHECKLIST = "PROJEKT_KORT_ON_START_ADD_CHECKLIST"
export const PROJEKT_KORT_ON_ERROR_ADD_CHECKLIST = "PROJEKT_KORT_ON_ERROR_ADD_CHECKLIST"
export const PROJEKT_KORT_ON_UPDATE_CHECKLIST = "PROJEKT_KORT_ON_UPDATE_CHECKLIST"
export const PROJEKT_KORT_ON_START_UPDATE_CHECKLIST = "PROJEKT_KORT_ON_START_UPDATE_CHECKLIST"
export const PROJEKT_KORT_ON_ERROR_UPDATE_CHECKLIST = "PROJEKT_KORT_ON_ERROR_UPDATE_CHECKLIST"
export const PROJEKT_KORT_ON_DELETE_CHECKLIST = "PROJEKT_KORT_ON_DELETE_CHECKLIST"
export const PROJEKT_KORT_ON_START_DELETE_CHECKLIST = "PROJEKT_KORT_ON_START_DELETE_CHECKLIST"
export const PROJEKT_KORT_ON_ERROR_DELETE_CHECKLIST = "PROJEKT_KORT_ON_ERROR_DELETE_CHECKLIST"
export const PROJEKT_KORT_ON_ADD_CHECKLIST_ITEM = "PROJEKT_KORT_ON_ADD_CHECKLIST_ITEM"
export const PROJEKT_KORT_ON_START_ADD_CHECKLIST_ITEM = "PROJEKT_KORT_ON_START_ADD_CHECKLIST_ITEM"
export const PROJEKT_KORT_ON_ERROR_ADD_CHECKLIST_ITEM = "PROJEKT_KORT_ON_ERROR_ADD_CHECKLIST_ITEM"
export const PROJEKT_KORT_ON_UPDATE_CHECKLIST_ITEM = "PROJEKT_KORT_ON_UPDATE_CHECKLIST_ITEM"
export const PROJEKT_KORT_ON_START_UPDATE_CHECKLIST_ITEM = "PROJEKT_KORT_ON_START_UPDATE_CHECKLIST_ITEM"
export const PROJEKT_KORT_ON_ERROR_UPDATE_CHECKLIST_ITEM = "PROJEKT_KORT_ON_ERROR_UPDATE_CHECKLIST_ITEM"
export const PROJEKT_KORT_ON_DELETE_CHECKLIST_ITEM = "PROJEKT_KORT_ON_DELETE_CHECKLIST_ITEM"
export const PROJEKT_KORT_ON_START_DELETE_CHECKLIST_ITEM = "PROJEKT_KORT_ON_START_DELETE_CHECKLIST_ITEM"
export const PROJEKT_KORT_ON_ERROR_DELETE_CHECKLIST_ITEM = "PROJEKT_KORT_ON_ERROR_DELETE_CHECKLIST_ITEM"
export const PROJEKT_KORT_ON_FOLLOW_CARD = "PROJEKT_KORT_ON_FOLLOW_CARD"
export const PROJEKT_KORT_ON_START_FOLLOW_CARD = "PROJEKT_KORT_ON_START_FOLLOW_CARD"
export const PROJEKT_KORT_ON_ERROR_FOLLOW_CARD = "PROJEKT_KORT_ON_ERROR_FOLLOW_CARD"
//end Projektkort actions

export const PROJEKT_ON_START_UPDATE_PROJEKT_BY_META = "PROJEKT_ON_START_UPDATE_PROJEKT_BY_META";
export const PROJEKT_ON_UPDATE_PROJEKT_BY_META = "PROJEKT_ON_UPDATE_PROJEKT_BY_META";
export const PROJEKT_ON_ERROR_UPDATE_PROJEKT_BY_META = "PROJEKT_ON_ERROR_UPDATE_PROJEKT_BY_META";

export const PROJEKT_ON_START_GET_THIS_PROJEKT = "PROJEKT_ON_START_GET_THIS_PROJEKT";
export const PROJEKT_ON_START_GET_THIS_CPROJEKT = "PROJEKT_ON_START_GET_THIS_CPROJEKT";
export const PROJEKT_ON_GET_THIS_PROJEKT = "PROJEKT_ON_GET_THIS_PROJEKT";

export const PROJEKT_ON_START_GET_BOARDS = "PROJEKT_ON_START_GET_BOARDS";
export const PROJEKT_ON_GET_BOARDS = "PROJEKT_ON_GET_BOARDS";
export const PROJEKT_ON_GET_BOARD_TEMPLATES = "PROJEKT_ON_GET_BOARD_TEMPLATES";
export const PROJEKT_ON_UPDADE_BOARD_TEMPLATE = "PROJEKT_ON_UPDADE_BOARD_TEMPLATE";
export const PROJEKT_ON_ERROR_UPDADE_BOARD_TEMPLATE = "PROJEKT_ON_ERROR_UPDADE_BOARD_TEMPLATE";
export const PROJEKT_ON_START_UPDADE_BOARD_TEMPLATE = "PROJEKT_ON_START_UPDADE_BOARD_TEMPLATE";
export const PROJEKT_ON_START_GET_THIS_BOARD = "PROJEKT_ON_START_GET_THIS_BOARD";
export const PROJEKT_ON_GET_THIS_BOARD = "PROJEKT_ON_GET_THIS_BOARD";
export const PROJEKT_ON_START_GET_THIS_BOARD_AKTIVITET = "PROJEKT_ON_START_GET_THIS_BOARD_AKTIVITET";
export const PROJEKT_ON_ERROR_GET_THIS_BOARD_AKTIVITET = "PROJEKT_ON_ERROR_GET_THIS_BOARD_AKTIVITET";
export const PROJEKT_ON_GET_THIS_BOARD_AKTIVITET = "PROJEKT_ON_GET_THIS_BOARD_AKTIVITET";

export const PROJEKT_ON_ADD_EXTERN_PART_BOARD = "PROJEKT_ON_ADD_EXTERN_PART_BOARD";
export const PROJEKT_ON_START_ADD_EXTERN_PART_BOARD = "PROJEKT_ON_START_ADD_EXTERN_PART_BOARD";
export const PROJEKT_ON_ERROR_ADD_EXTERN_PART_BOARD = "PROJEKT_ON_ERROR_ADD_EXTERN_PART_BOARD";
export const PROJEKT_ON_GET_BOARD_BY_TOKEN = "PROJEKT_ON_GET_BOARD_BY_TOKEN";
export const PROJEKT_ON_START_GET_BOARD_BY_TOKEN = "PROJEKT_ON_START_GET_BOARD_BY_TOKEN";
export const PROJEKT_ON_ERROR_GET_BOARD_BY_TOKEN = "PROJEKT_ON_ERROR_GET_BOARD_BY_TOKEN";
export const PROJEKT_ON_GET_BOARD_LIST_BY_TOKEN = "PROJEKT_ON_GET_BOARD_LIST_BY_TOKEN";
export const PROJEKT_ON_GET_BOARD_LIST_BY_USER = "PROJEKT_ON_GET_BOARD_LIST_BY_USER";
export const PROJEKT_ON_START_GET_BOARD_LIST_BY_TOKEN = "PROJEKT_ON_START_GET_BOARD_LIST_BY_TOKEN";
export const PROJEKT_ON_ERROR_GET_BOARD_LIST_BY_TOKEN = "PROJEKT_ON_ERROR_GET_BOARD_LIST_BY_TOKEN";
export const PROJEKT_ON_RESET_BOARD_RESPONSE = "PROJEKT_ON_RESET_BOARD_RESPONSE"


export const PROJEKT_ON_START_UPDATE_BOARD = "PROJEKT_ON_START_UPDATE_BOARD";
export const PROJEKT_ON_UPDATE_BOARD = "PROJEKT_ON_UPDATE_BOARD";
export const PROJEKT_ON_ERROR_UPDATE_BOARD = "PROJEKT_ON_ERROR_UPDATE_BOARD";

export const PROJEKT_ON_START_GO_TO_BOARD = "PROJEKT_ON_START_GO_TO_BOARD";
export const PROJEKT_ON_GO_TO_BOARD = "PROJEKT_ON_GO_TO_BOARD";
export const PROJEKT_ON_ERROR_GO_TO_BOARD = "PROJEKT_ON_ERROR_GO_TO_BOARD";

export const PROJEKT_ON_START_BUFFER_CARDS = "PROJEKT_ON_START_BUFFER_CARDS";
export const PROJEKT_ON_ERROR_BUFFER_CARDS = "PROJEKT_ON_ERROR_BUFFER_CARDS";
export const PROJEKT_ON_BUFFER_CARDS = "PROJEKT_ON_BUFFER_CARDS";
export const PROJEKT_ON_BUFFER_CARDS_BUFFERED = "PROJEKT_ON_BUFFER_CARDS_BUFFERED";

export const ON_START_BUFFER_PROSPEKT_FAS = "ON_START_BUFFER_PROSPEKT_FAS";
export const ON_ERROR_BUFFER_PROSPEKT_FAS = "ON_ERROR_BUFFER_PROSPEKT_FAS";
export const ON_BUFFER_PROSPEKT_FAS = "ON_BUFFER_PROSPEKT_FAS";
export const ON_BUFFER_PROSPEKT_FAS_BUFFERED = "ON_BUFFER_PROSPEKT_FAS_BUFFERED";

export const PROJEKT_ON_START_SEARCH_CARDS = "PROJEKT_ON_START_SEARCH_CARDS";
export const PROJEKT_ON_ERROR_SEARCH_CARDS = "PROJEKT_ON_ERROR_SEARCH_CARDS";
export const PROJEKT_ON_SEARCH_CARDS = "PROJEKT_ON_SEARCH_CARDS";

export const PROJEKT_ON_START_GET_DOKUMENT = "PROJEKT_ON_START_GET_DOKUMENT";
export const PROJEKT_ON_GET_DOKUMENT = "PROJEKT_ON_GET_DOKUMENT";

export const PROJEKT_ON_START_GET_ORDER = "PROJEKT_ON_START_GET_ORDER";
export const PROJEKT_ON_GET_ORDER = "PROJEKT_ON_GET_ORDER";
export const PROJEKT_ON_ERROR_GET_ORDER = "PROJEKT_ON_ERROR_GET_ORDER";

export const PROJEKT_ON_START_GET_TOOLTIPINFO = "PROJEKT_ON_START_GET_TOOLTIPINFO";
export const PROJEKT_ON_GET_TOOLTIPINFO = "PROJEKT_ON_GET_TOOLTIPINFO";
export const PROJEKT_ON_ERROR_GET_TOOLTIPINFO = "PROJEKT_ON_ERROR_GET_TOOLTIPINFO";

export const PROJEKT_ON_GET_TAGS = "PROJEKT_ON_GET_TAGS";
export const PROJEKT_ON_GET_STATS = "PROJEKT_ON_GET_STATS";

export const PROJEKT_ON_START_UPDATE = "PROJEKT_ON_START_UPDATE";
export const PROJEKT_ON_UPDATE = "PROJEKT_ON_UPDATE";

export const PROJEKT_GET_REGISTERED_TIME = "PROJEKT_GET_REGISTERED_TIME";
export const PROJEKT_GET_CALENDAR_EVENTS = "PROJEKT_GET_CALENDAR_EVENTS";
export const PROJEKT_START_GET_CALENDAR_EVENTS = "PROJEKT_START_GET_CALENDAR_EVENTS";
export const PROJEKT_ERROR_GET_CALENDAR_EVENTS = "PROJEKT_ERROR_GET_CALENDAR_EVENTS";
export const PROJEKT_UPDATE_CALENDAR_EVENT = "PROJEKT_UPDATE_CALENDAR_EVENT";
export const PROJEKT_START_UPDATE_CALENDAR_EVENT = "PROJEKT_START_UPDATE_CALENDAR_EVENT";
export const PROJEKT_ERROR_UPDATE_CALENDAR_EVENT = "PROJEKT_ERROR_UPDATE_CALENDAR_EVENT";

export const PROJEKT_GET_TIME_TYPES = "PROJEKT_GET_TIME_TYPES";
//

export const ON_START_CHECK_PLANING_USER = "ON_START_CHECK_PLANING_USER";
export const PROJEKT_GET_CHECK_PLANING_USER = "PROJEKT_GET_CHECK_PLANING_USER";

export const PROJEKT_ON_POST_TO_FLODE = "PROJEKT_ON_POST_TO_FLODE";
export const PROJEKT_ON_START_POST_TO_FLODE = "PROJEKT_ON_START_POST_TO_FLODE";
export const PROJEKT_ON_ERROR_POST_TO_FLODE = "PROJEKT_ON_ERROR_POST_TO_FLODE";
export const PROJEKT_ON_EDIT_TO_FLODE = "PROJEKT_ON_EDIT_TO_FLODE";
export const PROJEKT_ON_START_EDIT_TO_FLODE = "PROJEKT_ON_START_EDIT_TO_FLODE";
export const PROJEKT_ON_ERROR_EDIT_TO_FLODE = "PROJEKT_ON_ERROR_EDIT_TO_FLODE";
export const PROJEKT_ON_DELETE_TO_FLODE = "PROJEKT_ON_DELETE_TO_FLODE";
export const PROJEKT_ON_START_DELETE_TO_FLODE = "PROJEKT_ON_START_DELETE_TO_FLODE";
export const PROJEKT_ON_ERROR_DELETE_TO_FLODE = "PROJEKT_ON_ERROR_DELETE_TO_FLODE";

export const ON_START_NEW_PROJEKT_KALKYL_ID = "ON_START_NEW_PROJEKT_KALKYL_ID";
export const ON_NEW_PROJEKT_KALKYL_ID = "ON_NEW_PROJEKT_KALKYL_ID";
export const ON_ERROR_NEW_PROJEKT_KALKYL_ID = "ON_ERROR_NEW_PROJEKT_KALKYL_ID";
export const ON_START_NEW_PROJEKT_ABOKALKYL_ID = "ON_START_NEW_PROJEKT_ABOKALKYL_ID";
export const ON_NEW_PROJEKT_ABOKALKYL_ID = "ON_NEW_PROJEKT_ABOKALKYL_ID";
export const ON_ERROR_NEW_PROJEKT_ABOKALKYL_ID = "ON_ERROR_NEW_PROJEKT_ABOKALKYL_ID";
export const ON_START_GET_PROJEKT_KALKYL_ID = "ON_START_GET_PROJEKT_KALKYL_ID";
export const ON_GET_PROJEKT_KALKYL_ID = "ON_GET_PROJEKT_KALKYL_ID";
export const ON_ERROR_GET_PROJEKT_KALKYL_ID = "ON_ERROR_GET_PROJEKT_KALKYL_ID";
export const ON_START_DELETE_PROJEKT_KALKYL_RAD = "ON_START_DELETE_PROJEKT_KALKYL_RAD";
export const ON_DELETE_PROJEKT_KALKYL_RAD = "ON_DELETE_PROJEKT_KALKYL_RAD";
export const ON_ERROR_DELETE_PROJEKT_KALKYL_RAD = "ON_ERROR_DELETE_PROJEKT_KALKYL_RAD";
export const ON_START_UPDATE_PROJEKT_KALKYL_RAD = "ON_START_UPDATE_PROJEKT_KALKYL_RAD";
export const ON_UPDATE_PROJEKT_KALKYL_RAD = "ON_UPDATE_PROJEKT_KALKYL_RAD";
export const ON_ERROR_UPDATE_PROJEKT_KALKYL_RAD = "ON_ERROR_UPDATE_PROJEKT_KALKYL_RAD";

export const ON_SAVE_PROJEKT_CALC_ITEMS = "ON_SAVE_PROJEKT_CALC_ITEMS";
export const ON_START_SAVE_PROJEKT_CALC_ITEMS = "ON_START_SAVE_PROJEKT_CALC_ITEMS";
export const ON_ERROR_SAVE_PROJEKT_CALC_ITEMS = "ON_ERROR_SAVE_PROJEKT_CALC_ITEMS";

export const PROJEKT_ON_START_GET_USERS_CALENDAR_EVENTS = "PROJEKT_ON_START_GET_USERS_CALENDAR_EVENTS"
export const PROJEKT_ON_ERROR_GET_USERS_CALENDAR_EVENTS = "PROJEKT_ON_ERROR_GET_USERS_CALENDAR_EVENTS"
export const PROJEKT_ON_GET_USERS_CALENDAR_EVENTS = "PROJEKT_ON_GET_USERS_CALENDAR_EVENTS"
export const PROJEKT_ON_START_GET_USERS_CALENDAR = "PROJEKT_ON_START_GET_USERS_CALENDAR"
export const PROJEKT_ON_ERROR_GET_USERS_CALENDAR = "PROJEKT_ON_ERROR_GET_USERS_CALENDAR"
export const PROJEKT_ON_GET_USERS_CALENDAR = "PROJEKT_ON_GET_USERS_CALENDAR"
export const PROJEKT_ON_START_GET_USERS_OUTLOOK_STATUS = "PROJEKT_ON_START_GET_USERS_OUTLOOK_STATUS"
export const PROJEKT_ON_ERROR_GET_USERS_OUTLOOK_STATUS = "PROJEKT_ON_ERROR_GET_USERS_OUTLOOK_STATUS"
export const PROJEKT_ON_GET_USERS_OUTLOOK_STATUS = "PROJEKT_ON_GET_USERS_OUTLOOK_STATUS"

export const PROJEKT_ON_START_GET_PLANNED_TIME_PRESET = "PROJEKT_ON_START_GET_PLANNED_TIME_PRESET"
export const PROJEKT_ON_ERROR_GET_PLANNED_TIME_PRESET = "PROJEKT_ON_ERROR_GET_PLANNED_TIME_PRESET"
export const PROJEKT_ON_GET_PLANNED_TIME_PRESET = "PROJEKT_ON_GET_PLANNED_TIME_PRESET"

export const DOCTEMPEDITOR_ON_START_CREATE_TEMPLATE = "DOCTEMPEDITOR_ON_START_CREATE_TEMPLATE";
export const DOCTEMPEDITOR_ON_ERROR_CREATE_TEMPLATE = "DOCTEMPEDITOR_ON_ERROR_CREATE_TEMPLATE";
export const DOCTEMPEDITOR_ON_CREATE_TEMPLATE = "DOCTEMPEDITOR_ON_CREATE_TEMPLATE";

export const DOCTEMPEDITOR_ON_START_GET_TEMPLATES = "DOCTEMPEDITOR_ON_START_GET_TEMPLATES";
export const DOCTEMPEDITOR_ON_ERROR_GET_TEMPLATES = "DOCTEMPEDITOR_ON_ERROR_GET_TEMPLATES";
export const DOCTEMPEDITOR_ON_GET_TEMPLATES = "DOCTEMPEDITOR_ON_GET_TEMPLATES";
export const DOCTEMPEDITOR_ON_START_GET_TEMPLATES_RESPONSE = "DOCTEMPEDITOR_ON_START_GET_TEMPLATES_RESPONSE";
export const DOCTEMPEDITOR_ON_GET_TEMPLATES_RESPONSE = "DOCTEMPEDITOR_ON_GET_TEMPLATES_RESPONSE";

export const DOCTEMPEDITOR_ON_START_DELETE_TEMPLATES = "DOCTEMPEDITOR_ON_START_DELETE_TEMPLATES";
export const DOCTEMPEDITOR_ON_ERROR_DELETE_TEMPLATES = "DOCTEMPEDITOR_ON_ERROR_DELETE_TEMPLATES";
export const DOCTEMPEDITOR_ON_DELETE_TEMPLATES = "DOCTEMPEDITOR_ON_DELETE_TEMPLATES";

export const DOCTEMPEDITOR_ON_START_LOAD_TEMPLATE = "DOCTEMPEDITOR_ON_START_LOAD_TEMPLATE";
export const DOCTEMPEDITOR_ON_ERROR_LOAD_TEMPLATE = "DOCTEMPEDITOR_ON_ERROR_LOAD_TEMPLATE";
export const DOCTEMPEDITOR_ON_LOAD_TEMPLATE = "DOCTEMPEDITOR_ON_LOAD_TEMPLATE";

export const DOCTEMPEDITOR_ON_START_LOAD_PRE_TEMPLATE = "DOCTEMPEDITOR_ON_START_LOAD_PRE_TEMPLATE";
export const DOCTEMPEDITOR_ON_ERROR_LOAD_PRE_TEMPLATE = "DOCTEMPEDITOR_ON_ERROR_LOAD_PRE_TEMPLATE";
export const DOCTEMPEDITOR_ON_LOAD_PRE_TEMPLATE = "DOCTEMPEDITOR_ON_LOAD_PRE_TEMPLATE";

export const DOCTEMPEDITOR_ON_START_GET_TEMPLATE_DYNAMIC_FIELD = "DOCTEMPEDITOR_ON_START_GET_TEMPLATE_DYNAMIC_FIELD";
export const DOCTEMPEDITOR_ON_ERROR_GET_TEMPLATE_DYNAMIC_FIELD = "DOCTEMPEDITOR_ON_ERROR_GET_TEMPLATE_DYNAMIC_FIELD";
export const DOCTEMPEDITOR_ON_GET_TEMPLATE_DYNAMIC_FIELD = "DOCTEMPEDITOR_ON_GET_TEMPLATE_DYNAMIC_FIELD";
export const DOCTEMPEDITOR_ON_START_DELETE_TEMPLATE_DYNAMIC_FIELD = "DOCTEMPEDITOR_ON_START_DELETE_TEMPLATE_DYNAMIC_FIELD";
export const DOCTEMPEDITOR_ON_ERROR_DELETE_TEMPLATE_DYNAMIC_FIELD = "DOCTEMPEDITOR_ON_ERROR_DELETE_TEMPLATE_DYNAMIC_FIELD";
export const DOCTEMPEDITOR_ON_DELETE_TEMPLATE_DYNAMIC_FIELD = "DOCTEMPEDITOR_ON_DELETE_TEMPLATE_DYNAMIC_FIELD";
export const DOCTEMPEDITOR_ON_START_EDIT_TEMPLATE_DYNAMIC_FIELD = "DOCTEMPEDITOR_ON_START_EDIT_TEMPLATE_DYNAMIC_FIELD";
export const DOCTEMPEDITOR_ON_ERROR_EDIT_TEMPLATE_DYNAMIC_FIELD = "DOCTEMPEDITOR_ON_ERROR_EDIT_TEMPLATE_DYNAMIC_FIELD";
export const DOCTEMPEDITOR_ON_EDIT_TEMPLATE_DYNAMIC_FIELD = "DOCTEMPEDITOR_ON_EDIT_TEMPLATE_DYNAMIC_FIELD";
export const DOCTEMPEDITOR_ON_START_CREATE_TEMPLATE_DYNAMIC_FIELD = "DOCTEMPEDITOR_ON_START_CREATE_TEMPLATE_DYNAMIC_FIELD";
export const DOCTEMPEDITOR_ON_ERROR_CREATE_TEMPLATE_DYNAMIC_FIELD = "DOCTEMPEDITOR_ON_ERROR_CREATE_TEMPLATE_DYNAMIC_FIELD";
export const DOCTEMPEDITOR_ON_CREATE_TEMPLATE_DYNAMIC_FIELD = "DOCTEMPEDITOR_ON_CREATE_TEMPLATE_DYNAMIC_FIELD";

export const DOCTEMPEDITOR_ON_START_LOAD_DOCUMENT = "DOCTEMPEDITOR_ON_START_LOAD_DOCUMENT";
export const DOCTEMPEDITOR_ON_ERROR_LOAD_DOCUMENT = "DOCTEMPEDITOR_ON_ERROR_LOAD_DOCUMENT";
export const DOCTEMPEDITOR_ON_LOAD_DOCUMENT = "DOCTEMPEDITOR_ON_LOAD_DOCUMENT";

export const DOCTEMPEDITOR_ON_START_LOAD_DOCUMENT_SOLEL_ART = "DOCTEMPEDITOR_ON_START_LOAD_DOCUMENT_SOLEL_ART";
export const DOCTEMPEDITOR_ON_ERROR_LOAD_DOCUMENT_SOLEL_ART = "DOCTEMPEDITOR_ON_ERROR_LOAD_DOCUMENT_SOLEL_ART";
export const DOCTEMPEDITOR_ON_LOAD_DOCUMENT_SOLEL_ART = "DOCTEMPEDITOR_ON_LOAD_DOCUMENT_SOLEL_ART";

export const DOCTEMPEDITOR_ON_START_LOAD_DOCUMENT_REFERENS_ART = "DOCTEMPEDITOR_ON_START_LOAD_DOCUMENT_REFERENS_ART";
export const DOCTEMPEDITOR_ON_ERROR_LOAD_DOCUMENT_REFERENS_ART = "DOCTEMPEDITOR_ON_ERROR_LOAD_DOCUMENT_REFERENS_ART";
export const DOCTEMPEDITOR_ON_LOAD_DOCUMENT_REFERENS_ART = "DOCTEMPEDITOR_ON_LOAD_DOCUMENT_REFERENS_ART";

export const DOCTEMPEDITOR_ON_START_UPDATE_TEMPLATES = "DOCTEMPEDITOR_ON_START_UPDATE_TEMPLATES";
export const DOCTEMPEDITOR_ON_ERROR_UPDATE_TEMPLATES = "DOCTEMPEDITOR_ON_ERROR_UPDATE_TEMPLATES";
export const DOCTEMPEDITOR_ON_UPDATE_TEMPLATES = "DOCTEMPEDITOR_ON_UPDATE_TEMPLATES";

export const DOCTEMPEDITOR_ON_START_ADD_PAGE = "DOCTEMPEDITOR_ON_START_ADD_PAGE";
export const DOCTEMPEDITOR_ON_ERROR_ADD_PAGE = "DOCTEMPEDITOR_ON_ERROR_ADD_PAGE";
export const DOCTEMPEDITOR_ON_ADD_PAGE = "DOCTEMPEDITOR_ON_ADD_PAGE";
export const DOCTEMPEDITOR_ON_START_UPDATE_PAGE = "DOCTEMPEDITOR_ON_START_UPDATE_PAGE";
export const DOCTEMPEDITOR_ON_ERROR_UPDATE_PAGE = "DOCTEMPEDITOR_ON_ERROR_UPDATE_PAGE";
export const DOCTEMPEDITOR_ON_UPDATE_PAGE = "DOCTEMPEDITOR_ON_UPDATE_PAGE";
export const DOCTEMPEDITOR_ON_START_DELETE_PAGE = "DOCTEMPEDITOR_ON_START_DELETE_PAGE";
export const DOCTEMPEDITOR_ON_ERROR_DELETE_PAGE = "DOCTEMPEDITOR_ON_ERROR_DELETE_PAGE";
export const DOCTEMPEDITOR_ON_DELETE_PAGE = "DOCTEMPEDITOR_ON_DELETE_PAGE";

export const DOCTEMPEDITOR_ON_START_ADD_SECTION = "DOCTEMPEDITOR_ON_START_ADD_SECTION";
export const DOCTEMPEDITOR_ON_ERROR_ADD_SECTION = "DOCTEMPEDITOR_ON_ERROR_ADD_SECTION";
export const DOCTEMPEDITOR_ON_ADD_SECTION = "DOCTEMPEDITOR_ON_ADD_SECTION";
export const DOCTEMPEDITOR_ON_START_UPDATE_SECTION = "DOCTEMPEDITOR_ON_START_UPDATE_SECTION";
export const DOCTEMPEDITOR_ON_ERROR_UPDATE_SECTION = "DOCTEMPEDITOR_ON_ERROR_UPDATE_SECTION";
export const DOCTEMPEDITOR_ON_UPDATE_SECTION = "DOCTEMPEDITOR_ON_UPDATE_SECTION";
export const DOCTEMPEDITOR_ON_START_DELETE_SECTION = "DOCTEMPEDITOR_ON_START_DELETE_SECTION";
export const DOCTEMPEDITOR_ON_ERROR_DELETE_SECTION = "DOCTEMPEDITOR_ON_ERROR_DELETE_SECTION";
export const DOCTEMPEDITOR_ON_DELETE_SECTION = "DOCTEMPEDITOR_ON_DELETE_SECTION";

export const DOCTEMPEDITOR_ON_START_UPDATE_COLUMN = "DOCTEMPEDITOR_ON_START_UPDATE_COLUMN";
export const DOCTEMPEDITOR_ON_ERROR_UPDATE_COLUMN = "DOCTEMPEDITOR_ON_ERROR_UPDATE_COLUMN";
export const DOCTEMPEDITOR_ON_UPDATE_COLUMN = "DOCTEMPEDITOR_ON_UPDATE_COLUMN";

export const DOCTEMPEDITOR_ON_START_CONVERT_TEMPLATE = "DOCTEMPEDITOR_ON_START_CONVERT_TEMPLATE";
export const DOCTEMPEDITOR_ON_ERROR_CONVERT_TEMPLATE = "DOCTEMPEDITOR_ON_ERROR_CONVERT_TEMPLATE";
export const DOCTEMPEDITOR_ON_CONVERT_TEMPLATE = "DOCTEMPEDITOR_ON_CONVERT_TEMPLATE";

export const DOCTEMPEDITOR_ON_START_GET_DOCUMENTS = "DOCTEMPEDITOR_ON_START_GET_DOCUMENTS";
export const DOCTEMPEDITOR_ON_ERROR_GET_DOCUMENTS = "DOCTEMPEDITOR_ON_ERROR_GET_DOCUMENTS";
export const DOCTEMPEDITOR_ON_GET_DOCUMENTS = "DOCTEMPEDITOR_ON_GET_DOCUMENTS";

export const DOCTEMPEDITOR_ON_START_SEARCH_DOCUMENTS = "DOCTEMPEDITOR_ON_START_SEARCH_DOCUMENTS";
export const DOCTEMPEDITOR_ON_ERROR_SEARCH_DOCUMENTS = "DOCTEMPEDITOR_ON_ERROR_SEARCH_DOCUMENTS";
export const DOCTEMPEDITOR_ON_SEARCH_DOCUMENTS = "DOCTEMPEDITOR_ON_SEARCH_DOCUMENTS";

export const DOCTEMPEDITOR_ON_START_DELETE_DOCUMENT = "DOCTEMPEDITOR_ON_START_DELETE_DOCUMENT";
export const DOCTEMPEDITOR_ON_ERROR_DELETE_DOCUMENT = "DOCTEMPEDITOR_ON_ERROR_DELETE_DOCUMENT";
export const DOCTEMPEDITOR_ON_DELETE_DOCUMENT = "DOCTEMPEDITOR_ON_DELETE_DOCUMENT";

export const DOCTEMPEDITOR_ON_START_GET_DOCUMENT_STATS = "DOCTEMPEDITOR_ON_START_GET_DOCUMENT_STATS";
export const DOCTEMPEDITOR_ON_ERROR_GET_DOCUMENT_STATS = "DOCTEMPEDITOR_ON_ERROR_GET_DOCUMENT_STATS";
export const DOCTEMPEDITOR_ON_GET_DOCUMENT_STATS = "DOCTEMPEDITOR_ON_GET_DOCUMENT_STATS";

export const DOCTEMPEDITOR_ON_GET_DOCUMENT_ATTACH = "DOCTEMPEDITOR_ON_GET_DOCUMENT_ATTACH";

export const DOCTEMPEDITOR_ON_START_SEND_DOCUMENT = "DOCTEMPEDITOR_ON_START_SEND_DOCUMENT";
export const DOCTEMPEDITOR_ON_ERROR_SEND_DOCUMENT = "DOCTEMPEDITOR_ON_ERROR_SEND_DOCUMENT";
export const DOCTEMPEDITOR_ON_SEND_DOCUMENT = "DOCTEMPEDITOR_ON_SEND_DOCUMENT";
export const DOCTEMPEDITOR_ON_START_ATTEST_DOCUMENT = "DOCTEMPEDITOR_ON_START_ATTEST_DOCUMENT";
export const DOCTEMPEDITOR_ON_ERROR_ATTEST_DOCUMENT = "DOCTEMPEDITOR_ON_ERROR_ATTEST_DOCUMENT";
export const DOCTEMPEDITOR_ON_ATTEST_DOCUMENT = "DOCTEMPEDITOR_ON_ATTEST_DOCUMENT";

export const DOCTEMPEDITOR_ON_START_POST_MSG_SEND_DOCUMENT = "DOCTEMPEDITOR_ON_START_POST_MSG_SEND_DOCUMENT";
export const DOCTEMPEDITOR_ON_ERROR_POST_MSG_SEND_DOCUMENT = "DOCTEMPEDITOR_ON_ERROR_POST_MSG_SEND_DOCUMENT";
export const DOCTEMPEDITOR_ON_POST_MSG_SEND_DOCUMENT = "DOCTEMPEDITOR_ON_POST_MSG_SEND_DOCUMENT";

export const DOCTEMPEDITOR_ON_START_GET_DOCUMENT_SENT_TIMELINE = "DOCTEMPEDITOR_ON_START_GET_DOCUMENT_SENT_TIMELINE";
export const DOCTEMPEDITOR_ON_ERROR_GET_DOCUMENT_SENT_TIMELINE = "DOCTEMPEDITOR_ON_ERROR_GET_DOCUMENT_SENT_TIMELINE";
export const DOCTEMPEDITOR_ON_GET_DOCUMENT_SENT_TIMELINE = "DOCTEMPEDITOR_ON_GET_DOCUMENT_SENT_TIMELINE";

export const DOCTEMPEDITOR_ON_START_GET_CUSTOM_FONT_COLORS = "DOCTEMPEDITOR_ON_START_GET_CUSTOM_FONT_COLORS";
export const DOCTEMPEDITOR_ON_ERROR_GET_CUSTOM_FONT_COLORS = "DOCTEMPEDITOR_ON_ERROR_GET_CUSTOM_FONT_COLORS";
export const DOCTEMPEDITOR_ON_GET_CUSTOM_FONT_COLORS= "DOCTEMPEDITOR_ON_GET_CUSTOM_FONT_COLORS";

export const DOCTEMPEDITOR_ON_START_ADD_CUSTOM_FONT_COLORS = "DOCTEMPEDITOR_ON_START_ADD_CUSTOM_FONT_COLORS";
export const DOCTEMPEDITOR_ON_ERROR_ADD_CUSTOM_FONT_COLORS = "DOCTEMPEDITOR_ON_ERROR_ADD_CUSTOM_FONT_COLORS";
export const DOCTEMPEDITOR_ON_ADD_CUSTOM_FONT_COLORS= "DOCTEMPEDITOR_ON_ADD_CUSTOM_FONT_COLORS";

export const DOCTEMPEDITOR_ON_START_ADD_PRODUCTS_FROM_EXCEL = "DOCTEMPEDITOR_ON_START_ADD_PRODUCTS_FROM_EXCEL";
export const DOCTEMPEDITOR_ON_ERROR_ADD_PRODUCTS_FROM_EXCEL = "DOCTEMPEDITOR_ON_ERROR_ADD_PRODUCTS_FROM_EXCEL";
export const DOCTEMPEDITOR_ON_ADD_PRODUCTS_FROM_EXCEL= "DOCTEMPEDITOR_ON_ADD_PRODUCTS_FROM_EXCEL";

export const DOCTEMPEDITOR_ON_START_REMOVE_CUSTOM_FONT_COLORS = "DOCTEMPEDITOR_ON_START_REMOVE_CUSTOM_FONT_COLORS";
export const DOCTEMPEDITOR_ON_ERROR_REMOVE_CUSTOM_FONT_COLORS = "DOCTEMPEDITOR_ON_ERROR_REMOVE_CUSTOM_FONT_COLORS";
export const DOCTEMPEDITOR_ON_REMOVE_CUSTOM_FONT_COLORS= "DOCTEMPEDITOR_ON_REMOVE_CUSTOM_FONT_COLORS";



export const DOCTEMPEDITOR_ON_START_CREATE_DOCUMENT_FROM_TEMP = "DOCTEMPEDITOR_ON_START_CREATE_DOCUMENT_FROM_TEMP";
export const DOCTEMPEDITOR_ON_ERROR_CREATE_DOCUMENT_FROM_TEMP = "DOCTEMPEDITOR_ON_ERROR_CREATE_DOCUMENT_FROM_TEMP";
export const DOCTEMPEDITOR_ON_CREATE_DOCUMENT_FROM_TEMP = "DOCTEMPEDITOR_ON_CREATE_DOCUMENT_FROM_TEMP";

export const DOCTEMPEDITOR_ON_START_CREATE_DOCUMENT = "DOCTEMPEDITOR_ON_START_CREATE_DOCUMENT";
export const DOCTEMPEDITOR_ON_ERROR_CREATE_DOCUMENT = "DOCTEMPEDITOR_ON_ERROR_CREATE_DOCUMENT";
export const DOCTEMPEDITOR_ON_CREATE_DOCUMENT = "DOCTEMPEDITOR_ON_CREATE_DOCUMENT";

export const DOCTEMPEDITOR_ON_UNMOUNT_DOCUMENT_STATE = "DOCTEMPEDITOR_ON_UNMOUNT_DOCUMENT_STATE";

export const DOCTEMPEDITOR_ON_START_LOAD_META = "DOCTEMPEDITOR_ON_START_LOAD_META"
export const DOCTEMPEDITOR_ON_LOAD_META = "DOCTEMPEDITOR_ON_LOAD_META"
export const DOCTEMPEDITOR_ON_ERROR_LOAD_META = "DOCTEMPEDITOR_ON_ERROR_LOAD_META"

export const DOCTEMPEDITOR_ON_START_ACCEPT_OR_DECLINE_SENT_DOCUMENT = "DOCTEMPEDITOR_ON_START_ACCEPT_OR_DECLINE_SENT_DOCUMENT"
export const DOCTEMPEDITOR_ON_SET_GENERATING_BOOLEAN = "DOCTEMPEDITOR_ON_SET_GENERATING_BOOLEAN"
export const DOCTEMPEDITOR_ON_RESET_CRESPONSE = "DOCTEMPEDITOR_ON_RESET_CRESPONSE"
export const DOCTEMPEDITOR_ON_SET_CRESPONSE = "DOCTEMPEDITOR_ON_SET_CRESPONSE"

export const DOCTEMPEDITOR_ON_START_GET_PROSPECT_DOCS = "DOCTEMPEDITOR_ON_START_GET_PROSPECT_DOCS"
export const DOCTEMPEDITOR_ON_GET_PROSPECT_DOCS = "DOCTEMPEDITOR_ON_GET_PROSPECT_DOCS"
export const DOCTEMPEDITOR_ON_ERROR_GET_PROSPECT_DOCS = "DOCTEMPEDITOR_ON_ERROR_GET_PROSPECT_DOCS"

export const ON_START_CREATE_API_TOKEN = "ON_START_CREATE_API_TOKEN"
export const ON_ERROR_CREATE_API_TOKEN = "ON_ERROR_CREATE_API_TOKEN"
export const ON_CREATE_API_TOKEN = "ON_CREATE_API_TOKEN"

export const ON_START_REVOKE_API_TOKEN = "ON_START_REVOKE_API_TOKEN"
export const ON_ERROR_REVOKE_API_TOKEN = "ON_ERROR_REVOKE_API_TOKEN"
export const ON_REVOKE_API_TOKEN = "ON_REVOKE_API_TOKEN"

export const ON_START_GET_MAIL_LIST = "ON_START_GET_MAIL_LIST"
export const ON_ERROR_GET_MAIL_LIST = "ON_ERROR_GET_MAIL_LIST"
export const ON_GET_MAIL_LIST = "ON_GET_MAIL_LIST"
export const ON_GET_GMAIL_LIST = "ON_GET_GMAIL_LIST"
export const ON_START_GET_MAIL = "ON_START_GET_MAIL"
export const ON_ERROR_GET_MAIL = "ON_ERROR_GET_MAIL"
export const ON_GET_MAIL = "ON_GET_MAIL"
export const ON_GET_GMAIL = "ON_GET_GMAIL"
// export const ON_START_GET_MAIL = "ON_START_GET_MAIL"
// export const ON_ERROR_GET_MAIL = "ON_ERROR_GET_MAIL"
// export const ON_GET_MAIL = "ON_GET_MAIL"
export const ON_START_GET_MAIL_FOLDERS = "ON_START_GET_MAIL_FOLDERS"
export const ON_ERROR_GET_MAIL_FOLDERS = "ON_ERROR_GET_MAIL_FOLDERS"
export const ON_GET_MAIL_FOLDERS = "ON_GET_MAIL_FOLDERS"
export const ON_GET_GMAIL_FOLDERS = "ON_GET_GMAIL_FOLDERS"
export const ON_START_ATTACH_MAIL_TO_KUND = "ON_START_ATTACH_MAIL_TO_KUND"
export const ON_ERROR_ATTACH_MAIL_TO_KUND = "ON_ERROR_ATTACH_MAIL_TO_KUND"
export const ON_ATTACH_MAIL_TO_KUND = "ON_ATTACH_MAIL_TO_KUND"
export const ON_ATTACH_GMAIL_TO_KUND = "ON_ATTACH_GMAIL_TO_KUND"
export const ON_START_SEND_MAIL_AS_NEW = "ON_START_SEND_MAIL_AS_NEW"
export const ON_ERROR_SEND_MAIL_AS_NEW = "ON_ERROR_SEND_MAIL_AS_NEW"
export const ON_SEND_MAIL_AS_NEW = "ON_SEND_MAIL_AS_NEW"
export const ON_SEND_GMAIL_AS_NEW = "ON_SEND_GMAIL_AS_NEW"
export const ON_START_DELETE_MAILS = "ON_START_DELETE_MAILS"
export const ON_DELETE_DRAFT_GMAILS = "ON_DELETE_DRAFT_GMAILS"
export const ON_ERROR_DELETE_MAILS = "ON_ERROR_DELETE_MAILS"
export const ON_DELETE_MAILS = "ON_DELETE_MAILS"
export const ON_START_MOVE_MAILS = "ON_START_MOVE_MAILS"
export const ON_ERROR_MOVE_MAILS = "ON_ERROR_MOVE_MAILS"
export const ON_MOVE_MAILS = "ON_MOVE_MAILS"
export const ON_START_SAVE_MAIL = "ON_START_SAVE_MAIL"
export const ON_ERROR_SAVE_MAIL = "ON_ERROR_SAVE_MAIL"
export const ON_GET_SAVE_MAIL = "ON_GET_SAVE_MAIL"
export const ON_GET_SAVE_GMAIL = "ON_GET_SAVE_GMAIL"
export const ON_START_CREATE_REPLY_MAIL = "ON_START_CREATE_REPLY_MAIL"
export const ON_ERROR_CREATE_REPLY_MAIL = "ON_ERROR_CREATE_REPLY_MAIL"
export const ON_CREATE_REPLY_MAIL = "ON_CREATE_REPLY_MAIL"
export const ON_CREATE_REPLY_GMAIL = "ON_CREATE_REPLY_GMAIL"
export const ON_START_CREATE_FORWARD_MAIL = "ON_START_CREATE_FORWARD_MAIL"
export const ON_ERROR_CREATE_FORWARD_MAIL = "ON_ERROR_CREATE_FORWARD_MAIL"
export const ON_CREATE_FORWARD_MAIL = "ON_CREATE_FORWARD_MAIL"
export const ON_CREATE_FORWARD_GMAIL = "ON_CREATE_FORWARD_GMAIL"

export const ON_CREATE_SIGNATURE_MAIL = "ON_CREATE_SIGNATURE_MAIL"
export const ON_ERROR_CREATE_SIGNATURE_MAIL = "ON_ERROR_CREATE_SIGNATURE_MAIL"
export const ON_START_CREATE_SIGNATURE_MAIL = "ON_START_CREATE_SIGNATURE_MAIL"
export const ON_UPDATE_SIGNATURE_MAIL = "ON_UPDATE_SIGNATURE_MAIL"
export const ON_ERROR_UPDATE_SIGNATURE_MAIL = "ON_ERROR_UPDATE_SIGNATURE_MAIL"
export const ON_START_UPDATE_SIGNATURE_MAIL = "ON_START_UPDATE_SIGNATURE_MAIL"
export const ON_DELETE_SIGNATURE_MAIL = "ON_DELETE_SIGNATURE_MAIL"
export const ON_ERROR_DELETE_SIGNATURE_MAIL = "ON_ERROR_DELETE_SIGNATURE_MAIL"
export const ON_START_DELETE_SIGNATURE_MAIL = "ON_START_DELETE_SIGNATURE_MAIL"
export const ON_SET_DEFAULT_SIGNATURE_MAIL = "ON_SET_DEFAULT_SIGNATURE_MAIL"
export const ON_ERROR_SET_DEFAULT_SIGNATURE_MAIL = "ON_ERROR_SET_DEFAULT_SIGNATURE_MAIL"
export const ON_START_SET_DEFAULT_SIGNATURE_MAIL = "ON_START_SET_DEFAULT_SIGNATURE_MAIL"
export const ON_GET_SIGNATURE_MAIL = "ON_GET_SIGNATURE_MAIL"
export const ON_ERROR_GET_SIGNATURE_MAIL = "ON_ERROR_GET_SIGNATURE_MAIL"
export const ON_START_GET_SIGNATURE_MAIL = "ON_START_GET_SIGNATURE_MAIL"
export const ON_FETCH_URVAL_MAIL = "ON_FETCH_URVAL_MAIL"
export const ON_ERROR_FETCH_URVAL_MAIL = "ON_ERROR_FETCH_URVAL_MAIL"
export const ON_START_FETCH_URVAL_MAIL = "ON_START_FETCH_URVAL_MAIL"
export const ON_SET_CAMP_RECIPIENTS = "ON_SET_CAMP_RECIPIENTS"

export const ON_RESET_MAIL_RESPONSE = "ON_RESET_MAIL_RESPONSE"
export const ON_START_GET_MAIL_TEMPLATE = "ON_START_GET_MAIL_TEMPLATE"
export const ON_ERROR_GET_MAIL_TEMPLATE = "ON_ERROR_GET_MAIL_TEMPLATE"
export const ON_GET_MAIL_TEMPLATE = "ON_GET_MAIL_TEMPLATE"
export const ON_START_GET_MAIL_TEMPLATE_HTML = "ON_START_GET_MAIL_TEMPLATE_HTML"
export const ON_ERROR_GET_MAIL_TEMPLATE_HTML = "ON_ERROR_GET_MAIL_TEMPLATE_HTML"
export const ON_GET_MAIL_TEMPLATE_HTML = "ON_GET_MAIL_TEMPLATE_HTML"
export const ON_START_ADD_MAIL_TEMPLATE_SECTION = "ON_START_ADD_MAIL_TEMPLATE_SECTION"
export const ON_ERROR_ADD_MAIL_TEMPLATE_SECTION = "ON_ERROR_ADD_MAIL_TEMPLATE_SECTION"
export const ON_ADD_MAIL_TEMPLATE_SECTION = "ON_ADD_MAIL_TEMPLATE_SECTION"
export const ON_START_UPDATE_MAIL_TEMPLATE_BY_META = "ON_START_UPDATE_MAIL_TEMPLATE_BY_META"
export const ON_ERROR_UPDATE_MAIL_TEMPLATE_BY_META = "ON_ERROR_UPDATE_MAIL_TEMPLATE_BY_META"
export const ON_UPDATE_MAIL_TEMPLATE_BY_META = "ON_UPDATE_MAIL_TEMPLATE_BY_META"
export const ON_START_REMOVE_MAIL_TEMPLATE_SECTION = "ON_START_REMOVE_MAIL_TEMPLATE_SECTION"
export const ON_ERROR_REMOVE_MAIL_TEMPLATE_SECTION = "ON_ERROR_REMOVE_MAIL_TEMPLATE_SECTION"
export const ON_REMOVE_MAIL_TEMPLATE_SECTION = "ON_REMOVE_MAIL_TEMPLATE_SECTION"
export const ON_START_MOVE_MAIL_TEMPLATE_SECTION = "ON_START_MOVE_MAIL_TEMPLATE_SECTION"
export const ON_ERROR_MOVE_MAIL_TEMPLATE_SECTION = "ON_ERROR_MOVE_MAIL_TEMPLATE_SECTION"
export const ON_MOVE_MAIL_TEMPLATE_SECTION = "ON_MOVE_MAIL_TEMPLATE_SECTION"
export const ON_START_UPDATE_MAIL_TEMPLATE_SECTION = "ON_START_UPDATE_MAIL_TEMPLATE_SECTION"
export const ON_ERROR_UPDATE_MAIL_TEMPLATE_SECTION = "ON_ERROR_UPDATE_MAIL_TEMPLATE_SECTION"
export const ON_UPDATE_MAIL_TEMPLATE_SECTION = "ON_MOVE_UPDATE_TEMPLATE_SECTION"
export const ON_START_MOVE_MAIL_TEMPLATE_CONTENT = "ON_START_MOVE_MAIL_TEMPLATE_CONTENT"
export const ON_ERROR_MOVE_MAIL_TEMPLATE_CONTENT = "ON_ERROR_MOVE_MAIL_TEMPLATE_CONTENT"
export const ON_MOVE_MAIL_TEMPLATE_CONTENT = "ON_MOVE_MAIL_TEMPLATE_CONTENT"
export const ON_START_ADD_MAIL_TEMPLATE_CONTENT = "ON_START_ADD_MAIL_TEMPLATE_CONTENT"
export const ON_ERROR_ADD_MAIL_TEMPLATE_CONTENT = "ON_ERROR_ADD_MAIL_TEMPLATE_CONTENT"
export const ON_ADD_MAIL_TEMPLATE_CONTENT = "ON_ADD_MAIL_TEMPLATE_CONTENT"
export const ON_START_REMOVE_MAIL_TEMPLATE_CONTENT = "ON_START_REMOVE_MAIL_TEMPLATE_CONTENT"
export const ON_ERROR_REMOVE_MAIL_TEMPLATE_CONTENT = "ON_ERROR_REMOVE_MAIL_TEMPLATE_CONTENT"
export const ON_REMOVE_MAIL_TEMPLATE_CONTENT = "ON_REMOVE_MAIL_TEMPLATE_CONTENT"
export const ON_START_ADD_MAIL_TEMPLATE_COLUMN = "ON_START_ADD_MAIL_TEMPLATE_COLUMN"
export const ON_ERROR_ADD_MAIL_TEMPLATE_COLUMN = "ON_ERROR_ADD_MAIL_TEMPLATE_COLUMN"
export const ON_ADD_MAIL_TEMPLATE_COLUMN = "ON_ADD_MAIL_TEMPLATE_COLUMN"
export const ON_START_REMOVE_MAIL_TEMPLATE_COLUMN = "ON_START_REMOVE_MAIL_TEMPLATE_COLUMN"
export const ON_ERROR_REMOVE_MAIL_TEMPLATE_COLUMN = "ON_ERROR_REMOVE_MAIL_TEMPLATE_COLUMN"
export const ON_REMOVE_MAIL_TEMPLATE_COLUMN = "ON_REMOVE_MAIL_TEMPLATE_COLUMN"
export const ON_START_UPDATE_MAIL_TEMPLATE_COLUMN = "ON_START_UPDATE_MAIL_TEMPLATE_COLUMN"
export const ON_ERROR_UPDATE_MAIL_TEMPLATE_COLUMN = "ON_ERROR_UPDATE_MAIL_TEMPLATE_COLUMN"
export const ON_UPDATE_MAIL_TEMPLATE_COLUMN = "ON_UPDATE_MAIL_TEMPLATE_COLUMN"
export const ON_START_UPDATE_MAIL_TEMPLATE_CONTENT = "ON_START_UPDATE_MAIL_TEMPLATE_CONTENT"
export const ON_ERROR_UPDATE_MAIL_TEMPLATE_CONTENT = "ON_ERROR_UPDATE_MAIL_TEMPLATE_CONTENT"
export const ON_UPDATE_MAIL_TEMPLATE_CONTENT = "ON_UPDATE_MAIL_TEMPLATE_CONTENT"
export const ON_START_ADD_MAIL_TEMPLATE_SOCIAL = "ON_START_ADD_MAIL_TEMPLATE_SOCIAL"
export const ON_ERROR_ADD_MAIL_TEMPLATE_SOCIAL = "ON_ERROR_ADD_MAIL_TEMPLATE_SOCIAL"
export const ON_ADD_MAIL_TEMPLATE_SOCIAL = "ON_ADD_MAIL_TEMPLATE_SOCIAL"
export const ON_START_UPDATE_MAIL_TEMPLATE_SOCIAL = "ON_START_UPDATE_MAIL_TEMPLATE_SOCIAL"
export const ON_ERROR_UPDATE_MAIL_TEMPLATE_SOCIAL = "ON_ERROR_UPDATE_MAIL_TEMPLATE_SOCIAL"
export const ON_UPDATE_MAIL_TEMPLATE_SOCIAL = "ON_UPDATE_MAIL_TEMPLATE_SOCIAL"
export const ON_START_REMOVE_MAIL_TEMPLATE_SOCIAL = "ON_START_REMOVE_MAIL_TEMPLATE_SOCIAL"
export const ON_ERROR_REMOVE_MAIL_TEMPLATE_SOCIAL = "ON_ERROR_REMOVE_MAIL_TEMPLATE_SOCIAL"
export const ON_REMOVE_MAIL_TEMPLATE_SOCIAL = "ON_REMOVE_MAIL_TEMPLATE_SOCIAL"
export const ON_START_MOVE_MAIL_TEMPLATE_SOCIAL = "ON_START_MOVE_MAIL_TEMPLATE_SOCIAL"
export const ON_ERROR_MOVE_MAIL_TEMPLATE_SOCIAL = "ON_ERROR_MOVE_MAIL_TEMPLATE_SOCIAL"
export const ON_MOVE_MAIL_TEMPLATE_SOCIAL = "ON_MOVE_MAIL_TEMPLATE_SOCIAL"
export const ON_START_SEND_TEST_MAIL_TEMPLATE = "ON_START_SEND_TEST_MAIL_TEMPLATE"
export const ON_ERROR_SEND_MAIL_TEMPLATE = "ON_ERROR_SEND_MAIL_TEMPLATE"
export const ON_SEND_MAIL_TEMPLATE = "ON_SEND_MAIL_TEMPLATE"
export const ON_START_SEND_URVAL_MAIL_TEMPLATE = "ON_START_SEND_URVAL_MAIL_TEMPLATE"
export const ON_ERROR_SEND_URVAL_MAIL_TEMPLATE = "ON_ERROR_SEND_URVAL_MAIL_TEMPLATE"
export const ON_SEND_URVAL_MAIL_TEMPLATE = "ON_SEND_URVAL_MAIL_TEMPLATE"
export const ON_START_GET_URVAL_MAIL_TEMPLATE = "ON_START_GET_URVAL_MAIL_TEMPLATE"
export const ON_ERROR_GET_URVAL_MAIL_TEMPLATE = "ON_ERROR_GET_URVAL_MAIL_TEMPLATE"
export const ON_GET_URVAL_MAIL_TEMPLATE = "ON_GET_URVAL_MAIL_TEMPLATE"
export const ON_START_SEND_MAIL_CAMPAIGN = "ON_START_SEND_MAIL_CAMPAIGN"
export const ON_ERROR_SEND_MAIL_CAMPAIGN = "ON_ERROR_SEND_MAIL_CAMPAIGN"
export const ON_SEND_MAIL_CAMPAIGN = "ON_SEND_MAIL_CAMPAIGN"
export const ON_START_UPDATE_MAIL_CAMPAIGN = "ON_START_UPDATE_MAIL_CAMPAIGN"
export const ON_ERROR_UPDATE_MAIL_CAMPAIGN = "ON_ERROR_UPDATE_MAIL_CAMPAIGN"
export const ON_UPDATE_MAIL_CAMPAIGN = "ON_UPDATE_MAIL_CAMPAIGN"
export const ON_START_DELETE_MAIL_CAMPAIGN = "ON_START_DELETE_MAIL_CAMPAIGN"
export const ON_ERROR_DELETE_MAIL_CAMPAIGN = "ON_ERROR_DELETE_MAIL_CAMPAIGN"
export const ON_DELETE_MAIL_CAMPAIGN = "ON_DELETE_MAIL_CAMPAIGN"
export const ON_START_DUPLICATE_MAIL_TEMPLATE_CAMPAIGN = "ON_START_DUPLICATE_MAIL_TEMPLATE_CAMPAIGN"
export const ON_ERROR_DUPLICATE_MAIL_TEMPLATE_CAMPAIGN = "ON_ERROR_DUPLICATE_MAIL_TEMPLATE_CAMPAIGN"
export const ON_DUPLICATE_MAIL_TEMPLATE_CAMPAIGN = "ON_DUPLICATE_MAIL_TEMPLATE_CAMPAIGN"

export const ON_START_UPDATE_MAIL_CAMPAIGN_RECIPIENT = "ON_START_UPDATE_MAIL_CAMPAIGN_RECIPIENT"
export const ON_ERROR_UPDATE_MAIL_CAMPAIGN_RECIPIENT = "ON_ERROR_UPDATE_MAIL_CAMPAIGN_RECIPIENT"
export const ON_UPDATE_MAIL_CAMPAIGN_RECIPIENT = "ON_UPDATE_MAIL_CAMPAIGN_RECIPIENT"
export const ON_START_DELETE_MAIL_CAMPAIGN_RECIPIENT = "ON_START_DELETE_MAIL_CAMPAIGN_RECIPIENT"
export const ON_ERROR_DELETE_MAIL_CAMPAIGN_RECIPIENT = "ON_ERROR_DELETE_MAIL_CAMPAIGN_RECIPIENT"
export const ON_DELETE_MAIL_CAMPAIGN_RECIPIENT = "ON_DELETE_MAIL_CAMPAIGN_RECIPIENT"

export const ON_START_CREATE_MAIL_CAMPAIGN_GROUP = "ON_START_CREATE_MAIL_CAMPAIGN_GROUP"
export const ON_ERROR_CREATE_MAIL_CAMPAIGN_GROUP = "ON_ERROR_CREATE_MAIL_CAMPAIGN_GROUP"
export const ON_CREATE_MAIL_CAMPAIGN_GROUP = "ON_CREATE_MAIL_CAMPAIGN_GROUP"
export const ON_START_UPDATE_MAIL_CAMPAIGN_GROUP = "ON_START_UPDATE_MAIL_CAMPAIGN_GROUP"
export const ON_ERROR_UPDATE_MAIL_CAMPAIGN_GROUP = "ON_ERROR_UPDATE_MAIL_CAMPAIGN_GROUP"
export const ON_UPDATE_MAIL_CAMPAIGN_GROUP = "ON_UPDATE_MAIL_CAMPAIGN_GROUP"
export const ON_START_REMOVE_MAIL_CAMPAIGN_GROUP = "ON_START_REMOVE_MAIL_CAMPAIGN_GROUP"
export const ON_ERROR_REMOVE_MAIL_CAMPAIGN_GROUP = "ON_ERROR_REMOVE_MAIL_CAMPAIGN_GROUP"
export const ON_REMOVE_MAIL_CAMPAIGN_GROUP = "ON_REMOVE_MAIL_CAMPAIGN_GROUP"
export const ON_START_GET_MAIL_CAMPAIGN_GROUPS = "ON_START_GET_MAIL_CAMPAIGN_GROUPS"
export const ON_ERROR_GET_MAIL_CAMPAIGN_GROUPS = "ON_ERROR_GET_MAIL_CAMPAIGN_GROUPS"
export const ON_GET_MAIL_CAMPAIGN_GROUPS = "ON_GET_MAIL_CAMPAIGN_GROUPS"

export const ON_START_GET_MAIL_CAMPAIGN_AUDIENCES = "ON_START_GET_MAIL_CAMPAIGN_AUDIENCES"
export const ON_ERROR_GET_MAIL_CAMPAIGN_AUDIENCES = "ON_ERROR_GET_MAIL_CAMPAIGN_AUDIENCES"
export const ON_GET_MAIL_CAMPAIGN_AUDIENCES = "ON_GET_MAIL_CAMPAIGN_AUDIENCES"
export const ON_START_CREATE_MAIL_CAMPAIGN_AUDIENCES = "ON_START_CREATE_MAIL_CAMPAIGN_AUDIENCES"
export const ON_ERROR_CREATE_MAIL_CAMPAIGN_AUDIENCES = "ON_ERROR_CREATE_MAIL_CAMPAIGN_AUDIENCES"
export const ON_CREATE_MAIL_CAMPAIGN_AUDIENCES = "ON_CREATE_MAIL_CAMPAIGN_AUDIENCES"
export const ON_START_DELETE_MAIL_CAMPAIGN_AUDIENCES = "ON_START_DELETE_MAIL_CAMPAIGN_AUDIENCES"
export const ON_ERROR_DELETE_MAIL_CAMPAIGN_AUDIENCES = "ON_ERROR_DELETE_MAIL_CAMPAIGN_AUDIENCES"
export const ON_DELETE_MAIL_CAMPAIGN_AUDIENCES = "ON_DELETE_MAIL_CAMPAIGN_AUDIENCES"
export const ON_START_UPDATE_MAIL_CAMPAIGN_AUDIENCES = "ON_START_UPDATE_MAIL_CAMPAIGN_AUDIENCES"
export const ON_ERROR_UPDATE_MAIL_CAMPAIGN_AUDIENCES = "ON_ERROR_UPDATE_MAIL_CAMPAIGN_AUDIENCES"
export const ON_UPDATE_MAIL_CAMPAIGN_AUDIENCES = "ON_UPDATE_MAIL_CAMPAIGN_AUDIENCES"

export const ON_START_GET_CURRENT_MAIL_CAMPAIGN_AUDIENCES = "ON_START_GET_CURRENT_MAIL_CAMPAIGN_AUDIENCES"
export const ON_ERROR_GET_CURRENT_MAIL_CAMPAIGN_AUDIENCES = "ON_ERROR_GET_CURRENT_MAIL_CAMPAIGN_AUDIENCES"
export const ON_GET_CURRENT_MAIL_CAMPAIGN_AUDIENCES = "ON_GET_CURRENT_MAIL_CAMPAIGN_AUDIENCES"
export const ON_START_GET_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS = "ON_START_GET_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS"
export const ON_ERROR_GET_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS = "ON_ERROR_GET_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS"
export const ON_GET_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS = "ON_GET_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS"
export const ON_START_CREATE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS = "ON_START_CREATE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS"
export const ON_ERROR_CREATE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS = "ON_ERROR_CREATE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS"
export const ON_CREATE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS = "ON_CREATE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS"
export const ON_START_IMPORT_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS = "ON_START_IMPORT_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS"
export const ON_ERROR_IMPORT_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS = "ON_ERROR_IMPORT_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS"
export const ON_IMPORT_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS = "ON_IMPORT_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS"
export const ON_START_UPDATE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS = "ON_START_UPDATE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS"
export const ON_ERROR_UPDATE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS = "ON_ERROR_UPDATE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS"
export const ON_UPDATE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS = "ON_UPDATE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS"
export const ON_START_DELETE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS = "ON_START_DELETE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS"
export const ON_ERROR_DELETE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS = "ON_ERROR_DELETE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS"
export const ON_DELETE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS = "ON_DELETE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS"
export const ON_START_DELETE_MULTI_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS = "ON_START_DELETE_MULTI_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS"
export const ON_ERROR_DELETE_MULTI_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS = "ON_ERROR_DELETE_MULTI_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS"
export const ON_DELETE_MULTI_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS = "ON_DELETE_MULTI_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS"

export const ON_ADD_AUTH_MAIL_DOMAIN = "ON_ADD_AUTH_MAIL_DOMAIN"
export const ON_ERROR_ADD_AUTH_MAIL_DOMAIN = "ON_ERROR_ADD_AUTH_MAIL_DOMAIN"
export const ON_START_ADD_AUTH_MAIL_DOMAIN = "ON_START_ADD_AUTH_MAIL_DOMAIN"
export const ON_GET_AUTH_MAIL_DOMAIN = "ON_GET_AUTH_MAIL_DOMAIN"
export const ON_ERROR_GET_AUTH_MAIL_DOMAIN = "ON_ERROR_GET_AUTH_MAIL_DOMAIN"
export const ON_START_GET_AUTH_MAIL_DOMAIN = "ON_START_GET_AUTH_MAIL_DOMAIN"
export const ON_REMOVE_AUTH_MAIL_DOMAIN = "ON_REMOVE_AUTH_MAIL_DOMAIN"
export const ON_ERROR_REMOVE_AUTH_MAIL_DOMAIN = "ON_ERROR_REMOVE_AUTH_MAIL_DOMAIN"
export const ON_START_REMOVE_AUTH_MAIL_DOMAIN = "ON_START_REMOVE_AUTH_MAIL_DOMAIN"
export const ON_VALIDATE_AUTH_MAIL_DOMAIN = "ON_VALIDATE_AUTH_MAIL_DOMAIN"
export const ON_ERROR_VALIDATE_AUTH_MAIL_DOMAIN = "ON_ERROR_VALIDATE_AUTH_MAIL_DOMAIN"
export const ON_START_VALIDATE_AUTH_MAIL_DOMAIN = "ON_START_VALIDATE_AUTH_MAIL_DOMAIN"

export const ON_START_ADD_MAIL_TEMPLATE_EVENT = "ON_START_ADD_MAIL_TEMPLATE_EVENT"
export const ON_ERROR_ADD_MAIL_TEMPLATE_EVENT = "ON_ERROR_ADD_MAIL_TEMPLATE_EVENT"
export const ON_ADD_MAIL_TEMPLATE_EVENT = "ON_ADD_MAIL_TEMPLATE_EVENT"
export const ON_START_REMOVE_MAIL_TEMPLATE_EVENT = "ON_START_REMOVE_MAIL_TEMPLATE_EVENT"
export const ON_ERROR_REMOVE_MAIL_TEMPLATE_EVENT = "ON_ERROR_REMOVE_MAIL_TEMPLATE_EVENT"
export const ON_REMOVE_MAIL_TEMPLATE_EVENT = "ON_REMOVE_MAIL_TEMPLATE_EVENT"
export const ON_START_UPDATE_MAIL_TEMPLATE_EVENT = "ON_START_UPDATE_MAIL_TEMPLATE_EVENT"
export const ON_ERROR_UPDATE_MAIL_TEMPLATE_EVENT = "ON_ERROR_UPDATE_MAIL_TEMPLATE_EVENT"
export const ON_UPDATE_MAIL_TEMPLATE_EVENT = "ON_UPDATE_MAIL_TEMPLATE_EVENT"
export const ON_START_GET_MAIL_TEMPLATE_EVENT = "ON_START_GET_MAIL_TEMPLATE_EVENT"
export const ON_ERROR_GET_MAIL_TEMPLATE_EVENT = "ON_ERROR_GET_MAIL_TEMPLATE_EVENT"
export const ON_GET_MAIL_TEMPLATE_EVENT = "ON_GET_MAIL_TEMPLATE_EVENT"

export const ON_START_FETCH_VALID_REST_API_TOKEN = "ON_START_FETCH_VALID_REST_API_TOKEN"
export const ON_ERROR_FETCH_VALID_REST_API_TOKEN = "ON_ERROR_FETCH_VALID_REST_API_TOKEN"
export const ON_FETCH_VALID_REST_API_TOKEN = "ON_FETCH_VALID_REST_API_TOKEN"
//
export const ON_START_USER_ATTEMPT_MORE_5 = "ON_START_USER_ATTEMPT_MORE_5"
export const ON_USER_ATTEMPT_MORE_5 = "ON_USER_ATTEMPT_MORE_5"

